interface PlayIconProps {
  color?: string;
}

export const FilterIcon = ({ color }: PlayIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M3.66674 3.33203H12.3334C12.528 3.40027 12.68 3.5547 12.7452 3.75031C12.8104 3.94592 12.7815 4.1607 12.6667 4.33203L9.33341 7.9987V12.6654L6.66674 10.6654V7.9987L3.33341 4.33203C3.21869 4.1607 3.18971 3.94592 3.25492 3.75031C3.32012 3.5547 3.47217 3.40027 3.66674 3.33203"
        stroke={color ? color : "#212121"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const TimeIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M10.6888 9.7474V6.1849C10.6888 6.00434 10.6298 5.85503 10.5117 5.73698C10.3937 5.61892 10.2444 5.5599 10.0638 5.5599C9.88325 5.5599 9.73394 5.61892 9.61588 5.73698C9.49783 5.85503 9.4388 6.00434 9.4388 6.1849V9.9974C9.4388 10.0807 9.45269 10.1571 9.48047 10.2266C9.50825 10.296 9.54991 10.3655 9.60547 10.4349L12.6055 13.5391C12.7305 13.678 12.8867 13.7439 13.0742 13.737C13.2617 13.73 13.418 13.6641 13.543 13.5391C13.668 13.4141 13.7305 13.2613 13.7305 13.0807C13.7305 12.9002 13.668 12.7474 13.543 12.6224L10.6888 9.7474ZM10.0013 18.3307C8.86241 18.3307 7.78602 18.112 6.77214 17.6745C5.75825 17.237 4.87283 16.6398 4.11589 15.8828C3.35894 15.1259 2.76172 14.2405 2.32422 13.2266C1.88672 12.2127 1.66797 11.1363 1.66797 9.9974C1.66797 8.85851 1.88672 7.78212 2.32422 6.76823C2.76172 5.75434 3.35894 4.86892 4.11589 4.11198C4.87283 3.35503 5.75825 2.75781 6.77214 2.32031C7.78602 1.88281 8.86241 1.66406 10.0013 1.66406C11.1402 1.66406 12.2166 1.88281 13.2305 2.32031C14.2444 2.75781 15.1298 3.35503 15.8867 4.11198C16.6437 4.86892 17.2409 5.75434 17.6784 6.76823C18.1159 7.78212 18.3346 8.85851 18.3346 9.9974C18.3346 11.1363 18.1159 12.2127 17.6784 13.2266C17.2409 14.2405 16.6437 15.1259 15.8867 15.8828C15.1298 16.6398 14.2444 17.237 13.2305 17.6745C12.2166 18.112 11.1402 18.3307 10.0013 18.3307ZM10.0013 17.0807C11.9457 17.0807 13.6124 16.3863 15.0013 14.9974C16.3902 13.6085 17.0846 11.9418 17.0846 9.9974C17.0846 8.05295 16.3902 6.38628 15.0013 4.9974C13.6124 3.60851 11.9457 2.91406 10.0013 2.91406C8.05686 2.91406 6.39019 3.60851 5.0013 4.9974C3.61241 6.38628 2.91797 8.05295 2.91797 9.9974C2.91797 11.9418 3.61241 13.6085 5.0013 14.9974C6.39019 16.3863 8.05686 17.0807 10.0013 17.0807Z"
        fill="#757575"
      />
    </svg>
  );
};

export const FilledClockIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M10 0C15.523 0 20 4.477 20 10C20 15.523 15.523 20 10 20C4.477 20 0 15.523 0 10C0 4.477 4.477 0 10 0ZM10 4C9.73478 4 9.48043 4.10536 9.29289 4.29289C9.10536 4.48043 9 4.73478 9 5V10C9.00006 10.2652 9.10545 10.5195 9.293 10.707L12.293 13.707C12.4816 13.8892 12.7342 13.99 12.9964 13.9877C13.2586 13.9854 13.5094 13.8802 13.6948 13.6948C13.8802 13.5094 13.9854 13.2586 13.9877 12.9964C13.99 12.7342 13.8892 12.4816 13.707 12.293L11 9.586V5C11 4.73478 10.8946 4.48043 10.7071 4.29289C10.5196 4.10536 10.2652 4 10 4Z"
        fill="#424242"
      />
    </svg>
  );
};

export const CalendarIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M3.75 18.3307C3.41667 18.3307 3.125 18.2057 2.875 17.9557C2.625 17.7057 2.5 17.4141 2.5 17.0807V4.16406C2.5 3.83073 2.625 3.53906 2.875 3.28906C3.125 3.03906 3.41667 2.91406 3.75 2.91406H5.10417V2.33073C5.10417 2.14184 5.16806 1.98351 5.29583 1.85573C5.42361 1.72795 5.58194 1.66406 5.77083 1.66406C5.96563 1.66406 6.12891 1.72795 6.26069 1.85573C6.39245 1.98351 6.45833 2.14184 6.45833 2.33073V2.91406H13.5417V2.33073C13.5417 2.14184 13.6056 1.98351 13.7333 1.85573C13.8611 1.72795 14.0194 1.66406 14.2083 1.66406C14.4031 1.66406 14.5664 1.72795 14.6982 1.85573C14.83 1.98351 14.8958 2.14184 14.8958 2.33073V2.91406H16.25C16.5833 2.91406 16.875 3.03906 17.125 3.28906C17.375 3.53906 17.5 3.83073 17.5 4.16406V17.0807C17.5 17.4141 17.375 17.7057 17.125 17.9557C16.875 18.2057 16.5833 18.3307 16.25 18.3307H3.75ZM3.75 17.0807H16.25V8.1224H3.75V17.0807ZM3.75 6.8724H16.25V4.16406H3.75V6.8724ZM10 11.6641C9.76389 11.6641 9.56597 11.5842 9.40625 11.4245C9.24653 11.2648 9.16667 11.0668 9.16667 10.8307C9.16667 10.5946 9.24653 10.3967 9.40625 10.237C9.56597 10.0773 9.76389 9.9974 10 9.9974C10.2361 9.9974 10.434 10.0773 10.5938 10.237C10.7535 10.3967 10.8333 10.5946 10.8333 10.8307C10.8333 11.0668 10.7535 11.2648 10.5938 11.4245C10.434 11.5842 10.2361 11.6641 10 11.6641ZM6.66667 11.6641C6.43056 11.6641 6.23264 11.5842 6.07292 11.4245C5.91319 11.2648 5.83333 11.0668 5.83333 10.8307C5.83333 10.5946 5.91319 10.3967 6.07292 10.237C6.23264 10.0773 6.43056 9.9974 6.66667 9.9974C6.90278 9.9974 7.10069 10.0773 7.26042 10.237C7.42014 10.3967 7.5 10.5946 7.5 10.8307C7.5 11.0668 7.42014 11.2648 7.26042 11.4245C7.10069 11.5842 6.90278 11.6641 6.66667 11.6641ZM13.3333 11.6641C13.0972 11.6641 12.8993 11.5842 12.7396 11.4245C12.5799 11.2648 12.5 11.0668 12.5 10.8307C12.5 10.5946 12.5799 10.3967 12.7396 10.237C12.8993 10.0773 13.0972 9.9974 13.3333 9.9974C13.5694 9.9974 13.7674 10.0773 13.9271 10.237C14.0868 10.3967 14.1667 10.5946 14.1667 10.8307C14.1667 11.0668 14.0868 11.2648 13.9271 11.4245C13.7674 11.5842 13.5694 11.6641 13.3333 11.6641ZM10 14.9974C9.76389 14.9974 9.56597 14.9175 9.40625 14.7578C9.24653 14.5981 9.16667 14.4002 9.16667 14.1641C9.16667 13.928 9.24653 13.73 9.40625 13.5703C9.56597 13.4106 9.76389 13.3307 10 13.3307C10.2361 13.3307 10.434 13.4106 10.5938 13.5703C10.7535 13.73 10.8333 13.928 10.8333 14.1641C10.8333 14.4002 10.7535 14.5981 10.5938 14.7578C10.434 14.9175 10.2361 14.9974 10 14.9974ZM6.66667 14.9974C6.43056 14.9974 6.23264 14.9175 6.07292 14.7578C5.91319 14.5981 5.83333 14.4002 5.83333 14.1641C5.83333 13.928 5.91319 13.73 6.07292 13.5703C6.23264 13.4106 6.43056 13.3307 6.66667 13.3307C6.90278 13.3307 7.10069 13.4106 7.26042 13.5703C7.42014 13.73 7.5 13.928 7.5 14.1641C7.5 14.4002 7.42014 14.5981 7.26042 14.7578C7.10069 14.9175 6.90278 14.9974 6.66667 14.9974ZM13.3333 14.9974C13.0972 14.9974 12.8993 14.9175 12.7396 14.7578C12.5799 14.5981 12.5 14.4002 12.5 14.1641C12.5 13.928 12.5799 13.73 12.7396 13.5703C12.8993 13.4106 13.0972 13.3307 13.3333 13.3307C13.5694 13.3307 13.7674 13.4106 13.9271 13.5703C14.0868 13.73 14.1667 13.928 14.1667 14.1641C14.1667 14.4002 14.0868 14.5981 13.9271 14.7578C13.7674 14.9175 13.5694 14.9974 13.3333 14.9974Z"
        fill="#757575"
      />
    </svg>
  );
};
export const SearchIcon = ({ color }: PlayIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <circle
        cx="8.33333"
        cy="8.33333"
        r="5.83333"
        stroke={color ? color : "#757575"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.5 17.5L12.5 12.5"
        stroke={color ? color : "#757575"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PlayIcon = ({ color }: PlayIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
    >
      <path
        d="M3.84961 9.49967V6.8027C3.84961 3.45421 6.22082 2.083 9.12234 3.75724L11.4632 5.10573L13.8042 6.45421C16.7057 8.12846 16.7057 10.8709 13.8042 12.5451L11.4632 13.8936L9.12234 15.2421C6.22082 16.9163 3.84961 15.5451 3.84961 12.1966V9.49967Z"
        fill={color}
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const UploadFileIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="29"
      height="20"
      viewBox="0 0 29 20"
      fill="none"
    >
      <path
        d="M23.0239 7.55C22.235 3.2375 18.7199 0 14.4972 0C11.1446 0 8.23275 2.05 6.78264 5.05C3.29078 5.45 0.576172 8.6375 0.576172 12.5C0.576172 16.6375 3.69681 20 7.5367 20H22.6178C25.8197 20 28.4183 17.2 28.4183 13.75C28.4183 10.45 26.0401 7.775 23.0239 7.55ZM16.8174 11.25V16.25H12.177V11.25H8.69679L14.4972 5L20.2977 11.25H16.8174Z"
        fill="#4199F7"
      />
    </svg>
  );
};

export const InfoIcon = ({ color }: PlayIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M10.0013 1.66504C14.6046 1.66504 18.3363 5.39671 18.3363 10C18.3363 14.6025 14.6046 18.3334 10.0013 18.3334C5.39797 18.3342 1.66797 14.6025 1.66797 10C1.66714 5.39671 5.39797 1.66504 10.0013 1.66504ZM9.99797 8.54004C9.79375 8.54032 9.59674 8.61558 9.44434 8.75153C9.29195 8.88749 9.19479 9.07467 9.1713 9.27754L9.16547 9.37421L9.1688 13.9592L9.1738 14.0559C9.19709 14.2591 9.29434 14.4467 9.44701 14.5829C9.59969 14.7191 9.79713 14.7943 10.0017 14.7943C10.2063 14.7943 10.4037 14.7191 10.5564 14.5829C10.7091 14.4467 10.8063 14.2591 10.8296 14.0559L10.8346 13.9584L10.8313 9.37337L10.8255 9.27587C10.8014 9.07317 10.7037 8.88636 10.551 8.75088C10.3984 8.6154 10.2013 8.54067 9.99714 8.54087L9.99797 8.54004ZM10.0021 5.41587C9.72554 5.41587 9.46027 5.52575 9.26468 5.72134C9.0691 5.91692 8.95922 6.18219 8.95922 6.45879C8.95922 6.73539 9.0691 7.00066 9.26468 7.19624C9.46027 7.39183 9.72554 7.50171 10.0021 7.50171C10.139 7.50165 10.2746 7.47463 10.4011 7.42219C10.5275 7.36975 10.6424 7.29291 10.7392 7.19607C10.8359 7.09923 10.9127 6.98427 10.965 6.85777C11.0174 6.73127 11.0443 6.59569 11.0442 6.45879C11.0442 6.32189 11.0171 6.18633 10.9647 6.05987C10.9123 5.93341 10.8354 5.81852 10.7386 5.72175C10.6417 5.62499 10.5268 5.54824 10.4003 5.4959C10.2738 5.44356 10.1382 5.41665 10.0013 5.41671L10.0021 5.41587Z"
        fill={color}
      />
    </svg>
  );
};
export const EditIcon = ({ color }: PlayIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M2.25 13.3125C2.25 13.959 2.50681 14.579 2.96393 15.0361C3.42105 15.4932 4.04103 15.75 4.6875 15.75H8.37375L8.64075 14.6827C8.76225 14.1967 9.0135 13.7527 9.36825 13.3987L13.7947 8.9715C14.0488 8.71703 14.3555 8.52135 14.6933 8.39824C15.0311 8.27514 15.3918 8.22761 15.75 8.259V4.6875C15.75 4.04103 15.4932 3.42105 15.0361 2.96393C14.579 2.50681 13.959 2.25 13.3125 2.25H8.25V5.8125C8.25 6.1326 8.18695 6.44956 8.06446 6.74529C7.94196 7.04102 7.76241 7.30973 7.53607 7.53607C7.30973 7.76241 7.04102 7.94196 6.74529 8.06446C6.44956 8.18695 6.1326 8.25 5.8125 8.25H2.25V13.3125ZM7.125 2.58L2.58 7.125H5.8125C6.1606 7.125 6.49444 6.98672 6.74058 6.74058C6.98672 6.49444 7.125 6.1606 7.125 5.8125V2.58ZM14.325 9.5025L9.89775 13.929C9.63981 14.187 9.4568 14.5103 9.36825 14.8642L9.02475 16.2375C8.99059 16.3741 8.9924 16.5173 9.03002 16.653C9.06764 16.7887 9.13978 16.9124 9.2394 17.0119C9.33903 17.1115 9.46274 17.1835 9.59849 17.221C9.73424 17.2586 9.87739 17.2603 10.014 17.226L11.3865 16.8832C11.7408 16.7946 12.0644 16.6114 12.3225 16.353L16.749 11.9265C17.0581 11.6026 17.2282 11.1705 17.2229 10.7228C17.2176 10.2751 17.0375 9.84724 16.7209 9.53064C16.4043 9.21405 15.9764 9.03386 15.5287 9.0286C15.0809 9.02334 14.6489 9.19343 14.325 9.5025Z"
        fill={color}
      />
    </svg>
  );
};

export const BarChartIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.16699 15.8335C9.16699 16.0545 9.07919 16.2665 8.92291 16.4228C8.76663 16.579 8.55467 16.6668 8.33366 16.6668C8.11264 16.6668 7.90068 16.579 7.7444 16.4228C7.58812 16.2665 7.50033 16.0545 7.50033 15.8335V6.66683C7.50033 6.44582 7.58812 6.23385 7.7444 6.07757C7.90068 5.92129 8.11264 5.8335 8.33366 5.8335C8.55467 5.8335 8.76663 5.92129 8.92291 6.07757C9.07919 6.23385 9.16699 6.44582 9.16699 6.66683V15.8335ZM5.83366 15.8335C5.83366 16.0545 5.74586 16.2665 5.58958 16.4228C5.4333 16.579 5.22134 16.6668 5.00033 16.6668C4.77931 16.6668 4.56735 16.579 4.41107 16.4228C4.25479 16.2665 4.16699 16.0545 4.16699 15.8335V10.0002C4.16699 9.77915 4.25479 9.56719 4.41107 9.41091C4.56735 9.25463 4.77931 9.16683 5.00033 9.16683C5.22134 9.16683 5.4333 9.25463 5.58958 9.41091C5.74586 9.56719 5.83366 9.77915 5.83366 10.0002V15.8335ZM10.8337 15.8335V8.3335C10.8337 8.11248 10.9215 7.90052 11.0777 7.74424C11.234 7.58796 11.446 7.50016 11.667 7.50016C11.888 7.50016 12.1 7.58796 12.2562 7.74424C12.4125 7.90052 12.5003 8.11248 12.5003 8.3335V15.8335C12.5003 16.0545 12.4125 16.2665 12.2562 16.4228C12.1 16.579 11.888 16.6668 11.667 16.6668C11.446 16.6668 11.234 16.579 11.0777 16.4228C10.9215 16.2665 10.8337 16.0545 10.8337 15.8335ZM14.167 4.16683C14.167 3.94582 14.2548 3.73385 14.4111 3.57757C14.5673 3.42129 14.7793 3.3335 15.0003 3.3335C15.2213 3.3335 15.4333 3.42129 15.5896 3.57757C15.7459 3.73385 15.8337 3.94582 15.8337 4.16683V15.8335C15.8337 16.0545 15.7459 16.2665 15.5896 16.4228C15.4333 16.579 15.2213 16.6668 15.0003 16.6668C14.7793 16.6668 14.5673 16.579 14.4111 16.4228C14.2548 16.2665 14.167 16.0545 14.167 15.8335V4.16683Z"
        fill="#424242"
      />
    </svg>
  );
};

export const PhoneIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.16667 3.33325H7.5L9.16667 7.49992L7.08333 8.74992C7.9758 10.5595 9.44039 12.0241 11.25 12.9166L12.5 10.8333L16.6667 12.4999V15.8333C16.6667 16.7537 15.9205 17.4999 15 17.4999C8.27304 17.0911 2.9088 11.7269 2.5 4.99992C2.5 4.07944 3.24619 3.33325 4.16667 3.33325"
        fill="#212121"
      />
      <path
        d="M4.16667 3.33325H7.5L9.16667 7.49992L7.08333 8.74992C7.9758 10.5595 9.44039 12.0241 11.25 12.9166L12.5 10.8333L16.6667 12.4999V15.8333C16.6667 16.7537 15.9205 17.4999 15 17.4999C8.27304 17.0911 2.9088 11.7269 2.5 4.99992C2.5 4.07944 3.24619 3.33325 4.16667 3.33325"
        stroke="#212121"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.4999 5.8334V5.84173"
        stroke="#43A047"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.9999 5.8334V5.84173"
        stroke="#43A047"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.4999 5.8334V5.84173"
        stroke="#43A047"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CallHoldIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="51"
      height="51"
      viewBox="0 0 51 51"
      fill="none"
    >
      <circle cx="25.3198" cy="25.3198" r="25.3198" fill="#303740" />
      <path
        d="M22 35.301V14.6932C22 14.3094 21.775 14 21.4917 14H18.5083C18.225 14 18 14.3094 18 14.6932V35.301C18 35.6849 18.225 36 18.5083 36H21.4917C21.775 36 22 35.6906 22 35.301Z"
        fill="white"
      />
      <path
        d="M31.4917 14H28.5083C28.2292 14 28 14.3094 28 14.6932V35.301C28 35.6849 28.225 36 28.5083 36H31.4917C31.7708 36 32 35.6906 32 35.301V14.6932C32 14.3094 31.775 14 31.4917 14Z"
        fill="white"
      />
    </svg>
  );
};

export const VolumeIcon = () => {
  return (
    <svg
      width="31"
      height="23"
      viewBox="0 0 31 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M25.7744 21.821C26.1533 22.0996 26.6994 21.9882 27.0003 21.5424C28.9505 18.7229 30.1207 15.1456 30.1207 11.2116C30.1207 7.26657 28.9171 3.71154 27.0003 0.880897C26.6994 0.423982 26.1533 0.323683 25.7744 0.60229C25.3509 0.892041 25.2952 1.41582 25.5961 1.87274C27.3234 4.42478 28.4156 7.63433 28.4156 11.2116C28.4156 14.7778 27.3234 18.0097 25.5961 20.5505C25.2952 21.0075 25.3509 21.5312 25.7744 21.821ZM2.4717 15.7474H5.67011C5.77041 15.7474 5.85957 15.7808 5.93758 15.8477L10.9636 20.35C11.4986 20.8292 11.9109 21.052 12.4458 21.052C13.1591 21.052 13.7051 20.5283 13.7051 19.8039V2.70856C13.7051 1.98418 13.1591 1.39353 12.4235 1.39353C11.8886 1.39353 11.5431 1.63871 10.9636 2.16249L5.93758 6.6202C5.85957 6.68707 5.77041 6.7205 5.67011 6.7205H2.4717C0.956083 6.7205 0.209416 7.48945 0.209416 9.10537V13.3736C0.209416 14.9896 0.967227 15.7474 2.4717 15.7474ZM21.5953 18.8678C22.0076 19.1464 22.5203 19.0461 22.8212 18.6226C24.2476 16.6612 25.0834 13.9643 25.0834 11.2116C25.0834 8.45901 24.2588 5.7398 22.8212 3.8007C22.5203 3.37722 22.0076 3.27692 21.5953 3.55552C21.1829 3.83413 21.1161 4.35791 21.4393 4.81483C22.654 6.53105 23.3561 8.83791 23.3561 11.2116C23.3561 13.5854 22.6317 15.87 21.4393 17.6085C21.1272 18.0654 21.1829 18.5892 21.5953 18.8678ZM2.54971 14.1203C2.13738 14.1203 1.94792 13.9308 1.94792 13.5185V8.9605C1.94792 8.53702 2.13738 8.34756 2.54971 8.34756H6.11588C6.40564 8.34756 6.62852 8.29184 6.88484 8.05781L11.6323 3.74498C11.688 3.68926 11.7437 3.65582 11.8218 3.65582C11.8998 3.65582 11.9666 3.71154 11.9666 3.81184V18.6226C11.9666 18.7229 11.8998 18.7898 11.8218 18.7898C11.766 18.7898 11.6992 18.7563 11.6323 18.7006L6.88484 14.4101C6.62852 14.1872 6.40564 14.1203 6.11588 14.1203H2.54971ZM17.4719 15.9591C17.8397 16.2154 18.3634 16.1374 18.6643 15.7028C19.5225 14.5772 20.0351 12.9167 20.0351 11.2116C20.0351 9.50657 19.5225 7.85722 18.6643 6.7205C18.3634 6.28587 17.8397 6.19672 17.4719 6.46418C17.015 6.77622 16.9481 7.33343 17.2936 7.79035C17.94 8.68189 18.3077 9.91891 18.3077 11.2116C18.3077 12.5044 17.9288 13.7303 17.2936 14.6329C16.9593 15.101 17.015 15.6359 17.4719 15.9591Z"
        fill="white"
      />
    </svg>
  );
};

export const MicIcon = () => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 17 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.15088 16.1314C10.3686 16.1314 11.8619 14.4709 11.8619 12.0972V4.64169C11.8619 2.25682 10.3686 0.607464 8.15088 0.607464C5.92202 0.607464 4.42869 2.25682 4.42869 4.64169V12.0972C4.42869 14.4709 5.92202 16.1314 8.15088 16.1314ZM0.171575 12.2755C0.171575 16.6441 3.05794 19.7088 7.30391 20.0654V22.662H3.16939C2.70133 22.662 2.32242 23.0409 2.32242 23.509C2.32242 23.977 2.70133 24.3448 3.16939 24.3448H13.1212C13.5893 24.3448 13.9682 23.977 13.9682 23.509C13.9682 23.0409 13.5893 22.662 13.1212 22.662H8.9867V20.0654C13.2438 19.7088 16.119 16.6441 16.119 12.2755V10.0132C16.119 9.54518 15.7513 9.17741 15.2832 9.17741C14.8152 9.17741 14.4363 9.54518 14.4363 10.0132V12.2087C14.4363 16.0089 11.9622 18.5275 8.15088 18.5275C4.32839 18.5275 1.85436 16.0089 1.85436 12.2087V10.0132C1.85436 9.54518 1.4866 9.17741 1.0074 9.17741C0.539336 9.17741 0.171575 9.54518 0.171575 10.0132V12.2755Z"
        fill="white"
      />
    </svg>
  );
};

export const PauseIcon = ({ color }: PlayIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <rect
        x="5"
        y="4.16675"
        width="3.33333"
        height="11.6667"
        rx="1"
        fill={color ? color : "#212121"}
        stroke={color ? color : "#212121"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="11.6667"
        y="4.16675"
        width="3.33333"
        height="11.6667"
        rx="1"
        fill={color ? color : "#212121"}
        stroke={color ? color : "#212121"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const GroupDiscussionMeetingIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M12.0003 6.02125C12.0003 5.62453 11.9221 5.23169 11.7703 4.86516C11.6185 4.49864 11.396 4.16561 11.1155 3.88508C10.8349 3.60455 10.5019 3.38203 10.1354 3.23021C9.76885 3.07839 9.37601 3.00025 8.97929 3.00025H6.02129C5.62133 2.9951 5.22433 3.06944 4.85332 3.21894C4.48232 3.36843 4.14469 3.59012 3.86004 3.87113C3.57539 4.15215 3.34938 4.48689 3.19512 4.85594C3.04086 5.22499 2.96143 5.62101 2.96143 6.021C2.96143 6.42099 3.04086 6.81701 3.19512 7.18606C3.34938 7.55511 3.57539 7.88985 3.86004 8.17087C4.14469 8.45188 4.48232 8.67357 4.85332 8.82306C5.22433 8.97256 5.62133 9.0469 6.02129 9.04175H6.60029V10.5002C6.60029 10.5002 12.0003 9.77125 12.0003 6.02125ZM9.25029 14.0002C9.25029 15.1052 8.35529 16.0002 7.25029 16.0002C6.14529 16.0002 5.25029 15.1052 5.25029 14.0002C5.25029 12.8953 6.14529 12.0002 7.25029 12.0002C8.35529 12.0002 9.25029 12.8953 9.25029 14.0002ZM7.25029 17.0002C5.83179 17.0002 3.00029 17.7152 3.00029 19.1337V21.0002H11.5003V19.1337C11.5003 17.7147 8.66879 17.0002 7.25029 17.0002ZM16.7503 16.0002C17.8553 16.0002 18.7503 15.1052 18.7503 14.0002C18.7503 12.8953 17.8553 12.0002 16.7503 12.0002C15.6453 12.0002 14.7503 12.8953 14.7503 14.0002C14.7503 15.1052 15.6453 16.0002 16.7503 16.0002ZM16.7503 17.0002C15.3318 17.0002 12.5003 17.7152 12.5003 19.1337V21.0002H21.0003V19.1337C21.0003 17.7147 18.1688 17.0002 16.7503 17.0002ZM16.0213 3.50025C15.2201 3.50025 14.4517 3.81853 13.8851 4.38508C13.3186 4.95163 13.0003 5.72003 13.0003 6.52125C13.0003 10.2712 17.8003 11.0002 17.8003 11.0002V9.54175H17.9793C18.3793 9.5469 18.7763 9.47256 19.1473 9.32306C19.5183 9.17357 19.8559 8.95188 20.1405 8.67087C20.4252 8.38985 20.6512 8.05511 20.8055 7.68606C20.9597 7.31701 21.0392 6.92099 21.0392 6.521C21.0392 6.12101 20.9597 5.72499 20.8055 5.35594C20.6512 4.98689 20.4252 4.65215 20.1405 4.37113C19.8559 4.09012 19.5183 3.86843 19.1473 3.71894C18.7763 3.56944 18.3793 3.4951 17.9793 3.50025H16.0213Z"
        fill="#424242"
      />
    </svg>
  );
};

export const RingGroupIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="54"
      height="53"
      viewBox="0 0 54 53"
      fill="none"
    >
      <mask
        id="mask0_2820_197693"
        // style="mask-type:luminance"
        maskUnits="userSpaceOnUse"
        x="4"
        y="2"
        width="46"
        height="49"
      >
        <path
          d="M27 12.8292C29.311 12.8292 31.1848 10.9454 31.1848 8.62227C31.1848 6.30132 29.311 4.4165 27 4.4165C24.689 4.4165 22.8152 6.30021 22.8152 8.62338C22.8152 10.9454 24.689 12.8292 27 12.8292ZM11.3098 44.3763C13.6197 44.3763 15.4935 42.4937 15.4935 40.1705C15.4935 37.8474 13.6197 35.9636 11.3087 35.9636C8.99877 35.9648 7.125 37.8485 7.125 40.1716C7.125 42.4948 8.99877 44.3785 11.3098 44.3785V44.3763ZM42.6902 44.3763C45.0012 44.3763 46.875 42.4937 46.875 40.1705C46.875 37.8474 45.0012 35.9636 42.6902 35.9636C40.3792 35.9636 38.5054 37.8474 38.5054 40.1705C38.5054 42.4937 40.3792 44.3774 42.6902 44.3774V44.3763Z"
          fill="white"
          stroke="white"
          strokeWidth="4.41667"
          strokeLinejoin="round"
        />
        <path
          d="M37.0954 11.3884C40.0798 13.1616 42.551 15.6814 44.2658 18.6998C45.9806 21.7181 46.8798 25.131 46.875 28.6024C46.875 29.2406 46.8452 29.87 46.7867 30.4916M34.7446 47.01C32.2957 48.0515 29.6613 48.5868 27 48.5834C24.2529 48.5834 21.636 48.0236 19.2554 47.01M7.21335 30.4916C7.15466 29.8639 7.12518 29.2339 7.12502 28.6035C7.1202 25.1321 8.01945 21.7192 9.73423 18.7009C11.449 15.6825 13.9202 13.1627 16.9046 11.3895"
          stroke="white"
          strokeWidth="4.41667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </mask>
      <g mask="url(#mask0_2820_197693)">
        <path d="M0.5 0H53.5V53H0.5V0Z" fill="#F44336" />
      </g>
    </svg>
  );
};

export const VoiceRecordIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="41"
      height="40"
      viewBox="0 0 41 40"
      fill="none"
    >
      <mask
        id="mask0_2820_197053"
        maskUnits="userSpaceOnUse"
        x="6"
        y="1"
        width="29"
        height="38"
      >
        <path
          d="M26.3334 9.16658C26.3334 5.94492 23.7217 3.33325 20.5001 3.33325C17.2784 3.33325 14.6667 5.94492 14.6667 9.16658V19.9999C14.6667 23.2216 17.2784 25.8333 20.5001 25.8333C23.7217 25.8333 26.3334 23.2216 26.3334 19.9999V9.16658Z"
          fill="white"
          stroke="white"
          strokeWidth="3.33333"
          strokeLinejoin="round"
        />
        <path
          d="M8 19.1667C8 26.0701 13.5967 31.6667 20.5 31.6667M20.5 31.6667C27.4033 31.6667 33 26.0701 33 19.1667M20.5 31.6667V36.6667"
          stroke="white"
          strokeWidth="3.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </mask>
      <g mask="url(#mask0_2820_197053)">
        <path d="M0.5 0H40.5V40H0.5V0Z" fill="#424242" />
      </g>
    </svg>
  );
};

export const UploadMediaIcon = ({ color }: PlayIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="41"
      height="40"
      viewBox="0 0 41 40"
      fill="none"
    >
      <path
        d="M12.1156 12.1344C11.9994 12.0183 11.9072 11.8804 11.8443 11.7287C11.7814 11.5769 11.749 11.4143 11.749 11.25C11.749 11.0857 11.7814 10.9231 11.8443 10.7713C11.9072 10.6196 11.9994 10.4817 12.1156 10.3656L19.6156 2.86563C19.7317 2.74941 19.8696 2.65721 20.0213 2.59431C20.1731 2.5314 20.3357 2.49902 20.5 2.49902C20.6643 2.49902 20.8269 2.5314 20.9787 2.59431C21.1304 2.65721 21.2683 2.74941 21.3844 2.86563L28.8844 10.3656C29.1189 10.6002 29.2507 10.9183 29.2507 11.25C29.2507 11.5817 29.1189 11.8998 28.8844 12.1344C28.6498 12.3689 28.3317 12.5007 28 12.5007C27.6683 12.5007 27.3502 12.3689 27.1156 12.1344L21.75 6.76719V20C21.75 20.3315 21.6183 20.6495 21.3839 20.8839C21.1495 21.1183 20.8315 21.25 20.5 21.25C20.1685 21.25 19.8505 21.1183 19.6161 20.8839C19.3817 20.6495 19.25 20.3315 19.25 20V6.76719L13.8844 12.1344C13.7683 12.2506 13.6304 12.3428 13.4787 12.4057C13.3269 12.4686 13.1643 12.501 13 12.501C12.8357 12.501 12.6731 12.4686 12.5213 12.4057C12.3696 12.3428 12.2317 12.2506 12.1156 12.1344ZM38 21.25V31.25C38 31.913 37.7366 32.5489 37.2678 33.0178C36.7989 33.4866 36.163 33.75 35.5 33.75H5.5C4.83696 33.75 4.20107 33.4866 3.73223 33.0178C3.26339 32.5489 3 31.913 3 31.25V21.25C3 20.587 3.26339 19.9511 3.73223 19.4822C4.20107 19.0134 4.83696 18.75 5.5 18.75H16.125C16.2908 18.75 16.4497 18.8159 16.5669 18.9331C16.6842 19.0503 16.75 19.2092 16.75 19.375V19.9156C16.75 22.0172 18.4688 23.7891 20.5719 23.75C21.5539 23.7312 22.4894 23.3278 23.1772 22.6266C23.865 21.9253 24.2502 20.9822 24.25 20V19.375C24.25 19.2092 24.3158 19.0503 24.4331 18.9331C24.5503 18.8159 24.7092 18.75 24.875 18.75H35.5C36.163 18.75 36.7989 19.0134 37.2678 19.4822C37.7366 19.9511 38 20.587 38 21.25ZM31.75 26.25C31.75 25.8792 31.64 25.5167 31.434 25.2083C31.228 24.9 30.9351 24.6596 30.5925 24.5177C30.2499 24.3758 29.8729 24.3387 29.5092 24.411C29.1455 24.4834 28.8114 24.662 28.5492 24.9242C28.287 25.1864 28.1084 25.5205 28.036 25.8842C27.9637 26.2479 28.0008 26.6249 28.1427 26.9675C28.2846 27.3101 28.525 27.603 28.8333 27.809C29.1416 28.015 29.5042 28.125 29.875 28.125C30.3723 28.125 30.8492 27.9275 31.2008 27.5758C31.5525 27.2242 31.75 26.7473 31.75 26.25Z"
        fill={color ? color : "#424242"}
      />
    </svg>
  );
};

export const LeadCenterIcon = ({ color }: PlayIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M11.25 7.875C11.25 8.20876 11.151 8.53502 10.9656 8.81252C10.7802 9.09003 10.5166 9.30632 10.2083 9.43405C9.89993 9.56177 9.56063 9.59519 9.23329 9.53008C8.90594 9.46496 8.60526 9.30424 8.36926 9.06824C8.13326 8.83224 7.97254 8.53156 7.90743 8.20422C7.84231 7.87687 7.87573 7.53757 8.00346 7.22922C8.13118 6.92087 8.34747 6.65732 8.62498 6.4719C8.90248 6.28647 9.22875 6.1875 9.5625 6.1875C10.0101 6.1875 10.4393 6.36529 10.7557 6.68176C11.0722 6.99822 11.25 7.42745 11.25 7.875ZM15.75 2.8125V15.1875C15.75 15.4859 15.6315 15.772 15.4205 15.983C15.2095 16.194 14.9234 16.3125 14.625 16.3125H4.5C4.20163 16.3125 3.91549 16.194 3.70451 15.983C3.49353 15.772 3.375 15.4859 3.375 15.1875V13.5H2.25C2.10082 13.5 1.95774 13.4407 1.85225 13.3352C1.74677 13.2298 1.6875 13.0867 1.6875 12.9375C1.6875 12.7883 1.74677 12.6452 1.85225 12.5398C1.95774 12.4343 2.10082 12.375 2.25 12.375H3.375V9.5625H2.25C2.10082 9.5625 1.95774 9.50324 1.85225 9.39775C1.74677 9.29226 1.6875 9.14918 1.6875 9C1.6875 8.85082 1.74677 8.70774 1.85225 8.60225C1.95774 8.49676 2.10082 8.4375 2.25 8.4375H3.375V5.625H2.25C2.10082 5.625 1.95774 5.56574 1.85225 5.46025C1.74677 5.35476 1.6875 5.21168 1.6875 5.0625C1.6875 4.91332 1.74677 4.77024 1.85225 4.66475C1.95774 4.55926 2.10082 4.5 2.25 4.5H3.375V2.8125C3.375 2.51413 3.49353 2.22798 3.70451 2.017C3.91549 1.80603 4.20163 1.6875 4.5 1.6875H14.625C14.9234 1.6875 15.2095 1.80603 15.4205 2.017C15.6315 2.22798 15.75 2.51413 15.75 2.8125ZM13.3875 11.475C12.8894 10.8072 12.2252 10.2814 11.4609 9.94992C11.8798 9.56752 12.1732 9.06742 12.3028 8.51526C12.4323 7.9631 12.3919 7.38468 12.1868 6.85591C11.9817 6.32713 11.6216 5.87271 11.1536 5.55228C10.6857 5.23185 10.1318 5.06038 9.56461 5.06038C8.99746 5.06038 8.44356 5.23185 7.9756 5.55228C7.50764 5.87271 7.14749 6.32713 6.94241 6.85591C6.73734 7.38468 6.69692 7.9631 6.82646 8.51526C6.95599 9.06742 7.24944 9.56752 7.66828 9.94992C6.90246 10.2808 6.23675 10.8066 5.7375 11.475C5.69318 11.5341 5.66093 11.6013 5.6426 11.6729C5.62427 11.7445 5.62021 11.8189 5.63066 11.892C5.6411 11.9652 5.66585 12.0355 5.70349 12.0991C5.74112 12.1627 5.79091 12.2182 5.85 12.2625C5.9091 12.3068 5.97634 12.3391 6.0479 12.3574C6.11946 12.3757 6.19393 12.3798 6.26705 12.3693C6.34018 12.3589 6.41053 12.3342 6.47409 12.2965C6.53765 12.2589 6.59318 12.2091 6.6375 12.15C6.97807 11.6959 7.41969 11.3273 7.92738 11.0735C8.43507 10.8197 8.99489 10.6875 9.5625 10.6875C10.1301 10.6875 10.6899 10.8197 11.1976 11.0735C11.7053 11.3273 12.1469 11.6959 12.4875 12.15C12.577 12.2693 12.7103 12.3482 12.858 12.3693C13.0056 12.3904 13.1557 12.352 13.275 12.2625C13.3943 12.173 13.4733 12.0397 13.4943 11.892C13.5154 11.7444 13.477 11.5943 13.3875 11.475Z"
        fill="#424242"
      />
    </svg>
  );
};

export const BroadcastIcon = ({ color }: PlayIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <g clip-path="url(#clip0_26_519)">
        <path
          d="M9.675 9.6C10.0274 9.46965 10.3314 9.2344 10.5459 8.92596C10.7605 8.61753 10.8753 8.25073 10.875 7.875C10.875 7.37772 10.6775 6.90081 10.3258 6.54917C9.9742 6.19754 9.49728 6 9 6C8.50272 6 8.02581 6.19754 7.67418 6.54917C7.32255 6.90081 7.125 7.37772 7.125 7.875C7.12467 8.25073 7.23952 8.61753 7.45409 8.92596C7.66865 9.2344 7.97261 9.46965 8.325 9.6L5.6625 16.0125C5.55 16.275 5.6625 16.5 5.85 16.5H12.15C12.3375 16.5 12.45 16.275 12.3375 16.0125L9.675 9.6Z"
          fill="#424242"
        />
        <path
          d="M6.5625 11.775C6.68927 11.6201 6.75536 11.4243 6.74846 11.2242C6.74156 11.0241 6.66214 10.8334 6.525 10.6875C6.12598 10.3356 5.8064 9.90282 5.5875 9.41791C5.3686 8.93299 5.25539 8.40705 5.25539 7.87502C5.25539 7.34298 5.3686 6.81704 5.5875 6.33213C5.8064 5.84721 6.12598 5.41442 6.525 5.06252C6.66214 4.91666 6.74156 4.72591 6.74846 4.52583C6.75536 4.32574 6.68927 4.12998 6.5625 3.97502C6.41664 3.83788 6.2259 3.75846 6.02581 3.75156C5.82573 3.74466 5.62996 3.81075 5.475 3.93752C4.93496 4.44214 4.50346 5.05156 4.20687 5.72856C3.91028 6.40556 3.75483 7.13592 3.75 7.87502C3.75483 8.61412 3.91028 9.34448 4.20687 10.0215C4.50346 10.6985 4.93496 11.3079 5.475 11.8125C5.62996 11.9393 5.82573 12.0054 6.02581 11.9985C6.2259 11.9916 6.41664 11.9122 6.5625 11.775Z"
          fill="#424242"
        />
        <path
          d="M12.525 3.93752C12.3737 3.80263 12.1763 3.73125 11.9737 3.73823C11.7712 3.74522 11.5791 3.83003 11.4375 3.97502C11.3107 4.12998 11.2446 4.32574 11.2515 4.52583C11.2584 4.72591 11.3379 4.91666 11.475 5.06252C11.874 5.41442 12.1936 5.84721 12.4125 6.33213C12.6314 6.81704 12.7446 7.34298 12.7446 7.87502C12.7446 8.40705 12.6314 8.93299 12.4125 9.41791C12.1936 9.90282 11.874 10.3356 11.475 10.6875C11.3727 10.8353 11.3241 11.0136 11.3372 11.1929C11.3503 11.3721 11.4243 11.5415 11.5469 11.6729C11.6695 11.8043 11.8334 11.8898 12.0113 11.9152C12.1893 11.9406 12.3705 11.9044 12.525 11.8125C13.0681 11.3104 13.5014 10.7014 13.7978 10.0238C14.0941 9.34621 14.2471 8.61461 14.2471 7.87502C14.2471 7.13542 14.0941 6.40383 13.7978 5.72621C13.5014 5.04859 13.0681 4.4396 12.525 3.93752Z"
          fill="#424242"
        />
        <path
          d="M14.775 2.10001C14.6306 1.99169 14.4519 1.9391 14.2718 1.9519C14.0918 1.9647 13.9223 2.04202 13.7947 2.16968C13.667 2.29734 13.5897 2.46676 13.5769 2.64685C13.5641 2.82693 13.6167 3.00558 13.725 3.15001C14.3649 3.75943 14.8743 4.49248 15.2224 5.30469C15.5705 6.1169 15.75 6.99135 15.75 7.87501C15.75 8.75867 15.5705 9.63312 15.2224 10.4453C14.8743 11.2575 14.3649 11.9906 13.725 12.6C13.6167 12.7444 13.5641 12.9231 13.5769 13.1032C13.5897 13.2833 13.667 13.4527 13.7947 13.5803C13.9223 13.708 14.0918 13.7853 14.2718 13.7981C14.4519 13.8109 14.6306 13.7583 14.775 13.65C15.5555 12.9042 16.1767 12.008 16.6011 11.0154C17.0256 10.0228 17.2444 8.95453 17.2444 7.87501C17.2444 6.7955 17.0256 5.72719 16.6011 4.73461C16.1767 3.74203 15.5555 2.84579 14.775 2.10001Z"
          fill="#424242"
        />
        <path
          d="M2.25 7.87501C2.25216 6.99169 2.43263 6.11789 2.78059 5.30598C3.12855 4.49407 3.63684 3.76077 4.275 3.15001C4.38332 3.00558 4.43591 2.82693 4.42312 2.64685C4.41032 2.46676 4.33299 2.29734 4.20533 2.16968C4.07767 2.04202 3.90825 1.9647 3.72817 1.9519C3.54809 1.9391 3.36943 1.99169 3.225 2.10001C2.44451 2.84579 1.82329 3.74203 1.39886 4.73461C0.974434 5.72719 0.755611 6.7955 0.755611 7.87501C0.755611 8.95453 0.974434 10.0228 1.39886 11.0154C1.82329 12.008 2.44451 12.9042 3.225 13.65C3.36943 13.7583 3.54809 13.8109 3.72817 13.7981C3.90825 13.7853 4.07767 13.708 4.20533 13.5803C4.33299 13.4527 4.41032 13.2833 4.42312 13.1032C4.43591 12.9231 4.38332 12.7444 4.275 12.6C3.63684 11.9893 3.12855 11.256 2.78059 10.444C2.43263 9.63214 2.25216 8.75834 2.25 7.87501Z"
          fill="#424242"
        />
      </g>
      <defs>
        <clipPath id="clip0_26_519">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const PowerDialerIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M16.5 12.7516C16.4993 14.9048 14.9862 16.7045 12.9654 17.1462L12.4869 15.7107C13.3899 15.5633 14.1574 15.0128 14.5987 14.25H12.75C11.9216 14.25 11.25 13.5785 11.25 12.75V9.75C11.25 8.92155 11.9216 8.25 12.75 8.25H14.9536C14.5845 5.29027 12.0597 3 9 3C5.94029 3 3.41549 5.29027 3.04642 8.25H5.25C6.07843 8.25 6.75 8.92155 6.75 9.75V12.75C6.75 13.5785 6.07843 14.25 5.25 14.25H3C2.17157 14.25 1.5 13.5785 1.5 12.75V9C1.5 4.85786 4.85786 1.5 9 1.5C13.1421 1.5 16.5 4.85786 16.5 9V9.74903V9.75V12.75V12.7516Z"
        fill="#424242"
      />
    </svg>
  );
};

export const BDCCampaignIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M15.75 7.54725V3C15.75 2.58579 15.4142 2.25 15 2.25H14.25C12.7661 3.73398 9.97703 4.56546 8.25 4.95961V13.0404C9.97703 13.4345 12.7661 14.2661 14.25 15.75H15C15.4142 15.75 15.75 15.4142 15.75 15V10.4528C16.397 10.2863 16.875 9.69893 16.875 9C16.875 8.30107 16.397 7.71375 15.75 7.54725ZM3.75 5.25C2.92157 5.25 2.25 5.92157 2.25 6.75V11.25C2.25 12.0785 2.92157 12.75 3.75 12.75H4.5L5.25 16.5H6.75V5.25H3.75Z"
        fill="#424242"
      />
    </svg>
  );
};
export const DashboardIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M3.3321 2.89944H15.5926L17.9258 2.91066L18.5315 2.92188L18.6325 2.94431L18.7222 3.0004L18.8792 3.15744L18.9465 3.26961L18.9578 3.31448V13.1408L18.9465 13.4998L18.9129 13.6119L18.8456 13.7241L18.711 13.8587L18.5764 13.926L18.4979 13.9372L18.2511 13.9485L12.8444 13.9597H12.104L11.7114 13.9485L11.7226 14.3859L11.7563 14.8234L11.8011 15.1824L11.8236 15.4291L11.8684 15.575L11.947 15.7544L12.0367 15.889L12.1601 16.0237L12.3059 16.147L12.4854 16.2592L12.6873 16.3714L12.9453 16.5396L13.0799 16.6294L13.1921 16.7303L13.237 16.7976L13.2594 16.9098L13.2033 16.9435L13.0911 16.9659L11.3188 16.9771H8.73883L7.2245 16.9659L6.91041 16.9547L6.84311 16.921L6.82068 16.8762L6.83189 16.7864L6.88798 16.6967L6.9665 16.6294L7.15719 16.5172L7.37032 16.3826L7.57223 16.2704L7.77414 16.147L7.89753 16.0461L7.97605 15.9676L8.05458 15.8554L8.18918 15.5974L8.23405 15.4516L8.32379 14.6776L8.34622 14.3523L8.36866 13.9597L1.67195 13.9485L1.49247 13.926L1.36908 13.8587L1.23447 13.7353L1.14474 13.6119L1.1223 13.5446L1.11108 13.4437V3.29205L1.15595 3.20231L1.25691 3.09014L1.35786 2.98918L1.45882 2.9331L1.50369 2.92188L1.66073 2.91066L3.3321 2.89944Z"
        fill="#FEFEFE"
      />
      <path
        d="M3.3321 2.89944H15.5926L17.9258 2.91066L18.5315 2.92188L18.6325 2.94431L18.7222 3.0004L18.8792 3.15744L18.9465 3.26961L18.9578 3.31448V13.1408L18.9465 13.4998L18.9129 13.6119L18.8456 13.7241L18.711 13.8587L18.5764 13.926L18.4979 13.9372L18.2511 13.9485L12.8444 13.9597H12.104L11.7114 13.9485L11.7226 14.3859L11.7563 14.8234L11.8011 15.1824L11.8236 15.4291L11.8684 15.575L11.947 15.7544L12.0367 15.889L12.1601 16.0237L12.3059 16.147L12.4854 16.2592L12.6873 16.3714L12.9453 16.5396L13.0799 16.6294L13.1921 16.7303L13.237 16.7976L13.2594 16.9098L13.2033 16.9435L13.0911 16.9659L11.3188 16.9771H8.73883L7.2245 16.9659L6.91041 16.9547L6.84311 16.921L6.82068 16.8762L6.83189 16.7864L6.88798 16.6967L6.9665 16.6294L7.15719 16.5172L7.37032 16.3826L7.57223 16.2704L7.77414 16.147L7.89753 16.0461L7.97605 15.9676L8.05458 15.8554L8.18918 15.5974L8.23405 15.4516L8.32379 14.6776L8.34622 14.3523L8.36866 13.9597L1.67195 13.9485L1.49247 13.926L1.36908 13.8587L1.23447 13.7353L1.14474 13.6119L1.1223 13.5446L1.11108 13.4437V3.29205L1.15595 3.20231L1.25691 3.09014L1.35786 2.98918L1.45882 2.9331L1.50369 2.92188L1.66073 2.91066L3.3321 2.89944ZM1.97481 3.71831L1.94116 3.74074L1.92994 4.22308L1.91873 8.12669V12.6697L1.92994 12.8379L1.94116 12.8492L2.06455 12.8604L9.23239 12.8492H17.8921L18.1277 12.8379L18.1389 12.8267L18.1277 3.74074L18.1165 3.72952L17.6229 3.71831H1.97481Z"
        fill="#424242"
      />
      <path
        d="M13.7081 5.59164H13.753V8.39596L13.8091 8.50814L13.9773 8.76613L14.1007 8.96804L14.2914 9.25969L14.4485 9.50647L14.7625 9.9776L14.8859 10.1683L15.0766 10.4599L15.2337 10.7179L15.2898 10.8189V10.8525L15.1551 10.9086L14.9757 10.9759L14.7177 11.0657L14.5606 11.1105L14.1344 11.2003L14.0446 11.2115H13.8652L13.5623 11.1666L13.2258 11.0881L12.8668 10.9647L12.5527 10.8189L12.3845 10.7179L12.2162 10.5833L12.0704 10.4712L11.9246 10.3478L11.8124 10.2244L11.7002 10.0786L11.5544 9.88786L11.4198 9.64108L11.2964 9.34943L11.2067 9.04656L11.1169 8.59787L11.1057 8.50814V8.36231L11.1281 8.14918L11.2291 7.67806L11.2964 7.45371L11.3974 7.20693L11.532 6.94893L11.6666 6.75824L11.79 6.61242L11.8909 6.48903L12.0592 6.32077L12.3396 6.09642L12.4967 5.99547L12.6649 5.90573L12.9678 5.78234L13.2706 5.68138L13.652 5.60286L13.7081 5.59164Z"
        fill="#424242"
      />
      <path
        d="M16.6023 6.89285L16.6359 6.9265L16.793 7.28546L16.8939 7.55467L16.95 7.79023L16.9837 8.04823L16.9949 8.22771V8.6764L16.9612 8.96805L16.9164 9.19239L16.8491 9.3943L16.7032 9.71961L16.5799 9.96639L16.5013 10.0898L16.4116 10.2132L16.3106 10.3253L16.1536 10.5048H16.1312L16.1087 10.5497L16.0078 10.6506L15.918 10.7292L15.8283 10.7965L15.7834 10.8189H15.7498L15.7049 10.7628L15.6376 10.6282L15.4918 10.3926L15.3235 10.1346L15.2001 9.94395L15.0319 9.68595L14.9085 9.49526L14.8075 9.33822L14.5607 8.96805L14.4822 8.85588L14.3925 8.72127L14.314 8.59788V8.54179L14.5607 8.38475L14.7514 8.25014L14.9085 8.12675L15.1328 7.95849L15.2899 7.84632L15.4245 7.74537L15.5927 7.62198L15.7834 7.48737L15.9853 7.33033L16.1312 7.21815L16.2882 7.10598L16.4789 6.97137L16.6023 6.89285Z"
        fill="#424242"
      />
      <path
        d="M8.30132 7.71167H9.10896L9.24357 7.72289L9.27722 7.79019L9.28844 8.00332V9.83173L9.27722 11.0208L9.25478 11.1554L9.23235 11.189L9.09774 11.2115H8.42471L8.24523 11.189L8.18914 11.1554L8.14427 11.0656L8.13306 11.0095V7.96967L8.14427 7.77897L8.16671 7.7341L8.18914 7.72289L8.30132 7.71167Z"
        fill="#424242"
      />
      <path
        d="M8.13317 5.40094H9.14272L9.2549 5.41216L9.27733 5.49068L9.28855 5.72624V6.83675L9.26611 6.89284L9.15394 6.91527H8.96325L8.94081 6.84797L8.92959 6.71336L8.91838 6.07398L8.87351 6.09641L8.76134 6.24224L8.62673 6.39928L8.4809 6.55632L8.37995 6.67971L8.25656 6.81432L8.13317 6.97136L8.03221 7.07231L7.95369 7.16205L7.85274 7.26301L7.77422 7.35275L7.63961 7.50979L7.48257 7.67805L7.38161 7.80144L7.28066 7.91361L7.12361 8.07065L7.06753 8.1043L6.97779 8.08187L6.77588 7.93604L6.67492 7.85752L6.51788 7.72292L6.29354 7.55466L6.11406 7.40883L5.95702 7.28544L5.75511 7.1284L5.64293 7.03866L5.48589 6.90405L5.37372 6.81432L5.31763 6.8031L5.10451 7.01623L5.01477 7.09475L4.88016 7.21814L4.73434 7.35275L4.54364 7.53222L4.39782 7.66683L4.21834 7.83509L4.08373 7.95848L4.02765 8.01456H4.00521V8.037L3.91547 8.11552L3.65748 8.37352L3.56774 8.45204L3.46678 8.54178L3.33218 8.64273L3.20879 8.6876L3.16392 8.67638L3.0854 8.55299L3.04053 8.45204L3.14148 8.30621L3.23122 8.22769L3.34339 8.12674L3.46678 8.02578L3.64626 7.85752L3.81452 7.70048L4.00521 7.521L4.11739 7.40883L4.20712 7.33031L4.33051 7.20692L4.42025 7.1284L4.59973 6.96014L4.7119 6.85919L4.88016 6.70214L5.05964 6.52267L5.14937 6.44415L5.2279 6.36563L5.28398 6.33197L5.3625 6.34319L5.51954 6.45536L5.66537 6.57875L5.97945 6.82553L6.12528 6.93771L6.32719 7.09475L6.48423 7.21814L6.66371 7.36396L6.86562 7.521L6.98901 7.61074H7.02266L7.07875 7.56587H7.10118L7.12361 7.521L7.28066 7.35275L7.41526 7.1957L7.57231 7.02744L7.67326 6.90405L7.79665 6.75823L7.96491 6.57875L8.04343 6.48902L8.14439 6.37684L8.22291 6.2871L8.3463 6.1525L8.44725 6.02911L8.59308 5.87207L8.66038 5.77111L8.6716 5.74868H7.86395L7.763 5.71502L7.74056 5.61407L7.75178 5.46824L7.80787 5.41216L8.13317 5.40094Z"
        fill="#424242"
      />
      <path
        d="M14.1567 5.38968L14.2689 5.4009L14.7176 5.47942L14.8858 5.52429L15.1775 5.63646L15.3906 5.73741L15.6486 5.89446L15.8618 6.0515L16.0188 6.18611L16.131 6.28706L16.3104 6.47775L16.3665 6.54506L16.3553 6.57871L16.1646 6.71332L15.9627 6.85914L15.8057 6.97131L15.615 7.11714L15.4131 7.26296L15.1999 7.42001L14.998 7.57705L14.7849 7.73409L14.6054 7.8687L14.4259 8.01452L14.3025 8.11548L14.1904 8.194L14.1455 8.20521L14.1567 7.87991V5.38968Z"
        fill="#424242"
      />
      <path
        d="M4.8239 8.30621H5.8671L5.88954 8.33987L5.90075 8.39595V10.4487L5.88954 10.9647L5.85588 11.1442L5.84467 11.1666L5.74371 11.2003L5.65397 11.2115H5.11554L4.92485 11.2003L4.8239 11.1778L4.77903 11.1217L4.75659 10.9984V8.32865L4.8239 8.30621Z"
        fill="#424242"
      />
      <path
        d="M6.57383 8.87823H7.44878L7.58338 8.91189L7.5946 8.94554V10.931L7.56095 11.1105L7.51608 11.1778L7.41512 11.2114H6.84304L6.6187 11.2002L6.52896 11.189L6.49531 11.1553L6.47287 11.0768L6.46166 10.9759L6.45044 10.3701V9.1811L6.46166 8.91189L6.48409 8.88945L6.57383 8.87823Z"
        fill="#424242"
      />
      <path
        d="M3.28709 9.46161H3.82552L4.18447 9.47283L4.19569 9.49526L4.20691 9.64109V10L4.19569 10.9872L4.16204 11.1554L4.10595 11.2003L4.03865 11.2115H3.20857L3.11883 11.2003L3.08518 11.0993L3.07396 10.9984L3.06274 9.77569L3.07396 9.47283L3.28709 9.46161Z"
        fill="#424242"
      />
    </svg>
  );
};

export const LiveTrackingIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M9.5625 5.0625V8.09016L12.1233 6.80907C12.1894 6.77601 12.2614 6.7563 12.3351 6.75106C12.4088 6.74582 12.4829 6.75515 12.553 6.77853C12.6231 6.8019 12.6879 6.83886 12.7438 6.88729C12.7996 6.93572 12.8454 6.99467 12.8784 7.06078C12.9115 7.1269 12.9312 7.19887 12.9364 7.2726C12.9417 7.34633 12.9324 7.42037 12.909 7.4905C12.8856 7.56062 12.8486 7.62545 12.8002 7.68129C12.7518 7.73713 12.6928 7.78288 12.6267 7.81594L9.25172 9.50344C9.16593 9.54637 9.07059 9.56665 8.97475 9.56234C8.87892 9.55803 8.78578 9.52929 8.70418 9.47884C8.62259 9.42839 8.55525 9.35791 8.50858 9.2741C8.4619 9.19029 8.43743 9.09593 8.4375 9V5.0625C8.4375 4.91332 8.49676 4.77025 8.60225 4.66476C8.70774 4.55927 8.85082 4.5 9 4.5C9.14919 4.5 9.29226 4.55927 9.39775 4.66476C9.50324 4.77025 9.5625 4.91332 9.5625 5.0625ZM9 15.1875C7.77623 15.1875 6.57994 14.8246 5.56241 14.1447C4.54488 13.4648 3.75181 12.4985 3.2835 11.3679C2.81518 10.2372 2.69265 8.99314 2.93139 7.79288C3.17014 6.59262 3.75944 5.49012 4.62478 4.62478C5.49012 3.75944 6.59262 3.17014 7.79288 2.93139C8.99314 2.69265 10.2372 2.81518 11.3679 3.2835C12.4985 3.75182 13.4648 4.54488 14.1447 5.56241C14.8246 6.57994 15.1875 7.77623 15.1875 9C15.1875 9.14919 15.2468 9.29226 15.3523 9.39775C15.4577 9.50324 15.6008 9.5625 15.75 9.5625C15.8992 9.5625 16.0423 9.50324 16.1477 9.39775C16.2532 9.29226 16.3125 9.14919 16.3125 9C16.3125 7.55373 15.8836 6.13993 15.0801 4.9374C14.2766 3.73486 13.1346 2.7976 11.7984 2.24413C10.4622 1.69067 8.99189 1.54586 7.5734 1.82801C6.15492 2.11017 4.85195 2.80661 3.82928 3.82928C2.80661 4.85196 2.11016 6.15492 1.82801 7.57341C1.54585 8.99189 1.69067 10.4622 2.24413 11.7984C2.7976 13.1346 3.73486 14.2766 4.93739 15.0801C6.13993 15.8836 7.55373 16.3125 9 16.3125C9.14919 16.3125 9.29226 16.2532 9.39775 16.1478C9.50324 16.0423 9.5625 15.8992 9.5625 15.75C9.5625 15.6008 9.50324 15.4577 9.39775 15.3523C9.29226 15.2468 9.14919 15.1875 9 15.1875ZM15.0905 13.9655C15.4053 13.6509 15.6197 13.25 15.7067 12.8135C15.7936 12.377 15.7491 11.9245 15.5789 11.5133C15.4086 11.102 15.1202 10.7506 14.7502 10.5033C14.3801 10.256 13.9451 10.124 13.5 10.124C13.0549 10.124 12.6199 10.256 12.2498 10.5033C11.8798 10.7506 11.5914 11.102 11.4211 11.5133C11.2509 11.9245 11.2064 12.377 11.2933 12.8135C11.3803 13.25 11.5947 13.6509 11.9095 13.9655C11.3172 14.3439 10.888 14.9303 10.7065 15.6094C10.685 15.6924 10.6829 15.7792 10.7001 15.8632C10.7174 15.9472 10.7536 16.0262 10.8061 16.094C10.8585 16.1619 10.9258 16.2168 11.0027 16.2547C11.0797 16.2926 11.1642 16.3123 11.25 16.3125H15.75C15.8362 16.3125 15.9213 16.2927 15.9986 16.2546C16.0759 16.2165 16.1435 16.1611 16.196 16.0927C16.2485 16.0244 16.2847 15.9448 16.3016 15.8603C16.3185 15.7758 16.3157 15.6885 16.2935 15.6052C16.1111 14.9277 15.682 14.3428 15.0905 13.9655Z"
        fill="#424242"
      />
    </svg>
  );
};
export const SarahAIIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M14.0625 3.375H9.5625V1.125C9.5625 0.975816 9.50324 0.832742 9.39775 0.727252C9.29226 0.621763 9.14919 0.5625 9 0.5625C8.85082 0.5625 8.70774 0.621763 8.60225 0.727252C8.49677 0.832742 8.4375 0.975816 8.4375 1.125V3.375H3.9375C3.34076 3.375 2.76847 3.61205 2.34651 4.03401C1.92455 4.45597 1.6875 5.02826 1.6875 5.625V13.5C1.6875 14.0967 1.92455 14.669 2.34651 15.091C2.76847 15.5129 3.34076 15.75 3.9375 15.75H14.0625C14.6592 15.75 15.2315 15.5129 15.6535 15.091C16.0754 14.669 16.3125 14.0967 16.3125 13.5V5.625C16.3125 5.02826 16.0754 4.45597 15.6535 4.03401C15.2315 3.61205 14.6592 3.375 14.0625 3.375ZM12.0938 6.75C12.2606 6.75 12.4238 6.79948 12.5625 6.8922C12.7013 6.98491 12.8094 7.11669 12.8733 7.27086C12.9371 7.42504 12.9538 7.59469 12.9213 7.75836C12.8887 7.92203 12.8084 8.07237 12.6904 8.19037C12.5724 8.30837 12.422 8.38873 12.2584 8.42129C12.0947 8.45384 11.925 8.43713 11.7709 8.37327C11.6167 8.30941 11.4849 8.20127 11.3922 8.06251C11.2995 7.92376 11.25 7.76063 11.25 7.59375C11.25 7.36997 11.3389 7.15536 11.4971 6.99713C11.6554 6.83889 11.87 6.75 12.0938 6.75ZM6.75 12.9375H5.625C5.32663 12.9375 5.04049 12.819 4.82951 12.608C4.61853 12.397 4.5 12.1109 4.5 11.8125C4.5 11.5141 4.61853 11.228 4.82951 11.017C5.04049 10.806 5.32663 10.6875 5.625 10.6875H6.75V12.9375ZM5.90625 8.4375C5.73937 8.4375 5.57624 8.38802 5.43749 8.2953C5.29874 8.20259 5.19059 8.07081 5.12673 7.91664C5.06287 7.76246 5.04616 7.59281 5.07871 7.42914C5.11127 7.26547 5.19163 7.11513 5.30963 6.99713C5.42763 6.87913 5.57797 6.79877 5.74164 6.76621C5.90532 6.73366 6.07497 6.75037 6.22914 6.81423C6.38332 6.87809 6.51509 6.98623 6.6078 7.12499C6.70052 7.26374 6.75 7.42687 6.75 7.59375C6.75 7.81753 6.66111 8.03214 6.50287 8.19037C6.34464 8.34861 6.13003 8.4375 5.90625 8.4375ZM10.125 12.9375H7.875V10.6875H10.125V12.9375ZM12.375 12.9375H11.25V10.6875H12.375C12.6734 10.6875 12.9595 10.806 13.1705 11.017C13.3815 11.228 13.5 11.5141 13.5 11.8125C13.5 12.1109 13.3815 12.397 13.1705 12.608C12.9595 12.819 12.6734 12.9375 12.375 12.9375Z"
        fill="#424242"
      />
    </svg>
  );
};

export const CalenderIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M14.625 2.25H12.9375V1.6875C12.9375 1.53832 12.8782 1.39524 12.7727 1.28975C12.6673 1.18426 12.5242 1.125 12.375 1.125C12.2258 1.125 12.0827 1.18426 11.9773 1.28975C11.8718 1.39524 11.8125 1.53832 11.8125 1.6875V2.25H6.1875V1.6875C6.1875 1.53832 6.12824 1.39524 6.02275 1.28975C5.91726 1.18426 5.77419 1.125 5.625 1.125C5.47582 1.125 5.33274 1.18426 5.22725 1.28975C5.12177 1.39524 5.0625 1.53832 5.0625 1.6875V2.25H3.375C3.07663 2.25 2.79049 2.36853 2.57951 2.5795C2.36853 2.79048 2.25 3.07663 2.25 3.375V14.625C2.25 14.9234 2.36853 15.2095 2.57951 15.4205C2.79049 15.6315 3.07663 15.75 3.375 15.75H14.625C14.9234 15.75 15.2095 15.6315 15.4205 15.4205C15.6315 15.2095 15.75 14.9234 15.75 14.625V3.375C15.75 3.07663 15.6315 2.79048 15.4205 2.5795C15.2095 2.36853 14.9234 2.25 14.625 2.25ZM5.90625 12.9375C5.73937 12.9375 5.57624 12.888 5.43749 12.7953C5.29874 12.7026 5.19059 12.5708 5.12673 12.4166C5.06287 12.2625 5.04616 12.0928 5.07871 11.9291C5.11127 11.7655 5.19163 11.6151 5.30963 11.4971C5.42763 11.3791 5.57797 11.2988 5.74164 11.2662C5.90532 11.2337 6.07497 11.2504 6.22914 11.3142C6.38332 11.3781 6.51509 11.4862 6.6078 11.625C6.70052 11.7637 6.75 11.9269 6.75 12.0938C6.75 12.3175 6.66111 12.5321 6.50287 12.6904C6.34464 12.8486 6.13003 12.9375 5.90625 12.9375ZM9 12.9375C8.83312 12.9375 8.66999 12.888 8.53124 12.7953C8.39249 12.7026 8.28434 12.5708 8.22048 12.4166C8.15662 12.2625 8.13991 12.0928 8.17246 11.9291C8.20502 11.7655 8.28538 11.6151 8.40338 11.4971C8.52138 11.3791 8.67172 11.2988 8.83539 11.2662C8.99907 11.2337 9.16872 11.2504 9.32289 11.3142C9.47707 11.3781 9.60884 11.4862 9.70155 11.625C9.79427 11.7637 9.84375 11.9269 9.84375 12.0938C9.84375 12.3175 9.75486 12.5321 9.59662 12.6904C9.43839 12.8486 9.22378 12.9375 9 12.9375ZM9 10.125C8.83312 10.125 8.66999 10.0755 8.53124 9.9828C8.39249 9.89009 8.28434 9.75831 8.22048 9.60414C8.15662 9.44996 8.13991 9.28031 8.17246 9.11664C8.20502 8.95297 8.28538 8.80263 8.40338 8.68463C8.52138 8.56663 8.67172 8.48627 8.83539 8.45371C8.99907 8.42116 9.16872 8.43787 9.32289 8.50173C9.47707 8.56559 9.60884 8.67373 9.70155 8.81249C9.79427 8.95124 9.84375 9.11437 9.84375 9.28125C9.84375 9.50503 9.75486 9.71964 9.59662 9.87787C9.43839 10.0361 9.22378 10.125 9 10.125ZM12.0938 12.9375C11.9269 12.9375 11.7637 12.888 11.625 12.7953C11.4862 12.7026 11.3781 12.5708 11.3142 12.4166C11.2504 12.2625 11.2337 12.0928 11.2662 11.9291C11.2988 11.7655 11.3791 11.6151 11.4971 11.4971C11.6151 11.3791 11.7655 11.2988 11.9291 11.2662C12.0928 11.2337 12.2625 11.2504 12.4166 11.3142C12.5708 11.3781 12.7026 11.4862 12.7953 11.625C12.888 11.7637 12.9375 11.9269 12.9375 12.0938C12.9375 12.3175 12.8486 12.5321 12.6904 12.6904C12.5321 12.8486 12.3175 12.9375 12.0938 12.9375ZM12.0938 10.125C11.9269 10.125 11.7637 10.0755 11.625 9.9828C11.4862 9.89009 11.3781 9.75831 11.3142 9.60414C11.2504 9.44996 11.2337 9.28031 11.2662 9.11664C11.2988 8.95297 11.3791 8.80263 11.4971 8.68463C11.6151 8.56663 11.7655 8.48627 11.9291 8.45371C12.0928 8.42116 12.2625 8.43787 12.4166 8.50173C12.5708 8.56559 12.7026 8.67373 12.7953 8.81249C12.888 8.95124 12.9375 9.11437 12.9375 9.28125C12.9375 9.50503 12.8486 9.71964 12.6904 9.87787C12.5321 10.0361 12.3175 10.125 12.0938 10.125ZM14.625 5.625H3.375V3.375H5.0625V3.9375C5.0625 4.08668 5.12177 4.22976 5.22725 4.33525C5.33274 4.44074 5.47582 4.5 5.625 4.5C5.77419 4.5 5.91726 4.44074 6.02275 4.33525C6.12824 4.22976 6.1875 4.08668 6.1875 3.9375V3.375H11.8125V3.9375C11.8125 4.08668 11.8718 4.22976 11.9773 4.33525C12.0827 4.44074 12.2258 4.5 12.375 4.5C12.5242 4.5 12.6673 4.44074 12.7727 4.33525C12.8782 4.22976 12.9375 4.08668 12.9375 3.9375V3.375H14.625V5.625Z"
        fill="#424242"
      />
    </svg>
  );
};
export const MeetingCalendarIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M1.5 14.25C1.5 15.525 2.475 16.5 3.75 16.5L14.25 16.5C15.525 16.5 16.5 15.525 16.5 14.25L16.5 8.25L1.5 8.25L1.5 14.25ZM14.25 3L12.75 3L12.75 2.25C12.75 1.8 12.45 1.5 12 1.5C11.55 1.5 11.25 1.8 11.25 2.25L11.25 3L6.75 3L6.75 2.25C6.75 1.8 6.45 1.5 6 1.5C5.55 1.5 5.25 1.8 5.25 2.25L5.25 3L3.75 3C2.475 3 1.5 3.975 1.5 5.25L1.5 6.75L16.5 6.75L16.5 5.25C16.5 3.975 15.525 3 14.25 3Z"
        fill="#424242"
      />
    </svg>
  );
};
export const DMSEquityIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <g clip-path="url(#clip0_36_66)">
        <path
          d="M1.50469 2.96718C1.20938 3.02343 0.878908 3.30468 0.766408 3.59999C0.703127 3.74765 0.703127 3.90234 0.703127 7.65702V11.5523L0.787502 11.7211C0.907033 11.9461 1.07578 12.1078 1.30078 12.2133L1.4836 12.2976L4.79531 12.3047L8.10703 12.3117L6.91875 13.507C5.625 14.8008 5.6461 14.7797 5.80781 14.9625L5.88516 15.0539H9H12.1219L12.1992 14.9625C12.3609 14.7726 12.375 14.7937 11.0883 13.507L9.9 12.3117L13.2117 12.3047L16.5234 12.2976L16.6992 12.2133C16.9102 12.1078 17.1 11.932 17.2125 11.7141L17.2969 11.5523V7.63593V3.72656L17.2195 3.55781C17.1281 3.3539 16.882 3.11484 16.6711 3.0164L16.5164 2.94609H9.07735C4.99219 2.93906 1.58203 2.94609 1.50469 2.96718ZM6.46875 5.02734C6.71485 5.10468 6.96797 5.35078 7.03828 5.61093C7.18594 6.10312 6.8836 6.60937 6.37031 6.7289C5.89922 6.8414 5.37891 6.46874 5.31563 5.96249C5.28047 5.68828 5.36485 5.45624 5.56875 5.24531C5.82891 4.99218 6.11016 4.92187 6.46875 5.02734ZM15.6164 5.34374C15.9891 5.53359 16.1789 5.96249 16.0664 6.34921C15.9961 6.58828 15.8414 6.77812 15.6234 6.90468C15.4688 6.98906 15.4125 7.00312 15.2156 7.00312C14.9344 7.00312 14.7305 6.91171 14.5547 6.70781C14.2313 6.34218 14.2523 5.85703 14.5969 5.50546C14.8852 5.22421 15.2578 5.16093 15.6164 5.34374ZM8.67656 7.39687C9.3375 7.93124 9.89297 8.38827 9.91406 8.4164C9.92813 8.45156 9.94219 8.5289 9.94219 8.59218C9.94219 8.76093 9.79453 8.90156 9.61875 8.90156C9.50625 8.90156 9.39375 8.82421 8.29688 7.94531C6.9961 6.91171 6.95391 6.85546 7.01719 6.64453C7.06641 6.49687 7.2211 6.3914 7.36875 6.41953C7.45313 6.42656 7.7836 6.67968 8.67656 7.39687ZM5.33672 6.56015C5.41406 6.63749 5.42813 6.68671 5.42813 6.79921C5.42813 6.93281 5.4211 6.94687 5.0836 7.27734C4.17656 8.14921 3.97969 8.31796 3.87422 8.31796C3.64219 8.31796 3.4875 8.14218 3.52969 7.91718C3.54375 7.83281 3.60703 7.74843 3.77578 7.60077C3.90235 7.48828 4.21875 7.18593 4.48594 6.93281C4.95703 6.48984 4.98516 6.46874 5.11172 6.46874C5.21016 6.46874 5.25938 6.48984 5.33672 6.56015ZM14.3016 6.76406C14.393 6.86952 14.4141 6.99609 14.3508 7.12968C14.3086 7.21406 12.2203 8.83827 12.0656 8.90156C11.9742 8.94374 11.9391 8.93671 11.8406 8.90156C11.6156 8.80312 11.5594 8.52187 11.7492 8.35312C11.8828 8.22656 13.8375 6.7289 13.9289 6.67968C14.0484 6.60937 14.1961 6.64452 14.3016 6.76406ZM3.0586 8.11406C3.3961 8.21249 3.67735 8.59921 3.67735 8.95781C3.67735 9.13359 3.58594 9.37968 3.46641 9.52031C3.00235 10.0687 2.14453 9.87187 1.94063 9.18281C1.78594 8.64843 2.20781 8.0789 2.77735 8.07187C2.8336 8.05781 2.96016 8.08593 3.0586 8.11406ZM11.1656 8.57812C11.2359 8.61328 11.3555 8.69062 11.4188 8.76093C11.8828 9.23202 11.6789 10.0406 11.0461 10.2305C10.6242 10.35 10.1953 10.1601 9.98438 9.75234C9.9 9.59765 9.9 9.16171 9.98438 9.01406C10.118 8.76796 10.35 8.58515 10.6102 8.51484C10.7438 8.47265 11.0039 8.50781 11.1656 8.57812Z"
          fill="#424242"
        />
      </g>
      <defs>
        <clipPath id="clip0_36_66">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const DigitalLeadWarIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M15.0656 1.2C12.4927 1.2 9.04032 2.9652 6.72192 6H4.8C3.41124 6 2.61528 7.03656 2.06724 8.13276L1.33356 9.6H3.06564H4.8L6.6 11.4L8.4 13.2V14.9344V16.6664L9.86724 15.9329C10.9634 15.3847 12 14.5888 12 13.2V11.2781C15.0348 8.95968 16.8 5.50728 16.8 2.93436V1.2H15.0656ZM12 4.8C12.6628 4.8 13.2 5.33724 13.2 6C13.2 6.66276 12.6628 7.2 12 7.2C11.3372 7.2 10.8 6.66276 10.8 6C10.8 5.33724 11.3372 4.8 12 4.8ZM4.2 12L3.6 12.6C2.73336 13.4666 2.4 15.6 2.4 15.6C2.4 15.6 4.4376 15.3624 5.4 14.4L6 13.8L4.2 12Z"
        fill="#424242"
      />
    </svg>
  );
};

export const SocialTalkIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M16.3174 13.1316C16.7061 12.3254 16.8968 11.4382 16.8737 10.5435C16.8506 9.64887 16.6144 8.77264 16.1846 7.98762C15.7549 7.2026 15.1441 6.53145 14.4028 6.02992C13.6616 5.52839 12.8114 5.21095 11.9229 5.10399C11.6272 4.41659 11.1974 3.79509 10.6586 3.27588C10.1197 2.75667 9.48271 2.35019 8.78482 2.08024C8.08693 1.81029 7.34219 1.6823 6.59421 1.70377C5.84624 1.72523 5.11006 1.89572 4.4288 2.20525C3.74753 2.51477 3.13488 2.95711 2.6267 3.50637C2.11852 4.05562 1.72504 4.70075 1.46929 5.40397C1.21355 6.1072 1.10068 6.85438 1.13731 7.60176C1.17393 8.34915 1.35931 9.08172 1.68258 9.75657L1.17141 11.494C1.11426 11.6879 1.11043 11.8937 1.16035 12.0897C1.21026 12.2856 1.31206 12.4645 1.45504 12.6075C1.59802 12.7504 1.77689 12.8522 1.97284 12.9022C2.16878 12.9521 2.37456 12.9483 2.56852 12.8911L4.30594 12.3799C4.86382 12.648 5.46194 12.8225 6.07641 12.8967C6.37494 13.5962 6.81221 14.2279 7.36179 14.7535C7.91137 15.2792 8.56185 15.688 9.27389 15.9552C9.98593 16.2223 10.7448 16.3423 11.5045 16.3079C12.2642 16.2735 13.0091 16.0854 13.6941 15.7549L15.4315 16.2661C15.6254 16.3232 15.8311 16.327 16.0269 16.2771C16.2228 16.2272 16.4016 16.1255 16.5445 15.9826C16.6875 15.8397 16.7893 15.661 16.8393 15.4651C16.8893 15.2693 16.8856 15.0636 16.8286 14.8697L16.3174 13.1316ZM15.1748 13.2349L15.75 15.1875L13.7981 14.6131C13.6571 14.5722 13.5057 14.5881 13.3763 14.6573C12.3404 15.2104 11.1295 15.3371 10.0017 15.0103C8.87383 14.6835 7.91821 13.9291 7.33852 12.908C8.10871 12.8276 8.85397 12.5889 9.52756 12.2069C10.2011 11.8249 10.7885 11.3078 11.2528 10.6881C11.7172 10.0684 12.0484 9.35936 12.2258 8.60558C12.4031 7.85179 12.4228 7.06949 12.2836 6.30774C12.9547 6.46592 13.5804 6.77617 14.1125 7.21456C14.6446 7.65295 15.0689 8.20774 15.3526 8.83612C15.6363 9.4645 15.7718 10.1497 15.7486 10.8387C15.7255 11.5278 15.5443 12.2023 15.2191 12.8102C15.1491 12.9405 15.1332 13.093 15.1748 13.2349Z"
        fill="#424242"
      />
    </svg>
  );
};

export const MessengerIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <g clipPath="url(#clip0_4437_55780)">
        <path
          d="M1.5264e-06 8.73C6.49311e-07 3.71363 3.92963 -6.87077e-07 9 -1.57361e-06C14.0704 -2.46014e-06 18 3.71362 18 8.73C18 13.7464 14.0704 17.46 9 17.46C8.08875 17.46 7.21575 17.3396 6.3945 17.1146C6.23526 17.0703 6.06561 17.0822 5.91413 17.1484L4.12763 17.9381C4.01973 17.9857 3.9018 18.0061 3.78419 17.9974C3.66658 17.9888 3.55289 17.9514 3.45313 17.8885C3.35336 17.8256 3.27057 17.7392 3.21203 17.6368C3.15348 17.5344 3.12098 17.4192 3.11738 17.3014L3.06788 15.7005C3.06446 15.6031 3.04125 15.5073 2.99967 15.4191C2.95809 15.3309 2.899 15.2521 2.826 15.1875C1.0755 13.6215 1.98511e-06 11.3535 1.5264e-06 8.73ZM6.23925 7.08862L3.5955 11.2826C3.34238 11.6854 3.83625 12.1387 4.21538 11.8519L7.056 9.69637C7.14943 9.62541 7.26343 9.58681 7.38075 9.5864C7.49807 9.586 7.61233 9.62381 7.70625 9.69412L9.80888 11.2714C9.95806 11.3832 10.1288 11.463 10.3104 11.5056C10.4919 11.5482 10.6803 11.5528 10.8637 11.5189C11.0471 11.4851 11.2214 11.4137 11.3758 11.3091C11.5302 11.2045 11.6613 11.0691 11.7608 10.9114L14.4045 6.71737C14.6588 6.31462 14.1638 5.86125 13.7846 6.14812L10.944 8.30362C10.8506 8.37459 10.7366 8.41319 10.6193 8.4136C10.5019 8.414 10.3877 8.37619 10.2938 8.30587L8.19113 6.7275C8.04194 6.61562 7.87119 6.53587 7.68965 6.49326C7.50811 6.45065 7.31971 6.44612 7.13633 6.47994C6.95295 6.51376 6.77856 6.58521 6.62417 6.68978C6.46977 6.79434 6.33871 6.93089 6.23925 7.08862Z"
          fill="#424242"
        />
      </g>
      <defs>
        <clipPath id="clip0_4437_55780">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const EmailBlastIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M14.25 3L3.75 3C3.15326 3 2.58097 3.23705 2.15901 3.65901C1.73705 4.08097 1.5 4.65326 1.5 5.25L1.5 12.75C1.5 13.3467 1.73705 13.919 2.15901 14.341C2.58097 14.7629 3.15326 15 3.75 15L14.25 15C14.8467 15 15.419 14.7629 15.841 14.341C16.2629 13.919 16.5 13.3467 16.5 12.75L16.5 5.25C16.5 4.65326 16.2629 4.08096 15.841 3.65901C15.419 3.23705 14.8467 3 14.25 3ZM14.25 4.5L9.375 7.8525C9.26099 7.91833 9.13165 7.95298 9 7.95298C8.86835 7.95298 8.73902 7.91833 8.625 7.8525L3.75 4.5L14.25 4.5Z"
        fill="#424242"
      />
    </svg>
  );
};

export const TrainingIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M6 3C6 3.82843 5.32843 4.5 4.5 4.5C3.67157 4.5 3 3.82843 3 3C3 2.17157 3.67157 1.5 4.5 1.5C5.32843 1.5 6 2.17157 6 3ZM3.75 12V16.5H2.25V7.5C2.25 6.25736 3.25736 5.25 4.5 5.25C5.11544 5.25 5.67317 5.4971 6.07939 5.8975L7.86023 7.57928L9.59483 5.84467L10.6555 6.90533L7.89008 9.67073L6.75 8.59403V16.5H5.25V12H3.75ZM7.5 3.75H14.25V10.5H7.5V12H10.7741L12.8917 16.5H14.5495L12.4319 12H15C15.4142 12 15.75 11.6642 15.75 11.25V3C15.75 2.58579 15.4142 2.25 15 2.25H7.5V3.75Z"
        fill="#424242"
      />
    </svg>
  );
};

export const TagsIcon = ({ color }: PlayIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M1.9425 8.685L8.6925 1.935C8.97 1.6575 9.3525 1.5 9.75 1.5L15 1.5C15.3978 1.5 15.7794 1.65804 16.0607 1.93934C16.342 2.22064 16.5 2.60218 16.5 3L16.5 8.25C16.5 8.6475 16.3425 9.03 16.0575 9.3075L15.75 9.6075C15.075 9.2025 14.295 9 13.5 9C12.3065 9 11.1619 9.4741 10.318 10.318C9.4741 11.1619 9 12.3065 9 13.5C9 14.295 9.21 15.0675 9.615 15.75L9.315 16.05C9.0375 16.335 8.6475 16.5 8.25 16.5C7.8525 16.5 7.47 16.3425 7.1925 16.0575L1.9425 10.8075C1.6575 10.53 1.5 10.1475 1.5 9.75C1.5 9.3525 1.6575 8.97 1.9425 8.685ZM13.875 5.25C14.1734 5.25 14.4595 5.13147 14.6705 4.92049C14.8815 4.70952 15 4.42337 15 4.125C15 3.82663 14.8815 3.54048 14.6705 3.3295C14.4595 3.11853 14.1734 3 13.875 3C13.5766 3 13.2905 3.11853 13.0795 3.3295C12.8685 3.54048 12.75 3.82663 12.75 4.125C12.75 4.42337 12.8685 4.70952 13.0795 4.92049C13.2905 5.13147 13.5766 5.25 13.875 5.25ZM10.5 14.25L12.75 14.25L12.75 16.5L14.25 16.5L14.25 14.25L16.5 14.25L16.5 12.75L14.25 12.75L14.25 10.5L12.75 10.5L12.75 12.75L10.5 12.75L10.5 14.25Z"
        fill={color ? color : "#424242"}
      />
    </svg>
  );
};
export const ReportIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M15.1875 2.8125H2.8125C2.51413 2.8125 2.22799 2.93103 2.01701 3.142C1.80603 3.35298 1.6875 3.63913 1.6875 3.9375V14.0625C1.6875 14.3609 1.80603 14.647 2.01701 14.858C2.22799 15.069 2.51413 15.1875 2.8125 15.1875H15.1875C15.4859 15.1875 15.772 15.069 15.983 14.858C16.194 14.647 16.3125 14.3609 16.3125 14.0625V3.9375C16.3125 3.63913 16.194 3.35298 15.983 3.142C15.772 2.93103 15.4859 2.8125 15.1875 2.8125ZM14.0625 13.5H3.9375C3.78832 13.5 3.64524 13.4407 3.53975 13.3352C3.43427 13.2298 3.375 13.0867 3.375 12.9375V5.0625C3.375 4.91332 3.43427 4.77024 3.53975 4.66475C3.64524 4.55926 3.78832 4.5 3.9375 4.5C4.08669 4.5 4.22976 4.55926 4.33525 4.66475C4.44074 4.77024 4.5 4.91332 4.5 5.0625V10.4548L6.91453 8.03953C6.96677 7.98723 7.02881 7.94574 7.0971 7.91744C7.16538 7.88913 7.23858 7.87456 7.3125 7.87456C7.38642 7.87456 7.45962 7.88913 7.52791 7.91744C7.59619 7.94574 7.65823 7.98723 7.71047 8.03953L9 9.32977L12.1423 6.1875H10.125C9.97582 6.1875 9.83274 6.12824 9.72725 6.02275C9.62176 5.91726 9.5625 5.77418 9.5625 5.625C9.5625 5.47582 9.62176 5.33274 9.72725 5.22725C9.83274 5.12176 9.97582 5.0625 10.125 5.0625H13.5C13.6492 5.0625 13.7923 5.12176 13.8977 5.22725C14.0032 5.33274 14.0625 5.47582 14.0625 5.625V9C14.0625 9.14918 14.0032 9.29226 13.8977 9.39775C13.7923 9.50324 13.6492 9.5625 13.5 9.5625C13.3508 9.5625 13.2077 9.50324 13.1023 9.39775C12.9968 9.29226 12.9375 9.14918 12.9375 9V6.98273L9.39797 10.523C9.34573 10.5753 9.28369 10.6168 9.21541 10.6451C9.14712 10.6734 9.07392 10.6879 9 10.6879C8.92608 10.6879 8.85288 10.6734 8.7846 10.6451C8.71631 10.6168 8.65427 10.5753 8.60203 10.523L7.3125 9.23273L4.5 12.0452V12.375H14.0625C14.2117 12.375 14.3548 12.4343 14.4602 12.5398C14.5657 12.6452 14.625 12.7883 14.625 12.9375C14.625 13.0867 14.5657 13.2298 14.4602 13.3352C14.3548 13.4407 14.2117 13.5 14.0625 13.5Z"
        fill="#424242"
      />
    </svg>
  );
};
export const PhoneLineIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M14.2125 16.5C12.65 16.5 11.1063 16.1593 9.58125 15.4778C8.05625 14.7963 6.66875 13.8308 5.41875 12.5813C4.16875 11.3313 3.20325 9.94375 2.52225 8.41875C1.84125 6.89375 1.5005 5.35 1.5 3.7875C1.5 3.5625 1.575 3.375 1.725 3.225C1.875 3.075 2.0625 3 2.2875 3L5.325 3C5.5 3 5.65625 3.0595 5.79375 3.1785C5.93125 3.2975 6.0125 3.438 6.0375 3.6L6.525 6.225C6.55 6.425 6.54375 6.59375 6.50625 6.73125C6.46875 6.86875 6.4 6.9875 6.3 7.0875L4.48125 8.925C4.73125 9.3875 5.028 9.8345 5.3715 10.266C5.715 10.6975 6.09325 11.113 6.50625 11.5125C6.89375 11.9 7.3 12.2595 7.725 12.591C8.15 12.9225 8.6 13.2255 9.075 13.5L10.8375 11.7375C10.95 11.625 11.097 11.5405 11.2785 11.484C11.46 11.4275 11.638 11.412 11.8125 11.4375L14.4 11.9625C14.575 12.0125 14.7188 12.1033 14.8313 12.2348C14.9438 12.3663 15 12.513 15 12.675L15 15.7125C15 15.9375 14.925 16.125 14.775 16.275C14.625 16.425 14.4375 16.5 14.2125 16.5ZM9.75 3C9.5375 3 9.35925 2.928 9.21525 2.784C9.07125 2.64 8.9995 2.462 9 2.25C9 2.0375 9.072 1.85925 9.216 1.71525C9.36 1.57125 9.538 1.4995 9.75 1.5L15.75 1.5C15.9625 1.5 16.1407 1.572 16.2848 1.716C16.4287 1.86 16.5005 2.038 16.5 2.25C16.5 2.4625 16.428 2.64075 16.284 2.78475C16.14 2.92875 15.962 3.0005 15.75 3L9.75 3ZM9.75 6C9.5375 6 9.35925 5.928 9.21525 5.784C9.07125 5.64 8.9995 5.462 9 5.25C9 5.0375 9.072 4.85925 9.216 4.71525C9.36 4.57125 9.538 4.4995 9.75 4.5L15.75 4.5C15.9625 4.5 16.1408 4.572 16.2848 4.716C16.4287 4.86 16.5005 5.038 16.5 5.25C16.5 5.4625 16.428 5.64075 16.284 5.78475C16.14 5.92875 15.962 6.0005 15.75 6L9.75 6ZM9.75 9C9.5375 9 9.35925 8.928 9.21525 8.784C9.07125 8.64 8.9995 8.462 9 8.25C9 8.0375 9.072 7.85925 9.216 7.71525C9.36 7.57125 9.538 7.4995 9.75 7.5L15.75 7.5C15.9625 7.5 16.1408 7.572 16.2848 7.716C16.4288 7.86 16.5005 8.038 16.5 8.25C16.5 8.4625 16.428 8.64075 16.284 8.78475C16.14 8.92875 15.962 9.0005 15.75 9L9.75 9Z"
        fill="#424242"
      />
    </svg>
  );
};

export const ChatIcon = ({ color }: PlayIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="2rem"
      height="2rem"
      viewBox="0 0 32 32"
      fill="none"
    >
      <g clipPath="url(#clip0_1936_65590)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M25.3333 4.00012C26.3942 4.00012 27.4116 4.42155 28.1617 5.17169C28.9119 5.92184 29.3333 6.93926 29.3333 8.00012V21.3335C29.3333 22.3943 28.9119 23.4117 28.1617 24.1619C27.4116 24.912 26.3942 25.3335 25.3333 25.3335H9.77729L5.33329 28.6668C4.23463 29.4908 2.66663 28.7068 2.66663 27.3335V8.00012C2.66663 6.93926 3.08805 5.92184 3.8382 5.17169C4.58834 4.42155 5.60576 4.00012 6.66663 4.00012H25.3333ZM14.6666 16.0001H10.6666C10.313 16.0001 9.97387 16.1406 9.72382 16.3906C9.47377 16.6407 9.33329 16.9798 9.33329 17.3335C9.33329 17.6871 9.47377 18.0262 9.72382 18.2763C9.97387 18.5263 10.313 18.6668 10.6666 18.6668H14.6666C15.0202 18.6668 15.3594 18.5263 15.6094 18.2763C15.8595 18.0262 16 17.6871 16 17.3335C16 16.9798 15.8595 16.6407 15.6094 16.3906C15.3594 16.1406 15.0202 16.0001 14.6666 16.0001ZM21.3333 10.6668H10.6666C10.3268 10.6672 9.99992 10.7973 9.7528 11.0306C9.50569 11.2639 9.35698 11.5827 9.33706 11.922C9.31715 12.2612 9.42753 12.5953 9.64565 12.8559C9.86377 13.1165 10.1732 13.284 10.5106 13.3241L10.6666 13.3335H21.3333C21.6731 13.3331 22 13.2029 22.2471 12.9697C22.4942 12.7364 22.6429 12.4175 22.6629 12.0783C22.6828 11.739 22.5724 11.4049 22.3543 11.1443C22.1362 10.8837 21.8268 10.7163 21.4893 10.6761L21.3333 10.6668Z"
          fill={color || "#424242"}
        />
        <path
          d="M2.09519 0.666789V1.52393C2.09519 1.62869 2.00948 1.71441 1.90472 1.71441H0.571382L0.19043 2.09536V0.381074C0.19043 0.276313 0.276144 0.190598 0.380906 0.190598H1.34281C1.33329 0.21917 1.33329 0.257265 1.33329 0.285836C1.33329 0.552503 1.54281 0.762027 1.80948 0.762027C1.91424 0.762027 2.019 0.723932 2.09519 0.666789ZM1.52376 0.285836C1.52376 0.447741 1.64757 0.571551 1.80948 0.571551C1.97138 0.571551 2.09519 0.447741 2.09519 0.285836C2.09519 0.123932 1.97138 0.00012207 1.80948 0.00012207C1.64757 0.00012207 1.52376 0.123932 1.52376 0.285836Z"
          fill={"#E0E0E0"}
        />
      </g>
      <defs>
        <clipPath id="clip0_1936_65590">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const ChatIconCall = ({ color }: PlayIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      viewBox="0 0 32 32"
      fill="none"
    >
      <g clipPath="url(#clip0_1936_65590)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M25.3333 4.00012C26.3942 4.00012 27.4116 4.42155 28.1617 5.17169C28.9119 5.92184 29.3333 6.93926 29.3333 8.00012V21.3335C29.3333 22.3943 28.9119 23.4117 28.1617 24.1619C27.4116 24.912 26.3942 25.3335 25.3333 25.3335H9.77729L5.33329 28.6668C4.23463 29.4908 2.66663 28.7068 2.66663 27.3335V8.00012C2.66663 6.93926 3.08805 5.92184 3.8382 5.17169C4.58834 4.42155 5.60576 4.00012 6.66663 4.00012H25.3333ZM14.6666 16.0001H10.6666C10.313 16.0001 9.97387 16.1406 9.72382 16.3906C9.47377 16.6407 9.33329 16.9798 9.33329 17.3335C9.33329 17.6871 9.47377 18.0262 9.72382 18.2763C9.97387 18.5263 10.313 18.6668 10.6666 18.6668H14.6666C15.0202 18.6668 15.3594 18.5263 15.6094 18.2763C15.8595 18.0262 16 17.6871 16 17.3335C16 16.9798 15.8595 16.6407 15.6094 16.3906C15.3594 16.1406 15.0202 16.0001 14.6666 16.0001ZM21.3333 10.6668H10.6666C10.3268 10.6672 9.99992 10.7973 9.7528 11.0306C9.50569 11.2639 9.35698 11.5827 9.33706 11.922C9.31715 12.2612 9.42753 12.5953 9.64565 12.8559C9.86377 13.1165 10.1732 13.284 10.5106 13.3241L10.6666 13.3335H21.3333C21.6731 13.3331 22 13.2029 22.2471 12.9697C22.4942 12.7364 22.6429 12.4175 22.6629 12.0783C22.6828 11.739 22.5724 11.4049 22.3543 11.1443C22.1362 10.8837 21.8268 10.7163 21.4893 10.6761L21.3333 10.6668Z"
          fill={color || "#424242"}
        />
        <path
          d="M2.09519 0.666789V1.52393C2.09519 1.62869 2.00948 1.71441 1.90472 1.71441H0.571382L0.19043 2.09536V0.381074C0.19043 0.276313 0.276144 0.190598 0.380906 0.190598H1.34281C1.33329 0.21917 1.33329 0.257265 1.33329 0.285836C1.33329 0.552503 1.54281 0.762027 1.80948 0.762027C1.91424 0.762027 2.019 0.723932 2.09519 0.666789ZM1.52376 0.285836C1.52376 0.447741 1.64757 0.571551 1.80948 0.571551C1.97138 0.571551 2.09519 0.447741 2.09519 0.285836C2.09519 0.123932 1.97138 0.00012207 1.80948 0.00012207C1.64757 0.00012207 1.52376 0.123932 1.52376 0.285836Z"
          fill={"#E0E0E0"}
        />
      </g>
      <defs>
        <clipPath id="clip0_1936_65590">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const VoicemailIcon = ({ color }: PlayIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="27"
      height="24"
      viewBox="0 0 27 24"
      fill="none"
    >
      <path
        d="M16.1131 12.0001C16.1131 11.4107 16.3473 10.8454 16.7641 10.4286C17.1809 10.0118 17.7462 9.77763 18.3356 9.77763C18.9251 9.77763 19.4904 10.0118 19.9072 10.4286C20.324 10.8454 20.5581 11.4107 20.5581 12.0001C20.5581 12.5896 20.324 13.1549 19.9072 13.5717C19.4904 13.9885 18.9251 14.2226 18.3356 14.2226C17.7462 14.2226 17.1809 13.9885 16.7641 13.5717C16.3473 13.1549 16.1131 12.5896 16.1131 12.0001ZM6.11187 12.0001C6.11187 11.4107 6.34603 10.8454 6.76283 10.4286C7.17963 10.0118 7.74493 9.77763 8.33437 9.77763C8.92382 9.77763 9.48912 10.0118 9.90592 10.4286C10.3227 10.8454 10.5569 11.4107 10.5569 12.0001C10.5569 12.5896 10.3227 13.1549 9.90592 13.5717C9.48912 13.9885 8.92382 14.2226 8.33437 14.2226C7.74493 14.2226 7.17963 13.9885 6.76283 13.5717C6.34603 13.1549 6.11187 12.5896 6.11187 12.0001ZM3.05594 0.887634C2.24545 0.887634 1.46816 1.2096 0.895063 1.7827C0.321964 2.3558 0 3.13309 0 3.94357V20.0567C0 20.8672 0.321964 21.6445 0.895063 22.2176C1.46816 22.7907 2.24545 23.1126 3.05594 23.1126H23.6141C24.4245 23.1126 25.2018 22.7907 25.7749 22.2176C26.348 21.6445 26.67 20.8672 26.67 20.0567V3.94357C26.67 3.13309 26.348 2.3558 25.7749 1.7827C25.2018 1.2096 24.4245 0.887634 23.6141 0.887634H3.05594ZM11.527 9.77763C12.0243 10.4918 12.2677 11.3521 12.2183 12.221C12.1689 13.0898 11.8295 13.917 11.2544 14.5702C10.6794 15.2234 9.90191 15.6648 9.04633 15.8239C8.19075 15.9831 7.30653 15.8506 6.5351 15.4479C5.76366 15.0451 5.14959 14.3953 4.79111 13.6023C4.43263 12.8093 4.35045 11.919 4.55772 11.0738C4.76499 10.2286 5.24973 9.47731 5.93441 8.94014C6.61908 8.40297 7.46413 8.11094 8.33437 8.11076H18.3356C19.2059 8.11094 20.0509 8.40297 20.7356 8.94014C21.4203 9.47731 21.905 10.2286 22.1123 11.0738C22.3195 11.919 22.2374 12.8093 21.8789 13.6023C21.5204 14.3953 20.9063 15.0451 20.1349 15.4479C19.3635 15.8506 18.4792 15.9831 17.6237 15.8239C16.7681 15.6648 15.9906 15.2234 15.4156 14.5702C14.8405 13.917 14.5011 13.0898 14.4517 12.221C14.4023 11.3521 14.6457 10.4918 15.143 9.77763H11.527Z"
        fill={color || "#424242"}
      />
    </svg>
  );
};
export const VoicemailIconCall = ({ color }: PlayIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      viewBox="0 0 27 24"
      fill="none"
    >
      <path
        d="M16.1131 12.0001C16.1131 11.4107 16.3473 10.8454 16.7641 10.4286C17.1809 10.0118 17.7462 9.77763 18.3356 9.77763C18.9251 9.77763 19.4904 10.0118 19.9072 10.4286C20.324 10.8454 20.5581 11.4107 20.5581 12.0001C20.5581 12.5896 20.324 13.1549 19.9072 13.5717C19.4904 13.9885 18.9251 14.2226 18.3356 14.2226C17.7462 14.2226 17.1809 13.9885 16.7641 13.5717C16.3473 13.1549 16.1131 12.5896 16.1131 12.0001ZM6.11187 12.0001C6.11187 11.4107 6.34603 10.8454 6.76283 10.4286C7.17963 10.0118 7.74493 9.77763 8.33437 9.77763C8.92382 9.77763 9.48912 10.0118 9.90592 10.4286C10.3227 10.8454 10.5569 11.4107 10.5569 12.0001C10.5569 12.5896 10.3227 13.1549 9.90592 13.5717C9.48912 13.9885 8.92382 14.2226 8.33437 14.2226C7.74493 14.2226 7.17963 13.9885 6.76283 13.5717C6.34603 13.1549 6.11187 12.5896 6.11187 12.0001ZM3.05594 0.887634C2.24545 0.887634 1.46816 1.2096 0.895063 1.7827C0.321964 2.3558 0 3.13309 0 3.94357V20.0567C0 20.8672 0.321964 21.6445 0.895063 22.2176C1.46816 22.7907 2.24545 23.1126 3.05594 23.1126H23.6141C24.4245 23.1126 25.2018 22.7907 25.7749 22.2176C26.348 21.6445 26.67 20.8672 26.67 20.0567V3.94357C26.67 3.13309 26.348 2.3558 25.7749 1.7827C25.2018 1.2096 24.4245 0.887634 23.6141 0.887634H3.05594ZM11.527 9.77763C12.0243 10.4918 12.2677 11.3521 12.2183 12.221C12.1689 13.0898 11.8295 13.917 11.2544 14.5702C10.6794 15.2234 9.90191 15.6648 9.04633 15.8239C8.19075 15.9831 7.30653 15.8506 6.5351 15.4479C5.76366 15.0451 5.14959 14.3953 4.79111 13.6023C4.43263 12.8093 4.35045 11.919 4.55772 11.0738C4.76499 10.2286 5.24973 9.47731 5.93441 8.94014C6.61908 8.40297 7.46413 8.11094 8.33437 8.11076H18.3356C19.2059 8.11094 20.0509 8.40297 20.7356 8.94014C21.4203 9.47731 21.905 10.2286 22.1123 11.0738C22.3195 11.919 22.2374 12.8093 21.8789 13.6023C21.5204 14.3953 20.9063 15.0451 20.1349 15.4479C19.3635 15.8506 18.4792 15.9831 17.6237 15.8239C16.7681 15.6648 15.9906 15.2234 15.4156 14.5702C14.8405 13.917 14.5011 13.0898 14.4517 12.221C14.4023 11.3521 14.6457 10.4918 15.143 9.77763H11.527Z"
        fill={color || "#424242"}
      />
    </svg>
  );
};
export const NotificationIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="33"
      height="32"
      viewBox="0 0 33 32"
      fill="none"
    >
      <g clipPath="url(#clip0_3902_114775)">
        <mask
          id="mask0_3902_114775"
          maskUnits="userSpaceOnUse"
          x="3"
          y="1"
          width="28"
          height="29"
        >
          <path
            d="M17.0001 28.7166C23.5814 28.7166 28.9166 23.3814 28.9166 16.8001C28.9166 10.2189 23.5814 4.88367 17.0001 4.88367C10.4189 4.88367 5.08301 10.2189 5.08301 16.8001C5.08301 23.3814 10.4189 28.7166 17.0001 28.7166Z"
            fill="white"
            stroke="white"
            strokeWidth="2"
            strokeLinejoin="round"
          />
          <path
            d="M16.8438 9.88019L16.8425 17.0354L21.895 22.0878"
            stroke="black"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M4 5.75012L8.55 2.50012M30 5.75012L25.45 2.50012"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </mask>
        <g mask="url(#mask0_3902_114775)">
          <path
            d="M1.3999 -0.0998535H32.5999V31.1001H1.3999V-0.0998535Z"
            fill="#424242"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_3902_114775">
          <rect
            width="32"
            height="32"
            fill="white"
            transform="translate(0.5 0.00012207)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export const PingingsIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      height="27"
      viewBox="0 0 26 27"
      fill="none"
    >
      <path
        d="M26 13.4962V13.6862C25.9575 15.4687 25.2962 17.4962 22.5 17.4962C19.6075 17.4962 19 15.3212 19 13.4962V8.49616C19.0003 8.35907 18.9724 8.22339 18.9181 8.09753C18.8637 7.97168 18.7841 7.85834 18.6841 7.76456C18.5841 7.67078 18.4659 7.59856 18.3368 7.55239C18.2077 7.50622 18.0705 7.48708 17.9338 7.49616C17.6762 7.51828 17.4366 7.63727 17.2633 7.82912C17.09 8.02097 16.9959 8.27141 17 8.52991V9.02991C16.0972 8.22082 14.9706 7.70417 13.7684 7.548C12.5663 7.39183 11.345 7.60348 10.2655 8.15506C9.18596 8.70665 8.29885 9.57229 7.721 10.638C7.14315 11.7036 6.90165 12.9194 7.02833 14.125C7.15501 15.3306 7.64392 16.4696 8.43066 17.3919C9.2174 18.3142 10.2651 18.9765 11.4356 19.2917C12.6062 19.6069 13.8448 19.56 14.9883 19.1574C16.1317 18.7548 17.1264 18.0152 17.8412 17.0362C17.9662 17.2548 18.1075 17.4637 18.2638 17.6612C18.935 18.4962 20.2137 19.4962 22.5 19.4962C22.8861 19.4974 23.2717 19.4661 23.6525 19.4024C23.7467 19.3867 23.8433 19.3983 23.9311 19.4358C24.0189 19.4733 24.0941 19.5351 24.1479 19.614C24.2016 19.6929 24.2317 19.7855 24.2345 19.8809C24.2373 19.9763 24.2128 20.0705 24.1637 20.1524C22.9885 22.1239 21.3124 23.7492 19.3058 24.8634C17.2992 25.9775 15.0335 26.5409 12.7388 26.4962C5.89125 26.3587 0.275 20.8537 0.0099999 14.0099C-0.0577813 12.2828 0.219545 10.5594 0.825754 8.94077C1.43196 7.32209 2.35488 5.84055 3.54052 4.58282C4.72616 3.32509 6.15072 2.31643 7.73084 1.61585C9.31097 0.915264 11.0149 0.536822 12.7431 0.502661C14.4712 0.468501 16.1888 0.779308 17.7954 1.4169C19.402 2.05449 20.8653 3.00607 22.0997 4.21596C23.3341 5.42585 24.3149 6.86976 24.9846 8.46322C25.6543 10.0567 25.9995 11.7677 26 13.4962ZM9 13.4962C9 14.2873 9.2346 15.0606 9.67412 15.7184C10.1136 16.3762 10.7384 16.8889 11.4693 17.1917C12.2002 17.4944 13.0044 17.5736 13.7804 17.4193C14.5563 17.265 15.269 16.884 15.8284 16.3246C16.3878 15.7652 16.7688 15.0524 16.9231 14.2765C17.0775 13.5006 16.9983 12.6963 16.6955 11.9654C16.3928 11.2345 15.8801 10.6098 15.2223 10.1703C14.5645 9.73076 13.7911 9.49616 13 9.49616C11.9391 9.49616 10.9217 9.91759 10.1716 10.6677C9.42143 11.4179 9 12.4353 9 13.4962Z"
        fill="#424242"
      />
    </svg>
  );
};

export const OpenChatIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="18"
      viewBox="0 0 17 18"
      fill="none"
    >
      <path
        d="M8.50009 0.666687C13.1026 0.666687 16.8334 4.39752 16.8334 9.00002C16.8334 13.6025 13.1026 17.3334 8.50009 17.3334C7.15195 17.3351 5.82366 17.0085 4.63009 16.3817L1.05509 17.3125C0.935636 17.3436 0.810125 17.343 0.690998 17.3106C0.57187 17.2783 0.463261 17.2154 0.375935 17.1282C0.288608 17.0409 0.225597 16.9324 0.193144 16.8133C0.160692 16.6942 0.159926 16.5687 0.190923 16.4492L1.12092 12.875C0.492422 11.6802 0.164898 10.3501 0.166756 9.00002C0.166756 4.39752 3.89759 0.666687 8.50009 0.666687ZM9.54342 9.83335H5.79176L5.70676 9.83919C5.55716 9.85977 5.42008 9.93382 5.32085 10.0476C5.22162 10.1615 5.16695 10.3074 5.16695 10.4584C5.16695 10.6094 5.22162 10.7553 5.32085 10.8691C5.42008 10.9829 5.55716 11.0569 5.70676 11.0775L5.79176 11.0834H9.54342L9.62759 11.0775C9.77718 11.0569 9.91427 10.9829 10.0135 10.8691C10.1127 10.7553 10.1674 10.6094 10.1674 10.4584C10.1674 10.3074 10.1127 10.1615 10.0135 10.0476C9.91427 9.93382 9.77718 9.85977 9.62759 9.83919L9.54342 9.83335ZM11.2084 6.91669H5.79176L5.70676 6.92252C5.55716 6.9431 5.42008 7.01715 5.32085 7.13097C5.22162 7.24479 5.16695 7.39068 5.16695 7.54169C5.16695 7.69269 5.22162 7.83859 5.32085 7.95241C5.42008 8.06623 5.55716 8.14027 5.70676 8.16085L5.79176 8.16669H11.2084L11.2934 8.16085C11.443 8.14027 11.5801 8.06623 11.6793 7.95241C11.7786 7.83859 11.8332 7.69269 11.8332 7.54169C11.8332 7.39068 11.7786 7.24479 11.6793 7.13097C11.5801 7.01715 11.443 6.9431 11.2934 6.92252L11.2084 6.91669Z"
        fill="white"
      />
    </svg>
  );
};
export const OpenPhoneIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
    >
      <path
        d="M9.8961 1.96331C9.91732 1.88399 9.95395 1.80963 10.0039 1.74447C10.0539 1.67932 10.1162 1.62464 10.1873 1.58358C10.2584 1.54252 10.3369 1.51586 10.4183 1.50515C10.4997 1.49443 10.5824 1.49986 10.6617 1.52112C11.8204 1.82342 12.8775 2.42912 13.7242 3.27583C14.5709 4.12255 15.1766 5.17966 15.4789 6.33831C15.5002 6.41761 15.5056 6.50033 15.4949 6.58174C15.4842 6.66314 15.4575 6.74164 15.4165 6.81274C15.3754 6.88384 15.3207 6.94615 15.2556 6.99612C15.1904 7.04608 15.116 7.08272 15.0367 7.10393C14.9839 7.1178 14.9296 7.12489 14.875 7.12503C14.7374 7.12507 14.6036 7.07968 14.4944 6.99592C14.3852 6.91215 14.3067 6.79468 14.2711 6.66174C14.0247 5.71576 13.5304 4.85262 12.8392 4.16131C12.1481 3.47 11.285 2.97555 10.3391 2.72893C10.2597 2.7078 10.1852 2.67122 10.12 2.6213C10.0548 2.57137 10 2.50907 9.95885 2.43796C9.91771 2.36685 9.89099 2.28832 9.88023 2.20688C9.86946 2.12543 9.87485 2.04266 9.8961 1.96331ZM9.71407 5.22893C10.7914 5.51643 11.4836 6.2094 11.7711 7.28674C11.8067 7.41968 11.8852 7.53715 11.9944 7.62092C12.1036 7.70468 12.2374 7.75007 12.375 7.75003C12.4296 7.74989 12.4839 7.7428 12.5367 7.72893C12.616 7.70772 12.6904 7.67108 12.7556 7.62112C12.8207 7.57115 12.8754 7.50884 12.9165 7.43774C12.9575 7.36664 12.9842 7.28814 12.9949 7.20674C13.0056 7.12533 13.0002 7.04261 12.9789 6.96331C12.5789 5.46643 11.5336 4.42112 10.0367 4.02112C9.95742 3.99993 9.87472 3.99457 9.79334 4.00535C9.71196 4.01613 9.63351 4.04283 9.56245 4.08392C9.49139 4.12502 9.42912 4.17971 9.3792 4.24487C9.32928 4.31003 9.29268 4.38439 9.27149 4.4637C9.25031 4.543 9.24495 4.62571 9.25572 4.70708C9.2665 4.78846 9.2932 4.86692 9.3343 4.93797C9.37539 5.00903 9.43008 5.0713 9.49525 5.12122C9.56041 5.17115 9.63476 5.20775 9.71407 5.22893ZM15.3727 11.3797L11.6922 9.73049L11.682 9.72581C11.491 9.64408 11.2825 9.61129 11.0756 9.63039C10.8687 9.64948 10.6698 9.71987 10.4969 9.83518C10.4765 9.84863 10.457 9.86323 10.4383 9.87893L8.53673 11.5C7.33204 10.9149 6.08829 9.68049 5.50313 8.49143L7.12657 6.56096C7.14219 6.54143 7.15704 6.5219 7.1711 6.50081C7.28394 6.32839 7.35239 6.13074 7.37039 5.92547C7.38838 5.7202 7.35534 5.51366 7.27423 5.32424V5.31487L5.62032 1.62815C5.51309 1.3807 5.3287 1.17457 5.09468 1.04052C4.86067 0.90648 4.58958 0.851713 4.32188 0.8844C3.26326 1.0237 2.29155 1.54359 1.58824 2.34697C0.884919 3.15035 0.498093 4.18228 0.500007 5.25002C0.500007 11.4531 5.54688 16.5 11.75 16.5C12.8177 16.5019 13.8497 16.1151 14.6531 15.4118C15.4564 14.7085 15.9763 13.7368 16.1156 12.6782C16.1484 12.4105 16.0937 12.1395 15.9598 11.9055C15.8259 11.6715 15.62 11.4871 15.3727 11.3797Z"
        fill="white"
      />
    </svg>
  );
};

export const DuplicateIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="18"
      viewBox="0 0 17 18"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.83333 0.666992C5.39131 0.666992 4.96738 0.842587 4.65482 1.15515C4.34226 1.46771 4.16667 1.89163 4.16667 2.33366V4.00033H5.83333V2.33366H15V11.5003H13.3333V13.167H15C15.442 13.167 15.8659 12.9914 16.1785 12.6788C16.4911 12.3663 16.6667 11.9424 16.6667 11.5003V2.33366C16.6667 1.89163 16.4911 1.46771 16.1785 1.15515C15.8659 0.842587 15.442 0.666992 15 0.666992H5.83333ZM1.66667 4.83366C1.22464 4.83366 0.800716 5.00925 0.488155 5.32181C0.175595 5.63437 0 6.0583 0 6.50033V15.667C0 16.109 0.175595 16.5329 0.488155 16.8455C0.800716 17.1581 1.22464 17.3337 1.66667 17.3337H10.8333C11.2754 17.3337 11.6993 17.1581 12.0118 16.8455C12.3244 16.5329 12.5 16.109 12.5 15.667V6.50033C12.5 6.0583 12.3244 5.63437 12.0118 5.32181C11.6993 5.00925 11.2754 4.83366 10.8333 4.83366H1.66667Z"
        fill="#424242"
      />
    </svg>
  );
};

export const DownloadIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="18"
      viewBox="0 0 16 18"
      fill="none"
    >
      <path
        d="M9.7998 0H2.5998C1.6008 0 0.799805 0.801 0.799805 1.8V16.2C0.799805 17.199 1.6008 18 2.5998 18H13.3998C14.3988 18 15.1998 17.199 15.1998 16.2V5.4L9.7998 0ZM7.9998 15.3L4.3998 11.7H6.6498V9H9.3498V11.7H11.5998L7.9998 15.3ZM8.8998 6.3V1.35L13.8498 6.3H8.8998Z"
        fill="#424242"
      />
    </svg>
  );
};

export const ImportIcon = ({ color }: PlayIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M10 11.6667V3.33333"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 3.33333L13.3333 6.66667"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 3.33333L6.66667 6.66667"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.33333 16.6667H16.6667"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const RunImportIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="20"
      viewBox="0 0 16 20"
      fill="none"
    >
      <path
        d="M10 0H2C0.89 0 0 0.89 0 2V18C0 19.11 0.89 20 2 20H14C15.11 20 16 19.11 16 18V6L10 0ZM8 17L4 13H6.5V10H9.5V13H12L8 17ZM9 7V1.5L14.5 7H9Z"
        fill="#424242"
      />
    </svg>
  );
};

export const ShowLogIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="20"
      viewBox="0 0 17 20"
      fill="none"
    >
      <path
        d="M14.5 -2.44784e-06C15.0304 -2.54058e-06 15.5391 0.210711 15.9142 0.585784C16.2893 0.960856 16.5 1.46956 16.5 2L16.5 18C16.5 18.5304 16.2893 19.0391 15.9142 19.4142C15.5391 19.7893 15.0304 20 14.5 20L2.5 20C1.96957 20 1.46086 19.7893 1.08579 19.4142C0.710717 19.0391 0.500003 18.5304 0.500003 18L0.5 2C0.5 1.46957 0.710714 0.960859 1.08579 0.585786C1.46086 0.210713 1.96957 -2.56947e-07 2.5 -3.49691e-07L14.5 -2.44784e-06ZM8.5 11L5.5 11C5.23478 11 4.98043 11.1054 4.79289 11.2929C4.60536 11.4804 4.5 11.7348 4.5 12C4.5 12.2652 4.60536 12.5196 4.79289 12.7071C4.98043 12.8946 5.23478 13 5.5 13L8.5 13C8.76522 13 9.01957 12.8946 9.20711 12.7071C9.39464 12.5196 9.5 12.2652 9.5 12C9.5 11.7348 9.39464 11.4804 9.20711 11.2929C9.01957 11.1054 8.76522 11 8.5 11ZM11.5 6L5.5 6C5.24512 6.00028 4.99997 6.09788 4.81463 6.27285C4.6293 6.44782 4.51776 6.68695 4.50283 6.9414C4.48789 7.19584 4.57067 7.44638 4.73426 7.64183C4.89785 7.83729 5.1299 7.9629 5.383 7.993L5.5 8L11.5 8C11.7549 7.99972 12 7.90212 12.1854 7.72715C12.3707 7.55218 12.4822 7.31305 12.4972 7.0586C12.5121 6.80416 12.4293 6.55362 12.2657 6.35817C12.1021 6.16271 11.8701 6.0371 11.617 6.007L11.5 6Z"
        fill="#424242"
      />
    </svg>
  );
};

export const VoicemailVector = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="33"
      height="16"
      viewBox="0 0 33 16"
      fill="none"
    >
      <path
        d="M25.1124 1C21.2472 1 18.1124 4.13381 18.1124 8C18.1124 10.5259 19.4546 12.7318 21.4592 13.9632H11.6532C13.6587 12.7318 15 10.5259 15 8C15 4.13381 11.8652 1 8 1C4.13478 1 1 4.13381 1 8C1 11.8662 4.13478 15 8 15H25.1114C28.9767 15 32.1114 11.8662 32.1114 8C32.1114 4.13381 28.9767 1 25.1114 1H25.1124ZM2.03779 8C2.03779 4.71252 4.71349 2.03682 8.00097 2.03682C11.2885 2.03682 13.9642 4.71252 13.9642 8C13.9642 11.2875 11.2885 13.9632 8.00097 13.9632C4.71349 13.9632 2.03779 11.2885 2.03779 8ZM25.1124 13.9632C21.8249 13.9632 19.1492 11.2885 19.1492 8C19.1492 4.71155 21.824 2.03682 25.1124 2.03682C28.4009 2.03682 31.0756 4.71252 31.0756 8C31.0756 11.2875 28.4009 13.9632 25.1124 13.9632Z"
        fill="#66BB6A"
        stroke="#4CAF50"
      />
    </svg>
  );
};

export const EmailVector = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <rect
        x="3"
        y="5"
        width="18"
        height="14"
        rx="2"
        stroke="#4CAF50"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 7L12 13L21 7"
        stroke="#4CAF50"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const MsgVector = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M4 21V8C4 6.34315 5.34315 5 7 5H17C18.6569 5 20 6.34315 20 8V14C20 15.6569 18.6569 17 17 17H8L4 21"
        stroke="#4CAF50"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 9H16"
        stroke="#4CAF50"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 13H14"
        stroke="#4CAF50"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PhoneVector = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M5 4H9L11 9L8.5 10.5C9.57096 12.6715 11.3285 14.429 13.5 15.5L15 13L20 15V19C20 20.1046 19.1046 21 18 21C9.92765 20.5094 3.49056 14.0724 3 6C3 4.89543 3.89543 4 5 4"
        stroke="#4CAF50"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 7C16.1046 7 17 7.89543 17 9"
        stroke="#43A047"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 3C18.3137 3 21 5.68629 21 9"
        stroke="#43A047"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PersonVector = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <circle
        cx="12"
        cy="7"
        r="4"
        stroke="#4CAF50"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 21V19C6 16.7909 7.79086 15 10 15H14C16.2091 15 18 16.7909 18 19V21"
        stroke="#4CAF50"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ChevronDown = ({ color }: PlayIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M4 6L8 10L12 6"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ExcelIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="20"
      viewBox="0 0 18 20"
      fill="none"
    >
      <path
        d="M1.38268 2.39737L11.8577 0.900707C11.9168 0.892226 11.977 0.896553 12.0343 0.913394C12.0916 0.930235 12.1447 0.959197 12.1898 0.998317C12.2349 1.03744 12.2711 1.0858 12.2959 1.14013C12.3207 1.19446 12.3335 1.25348 12.3335 1.31321V18.6857C12.3335 18.7453 12.3207 18.8043 12.2959 18.8586C12.2712 18.9128 12.2351 18.9611 12.1901 19.0002C12.145 19.0393 12.0921 19.0683 12.0349 19.0852C11.9777 19.1021 11.9176 19.1066 11.8585 19.0982L1.38185 17.6015C1.1832 17.5732 1.00143 17.4742 0.869923 17.3227C0.73842 17.1711 0.666018 16.9772 0.666016 16.7765V3.22237C0.666018 3.02172 0.73842 2.8278 0.869923 2.67624C1.00143 2.52469 1.18403 2.42567 1.38268 2.39737ZM13.1668 2.49904H16.5002C16.7212 2.49904 16.9332 2.58684 17.0894 2.74312C17.2457 2.8994 17.3335 3.11136 17.3335 3.33237V16.6657C17.3335 16.8867 17.2457 17.0987 17.0894 17.255C16.9332 17.4112 16.7212 17.499 16.5002 17.499H13.1668V2.49904ZM7.50018 9.99904L9.83352 6.66571H7.83352L6.50018 8.57071L5.16685 6.66571H3.16685L5.50018 9.99904L3.16685 13.3324H5.16685L6.50018 11.4274L7.83352 13.3324H9.83352L7.50018 9.99904Z"
        fill="#424242"
      />
    </svg>
  );
};

export const PDFIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="20"
      viewBox="0 0 18 20"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 2C0 1.46957 0.210714 0.960859 0.585787 0.585786C0.960859 0.210714 1.46957 0 2 0L12.9427 0L17.3333 4.39067V18C17.3333 18.5304 17.1226 19.0391 16.7475 19.4142C16.3725 19.7893 15.8638 20 15.3333 20H2C1.46957 20 0.960859 19.7893 0.585787 19.4142C0.210714 19.0391 0 18.5304 0 18V2ZM3.33333 8H1.33333V14.6667H2.66667V12H3.33333C3.86377 12 4.37247 11.7893 4.74755 11.4142C5.12262 11.0391 5.33333 10.5304 5.33333 10C5.33333 9.46957 5.12262 8.96086 4.74755 8.58579C4.37247 8.21071 3.86377 8 3.33333 8ZM8.66667 8H6.66667V14.6667H8.66667C9.1971 14.6667 9.70581 14.456 10.0809 14.0809C10.456 13.7058 10.6667 13.1971 10.6667 12.6667V10C10.6667 9.46957 10.456 8.96086 10.0809 8.58579C9.70581 8.21071 9.1971 8 8.66667 8ZM12 14.6667V8H16V9.33333H13.3333V10.6667H14.6667V12H13.3333V14.6667H12Z"
        fill="#424242"
      />
    </svg>
  );
};

export const WhiteMsg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
    >
      <g clip-path="url(#clip0_2888_149472)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.9912 3.47461C22.9121 3.47461 23.7954 3.84046 24.4466 4.49169C25.0978 5.14292 25.4637 6.02617 25.4637 6.94714V18.5222C25.4637 19.4432 25.0978 20.3265 24.4466 20.9777C23.7954 21.6289 22.9121 21.9948 21.9912 21.9948H8.48648L4.6285 24.8886C3.67471 25.6039 2.31348 24.9233 2.31348 23.731V6.94714C2.31348 6.02617 2.67933 5.14292 3.33056 4.49169C3.98178 3.84046 4.86504 3.47461 5.78601 3.47461H21.9912ZM12.7311 13.8922H9.25854C8.95155 13.8922 8.65713 14.0142 8.44006 14.2312C8.22298 14.4483 8.10103 14.7427 8.10103 15.0497C8.10103 15.3567 8.22298 15.6511 8.44006 15.8682C8.65713 16.0853 8.95155 16.2072 9.25854 16.2072H12.7311C13.0381 16.2072 13.3325 16.0853 13.5496 15.8682C13.7666 15.6511 13.8886 15.3567 13.8886 15.0497C13.8886 14.7427 13.7666 14.4483 13.5496 14.2312C13.3325 14.0142 13.0381 13.8922 12.7311 13.8922ZM18.5186 9.26216H9.25854C8.96351 9.26249 8.67975 9.37546 8.46522 9.57799C8.25069 9.78052 8.12159 10.0573 8.1043 10.3518C8.08701 10.6464 8.18284 10.9364 8.37219 11.1626C8.56155 11.3888 8.83015 11.5342 9.12311 11.5691L9.25854 11.5772H18.5186C18.8137 11.5769 19.0974 11.4639 19.3119 11.2614C19.5265 11.0588 19.6556 10.782 19.6729 10.4875C19.6902 10.193 19.5943 9.90299 19.405 9.67675C19.2156 9.45051 18.947 9.30511 18.6541 9.27027L18.5186 9.26216Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_2888_149472">
          <rect width="27.7803" height="27.7803" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const WhitePhone = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
    >
      <path
        d="M18.2307 3.47461C18.0004 3.47461 17.7796 3.56607 17.6168 3.72888C17.454 3.89169 17.3625 4.1125 17.3625 4.34274C17.3625 4.57299 17.454 4.7938 17.6168 4.9566C17.7796 5.11941 18.0004 5.21088 18.2307 5.21088H21.3438L15.8815 10.6749C15.7986 10.755 15.7324 10.8508 15.6869 10.9567C15.6414 11.0626 15.6175 11.1765 15.6165 11.2918C15.6155 11.4071 15.6375 11.5214 15.6811 11.6281C15.7248 11.7348 15.7892 11.8317 15.8707 11.9132C15.9522 11.9947 16.0492 12.0592 16.1559 12.1028C16.2626 12.1465 16.3769 12.1684 16.4921 12.1674C16.6074 12.1664 16.7213 12.1425 16.8272 12.097C16.9332 12.0515 17.029 11.9854 17.109 11.9024L22.5713 6.43842V9.55154C22.5713 9.78178 22.6628 10.0026 22.8256 10.1654C22.9884 10.3282 23.2092 10.4197 23.4395 10.4197C23.6697 10.4197 23.8905 10.3282 24.0533 10.1654C24.2161 10.0026 24.3076 9.78178 24.3076 9.55154V4.34274C24.3076 4.1125 24.2161 3.89169 24.0533 3.72888C23.8905 3.56607 23.6697 3.47461 23.4395 3.47461H18.2307ZM11.4071 5.22129C11.0799 4.53379 10.5065 3.99418 9.80042 3.7093C9.09432 3.42442 8.307 3.41502 7.5943 3.68296L7.13766 3.85485C4.7937 4.73514 3.13036 7.03222 3.54359 9.64703C3.903 11.9389 4.66522 14.9843 6.29905 17.547C7.77487 19.8632 9.73338 21.7696 11.3655 23.1274C13.5445 24.9383 16.5899 24.5442 18.5449 22.6985L19.0589 22.2124C19.3503 21.9372 19.5844 21.607 19.7476 21.2409C19.9109 20.8748 20.0001 20.48 20.0101 20.0792C20.0201 19.6785 19.9507 19.2797 19.8059 18.9059C19.6612 18.5321 19.4438 18.1907 19.1665 17.9012L17.8209 16.4949C17.4999 16.1602 17.0954 15.9173 16.6492 15.7912C16.2029 15.6651 15.7311 15.6605 15.2825 15.7778L12.0235 16.6286C11.4466 16.0984 10.9506 15.4865 10.5512 14.8124C10.162 14.1381 9.867 13.4138 9.67435 12.6595L11.9593 10.1662C12.3098 9.78392 12.5382 9.30573 12.6152 8.79286C12.6922 8.27998 12.6144 7.7558 12.3916 7.28745L11.4071 5.22129Z"
        fill="white"
      />
    </svg>
  );
};

export const SellCastIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="28"
      viewBox="0 0 25 28"
      fill="none"
    >
      <g clip-path="url(#clip0_2888_149465)">
        <path
          d="M19.1768 1.73633H5.14021C2.31336 1.73633 0.00195312 4.04773 0.00195312 6.86916V20.9058C0.00195312 23.7326 2.31336 26.0441 5.14021 26.0441H19.1768C22.0037 26.0441 24.3151 23.7326 24.3151 20.9112V6.86916C24.3151 4.04773 22.0037 1.73633 19.1768 1.73633ZM16.4639 18.9037C14.9501 21.5189 11.5861 22.425 8.96543 20.9221C7.72291 23.0815 5.98664 21.3887 6.6703 20.2059L7.52216 18.73C7.84228 18.1712 8.56391 17.9758 9.12278 18.3014C10.132 18.8874 9.11735 18.296 10.1266 18.882C11.6241 19.7447 13.5665 19.2238 14.4347 17.7263C15.2974 16.2287 14.7765 14.2863 13.279 13.4181C12.3132 12.8647 13.2464 13.3964 12.2698 12.843C10.935 12.0725 12.0853 10.027 13.4417 10.8083C14.4509 11.3943 13.4363 10.8029 14.4455 11.3889C17.0716 12.9081 17.9777 16.2884 16.4639 18.9037ZM17.6468 7.57452C16.7244 9.17514 16.7623 9.13716 16.6158 9.28366C16.2632 9.63634 15.7314 9.75571 15.178 9.47899C14.1688 8.893 15.1834 9.48442 14.1742 8.89843C12.6767 8.03572 10.7342 8.5566 9.86611 10.0541C8.99798 11.5517 9.52429 13.4941 11.0218 14.3622C11.0218 14.3622 12.0256 14.9374 12.031 14.9374C13.3658 15.7078 12.2155 17.7534 10.859 16.9721C9.84984 16.3861 10.8645 16.9775 9.85526 16.3915C7.24001 14.8831 6.3339 11.5028 7.84228 8.88215C9.35609 6.2669 12.7201 5.36078 15.3408 6.86374L15.6012 6.40797C16.3771 5.05694 18.4226 6.22892 17.6468 7.57452Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_2888_149465">
          <rect width="24.3113" height="27.7803" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const MissedCallIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
    >
      <path
        d="M24.2313 6.5523C21.9626 4.54981 18.4195 3.55088 13.5996 3.55667C8.78783 3.56361 5.35118 4.56833 3.28965 6.57082C2.41689 7.41928 2.09857 8.67633 2.45508 9.86973L2.81391 11.0701C3.14728 12.1894 4.27353 12.9371 5.44841 12.8191L7.80394 12.5829C8.81445 12.4811 9.61313 11.7599 9.78444 10.7923L10.237 8.23995C11.3816 7.72684 12.6175 7.44857 13.8716 7.42159C15.175 7.3834 16.3672 7.58596 17.4483 8.02929L18.1799 10.7552C18.4415 11.7356 19.3212 12.4683 20.3537 12.5679L22.7231 12.7971C23.913 12.9128 24.9629 12.157 25.177 11.033L25.4062 9.83269C25.6319 8.64277 25.1863 7.39497 24.2313 6.5523ZM13.6008 16.2059C13.831 16.2059 14.0518 16.2974 14.2146 16.4602C14.3774 16.623 14.4689 16.8438 14.4689 17.0741V19.0997H15.6264C15.8566 19.0997 16.0775 19.1912 16.2403 19.354C16.4031 19.5168 16.4945 19.7376 16.4945 19.9678C16.4945 20.1981 16.4031 20.4189 16.2403 20.5817C16.0775 20.7445 15.8566 20.836 15.6264 20.836H13.6008C13.3705 20.836 13.1497 20.7445 12.9869 20.5817C12.8241 20.4189 12.7326 20.1981 12.7326 19.9678V17.0741C12.7326 16.8438 12.8241 16.623 12.9869 16.4602C13.1497 16.2974 13.3705 16.2059 13.6008 16.2059ZM13.8901 12.7334C12.2017 12.7334 10.5824 13.4041 9.38847 14.5981C8.19456 15.792 7.52382 17.4113 7.52382 19.0997C7.52382 20.7882 8.19456 22.4075 9.38847 23.6014C10.5824 24.7953 12.2017 25.466 13.8901 25.466C15.5786 25.466 17.1979 24.7953 18.3918 23.6014C19.5857 22.4075 20.2564 20.7882 20.2564 19.0997C20.2564 17.4113 19.5857 15.792 18.3918 14.5981C17.1979 13.4041 15.5786 12.7334 13.8901 12.7334ZM9.26009 19.0997C9.26009 17.8718 9.7479 16.6941 10.6162 15.8258C11.4845 14.9575 12.6622 14.4697 13.8901 14.4697C15.1181 14.4697 16.2958 14.9575 17.1641 15.8258C18.0324 16.6941 18.5202 17.8718 18.5202 19.0997C18.5202 20.3277 18.0324 21.5054 17.1641 22.3737C16.2958 23.242 15.1181 23.7298 13.8901 23.7298C12.6622 23.7298 11.4845 23.242 10.6162 22.3737C9.7479 21.5054 9.26009 20.3277 9.26009 19.0997Z"
        fill="white"
      />
    </svg>
  );
};

export const FilledPhoneIcon = ({ color }: PlayIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M13.2151 14.3495C11.8707 14.3495 10.5123 14.0273 9.1401 13.3828C7.76788 12.7384 6.50399 11.8384 5.34844 10.6828C4.18177 9.52726 3.27344 8.25503 2.62344 6.86615C1.97344 5.47726 1.64844 4.1217 1.64844 2.79948C1.64844 2.47726 1.75955 2.20226 1.98177 1.97448C2.20399 1.7467 2.47622 1.63281 2.79844 1.63281H5.04844C5.39288 1.63281 5.67622 1.72448 5.89844 1.90781C6.12066 2.09115 6.2651 2.35503 6.33177 2.69948L6.78177 4.46615C6.80399 4.75503 6.78455 5.01615 6.72344 5.24948C6.66233 5.48281 6.54844 5.6717 6.38177 5.81615L4.68177 7.38281C4.90399 7.78281 5.16233 8.16337 5.45677 8.52448C5.75122 8.88559 6.07066 9.22726 6.4151 9.54948C6.78177 9.94948 7.15399 10.2911 7.53177 10.5745C7.90955 10.8578 8.29288 11.105 8.68177 11.3161L10.3318 9.66615C10.5095 9.46615 10.7179 9.33004 10.9568 9.25781C11.1957 9.18559 11.454 9.18281 11.7318 9.24948L13.3151 9.61615C13.6484 9.71615 13.9068 9.87726 14.0901 10.0995C14.2734 10.3217 14.3651 10.5995 14.3651 10.9328V13.1995C14.3651 13.5217 14.2512 13.7939 14.0234 14.0161C13.7957 14.2384 13.5262 14.3495 13.2151 14.3495Z"
        fill={color}
      />
    </svg>
  );
};

export const ResumeIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <rect
        x="4"
        y="3.33398"
        width="2.66667"
        height="9.33333"
        rx="1"
        fill="#424242"
        stroke="#424242"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="9.33594"
        y="3.33398"
        width="2.66667"
        height="9.33333"
        rx="1"
        fill="#424242"
        stroke="#424242"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const GeneralIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="16"
      viewBox="0 0 15 16"
      fill="none"
    >
      <path
        d="M5.44844 6.16211C5.73594 5.87461 6.06406 5.64023 6.43281 5.45898C6.80156 5.27773 7.18594 5.18711 7.58594 5.18711C7.98594 5.18711 8.37031 5.27773 8.73906 5.45898C9.10781 5.64023 9.43594 5.87461 9.72344 6.16211L13.7172 3.81836L8.12969 0.780859C7.95469 0.680859 7.77344 0.630859 7.58594 0.630859C7.39844 0.630859 7.21719 0.680859 7.04219 0.780859L1.45469 3.81836L5.44844 6.16211ZM7.02344 15.1809V10.7559C6.37344 10.5809 5.83594 10.2402 5.41094 9.73398C4.98594 9.22773 4.77344 8.64961 4.77344 7.99961C4.77344 7.87461 4.77969 7.74336 4.79219 7.60586C4.80469 7.46836 4.84219 7.31836 4.90469 7.15586L0.835938 4.73711V10.9809C0.835938 11.1934 0.885938 11.384 0.985938 11.5527C1.08594 11.7215 1.22344 11.8559 1.39844 11.9559L7.02344 15.1809ZM7.58594 9.68711C8.06094 9.68711 8.46094 9.52148 8.78594 9.19023C9.11094 8.85898 9.27344 8.46211 9.27344 7.99961C9.27344 7.52461 9.11094 7.12461 8.78594 6.79961C8.46094 6.47461 8.06094 6.31211 7.58594 6.31211C7.12344 6.31211 6.72656 6.47461 6.39531 6.79961C6.06406 7.12461 5.89844 7.52461 5.89844 7.99961C5.89844 8.46211 6.06406 8.85898 6.39531 9.19023C6.72656 9.52148 7.12344 9.68711 7.58594 9.68711ZM8.14844 15.1809L13.7734 11.9559C13.9484 11.8559 14.0859 11.7215 14.1859 11.5527C14.2859 11.384 14.3359 11.1934 14.3359 10.9809V4.73711L10.2672 7.15586C10.3297 7.33086 10.3672 7.48398 10.3797 7.61523C10.3922 7.74648 10.3984 7.87461 10.3984 7.99961C10.3984 8.64961 10.1859 9.22773 9.76094 9.73398C9.33594 10.2402 8.79844 10.5809 8.14844 10.7559V15.1809Z"
        fill="#212121"
      />
    </svg>
  );
};
export const GreetIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
    >
      <path
        d="M17.5037 12.75C17.5037 15.2325 15.4862 17.25 13.0037 17.25V16.125C14.8787 16.125 16.3787 14.625 16.3787 12.75H17.5037ZM1.00375 5.25C1.00375 2.7675 3.02125 0.75 5.50375 0.75V1.875C3.62875 1.875 2.12875 3.375 2.12875 5.25H1.00375ZM6.25375 3.24L2.81125 6.69C0.39625 9.105 0.39625 13.0275 2.81125 15.4425C5.22625 17.8575 9.14875 17.8575 11.5638 15.4425L16.8662 10.125C17.2337 9.7725 17.2337 9.18 16.8662 8.8125C16.7792 8.72519 16.6757 8.65593 16.5618 8.60866C16.4479 8.5614 16.3258 8.53708 16.2025 8.53708C16.0792 8.53708 15.9571 8.5614 15.8432 8.60866C15.7293 8.65593 15.6258 8.72519 15.5387 8.8125L12.2238 12.1275L11.6912 11.595L16.5963 6.69C16.9637 6.3225 16.9637 5.73 16.5963 5.3625C16.2288 4.995 15.6287 4.995 15.2537 5.3625L10.8962 9.75L10.3787 9.2025L15.5312 4.035C15.8988 3.6675 15.8988 3.075 15.5312 2.7075C15.1637 2.34 14.5712 2.34 14.2037 2.7075L9.03625 7.875L8.50375 7.35L12.6287 3.24C13.0037 2.8725 13.0037 2.28 12.6287 1.9125C12.2537 1.545 11.6687 1.545 11.3012 1.9125L5.58625 7.6275C6.03373 8.20472 6.25546 8.92527 6.2099 9.65421C6.16434 10.3832 5.85462 11.0705 5.33875 11.5875L4.80625 11.055C5.2276 10.6331 5.46427 10.0613 5.46427 9.465C5.46427 8.86875 5.2276 8.29688 4.80625 7.875L4.54375 7.6125L7.59625 4.56C7.96375 4.1925 7.96375 3.6 7.59625 3.2325C7.22125 2.8725 6.62875 2.8725 6.25375 3.24Z"
        fill="#212121"
      />
    </svg>
  );
};
export const RoutingIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
    >
      <path
        d="M13.5694 2.41536C13.5179 2.36009 13.4558 2.31577 13.3868 2.28502C13.3178 2.25428 13.2433 2.23775 13.1678 2.23642C13.0922 2.23508 13.0172 2.24898 12.9472 2.27727C12.8771 2.30556 12.8135 2.34767 12.7601 2.40108C12.7067 2.45449 12.6646 2.51812 12.6363 2.58816C12.608 2.6582 12.5941 2.73322 12.5954 2.80875C12.5968 2.88428 12.6133 2.95876 12.644 3.02776C12.6748 3.09676 12.7191 3.15886 12.7744 3.21036L15.0019 5.43786H11.2969C10.6504 5.43786 10.0304 5.69467 9.5733 6.15179C9.11618 6.60891 8.85938 7.22889 8.85938 7.87536V10.1254C8.85957 10.4188 8.76142 10.7038 8.5806 10.935C8.39979 11.1661 8.14674 11.3299 7.86188 11.4004C7.71225 10.6727 7.29803 10.0264 6.69937 9.58656C6.10071 9.1467 5.36017 8.94454 4.62105 9.01919C3.88193 9.09385 3.19678 9.44002 2.69818 9.99072C2.19957 10.5414 1.92296 11.2575 1.92188 12.0004C1.92135 12.7494 2.20103 13.4715 2.70594 14.0248C3.21085 14.578 3.90446 14.9224 4.6504 14.9902C5.39635 15.058 6.14067 14.8442 6.73703 14.391C7.33339 13.9378 7.73865 13.278 7.87313 12.5411C8.4578 12.4621 8.99399 12.1738 9.38223 11.7296C9.77048 11.2853 9.98442 10.7153 9.98438 10.1254V7.87536C9.98438 7.15086 10.5724 6.56286 11.2969 6.56286H15.0019L12.7744 8.79036C12.7191 8.84186 12.6748 8.90396 12.644 8.97296C12.6133 9.04195 12.5968 9.11644 12.5954 9.19197C12.5941 9.26749 12.608 9.34252 12.6363 9.41256C12.6646 9.4826 12.7067 9.54622 12.7601 9.59964C12.8135 9.65305 12.8771 9.69516 12.9472 9.72345C13.0172 9.75174 13.0922 9.76564 13.1678 9.7643C13.2433 9.76297 13.3178 9.74644 13.3868 9.7157C13.4558 9.68495 13.5179 9.64062 13.5694 9.58536L16.7569 6.39786C16.8622 6.29239 16.9214 6.14942 16.9214 6.00036C16.9214 5.8513 16.8622 5.70833 16.7569 5.60286L13.5694 2.41536Z"
        fill="#212121"
      />
    </svg>
  );
};
export const TriggerIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
    >
      <path
        d="M6.9976 11.2501H4.31635C4.09135 11.2501 3.92572 11.1501 3.81947 10.9501C3.71322 10.7501 3.72885 10.5564 3.86635 10.3689L10.2038 1.21888C10.3038 1.08138 10.4288 0.98763 10.5788 0.93763C10.7288 0.88763 10.8788 0.89388 11.0288 0.95638C11.1788 1.01888 11.2976 1.11888 11.3851 1.25638C11.4726 1.39388 11.5038 1.54388 11.4788 1.70638L10.7476 7.50013H14.0476C14.2851 7.50013 14.4538 7.60638 14.5538 7.81888C14.6538 8.03138 14.6288 8.23138 14.4788 8.41888L7.5226 16.7626C7.4226 16.8876 7.29447 16.9689 7.13822 17.0064C6.98197 17.0439 6.8351 17.0314 6.6976 16.9689C6.5601 16.9064 6.45072 16.8064 6.36947 16.6689C6.28822 16.5314 6.2601 16.3814 6.2851 16.2189L6.9976 11.2501Z"
        fill="#212121"
      />
    </svg>
  );
};

export const SettingsIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
    >
      <path
        d="M14.9447 9.70578C14.9747 9.48078 14.9897 9.24828 14.9897 9.00078C14.9897 8.76078 14.9747 8.52078 14.9372 8.29578L16.4597 7.11078C16.5253 7.05671 16.5701 6.98156 16.5865 6.89813C16.603 6.81471 16.5899 6.72818 16.5497 6.65328L15.1097 4.16328C15.0673 4.08796 14.9996 4.03007 14.9186 3.99987C14.8376 3.96966 14.7486 3.9691 14.6672 3.99828L12.8747 4.71828C12.4997 4.43328 12.1022 4.19328 11.6597 4.01328L11.3897 2.10828C11.3764 2.02243 11.3328 1.94419 11.2667 1.88777C11.2007 1.83134 11.1166 1.80048 11.0297 1.80078H8.14969C7.96969 1.80078 7.82719 1.92828 7.79719 2.10828L7.52719 4.01328C7.08469 4.19328 6.6797 4.44078 6.31219 4.71828L4.51969 3.99828C4.35469 3.93828 4.16719 3.99828 4.07719 4.16328L2.64469 6.65328C2.55469 6.81078 2.58469 7.00578 2.73469 7.11078L4.25719 8.29578C4.21969 8.52078 4.1897 8.76828 4.1897 9.00078C4.1897 9.23328 4.20469 9.48078 4.24219 9.70578L2.71969 10.8908C2.65409 10.9449 2.60926 11.02 2.59285 11.1034C2.57644 11.1869 2.58946 11.2734 2.62969 11.3483L4.06969 13.8383C4.15969 14.0033 4.34719 14.0558 4.51219 14.0033L6.30469 13.2833C6.67969 13.5683 7.07719 13.8083 7.51969 13.9883L7.7897 15.8933C7.8272 16.0733 7.96969 16.2008 8.14969 16.2008H11.0297C11.2097 16.2008 11.3597 16.0733 11.3822 15.8933L11.6522 13.9883C12.0947 13.8083 12.4997 13.5683 12.8672 13.2833L14.6597 14.0033C14.8247 14.0633 15.0122 14.0033 15.1022 13.8383L16.5422 11.3483C16.6322 11.1833 16.5947 10.9958 16.4522 10.8908L14.9447 9.70578ZM9.58969 11.7008C8.10469 11.7008 6.88969 10.4858 6.88969 9.00078C6.88969 7.51578 8.10469 6.30078 9.58969 6.30078C11.0747 6.30078 12.2897 7.51578 12.2897 9.00078C12.2897 10.4858 11.0747 11.7008 9.58969 11.7008Z"
        fill="#212121"
      />
    </svg>
  );
};

export const TextToSpeechIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <g clip-path="url(#clip0_2141_94370)">
        <path
          d="M2.5 8.33333H11.6667V10H2.5V8.33333ZM2.5 6.66667H11.6667V5H2.5V6.66667ZM2.5 13.3333H8.33333V11.6667H2.5V13.3333ZM15.0083 10.725L15.6 10.1333C15.925 9.80833 16.45 9.80833 16.775 10.1333L17.3667 10.725C17.6917 11.05 17.6917 11.575 17.3667 11.9L16.775 12.4917L15.0083 10.725ZM14.4167 11.3167L10 15.7333V17.5H11.7667L16.1833 13.0833L14.4167 11.3167Z"
          fill="#3E3E3E"
        />
      </g>
      <defs>
        <clipPath id="clip0_2141_94370">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const AwesomeIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g clip-path="url(#clip0_2888_201093)">
        <path
          d="M19 9L20.25 6.25L23 5L20.25 3.75L19 1L17.75 3.75L15 5L17.75 6.25L19 9ZM11.5 9.5L9 4L6.5 9.5L1 12L6.5 14.5L9 20L11.5 14.5L17 12L11.5 9.5ZM19 15L17.75 17.75L15 19L17.75 20.25L19 23L20.25 20.25L23 19L20.25 17.75L19 15Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_2888_201093">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const PlayRecordingIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="18"
      viewBox="0 0 16 18"
      fill="none"
    >
      <path
        d="M3.83333 14.0013H5.5V4.0013H3.83333V14.0013ZM7.16667 17.3346H8.83333V0.667969H7.16667V17.3346ZM0.5 10.668H2.16667V7.33464H0.5V10.668ZM10.5 14.0013H12.1667V4.0013H10.5V14.0013ZM13.8333 7.33464V10.668H15.5V7.33464H13.8333Z"
        fill="#212121"
      />
    </svg>
  );
};

export const LocationIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
    >
      <g clip-path="url(#clip0_4408_209299)">
        <path
          d="M9 2C6.0975 2 3.75 4.3475 3.75 7.25C3.75 11.1875 9 17 9 17C9 17 14.25 11.1875 14.25 7.25C14.25 4.3475 11.9025 2 9 2ZM9 9.125C7.965 9.125 7.125 8.285 7.125 7.25C7.125 6.215 7.965 5.375 9 5.375C10.035 5.375 10.875 6.215 10.875 7.25C10.875 8.285 10.035 9.125 9 9.125Z"
          fill="#B0BEC5"
        />
      </g>
      <defs>
        <clipPath id="clip0_4408_209299">
          <rect
            width="18"
            height="18"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const QueueIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="14"
      viewBox="0 0 15 14"
      fill="none"
    >
      <path
        d="M0.5 2.29688C0.5 1.71671 0.730468 1.16031 1.1407 0.750079C1.55094 0.339843 2.10734 0.109375 2.6875 0.109375H12.3125C12.8927 0.109375 13.4491 0.339843 13.8593 0.750079C14.2695 1.16031 14.5 1.71671 14.5 2.29688C14.5 2.87704 14.2695 3.43344 13.8593 3.84367C13.4491 4.25391 12.8927 4.48438 12.3125 4.48438H2.6875C2.10734 4.48438 1.55094 4.25391 1.1407 3.84367C0.730468 3.43344 0.5 2.87704 0.5 2.29688ZM1.15625 6.307C0.982202 6.307 0.815282 6.37614 0.692211 6.49921C0.56914 6.62228 0.5 6.7892 0.5 6.96325C0.5 7.1373 0.56914 7.30422 0.692211 7.42729C0.815282 7.55036 0.982202 7.6195 1.15625 7.6195H13.8438C14.0178 7.6195 14.1847 7.55036 14.3078 7.42729C14.4309 7.30422 14.5 7.1373 14.5 6.96325C14.5 6.7892 14.4309 6.62228 14.3078 6.49921C14.1847 6.37614 14.0178 6.307 13.8438 6.307H1.15625ZM1.15625 9.4395C0.982202 9.4395 0.815282 9.50864 0.692211 9.63171C0.56914 9.75478 0.5 9.9217 0.5 10.0957C0.5 10.2698 0.56914 10.4367 0.692211 10.5598C0.815282 10.6829 0.982202 10.752 1.15625 10.752H13.8438C14.0178 10.752 14.1847 10.6829 14.3078 10.5598C14.4309 10.4367 14.5 10.2698 14.5 10.0957C14.5 9.9217 14.4309 9.75478 14.3078 9.63171C14.1847 9.50864 14.0178 9.4395 13.8438 9.4395H1.15625ZM1.15625 12.5781C0.982202 12.5781 0.815282 12.6473 0.692211 12.7703C0.56914 12.8934 0.5 13.0603 0.5 13.2344C0.5 13.4084 0.56914 13.5753 0.692211 13.6984C0.815282 13.8215 0.982202 13.8906 1.15625 13.8906H13.8438C14.0178 13.8906 14.1847 13.8215 14.3078 13.6984C14.4309 13.5753 14.5 13.4084 14.5 13.2344C14.5 13.0603 14.4309 12.8934 14.3078 12.7703C14.1847 12.6473 14.0178 12.5781 13.8438 12.5781H1.15625Z"
        fill="#212121"
      />
    </svg>
  );
};

export const GroupIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="13"
      viewBox="0 0 10 13"
      fill="none"
    >
      <path
        d="M8.66667 6.99935C9.03486 6.99935 9.33333 6.70087 9.33333 6.33268C9.33333 5.96449 9.03486 5.66602 8.66667 5.66602C8.29848 5.66602 8 5.96449 8 6.33268C8 6.70087 8.29848 6.99935 8.66667 6.99935Z"
        fill="#0A233C"
        stroke="#0A233C"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.66667 2.33333C9.03486 2.33333 9.33333 2.03486 9.33333 1.66667C9.33333 1.29848 9.03486 1 8.66667 1C8.29848 1 8 1.29848 8 1.66667C8 2.03486 8.29848 2.33333 8.66667 2.33333Z"
        fill="#0A233C"
        stroke="#0A233C"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.66667 11.6654C9.03486 11.6654 9.33333 11.3669 9.33333 10.9987C9.33333 10.6305 9.03486 10.332 8.66667 10.332C8.29848 10.332 8 10.6305 8 10.9987C8 11.3669 8.29848 11.6654 8.66667 11.6654Z"
        fill="#0A233C"
        stroke="#0A233C"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.66667 6.99935C2.03486 6.99935 2.33333 6.70087 2.33333 6.33268C2.33333 5.96449 2.03486 5.66602 1.66667 5.66602C1.29848 5.66602 1 5.96449 1 6.33268C1 6.70087 1.29848 6.99935 1.66667 6.99935Z"
        fill="#0A233C"
        stroke="#0A233C"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.66667 2.33333C2.03486 2.33333 2.33333 2.03486 2.33333 1.66667C2.33333 1.29848 2.03486 1 1.66667 1C1.29848 1 1 1.29848 1 1.66667C1 2.03486 1.29848 2.33333 1.66667 2.33333Z"
        fill="#0A233C"
        stroke="#0A233C"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.66667 11.6654C2.03486 11.6654 2.33333 11.3669 2.33333 10.9987C2.33333 10.6305 2.03486 10.332 1.66667 10.332C1.29848 10.332 1 10.6305 1 10.9987C1 11.3669 1.29848 11.6654 1.66667 11.6654Z"
        fill="#0A233C"
        stroke="#0A233C"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ReloadIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M7.9751 13.569C6.43452 13.569 5.12123 13.026 4.03523 11.94C2.94924 10.854 2.40625 9.54072 2.40625 8.00014C2.40625 6.45956 2.94924 5.14471 4.03523 4.05557C5.12123 2.96644 6.43452 2.42188 7.9751 2.42188C8.95723 2.42188 9.82113 2.61982 10.5668 3.01571C11.3124 3.41161 11.9558 3.96173 12.4969 4.66607V2.97839C12.4969 2.81888 12.5482 2.68625 12.6508 2.58049C12.7534 2.47475 12.8876 2.42188 13.0534 2.42188C13.2129 2.42188 13.3455 2.47475 13.4513 2.58049C13.557 2.68625 13.6099 2.81888 13.6099 2.97839V6.34363C13.6099 6.53202 13.5454 6.68915 13.4164 6.81499C13.2874 6.94085 13.1287 7.00378 12.9403 7.00378H9.56568C9.40884 7.00378 9.27844 6.9509 9.1745 6.84514C9.07056 6.7394 9.01858 6.60676 9.01858 6.44724C9.01858 6.2904 9.07146 6.16 9.1772 6.05606C9.28296 5.95211 9.41559 5.90014 9.5751 5.90014H11.7809C11.3524 5.2586 10.8227 4.74012 10.1917 4.34471C9.56072 3.9493 8.82186 3.75159 7.9751 3.75159C6.78911 3.75159 5.78452 4.16319 4.96133 4.98638C4.13814 5.80956 3.72655 6.81415 3.72655 8.00014C3.72655 9.18613 4.13814 10.1907 4.96133 11.0139C5.78452 11.8371 6.78911 12.2487 7.9751 12.2487C8.75819 12.2487 9.49201 12.0481 10.1766 11.6469C10.8611 11.2457 11.3843 10.7011 11.7461 10.0132C11.837 9.85856 11.9673 9.74623 12.1371 9.67621C12.3069 9.60617 12.4741 9.60836 12.6386 9.68276C12.8113 9.75087 12.9292 9.86451 12.9925 10.0237C13.0558 10.1829 13.0502 10.3417 12.9758 10.5002C12.5111 11.4398 11.8301 12.1861 10.9327 12.7393C10.0354 13.2924 9.0495 13.569 7.9751 13.569Z"
        fill="white"
      />
    </svg>
  );
};

export const CircleCheckIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M7.89375 10.7063L6.05625 8.86875C5.94375 8.75625 5.80625 8.7 5.64375 8.7C5.48125 8.7 5.3375 8.7625 5.2125 8.8875C5.1 9 5.04375 9.1375 5.04375 9.3C5.04375 9.4625 5.1 9.6 5.2125 9.7125L7.5 12.0188C7.6125 12.1313 7.74375 12.1875 7.89375 12.1875C8.04375 12.1875 8.175 12.1313 8.2875 12.0188L12.7688 7.5375C12.8938 7.4125 12.9563 7.26875 12.9563 7.10625C12.9563 6.94375 12.8938 6.8 12.7688 6.675C12.6438 6.5625 12.4969 6.50938 12.3281 6.51562C12.1594 6.52188 12.0188 6.58125 11.9062 6.69375L7.89375 10.7063ZM9 16.5C7.975 16.5 7.00625 16.3031 6.09375 15.9094C5.18125 15.5156 4.38438 14.9781 3.70312 14.2969C3.02188 13.6156 2.48438 12.8188 2.09063 11.9062C1.69688 10.9938 1.5 10.025 1.5 9C1.5 7.9625 1.69688 6.9875 2.09063 6.075C2.48438 5.1625 3.02188 4.36875 3.70312 3.69375C4.38438 3.01875 5.18125 2.48438 6.09375 2.09063C7.00625 1.69688 7.975 1.5 9 1.5C10.0375 1.5 11.0125 1.69688 11.925 2.09063C12.8375 2.48438 13.6313 3.01875 14.3063 3.69375C14.9813 4.36875 15.5156 5.1625 15.9094 6.075C16.3031 6.9875 16.5 7.9625 16.5 9C16.5 10.025 16.3031 10.9938 15.9094 11.9062C15.5156 12.8188 14.9813 13.6156 14.3063 14.2969C13.6313 14.9781 12.8375 15.5156 11.925 15.9094C11.0125 16.3031 10.0375 16.5 9 16.5ZM9 15.375C10.775 15.375 12.2812 14.7531 13.5188 13.5094C14.7563 12.2656 15.375 10.7625 15.375 9C15.375 7.225 14.7563 5.71875 13.5188 4.48125C12.2812 3.24375 10.775 2.625 9 2.625C7.2375 2.625 5.73438 3.24375 4.49063 4.48125C3.24688 5.71875 2.625 7.225 2.625 9C2.625 10.7625 3.24688 12.2656 4.49063 13.5094C5.73438 14.7531 7.2375 15.375 9 15.375Z"
        fill="#4CAF50"
      />
    </svg>
  );
};

export const DigitalLeadApplyFilterIcon = () => {
  return (
    <svg
      width="400"
      height="405"
      viewBox="0 0 400 405"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M62.6929 259.327C28.5421 184.77 61.3036 96.6421 135.868 62.4879C210.432 28.3338 298.563 61.0871 332.714 135.644C366.865 210.202 340.201 347.249 259.539 332.484C178.878 317.719 96.8438 333.885 62.6929 259.327Z"
        fill="#EEEEEE"
      />
      <path
        d="M160.54 123.031H134.015C132.42 123.031 130.89 122.397 129.762 121.269C128.634 120.141 128 118.611 128 117.015C128 115.42 128.634 113.89 129.762 112.762C130.89 111.634 132.42 111 134.015 111H160.54C162.135 111 163.665 111.634 164.793 112.762C165.921 113.89 166.555 115.42 166.555 117.015C166.555 118.611 165.921 120.141 164.793 121.269C163.665 122.397 162.135 123.031 160.54 123.031Z"
        fill="#43A047"
      />
      <path
        d="M241.743 136.156H131.281C130.411 136.156 129.576 135.81 128.961 135.195C128.346 134.58 128 133.745 128 132.875C128 132.005 128.346 131.17 128.961 130.555C129.576 129.939 130.411 129.594 131.281 129.594H241.743C242.613 129.594 243.448 129.939 244.063 130.555C244.678 131.17 245.024 132.005 245.024 132.875C245.024 133.745 244.678 134.58 244.063 135.195C243.448 135.81 242.613 136.156 241.743 136.156Z"
        fill="#E6E6E6"
      />
      <path
        d="M171.857 149.277H131.281C130.411 149.277 129.576 148.931 128.961 148.316C128.346 147.701 128 146.866 128 145.996C128 145.126 128.346 144.291 128.961 143.676C129.576 143.061 130.411 142.715 131.281 142.715H171.857C172.727 142.715 173.562 143.061 174.177 143.676C174.792 144.291 175.138 145.126 175.138 145.996C175.138 146.866 174.792 147.701 174.177 148.316C173.562 148.931 172.727 149.277 171.857 149.277Z"
        fill="#E6E6E6"
      />
      <path
        d="M304.729 227.312H93.6481C92.4158 227.311 91.2344 226.821 90.363 225.949C89.4916 225.078 89.0014 223.896 89 222.664V165.246C89.0014 164.013 89.4915 162.832 90.3629 161.961C91.2343 161.089 92.4158 160.599 93.6481 160.598H304.729C305.961 160.599 307.143 161.089 308.014 161.961C308.885 162.832 309.375 164.013 309.377 165.246V222.664C309.375 223.896 308.885 225.078 308.014 225.949C307.143 226.821 305.961 227.311 304.729 227.312Z"
        fill="#43A047"
      />
      <path
        d="M168.719 186.847H132.051C129.723 186.847 127.828 184.148 127.828 180.832C127.828 177.515 129.723 174.816 132.051 174.816H168.719C171.048 174.816 172.942 177.515 172.942 180.832C172.942 184.148 171.048 186.847 168.719 186.847Z"
        fill="white"
      />
      <path
        d="M267.273 199.972H131.109C130.239 199.972 129.404 199.627 128.789 199.011C128.174 198.396 127.828 197.561 127.828 196.691C127.828 195.821 128.174 194.986 128.789 194.371C129.404 193.756 130.239 193.41 131.109 193.41H267.273C268.143 193.41 268.977 193.756 269.593 194.371C270.208 194.986 270.554 195.821 270.554 196.691C270.554 197.561 270.208 198.396 269.593 199.011C268.977 199.627 268.143 199.972 267.273 199.972Z"
        fill="#E6E6E6"
      />
      <path
        d="M197.386 213.093H131.109C130.239 213.093 129.404 212.748 128.789 212.132C128.174 211.517 127.828 210.682 127.828 209.812C127.828 208.942 128.174 208.108 128.789 207.492C129.404 206.877 130.239 206.531 131.109 206.531H197.386C198.257 206.531 199.091 206.877 199.706 207.492C200.322 208.108 200.667 208.942 200.667 209.812C200.667 210.682 200.322 211.517 199.706 212.132C199.091 212.748 198.257 213.093 197.386 213.093Z"
        fill="#E6E6E6"
      />
    </svg>
  );
};

export const ResumeEmailIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 0H20V20H0V0Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.83325 3.33203V16.6654L16.6666 9.9987L5.83325 3.33203Z"
        fill="#212121"
        stroke="#43A047"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ImageIcon = ({ color }: PlayIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.333252 4.33203C0.333252 3.40377 0.702001 2.51354 1.35838 1.85716C2.01476 1.20078 2.90499 0.832031 3.83325 0.832031H20.1666C21.0948 0.832031 21.9851 1.20078 22.6415 1.85716C23.2978 2.51354 23.6666 3.40377 23.6666 4.33203V11.9154C23.6665 12.0138 23.6539 12.1118 23.6293 12.207C23.6539 12.3023 23.6665 12.4003 23.6666 12.4987V20.6654C23.6666 21.5936 23.2978 22.4839 22.6415 23.1402C21.9851 23.7966 21.0948 24.1654 20.1666 24.1654H3.83325C2.90499 24.1654 2.01476 23.7966 1.35838 23.1402C0.702001 22.4839 0.333252 21.5936 0.333252 20.6654V17.1654C0.333346 17.067 0.34589 16.969 0.370585 16.8737C0.345914 16.7784 0.333371 16.6804 0.333252 16.582V4.33203ZM3.82625 15.8004C3.42025 15.8074 3.03292 15.826 2.66659 15.854V4.33203C2.66659 4.02261 2.7895 3.72587 3.00829 3.50707C3.22709 3.28828 3.52383 3.16536 3.83325 3.16536H20.1666C20.476 3.16536 20.7728 3.28828 20.9915 3.50707C21.2103 3.72587 21.3333 4.02261 21.3333 4.33203V11.3507C16.3201 11.5129 12.6999 12.7204 10.1566 14.4109C11.1203 14.7527 12.1983 15.2392 13.2553 15.8762C14.8874 16.8562 16.5464 18.2329 17.6629 20.0564C17.7429 20.1871 17.7963 20.3322 17.8202 20.4836C17.8441 20.6349 17.8379 20.7895 17.8021 20.9384C17.7662 21.0874 17.7014 21.2278 17.6112 21.3517C17.5211 21.4756 17.4074 21.5806 17.2768 21.6605C17.1461 21.7405 17.0009 21.794 16.8496 21.8178C16.6982 21.8417 16.5437 21.8355 16.3947 21.7997C16.2457 21.7638 16.1053 21.699 15.9814 21.6088C15.8575 21.5187 15.7526 21.4051 15.6726 21.2744C14.8139 19.8709 13.4816 18.7334 12.0536 17.8759C10.6279 17.0195 9.17775 16.4852 8.17209 16.2519C6.75542 15.9283 5.30485 15.7771 3.85192 15.8015H3.82625V15.8004ZM6.14092 6.06803C6.66092 5.70166 7.2805 5.50301 7.91659 5.4987C8.39492 5.4987 9.08675 5.63286 9.69225 6.06803C10.3573 6.54636 10.8333 7.33503 10.8333 8.41537C10.8333 9.4957 10.3573 10.2832 9.69225 10.7615C9.17239 11.1283 8.5528 11.3274 7.91659 11.332C7.43825 11.332 6.74642 11.1979 6.14092 10.7615C5.47592 10.2832 4.99992 9.49687 4.99992 8.41537C4.99992 7.33503 5.47592 6.54753 6.14092 6.06803Z"
        fill={color}
      />
    </svg>
  );
};
export const VideoIcon = ({ color }: PlayIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="31"
      height="31"
      viewBox="0 0 31 31"
      fill="none"
    >
      <path
        d="M5.84675 6.12109C4.89588 6.12109 3.98395 6.49883 3.31158 7.1712C2.63921 7.84357 2.26147 8.75549 2.26147 9.70637V21.2896C2.26147 22.2404 2.63921 23.1524 3.31158 23.8247C3.98395 24.4971 4.89588 24.8748 5.84675 24.8748H16.3268C17.2777 24.8748 18.1896 24.4971 18.862 23.8247C19.5343 23.1524 19.9121 22.2404 19.9121 21.2896V9.70637C19.9121 8.75549 19.5343 7.84357 18.862 7.1712C18.1896 6.49883 17.2777 6.12109 16.3268 6.12109H5.84675ZM25.5636 22.8263L21.5668 18.91V12.1885L25.5514 8.18621C26.4196 7.31471 27.9078 7.92918 27.9078 9.1592V21.8411C27.9078 23.0634 26.4362 23.6812 25.5636 22.8263Z"
        fill={color}
      />
    </svg>
  );
};
export const VariableIcon = ({ color }: PlayIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="29"
      viewBox="0 0 28 29"
      fill="none"
    >
      <path
        d="M23.3334 7.4987C23.3334 4.96936 19.0599 2.83203 14.0001 2.83203C8.94025 2.83203 4.66675 4.96936 4.66675 7.4987V9.83203C4.66675 12.3614 8.94025 14.4987 14.0001 14.4987C19.0599 14.4987 23.3334 12.3614 23.3334 9.83203V7.4987ZM14.0001 22.6654C8.94025 22.6654 4.66675 20.528 4.66675 17.9987V21.4987C4.66675 24.028 8.94025 26.1654 14.0001 26.1654C19.0599 26.1654 23.3334 24.028 23.3334 21.4987V17.9987C23.3334 20.528 19.0599 22.6654 14.0001 22.6654Z"
        fill={color}
      />
      <path
        d="M23.3334 12.168C23.3334 14.6973 19.0599 16.8346 14.0001 16.8346C8.94025 16.8346 4.66675 14.6973 4.66675 12.168V15.668C4.66675 18.1973 8.94025 20.3346 14.0001 20.3346C19.0599 20.3346 23.3334 18.1973 23.3334 15.668V12.168Z"
        fill={color}
      />
    </svg>
  );
};
export const CreditAppIcon = ({ color }: PlayIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="29"
      height="29"
      viewBox="0 0 29 29"
      fill="none"
    >
      <path
        d="M13.261 3.49422C13.9925 2.93422 15.0092 2.93422 15.7407 3.49422L24.4242 10.132C25.5302 10.9772 24.937 12.7412 23.5475 12.7482H5.4525C4.06475 12.7412 3.46975 10.9772 4.5775 10.132L13.261 3.49422ZM14.5 9.68572C14.8481 9.68572 15.1819 9.54744 15.4281 9.3013C15.6742 9.05515 15.8125 8.72131 15.8125 8.37322C15.8125 8.02512 15.6742 7.69128 15.4281 7.44514C15.1819 7.199 14.8481 7.06072 14.5 7.06072C14.1519 7.06072 13.8181 7.199 13.5719 7.44514C13.3258 7.69128 13.1875 8.02512 13.1875 8.37322C13.1875 8.72131 13.3258 9.05515 13.5719 9.3013C13.8181 9.54744 14.1519 9.68572 14.5 9.68572ZM6.625 14.4982V19.7482H9.25V14.4982H6.625ZM11 14.4982V19.7482H13.625V14.4982H11ZM15.375 14.4982V19.7482H18V14.4982H15.375ZM19.75 14.4982V19.7482H22.375V14.4982H19.75ZM4 23.6857C4 22.4782 4.98 21.4982 6.1875 21.4982H22.8125C24.02 21.4982 25 22.4782 25 23.6857V24.1232C25 24.3553 24.9078 24.5778 24.7437 24.7419C24.5796 24.906 24.3571 24.9982 24.125 24.9982H4.875C4.64294 24.9982 4.42038 24.906 4.25628 24.7419C4.09219 24.5778 4 24.3553 4 24.1232V23.6857Z"
        fill={color}
      />
    </svg>
  );
};
export const AppointmentIcon = ({ color }: PlayIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="25"
      viewBox="0 0 28 29"
      fill="none"
    >
      <path
        d="M2.33325 22.6654C2.33325 24.6487 3.84992 26.1654 5.83325 26.1654H22.1666C24.1499 26.1654 25.6666 24.6487 25.6666 22.6654V13.332H2.33325V22.6654ZM22.1666 5.16536H19.8333V3.9987C19.8333 3.2987 19.3666 2.83203 18.6666 2.83203C17.9666 2.83203 17.4999 3.2987 17.4999 3.9987V5.16536H10.4999V3.9987C10.4999 3.2987 10.0333 2.83203 9.33325 2.83203C8.63325 2.83203 8.16659 3.2987 8.16659 3.9987V5.16536H5.83325C3.84992 5.16536 2.33325 6.68203 2.33325 8.66537V10.9987H25.6666V8.66537C25.6666 6.68203 24.1499 5.16536 22.1666 5.16536Z"
        fill={color}
      />
    </svg>
  );
};
export const AppointmentIconCall = ({ color }: PlayIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      viewBox="0 0 28 29"
      fill="none"
    >
      <path
        d="M2.33325 22.6654C2.33325 24.6487 3.84992 26.1654 5.83325 26.1654H22.1666C24.1499 26.1654 25.6666 24.6487 25.6666 22.6654V13.332H2.33325V22.6654ZM22.1666 5.16536H19.8333V3.9987C19.8333 3.2987 19.3666 2.83203 18.6666 2.83203C17.9666 2.83203 17.4999 3.2987 17.4999 3.9987V5.16536H10.4999V3.9987C10.4999 3.2987 10.0333 2.83203 9.33325 2.83203C8.63325 2.83203 8.16659 3.2987 8.16659 3.9987V5.16536H5.83325C3.84992 5.16536 2.33325 6.68203 2.33325 8.66537V10.9987H25.6666V8.66537C25.6666 6.68203 24.1499 5.16536 22.1666 5.16536Z"
        fill={color}
      />
    </svg>
  );
};

export const InventoryIcon = ({ color }: PlayIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="29"
      viewBox="0 0 28 29"
      fill="none"
    >
      <path
        d="M10.8103 2.82422C10.5783 2.82422 10.3557 2.91641 10.1916 3.0805C10.0275 3.24459 9.93533 3.46715 9.93533 3.69922V5.75022H9.16067C8.34776 5.74996 7.55629 6.01097 6.90301 6.49473C6.24972 6.9785 5.7692 7.65942 5.53233 8.43705L5.4635 8.66688H4.375C4.14294 8.66688 3.92038 8.75907 3.75628 8.92317C3.59219 9.08726 3.5 9.30982 3.5 9.54188C3.5 9.77395 3.59219 9.99651 3.75628 10.1606C3.92038 10.3247 4.14294 10.4169 4.375 10.4169H4.99683L4.76117 11.3817C4.37593 11.6158 4.05752 11.9453 3.83662 12.3382C3.61571 12.7312 3.49978 13.1744 3.5 13.6252V23.5419C3.5 24.6689 4.41467 25.5836 5.54167 25.5836H7.29167C7.83315 25.5836 8.35246 25.3684 8.73534 24.9856C9.11823 24.6027 9.33333 24.0834 9.33333 23.5419V22.0836H18.6667V23.5419C18.6667 24.6689 19.5813 25.5836 20.7083 25.5836H22.4583C22.9998 25.5836 23.5191 25.3684 23.902 24.9856C24.2849 24.6027 24.5 24.0834 24.5 23.5419V13.6252C24.5 12.6744 23.9937 11.8402 23.2365 11.3806L22.9962 10.4169H23.625C23.8571 10.4169 24.0796 10.3247 24.2437 10.1606C24.4078 9.99651 24.5 9.77395 24.5 9.54188C24.5 9.30982 24.4078 9.08726 24.2437 8.92317C24.0796 8.75907 23.8571 8.66688 23.625 8.66688H22.526L22.4618 8.45222C22.2275 7.67119 21.7476 6.98651 21.0934 6.49978C20.4391 6.01305 19.6454 5.75019 18.83 5.75022H18.0647V3.69922C18.0647 3.46715 17.9725 3.24459 17.8084 3.0805C17.6443 2.91641 17.4217 2.82422 17.1897 2.82422H10.8103ZM9.16067 7.50022H18.83C19.269 7.50026 19.6963 7.64181 20.0486 7.90387C20.4008 8.16594 20.6591 8.53456 20.7853 8.95505L21.0303 9.77405L21.3383 11.0002H6.65583L6.95567 9.77288L7.20767 8.94688C7.33519 8.52829 7.59383 8.16175 7.94545 7.90129C8.29708 7.64083 8.72308 7.50023 9.16067 7.50022ZM5.25 22.0836H7.58333V23.5419C7.58333 23.6192 7.5526 23.6934 7.49791 23.7481C7.44321 23.8028 7.36902 23.8336 7.29167 23.8336H5.54167C5.46431 23.8336 5.39013 23.8028 5.33543 23.7481C5.28073 23.6934 5.25 23.6192 5.25 23.5419V22.0836ZM20.4167 22.0836H22.75V23.5419C22.75 23.6192 22.7193 23.6934 22.6646 23.7481C22.6099 23.8028 22.5357 23.8336 22.4583 23.8336H20.7083C20.631 23.8336 20.5568 23.8028 20.5021 23.7481C20.4474 23.6934 20.4167 23.6192 20.4167 23.5419V22.0836ZM9.33917 15.6669C9.33917 15.9763 9.21625 16.2731 8.99746 16.4918C8.77867 16.7106 8.48192 16.8336 8.1725 16.8336C7.86308 16.8336 7.56633 16.7106 7.34754 16.4918C7.12875 16.2731 7.00583 15.9763 7.00583 15.6669C7.00583 15.3575 7.12875 15.0607 7.34754 14.8419C7.56633 14.6231 7.86308 14.5002 8.1725 14.5002C8.48192 14.5002 8.77867 14.6231 8.99746 14.8419C9.21625 15.0607 9.33917 15.3575 9.33917 15.6669ZM19.8333 16.8336C19.5239 16.8336 19.2272 16.7106 19.0084 16.4918C18.7896 16.2731 18.6667 15.9763 18.6667 15.6669C18.6667 15.3575 18.7896 15.0607 19.0084 14.8419C19.2272 14.6231 19.5239 14.5002 19.8333 14.5002C20.1428 14.5002 20.4395 14.6231 20.6583 14.8419C20.8771 15.0607 21 15.3575 21 15.6669C21 15.9763 20.8771 16.2731 20.6583 16.4918C20.4395 16.7106 20.1428 16.8336 19.8333 16.8336Z"
        fill={color}
      />
    </svg>
  );
};
export const TemplateIcon = ({ color }: PlayIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="31"
      viewBox="0 0 32 31"
      fill="none"
    >
      <g clip-path="url(#clip0_2325_165353)">
        <path
          d="M23.7226 2.62891C24.4053 2.62891 25.06 2.9001 25.5428 3.38283C26.0255 3.86555 26.2967 4.52027 26.2967 5.20295V25.7953C26.2967 26.478 26.0255 27.1327 25.5428 27.6154C25.06 28.0981 24.4053 28.3693 23.7226 28.3693H8.27839C7.59571 28.3693 6.94099 28.0981 6.45827 27.6154C5.97554 27.1327 5.70435 26.478 5.70435 25.7953V5.20295C5.70435 4.52027 5.97554 3.86555 6.45827 3.38283C6.94099 2.9001 7.59571 2.62891 8.27839 2.62891H23.7226ZM16.0005 16.7861H12.1395C11.7981 16.7861 11.4708 16.9217 11.2294 17.1631C10.988 17.4045 10.8524 17.7318 10.8524 18.0732C10.8524 18.4145 10.988 18.7419 11.2294 18.9832C11.4708 19.2246 11.7981 19.3602 12.1395 19.3602H16.0005C16.3419 19.3602 16.6692 19.2246 16.9106 18.9832C17.1519 18.7419 17.2875 18.4145 17.2875 18.0732C17.2875 17.7318 17.1519 17.4045 16.9106 17.1631C16.6692 16.9217 16.3419 16.7861 16.0005 16.7861ZM19.8616 10.351H12.1395C11.8114 10.3514 11.4959 10.477 11.2574 10.7022C11.0188 10.9274 10.8753 11.2352 10.8561 11.5626C10.8368 11.8901 10.9434 12.2126 11.1539 12.4641C11.3645 12.7157 11.6631 12.8773 11.9889 12.9161L12.1395 12.9251H19.8616C20.1896 12.9247 20.5051 12.7991 20.7437 12.5739C20.9822 12.3487 21.1257 12.041 21.145 11.7135C21.1642 11.386 21.0576 11.0636 20.8471 10.812C20.6366 10.5605 20.3379 10.3988 20.0122 10.36L19.8616 10.351Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_2325_165353">
          <rect
            width="30.8885"
            height="30.8885"
            fill="none"
            transform="translate(0.555664 0.0546875)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export const AttachIcon = ({ color }: PlayIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="31"
      viewBox="0 0 32 31"
      fill="none"
    >
      <path
        d="M15.3563 28.3706C13.3828 28.3706 11.7096 27.6841 10.3367 26.3112C8.96379 24.9384 8.27734 23.2651 8.27734 21.2916V7.77724C8.27734 6.36145 8.78145 5.14944 9.78967 4.14123C10.7979 3.13301 12.0099 2.62891 13.4257 2.62891C14.8415 2.62891 16.0535 3.13301 17.0617 4.14123C18.0699 5.14944 18.574 6.36145 18.574 7.77724V18.0739H16.6434V7.77724C16.6434 6.87628 16.3323 6.11476 15.7102 5.49267C15.0882 4.87058 14.3266 4.55953 13.4257 4.55953C12.5247 4.55953 11.7632 4.87058 11.1411 5.49267C10.519 6.11476 10.208 6.87628 10.208 7.77724V21.2916C10.208 22.7074 10.7121 23.9194 11.7203 24.9276C12.7285 25.9358 13.9405 26.4399 15.3563 26.4399C15.9784 26.4399 16.5632 26.3378 17.1106 26.1336C17.658 25.9294 18.1458 25.6454 18.574 25.2816V27.5983C18.0806 27.8343 17.5658 28.0222 17.0295 28.1621C16.4932 28.3019 15.9355 28.3714 15.3563 28.3706ZM21.1482 23.2222H18.574C18.2093 23.2222 17.9034 23.0987 17.6563 22.8516C17.4092 22.6044 17.2861 22.299 17.2869 21.9352C17.2869 21.5705 17.4105 21.2646 17.6576 21.0175C17.9047 20.7703 18.2102 20.6472 18.574 20.6481H21.1482V18.0739C21.1482 17.7092 21.2717 17.4033 21.5189 17.1562C21.766 16.9091 22.0714 16.786 22.4353 16.7868C22.7999 16.7868 23.1058 16.9104 23.353 17.1575C23.6001 17.4046 23.7232 17.7101 23.7223 18.0739V20.6481H26.2965C26.6612 20.6481 26.9671 20.7716 27.2142 21.0188C27.4613 21.2659 27.5845 21.5713 27.5836 21.9352C27.5836 22.2998 27.46 22.6057 27.2129 22.8528C26.9658 23.1 26.6603 23.2231 26.2965 23.2222H23.7223V25.7964C23.7223 26.1611 23.5988 26.467 23.3517 26.7141C23.1045 26.9612 22.7991 27.0843 22.4353 27.0835C22.0706 27.0835 21.7647 26.9599 21.5176 26.7128C21.2705 26.4657 21.1473 26.1602 21.1482 25.7964V23.2222ZM15.3563 21.2916V23.2222C14.4553 23.2222 13.6938 22.9112 13.0717 22.2891C12.4496 21.667 12.1386 20.9055 12.1386 20.0045V8.74255C12.1386 8.46368 12.23 8.2333 12.4127 8.05139C12.5955 7.86948 12.8259 7.7781 13.1039 7.77724C13.3828 7.77724 13.6132 7.86862 13.7951 8.05139C13.977 8.23415 14.0684 8.46454 14.0692 8.74255V20.0045C14.0692 20.3692 14.1928 20.6751 14.4399 20.9222C14.687 21.1693 14.9925 21.2925 15.3563 21.2916ZM20.5046 14.2127V8.74255C20.5046 8.46368 20.596 8.2333 20.7788 8.05139C20.9616 7.86948 21.1919 7.7781 21.4699 7.77724C21.7488 7.77724 21.9792 7.86862 22.1611 8.05139C22.343 8.23415 22.4344 8.46454 22.4353 8.74255V14.2127H20.5046Z"
        fill={color}
      />
    </svg>
  );
};

export const AttachIconSimple = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M13.7526 5.62504V14.4417C13.7526 16.1834 12.4776 17.7334 10.7443 17.9C10.2812 17.9463 9.81362 17.8949 9.37167 17.7492C8.92971 17.6036 8.52323 17.3668 8.17847 17.0542C7.83371 16.7417 7.55835 16.3603 7.37016 15.9347C7.18197 15.5091 7.08515 15.0487 7.08594 14.5834V4.28337C7.08594 3.1917 7.86927 2.20004 8.9526 2.0917C9.24313 2.06132 9.5368 2.09238 9.81455 2.18286C10.0923 2.27334 10.3479 2.42121 10.5648 2.61688C10.7817 2.81256 10.955 3.05166 11.0735 3.31866C11.192 3.58566 11.253 3.87459 11.2526 4.1667V12.9167C11.2526 13.375 10.8776 13.75 10.4193 13.75C9.96094 13.75 9.58594 13.375 9.58594 12.9167V5.62504C9.58594 5.28337 9.3026 5.00004 8.96094 5.00004C8.61927 5.00004 8.33594 5.28337 8.33594 5.62504V12.8C8.33594 13.8917 9.11927 14.8834 10.2026 14.9917C10.4931 15.0221 10.7868 14.991 11.0646 14.9005C11.3423 14.8101 11.5979 14.6622 11.8148 14.4665C12.0317 14.2709 12.205 14.0318 12.3235 13.7648C12.442 13.4978 12.503 13.2088 12.5026 12.9167V4.30837C12.5026 2.5667 11.2276 1.0167 9.49427 0.850038C9.03136 0.80443 8.56402 0.856262 8.12235 1.0022C7.68068 1.14813 7.27446 1.38494 6.92984 1.69737C6.58523 2.0098 6.30986 2.39093 6.12145 2.81622C5.93305 3.24151 5.83579 3.70155 5.83594 4.1667V14.3917C5.83594 16.7834 7.58594 18.925 9.96927 19.15C12.7109 19.4 15.0026 17.2667 15.0026 14.5834V5.62504C15.0026 5.28337 14.7193 5.00004 14.3776 5.00004C14.0359 5.00004 13.7526 5.28337 13.7526 5.62504Z"
        fill="#1E88E5"
      />
    </svg>
  );
};

export const CloudUploadIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="59"
      height="59"
      viewBox="0 0 59 59"
      fill="none"
    >
      <g filter="url(#filter0_d_3286_102358)">
        <circle cx="29.5" cy="25.5" r="25.5" fill="#43A047" />
      </g>
      <path
        d="M39.1693 22.8226C38.2748 18.1097 34.2889 14.5715 29.5006 14.5715C25.6988 14.5715 22.397 16.8119 20.7526 20.0905C16.7931 20.5276 13.7148 24.0111 13.7148 28.2322C13.7148 32.7539 17.2535 36.4287 21.6077 36.4287H38.7089C42.3396 36.4287 45.2863 33.3687 45.2863 29.5983C45.2863 25.9919 42.5895 23.0685 39.1693 22.8226ZM32.1315 26.8662V32.3305H26.8696V26.8662H22.9232L29.5006 20.0358L36.0779 26.8662H32.1315Z"
        fill="white"
      />
      <defs>
        <filter
          id="filter0_d_3286_102358"
          x="0"
          y="0"
          width="59"
          height="59"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_3286_102358"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_3286_102358"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export const IntegrationIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="13"
      height="14"
      viewBox="0 0 13 14"
      fill="none"
    >
      <path
        d="M10.9167 1.66683H8.13C7.85 0.893496 7.11667 0.333496 6.25 0.333496C5.38333 0.333496 4.65 0.893496 4.37 1.66683H1.58333C1.49 1.66683 1.40333 1.6735 1.31667 1.6935C1.10434 1.73804 0.906027 1.83353 0.738794 1.97173C0.571561 2.10993 0.440421 2.2867 0.356667 2.48683C0.29 2.64016 0.25 2.8135 0.25 3.00016V12.3335C0.25 12.5135 0.29 12.6935 0.356667 12.8535C0.423333 13.0135 0.523333 13.1535 0.643333 13.2802C0.823333 13.4602 1.05667 13.5935 1.31667 13.6468C1.40333 13.6602 1.49 13.6668 1.58333 13.6668H10.9167C11.65 13.6668 12.25 13.0668 12.25 12.3335V3.00016C12.25 2.26683 11.65 1.66683 10.9167 1.66683ZM5.58333 9.1135L4.64333 10.0602L2.25 7.66683L4.64333 5.2735L5.58333 6.22016L4.13667 7.66683L5.58333 9.1135ZM6.25 2.50016C5.97667 2.50016 5.75 2.2735 5.75 2.00016C5.75 1.72683 5.97667 1.50016 6.25 1.50016C6.52333 1.50016 6.75 1.72683 6.75 2.00016C6.75 2.2735 6.52333 2.50016 6.25 2.50016ZM7.85667 10.0602L6.91667 9.1135L8.36333 7.66683L6.91667 6.22016L7.85667 5.2735L10.25 7.66683L7.85667 10.0602Z"
        fill="#212121"
      />
    </svg>
  );
};

export const TiktokLogo = ({ width = "16", height = "16" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M6.44622 6.31195V5.6955C6.23231 5.66512 6.01646 5.64949 5.80044 5.64844C3.15781 5.64844 1.00781 7.79879 1.00781 10.4414C1.00781 12.0624 1.81797 13.4975 3.05384 14.3652C2.2263 13.4803 1.76616 12.3138 1.76686 11.1021C1.76686 8.49708 3.85575 6.37271 6.44622 6.31195Z"
        fill="#00F2EA"
      />
      <path
        d="M6.5595 13.2907C7.73864 13.2907 8.70036 12.3527 8.74427 11.1837L8.74831 0.748592H10.6547C10.614 0.530641 10.5934 0.309529 10.5933 0.0878906H7.98943L7.98504 10.5234C7.94166 11.692 6.97942 12.6296 5.80062 12.6296C5.44674 12.6298 5.09812 12.5436 4.78516 12.3783C5.19524 12.9505 5.85559 13.29 6.5595 13.2907ZM14.2157 4.29077V3.71086C13.5151 3.71156 12.8295 3.50766 12.2431 3.12445C12.7573 3.71648 13.4494 4.12568 14.216 4.29077"
        fill="#00F2EA"
      />
      <path
        d="M12.2445 3.12382C11.6699 2.46628 11.3533 1.62241 11.3536 0.749023H10.656C10.8385 1.72444 11.4126 2.58272 12.2445 3.12382ZM5.8021 8.25207C4.5938 8.25348 3.61469 9.23259 3.61328 10.4409C3.61398 11.2544 4.06569 12.0004 4.78628 12.3784C4.51705 12.0071 4.37216 11.5605 4.37216 11.1019C4.37339 9.89364 5.3525 8.91418 6.56097 8.91278C6.78647 8.91278 7.00267 8.95001 7.20674 9.01411V6.35585C6.99283 6.32547 6.77699 6.30984 6.56097 6.30878C6.52304 6.30878 6.48563 6.31089 6.44804 6.31159V8.35341C6.23905 8.28702 6.02128 8.25278 5.8021 8.25207Z"
        fill="#F44336"
      />
      <path
        d="M14.2162 4.29057V6.31429C12.8658 6.31429 11.6152 5.88243 10.5936 5.14937V10.441C10.5936 13.0836 8.44392 15.2336 5.80129 15.2336C4.78003 15.2336 3.83306 14.9113 3.05469 14.3648C3.95933 15.3404 5.22963 15.8946 6.55999 15.8943C9.20262 15.8943 11.3526 13.7443 11.3526 11.102V5.81042C12.4079 6.5693 13.6754 6.97693 14.9752 6.97535V4.37083C14.7146 4.37083 14.4612 4.34255 14.216 4.29004"
        fill="#F44336"
      />
      <path
        d="M10.5915 10.4409V5.14931C11.6468 5.90836 12.9143 6.31581 14.2141 6.31423V4.29068C13.4477 4.12541 12.7555 3.71603 12.2415 3.12382C11.4095 2.58272 10.8354 1.72444 10.653 0.749023H8.74672L8.74268 11.1841C8.69895 12.3527 7.73705 13.2908 6.5579 13.2908C5.85418 13.2901 5.19365 12.9504 4.78374 12.3786C4.06315 12.0008 3.61127 11.2547 3.61039 10.4411C3.6118 9.23276 4.5909 8.25365 5.7992 8.25225C6.02436 8.25225 6.24055 8.28913 6.44498 8.35359V6.31177C3.85451 6.37254 1.76562 8.4969 1.76562 11.1019C1.76562 12.3617 2.25509 13.5085 3.0526 14.3651C3.85662 14.9311 4.81606 15.2344 5.7992 15.2335C8.44201 15.2335 10.5915 13.0835 10.5915 10.4409Z"
        fill="black"
      />
    </svg>
  );
};

export const RouteIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <g clip-path="url(#clip0_2223_97345)">
        <path
          d="M12.6667 12.6667H3.33333V3.33333H8V2H3.33333C2.59333 2 2 2.6 2 3.33333V12.6667C2 13.4 2.59333 14 3.33333 14H12.6667C13.4 14 14 13.4 14 12.6667V8H12.6667V12.6667ZM9.33333 2V3.33333H11.7267L5.17333 9.88667L6.11333 10.8267L12.6667 4.27333V6.66667H14V2H9.33333Z"
          fill="#1E88E5"
        />
      </g>
      <defs>
        <clipPath id="clip0_2223_97345">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const UnreadMsgIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="54"
      height="41"
      viewBox="0 0 54 41"
      fill="none"
    >
      <g clip-path="url(#clip0_1878_138750)">
        <path
          d="M45.5 12.3514V27.2071C45.5 29.0228 43.8125 30.5084 41.75 30.5084H15.5L8 37.111V7.39944C8 5.58373 9.6875 4.09816 11.75 4.09816H30.6875C30.5 4.59335 30.5 5.25361 30.5 5.7488C30.5 10.3706 34.625 14.002 39.875 14.002C41.9375 14.002 44 13.3417 45.5 12.3514ZM34.25 5.7488C34.25 8.55489 36.6875 10.7007 39.875 10.7007C43.0625 10.7007 45.5 8.55489 45.5 5.7488C45.5 2.94271 43.0625 0.796875 39.875 0.796875C36.6875 0.796875 34.25 2.94271 34.25 5.7488Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_1878_138750">
          <rect
            width="53.2186"
            height="39.6154"
            fill="white"
            transform="translate(0 0.796875)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const NewLeadsIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="45"
      height="46"
      viewBox="0 0 45 46"
      fill="none"
    >
      <path
        d="M18.75 8.29688C22.875 8.29688 26.25 11.6719 26.25 15.7969C26.25 19.9219 22.875 23.2969 18.75 23.2969C14.625 23.2969 11.25 19.9219 11.25 15.7969C11.25 11.6719 14.625 8.29688 18.75 8.29688ZM31.875 40.1719L35.25 43.4906C36.1875 44.4281 37.5 43.6781 37.5 42.5719V34.5469L42.75 28.1719C42.9589 27.8933 43.0862 27.5621 43.1174 27.2153C43.1487 26.8685 43.0828 26.5198 42.927 26.2084C42.7713 25.8969 42.532 25.635 42.2357 25.4519C41.9395 25.2688 41.5982 25.1719 41.25 25.1719H28.125C26.625 25.1719 25.6875 27.0469 26.625 28.1719L31.875 34.5469V40.1719ZM28.125 35.8594L23.8125 30.6094C23.0625 29.6719 22.6875 28.5469 22.6875 27.4219C21.375 27.0469 20.0625 27.0469 18.75 27.0469C10.5 27.0469 3.75 30.4219 3.75 34.5469V38.2969H28.125V35.8594Z"
        fill="white"
      />
    </svg>
  );
};

export const EngagedLeadsIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="46"
      height="46"
      viewBox="0 0 46 46"
      fill="none"
    >
      <g clip-path="url(#clip0_1878_138765)">
        <path
          d="M1.97911 26.2918L5.04586 27.0523L7.35436 23.4275L2.96686 22.343C2.44322 22.212 1.889 22.2944 1.42611 22.5721C0.963222 22.8497 0.629589 23.2999 0.498605 23.8235C0.367622 24.3472 0.450017 24.9014 0.727664 25.3643C1.00531 25.8272 1.45547 26.1608 1.97911 26.2918ZM42.0089 26.879L31.9671 35.915L20.1614 26.7778C19.9361 26.6045 19.677 26.4804 19.4009 26.4133L17.8304 26.0218L15.5196 29.6465L17.9946 30.2608L30.8129 40.1788C31.1934 40.4717 31.6644 40.6224 32.1443 40.6047C32.6242 40.587 33.0829 40.4021 33.4409 40.082L44.7539 29.8963C44.953 29.7178 45.1149 29.5015 45.23 29.2601C45.3452 29.0187 45.4114 28.7568 45.4248 28.4897C45.4382 28.2225 45.3985 27.9554 45.3081 27.7036C45.2176 27.4519 45.0782 27.2206 44.8979 27.023C44.5329 26.6224 44.0243 26.3824 43.483 26.3554C42.9418 26.3284 42.4118 26.5167 42.0089 26.879ZM19.9656 16.952L30.9614 23.9923C31.408 24.2778 31.9477 24.3797 32.4676 24.2765C32.9876 24.1734 33.4476 23.8732 33.7514 23.4388L45.0621 7.14428C45.2152 6.92438 45.3233 6.67634 45.3801 6.41446C45.4369 6.15259 45.4412 5.88206 45.3929 5.61849C45.3446 5.35492 45.2445 5.10353 45.0986 4.87883C44.9526 4.65412 44.7635 4.46055 44.5424 4.30928C44.0961 4.00097 43.5458 3.8823 43.0122 3.97932C42.4786 4.07635 42.0052 4.38113 41.6961 4.82678L31.5081 19.499L20.4471 12.4183C19.9881 12.1248 19.4314 12.0253 18.8991 12.1415C18.3688 12.26 17.9069 12.5836 17.6144 13.0415L0.746105 39.5173C0.548303 39.8252 0.437357 40.1809 0.424989 40.5467C0.412621 40.9125 0.49929 41.2748 0.67584 41.5954C0.85239 41.916 1.11226 42.183 1.428 42.3681C1.74374 42.5532 2.10362 42.6496 2.46961 42.647C2.81393 42.6479 3.15289 42.5617 3.455 42.3965C3.7571 42.2313 4.01255 41.9924 4.19761 41.702L19.9656 16.952Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_1878_138765">
          <rect
            width="45"
            height="45"
            fill="white"
            transform="translate(0.426758 0.796875)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const AppointConfirmIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="46"
      height="46"
      viewBox="0 0 46 46"
      fill="none"
    >
      <path
        d="M39.5166 33.1406V17.6719H5.7666V33.1406C5.7666 35.0054 6.50739 36.7939 7.82601 38.1125C9.14462 39.4311 10.933 40.1719 12.7979 40.1719H32.4854C34.3502 40.1719 36.1386 39.4311 37.4572 38.1125C38.7758 36.7939 39.5166 35.0054 39.5166 33.1406ZM17.0082 23.9944C17.0082 24.5527 16.7864 25.0882 16.3916 25.4829C15.9968 25.8777 15.4613 26.0995 14.903 26.0995C14.3447 26.0995 13.8092 25.8777 13.4144 25.4829C13.0196 25.0882 12.7979 24.5527 12.7979 23.9944C12.7979 23.4361 13.0196 22.9006 13.4144 22.5058C13.8092 22.111 14.3447 21.8892 14.903 21.8892C15.4613 21.8892 15.9968 22.111 16.3916 22.5058C16.7864 22.9006 17.0082 23.4361 17.0082 23.9944ZM17.0082 31.0256C17.0082 31.5839 16.7864 32.1194 16.3916 32.5142C15.9968 32.909 15.4613 33.1308 14.903 33.1308C14.3447 33.1308 13.8092 32.909 13.4144 32.5142C13.0196 32.1194 12.7979 31.5839 12.7979 31.0256C12.7979 30.4673 13.0196 29.9318 13.4144 29.5371C13.8092 29.1423 14.3447 28.9205 14.903 28.9205C15.4613 28.9205 15.9968 29.1423 16.3916 29.5371C16.7864 29.9318 17.0082 30.4673 17.0082 31.0256ZM24.7482 23.9944C24.7482 24.5527 24.5264 25.0882 24.1316 25.4829C23.7368 25.8777 23.2013 26.0995 22.643 26.0995C22.0847 26.0995 21.5492 25.8777 21.1544 25.4829C20.7596 25.0882 20.5379 24.5527 20.5379 23.9944C20.5379 23.4361 20.7596 22.9006 21.1544 22.5058C21.5492 22.111 22.0847 21.8892 22.643 21.8892C23.2013 21.8892 23.7368 22.111 24.1316 22.5058C24.5264 22.9006 24.7482 23.4361 24.7482 23.9944ZM24.7482 31.0256C24.7482 31.5839 24.5264 32.1194 24.1316 32.5142C23.7368 32.909 23.2013 33.1308 22.643 33.1308C22.0847 33.1308 21.5492 32.909 21.1544 32.5142C20.7596 32.1194 20.5379 31.5839 20.5379 31.0256C20.5379 30.4673 20.7596 29.9318 21.1544 29.5371C21.5492 29.1423 22.0847 28.9205 22.643 28.9205C23.2013 28.9205 23.7368 29.1423 24.1316 29.5371C24.5264 29.9318 24.7482 30.4673 24.7482 31.0256ZM32.4769 23.9944C32.4769 24.5527 32.2551 25.0882 31.8603 25.4829C31.4655 25.8777 30.9301 26.0995 30.3718 26.0995C29.8134 26.0995 29.278 25.8777 28.8832 25.4829C28.4884 25.0882 28.2666 24.5527 28.2666 23.9944C28.2666 23.4361 28.4884 22.9006 28.8832 22.5058C29.278 22.111 29.8134 21.8892 30.3718 21.8892C30.9301 21.8892 31.4655 22.111 31.8603 22.5058C32.2551 22.9006 32.4769 23.4361 32.4769 23.9944ZM39.5166 13.4531C39.5166 11.5883 38.7758 9.7999 37.4572 8.48128C36.1386 7.16267 34.3502 6.42188 32.4854 6.42188H12.7979C10.933 6.42188 9.14462 7.16267 7.82601 8.48128C6.50739 9.7999 5.7666 11.5883 5.7666 13.4531V14.8594H39.5166V13.4531Z"
        fill="white"
      />
    </svg>
  );
};

export const PDFDarkIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <g clip-path="url(#clip0_2338_204133)">
        <path
          d="M4.66667 10.6663H4V9.33301H4.66667C4.84348 9.33301 5.01305 9.40325 5.13807 9.52827C5.2631 9.65329 5.33333 9.82286 5.33333 9.99967C5.33333 10.1765 5.2631 10.3461 5.13807 10.4711C5.01305 10.5961 4.84348 10.6663 4.66667 10.6663ZM9.33333 13.333V9.33301H10C10.1768 9.33301 10.3464 9.40325 10.4714 9.52827C10.5964 9.65329 10.6667 9.82286 10.6667 9.99967V12.6663C10.6667 12.8432 10.5964 13.0127 10.4714 13.1377C10.3464 13.2628 10.1768 13.333 10 13.333H9.33333Z"
          fill="#424242"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.33301 2C1.33301 1.46957 1.54372 0.960859 1.91879 0.585786C2.29387 0.210714 2.80257 0 3.33301 0L14.2757 0L18.6663 4.39067V18C18.6663 18.5304 18.4556 19.0391 18.0806 19.4142C17.7055 19.7893 17.1968 20 16.6663 20H3.33301C2.80257 20 2.29387 19.7893 1.91879 19.4142C1.54372 19.0391 1.33301 18.5304 1.33301 18V2ZM4.66634 8H2.66634V14.6667H3.99967V12H4.66634C5.19677 12 5.70548 11.7893 6.08055 11.4142C6.45563 11.0391 6.66634 10.5304 6.66634 10C6.66634 9.46957 6.45563 8.96086 6.08055 8.58579C5.70548 8.21071 5.19677 8 4.66634 8ZM9.99967 8H7.99967V14.6667H9.99967C10.5301 14.6667 11.0388 14.456 11.4139 14.0809C11.789 13.7058 11.9997 13.1971 11.9997 12.6667V10C11.9997 9.46957 11.789 8.96086 11.4139 8.58579C11.0388 8.21071 10.5301 8 9.99967 8ZM13.333 14.6667V8H17.333V9.33333H14.6663V10.6667H15.9997V12H14.6663V14.6667H13.333Z"
          fill="#424242"
        />
      </g>
      <defs>
        <clipPath id="clip0_2338_204133">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ExcelDarkIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M2.38268 2.39835L12.8577 0.901683C12.9168 0.893203 12.977 0.89753 13.0343 0.914371C13.0916 0.931212 13.1447 0.960174 13.1898 0.999294C13.2349 1.03841 13.2711 1.08678 13.2959 1.14111C13.3207 1.19544 13.3335 1.25446 13.3335 1.31418V18.6867C13.3335 18.7463 13.3207 18.8053 13.2959 18.8595C13.2712 18.9138 13.2351 18.9621 13.1901 19.0012C13.145 19.0403 13.0921 19.0693 13.0349 19.0862C12.9777 19.1031 12.9176 19.1075 12.8585 19.0992L2.38185 17.6025C2.1832 17.5742 2.00143 17.4752 1.86992 17.3236C1.73842 17.1721 1.66602 16.9782 1.66602 16.7775V3.22335C1.66602 3.02269 1.73842 2.82878 1.86992 2.67722C2.00143 2.52566 2.18403 2.42664 2.38268 2.39835ZM14.1668 2.50002H17.5002C17.7212 2.50002 17.9332 2.58781 18.0894 2.74409C18.2457 2.90037 18.3335 3.11234 18.3335 3.33335V16.6667C18.3335 16.8877 18.2457 17.0997 18.0894 17.2559C17.9332 17.4122 17.7212 17.5 17.5002 17.5H14.1668V2.50002ZM8.50018 10L10.8335 6.66668H8.83352L7.50018 8.57168L6.16685 6.66668H4.16685L6.50018 10L4.16685 13.3333H6.16685L7.50018 11.4283L8.83352 13.3333H10.8335L8.50018 10Z"
        fill="#424242"
      />
    </svg>
  );
};

export const SetPriorityIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M10.0003 3.33301C5.40533 3.33301 1.667 7.07134 1.667 11.6663C1.66591 12.9525 1.96586 14.221 2.54283 15.3705C2.6845 15.6538 2.97283 15.833 3.28866 15.833H16.7112C17.027 15.833 17.3162 15.6538 17.4578 15.3705C18.0348 14.221 18.3347 12.9525 18.3337 11.6663C18.3337 7.07134 14.5953 3.33301 10.0003 3.33301ZM14.1853 7.51801L10.8837 12.5497C10.7918 12.69 10.6732 12.8107 10.5346 12.9051C10.396 12.9995 10.2401 13.0656 10.076 13.0996C9.91179 13.1337 9.74251 13.135 9.57781 13.1036C9.41311 13.0721 9.25623 13.0085 9.11616 12.9163C8.93889 12.8004 8.79329 12.6422 8.69252 12.4558C8.59175 12.2695 8.53899 12.0611 8.53899 11.8493C8.53899 11.6374 8.59175 11.429 8.69252 11.2427C8.79329 11.0564 8.93889 10.8981 9.11616 10.7822L14.1478 7.48051C14.1539 7.47673 14.1613 7.47548 14.1683 7.47704C14.1753 7.4786 14.1814 7.48283 14.1853 7.48884C14.188 7.49325 14.1894 7.49829 14.1894 7.50342C14.1894 7.50856 14.188 7.5136 14.1853 7.51801Z"
        fill="#545454"
      />
    </svg>
  );
};

export const DarkFilterIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M11.6668 10V16.5667C11.7001 16.8167 11.6168 17.0833 11.4251 17.2583C11.348 17.3356 11.2564 17.3969 11.1556 17.4387C11.0548 17.4805 10.9467 17.502 10.8376 17.502C10.7285 17.502 10.6204 17.4805 10.5196 17.4387C10.4188 17.3969 10.3272 17.3356 10.2501 17.2583L8.57511 15.5833C8.48422 15.4945 8.41511 15.3858 8.37319 15.2658C8.33127 15.1458 8.31766 15.0178 8.33344 14.8917V10H8.30844L3.50844 3.85C3.37312 3.67628 3.31205 3.45605 3.3386 3.23744C3.36514 3.01883 3.47714 2.81962 3.65011 2.68333C3.80844 2.56667 3.98344 2.5 4.16678 2.5H15.8334C16.0168 2.5 16.1918 2.56667 16.3501 2.68333C16.5231 2.81962 16.6351 3.01883 16.6616 3.23744C16.6882 3.45605 16.6271 3.67628 16.4918 3.85L11.6918 10H11.6668Z"
        fill="#212121"
      />
    </svg>
  );
};

export const InboundCallIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
    >
      <path
        d="M18.1995 2.80078H4.19946V24.5008H18.1995V2.80078Z"
        fill="#424242"
      />
      <mask
        id="mask0_5116_55695"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="28"
        height="28"
      >
        <rect
          width="28"
          height="28"
          transform="matrix(-1 0 0 1 28 0)"
          fill="#D9D9D9"
        />
      </mask>
      <g mask="url(#mask0_5116_55695)">
        <path
          d="M18.1992 8.39981V4.1998C18.1992 3.4266 17.5724 2.7998 16.7992 2.7998H5.59922C4.82602 2.7998 4.19922 3.42661 4.19922 4.1998V23.7998C4.19922 24.573 4.82602 25.1998 5.59922 25.1998H16.7992C17.5724 25.1998 18.1992 24.573 18.1992 23.7998V19.5998"
          stroke="#424242"
          strokeWidth="2.1"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.6006 4.19902H9.80059"
          stroke="white"
          strokeWidth="2.1"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M23.7998 16.3339H10.7331"
          stroke="white"
          strokeWidth="5.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.4666 20.0673L10.7332 16.334"
          stroke="white"
          strokeWidth="5.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.4666 12.6006L10.7332 16.3339"
          stroke="white"
          strokeWidth="5.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M23.7998 16.3339H10.7331"
          stroke="#424242"
          strokeWidth="2.1"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.4666 20.0673L10.7332 16.334"
          stroke="#424242"
          strokeWidth="2.1"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.4666 12.6006L10.7332 16.3339"
          stroke="#424242"
          strokeWidth="2.1"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

export const OutboundCallIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
    >
      <path
        d="M9.80054 2.80078H23.8005V24.5008H9.80054V2.80078Z"
        fill="#424242"
      />
      <mask
        id="mask0_5116_55712"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="28"
        height="28"
      >
        <rect width="28" height="28" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5116_55712)">
        <path
          d="M9.80078 8.39981V4.1998C9.80078 3.4266 10.4276 2.7998 11.2008 2.7998H22.4008C23.174 2.7998 23.8008 3.42661 23.8008 4.1998V23.7998C23.8008 24.573 23.174 25.1998 22.4008 25.1998H11.2008C10.4276 25.1998 9.80078 24.573 9.80078 23.7998V19.5998"
          stroke="#424242"
          strokeWidth="2.1"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.3994 4.19902H18.1994"
          stroke="white"
          strokeWidth="2.1"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.2002 16.3339H17.2669"
          stroke="white"
          strokeWidth="5.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.5334 20.0673L17.2668 16.334"
          stroke="white"
          strokeWidth="5.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.5334 12.6006L17.2668 16.3339"
          stroke="white"
          strokeWidth="5.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.2002 16.3339H17.2669"
          stroke="#424242"
          strokeWidth="2.1"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.5334 20.0673L17.2668 16.334"
          stroke="#424242"
          strokeWidth="2.1"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.5334 12.6006L17.2668 16.3339"
          stroke="#424242"
          strokeWidth="2.1"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

export const BlockUserIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
    >
      <path
        d="M7.29167 8.75C7.29167 8.17547 7.40483 7.60656 7.62469 7.07576C7.84456 6.54496 8.16682 6.06266 8.57307 5.65641C8.97933 5.25015 9.46163 4.92789 9.99243 4.70803C10.5232 4.48816 11.0921 4.375 11.6667 4.375C12.2412 4.375 12.8101 4.48816 13.3409 4.70803C13.8717 4.92789 14.354 5.25015 14.7603 5.65641C15.1665 6.06266 15.4888 6.54496 15.7086 7.07576C15.9285 7.60656 16.0417 8.17547 16.0417 8.75C16.0417 9.91032 15.5807 11.0231 14.7603 11.8436C13.9398 12.6641 12.827 13.125 11.6667 13.125C10.5063 13.125 9.39355 12.6641 8.57307 11.8436C7.7526 11.0231 7.29167 9.91032 7.29167 8.75ZM2.625 19.8333C2.625 18.673 3.08594 17.5602 3.90641 16.7397C4.72688 15.9193 5.83968 15.4583 7 15.4583H7.39667C7.6125 15.4583 7.82717 15.4933 8.03133 15.5587L9.04167 15.8888C10.1569 16.2531 11.3357 16.3814 12.5032 16.2657C12.5467 16.262 12.5904 16.2695 12.6302 16.2875C12.67 16.3055 12.7045 16.3333 12.7306 16.3683C12.7566 16.4034 12.7733 16.4445 12.779 16.4877C12.7848 16.531 12.7794 16.5751 12.7633 16.6157C12.4234 17.4523 12.2491 18.3469 12.25 19.25C12.25 20.7107 12.698 22.0675 13.4633 23.1898C13.5695 23.3462 13.4668 23.5667 13.2767 23.5725C10.216 23.6781 7.15243 23.4827 4.13 22.9892C3.70991 22.9208 3.32785 22.7052 3.05213 22.3809C2.77641 22.0567 2.62501 21.645 2.625 21.2193V19.8333Z"
        fill="#424242"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 19.25C14 20.384 14.3593 21.434 14.9707 22.2915C15.4546 22.9758 16.0961 23.5336 16.8408 23.918C17.5856 24.3023 18.4119 24.502 19.25 24.5C20.2884 24.5 21.3034 24.1921 22.1667 23.6152C23.0301 23.0383 23.703 22.2184 24.1004 21.2591C24.4977 20.2998 24.6017 19.2442 24.3991 18.2258C24.1966 17.2074 23.6965 16.2719 22.9623 15.5377C22.2281 14.8035 21.2926 14.3035 20.2742 14.1009C19.2558 13.8983 18.2002 14.0023 17.2409 14.3996C16.2816 14.797 15.4617 15.4699 14.8848 16.3333C14.3079 17.1966 14 18.2117 14 19.25ZM19.25 22.75C18.6246 22.7512 18.0104 22.5839 17.472 22.2658L22.2658 17.472C22.5794 18.0036 22.7468 18.6088 22.751 19.226C22.7552 19.8432 22.5962 20.4505 22.29 20.9864C21.9838 21.5223 21.5413 21.9677 21.0074 22.2774C20.4735 22.5872 19.8672 22.7502 19.25 22.75ZM16.2342 21.028L21.028 16.2342C20.3595 15.8391 19.5785 15.6776 18.8081 15.775C18.0377 15.8725 17.3216 16.2234 16.7725 16.7725C16.2234 17.3216 15.8725 18.0377 15.775 18.8081C15.6776 19.5785 15.8391 20.3595 16.2342 21.028Z"
        fill="#424242"
      />
    </svg>
  );
};

export const DNCIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 8.75C14 9.884 14.3593 10.934 14.9707 11.7915C15.4546 12.4758 16.0961 13.0336 16.8408 13.418C17.5856 13.8023 18.4119 14.002 19.25 14C20.2884 14 21.3034 13.6921 22.1667 13.1152C23.0301 12.5383 23.703 11.7184 24.1004 10.7591C24.4977 9.79978 24.6017 8.74418 24.3991 7.72578C24.1966 6.70738 23.6965 5.77192 22.9623 5.03769C22.2281 4.30347 21.2926 3.80345 20.2742 3.60088C19.2558 3.39831 18.2002 3.50227 17.2409 3.89963C16.2816 4.29699 15.4617 4.9699 14.8848 5.83326C14.3079 6.69662 14 7.71165 14 8.75ZM19.25 12.25C18.6246 12.2512 18.0104 12.0839 17.472 11.7658L22.2658 6.972C22.5794 7.50365 22.7468 8.10876 22.751 8.72596C22.7552 9.34316 22.5962 9.95051 22.29 10.4864C21.9838 11.0223 21.5413 11.4677 21.0074 11.7774C20.4735 12.0872 19.8672 12.2502 19.25 12.25ZM16.2342 10.528L21.028 5.73417C20.3595 5.3391 19.5785 5.17757 18.8081 5.27503C18.0377 5.37248 17.3216 5.72338 16.7725 6.27248C16.2234 6.82159 15.8725 7.53771 15.775 8.30812C15.6776 9.07852 15.8391 9.85946 16.2342 10.528Z"
        fill="#424242"
      />
      <path
        d="M5.62695 17.7454C3.26211 11.9389 7.06662 5.62377 13.0318 4.76627C13.2301 4.7371 13.3608 4.95993 13.2581 5.13027C12.4138 6.52598 12.0834 8.17275 12.3241 9.78612C12.5647 11.3995 13.3613 12.8782 14.5762 13.9667C15.791 15.0553 17.3479 15.6854 18.978 15.7482C20.608 15.811 22.2087 15.3026 23.5038 14.3108C23.6659 14.1859 23.9063 14.2991 23.8923 14.5033C23.711 17.075 22.5616 19.4823 20.6756 21.2401C18.7897 22.9979 16.3075 23.9753 13.7294 23.9754H4.60611C4.4852 23.9757 4.36719 23.9384 4.2684 23.8687C4.16962 23.7989 4.09495 23.7002 4.05472 23.5862C4.01449 23.4722 4.01069 23.3484 4.04384 23.2322C4.07699 23.1159 4.14547 23.0128 4.23978 22.9371L6.54045 21.0903C6.63853 21.0116 6.70855 20.9033 6.74009 20.7816C6.77163 20.6598 6.76298 20.5312 6.71545 20.4148L5.62695 17.7454Z"
        fill="#424242"
      />
    </svg>
  );
};

export const LastActivityIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M12.5 4.84389C12.5 4.33914 12.4006 3.83934 12.2074 3.37302C12.0143 2.90669 11.7312 2.48298 11.3742 2.12607C11.0173 1.76917 10.5936 1.48605 10.1273 1.29289C9.66098 1.09973 9.16118 1.00032 8.65643 1.00032H4.89302C4.38415 0.993771 3.87905 1.08834 3.40703 1.27855C2.93501 1.46875 2.50545 1.7508 2.14329 2.10833C1.78114 2.46586 1.49358 2.89175 1.29732 3.36129C1.10106 3.83082 1 4.33466 1 4.84357C1 5.35247 1.10106 5.85631 1.29732 6.32585C1.49358 6.79539 1.78114 7.22128 2.14329 7.57881C2.50545 7.93634 2.93501 8.21839 3.40703 8.40859C3.87905 8.59879 4.38415 8.69337 4.89302 8.68682H5.62967V10.5424C5.62967 10.5424 12.5 9.61495 12.5 4.84389ZM9.00122 14.9954C9.00122 16.4013 7.86253 17.54 6.45665 17.54C5.05078 17.54 3.91209 16.4013 3.91209 14.9954C3.91209 13.5896 5.05078 12.4509 6.45665 12.4509C7.86253 12.4509 9.00122 13.5896 9.00122 14.9954ZM6.45665 18.8123C4.65192 18.8123 1.04945 19.722 1.04945 21.5267V23.9014H11.8639V21.5267C11.8639 19.7213 8.26139 18.8123 6.45665 18.8123ZM18.5433 17.54C19.9492 17.54 21.0879 16.4013 21.0879 14.9954C21.0879 13.5896 19.9492 12.4509 18.5433 12.4509C17.1375 12.4509 15.9988 13.5896 15.9988 14.9954C15.9988 16.4013 17.1375 17.54 18.5433 17.54ZM18.5433 18.8123C16.7386 18.8123 13.1361 19.722 13.1361 21.5267V23.9014H23.9506V21.5267C23.9506 19.7213 20.3481 18.8123 18.5433 18.8123ZM17.6159 1.63646C16.5965 1.63646 15.6188 2.04141 14.898 2.76222C14.1772 3.48302 13.7723 4.46065 13.7723 5.48003C13.7723 10.2511 19.8792 11.1786 19.8792 11.1786V9.32296H20.107C20.6158 9.32951 21.1209 9.23494 21.593 9.04473C22.065 8.85453 22.4945 8.57248 22.8567 8.21495C23.2189 7.85742 23.5064 7.43153 23.7027 6.96199C23.8989 6.49246 24 5.98862 24 5.47971C24 4.97081 23.8989 4.46697 23.7027 3.99743C23.5064 3.52789 23.2189 3.102 22.8567 2.74447C22.4945 2.38694 22.065 2.10489 21.593 1.91469C21.1209 1.72449 20.6158 1.62991 20.107 1.63646H17.6159Z"
        fill="#43A047"
      />
    </svg>
  );
};

export const LastActiveSaleIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
    >
      <path
        d="M2.72461 21C2.44128 21 2.20361 20.904 2.01161 20.712C1.81961 20.52 1.72395 20.2827 1.72461 20C1.72461 19.7167 1.82061 19.479 2.01261 19.287C2.20461 19.095 2.44195 18.9993 2.72461 19H22.7246C23.0079 19 23.2456 19.096 23.4376 19.288C23.6296 19.48 23.7253 19.7173 23.7246 20C23.7246 20.2833 23.6286 20.521 23.4366 20.713C23.2446 20.905 23.0073 21.0007 22.7246 21H2.72461ZM4.72461 18C4.17461 18 3.70361 17.804 3.31161 17.412C2.91961 17.02 2.72395 16.5493 2.72461 16V11H8.09961L9.82461 14.45C9.90795 14.6167 10.0289 14.75 10.1876 14.85C10.3463 14.95 10.5169 15 10.6996 15C10.8829 15 11.0579 14.9583 11.2246 14.875C11.3913 14.7917 11.5163 14.6667 11.5996 14.5L14.6746 9.125L15.3246 10.45C15.4079 10.6333 15.5329 10.771 15.6996 10.863C15.8663 10.955 16.0413 11.0007 16.2246 11H22.7246V16C22.7246 16.55 22.5286 17.0207 22.1366 17.412C21.7446 17.8033 21.2739 17.9993 20.7246 18H4.72461ZM10.7996 11.875L9.62461 9.55C9.54128 9.38334 9.41628 9.25 9.24961 9.15C9.08295 9.05 8.90795 9 8.72461 9H2.72461V5C2.72461 4.45 2.92061 3.979 3.31261 3.587C3.70461 3.195 4.17528 2.99934 4.72461 3H20.7246C21.2746 3 21.7456 3.196 22.1376 3.588C22.5296 3.98 22.7253 4.45067 22.7246 5V9H16.8496L15.6246 6.55C15.5413 6.36667 15.4163 6.229 15.2496 6.137C15.0829 6.045 14.9079 5.99934 14.7246 6C14.5413 6 14.3746 6.046 14.2246 6.138C14.0746 6.23 13.9579 6.35067 13.8746 6.5L10.7996 11.875Z"
        fill="#43A047"
      />
    </svg>
  );
};

export const PointPersonIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="24"
      viewBox="0 0 20 24"
      fill="none"
    >
      <g clip-path="url(#clip0_5129_13109)">
        <path
          d="M18.846 17.2809C17.8358 15.9257 16.3935 14.9551 14.757 14.5291L14.706 14.5181L13.527 16.5065C13.5262 16.7713 13.4206 17.025 13.2332 17.2122C13.0458 17.3994 12.7919 17.5049 12.527 17.5057C11.977 17.5057 11.527 17.0561 11.002 15.7331V15.7012C11.002 15.3699 10.8703 15.0522 10.6358 14.818C10.4014 14.5837 10.0835 14.4521 9.75195 14.4521C9.42043 14.4521 9.10249 14.5837 8.86807 14.818C8.63365 15.0522 8.50195 15.3699 8.50195 15.7012V15.7341V15.7321C7.94195 17.0561 7.48795 17.5047 6.93895 17.5047C6.67398 17.5039 6.42009 17.3984 6.23272 17.2112C6.04536 17.024 5.93974 16.7703 5.93895 16.5055L4.79695 14.5131C3.14919 14.9319 1.6937 15.8998 0.670953 17.2569L0.656953 17.2759C0.251553 17.9384 0.0258114 18.695 0.00195312 19.4712V19.4782C0.00695312 19.628 0.00195312 19.8029 0.00195312 19.9778V21.9762C0.00195313 22.5062 0.212667 23.0145 0.58774 23.3893C0.962812 23.7641 1.47152 23.9746 2.00195 23.9746H17.502C18.0324 23.9746 18.5411 23.7641 18.9162 23.3893C19.2912 23.0145 19.502 22.5062 19.502 21.9762V19.9778C19.502 19.8039 19.497 19.628 19.502 19.4782C19.4768 18.6932 19.2472 17.9283 18.836 17.2589L18.847 17.2789L18.846 17.2809ZM4.50095 5.28541C4.50095 8.2031 6.32095 12.4897 9.75095 12.4897C13.121 12.4897 15.001 8.2031 15.001 5.28541V5.22046C15.001 4.53156 14.8652 3.84941 14.6013 3.21296C14.3375 2.5765 13.9508 1.9982 13.4633 1.51108C12.9758 1.02396 12.397 0.637554 11.76 0.373926C11.1231 0.110297 10.4404 -0.0253906 9.75095 -0.0253906C9.06151 -0.0253906 8.37882 0.110297 7.74187 0.373926C7.10491 0.637554 6.52615 1.02396 6.03864 1.51108C5.55114 1.9982 5.16442 2.5765 4.90059 3.21296C4.63675 3.84941 4.50095 4.53156 4.50095 5.22046V5.2884V5.28541Z"
          fill="#43A047"
        />
      </g>
      <defs>
        <clipPath id="clip0_5129_13109">
          <rect width="20" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const LeadSourceIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
    >
      <path
        d="M12.2845 18C10.6845 17.9167 9.33447 17.3 8.23447 16.15C7.13447 15 6.58447 13.6167 6.58447 12C6.58447 10.3333 7.16781 8.91667 8.33447 7.75C9.50114 6.58333 10.9178 6 12.5845 6C14.2011 6 15.5845 6.55 16.7345 7.65C17.8845 8.75 18.5011 10.1 18.5845 11.7L16.4845 11.075C16.2678 10.175 15.8011 9.43767 15.0845 8.863C14.3678 8.28833 13.5345 8.00067 12.5845 8C11.4845 8 10.5428 8.39167 9.75947 9.175C8.97614 9.95833 8.58447 10.9 8.58447 12C8.58447 12.95 8.87214 13.7833 9.44747 14.5C10.0228 15.2167 10.7601 15.6833 11.6595 15.9L12.2845 18ZM12.5845 22C11.2011 22 9.90114 21.7373 8.68447 21.212C7.46781 20.6867 6.40947 19.9743 5.50947 19.075C4.60947 18.175 3.89714 17.1167 3.37247 15.9C2.84781 14.6833 2.58514 13.3833 2.58447 12C2.58447 10.6167 2.84714 9.31667 3.37247 8.1C3.89781 6.88333 4.61014 5.825 5.50947 4.925C6.40947 4.025 7.46781 3.31267 8.68447 2.788C9.90114 2.26333 11.2011 2.00067 12.5845 2C13.9678 2 15.2678 2.26267 16.4845 2.788C17.7011 3.31333 18.7595 4.02567 19.6595 4.925C20.5595 5.825 21.2721 6.88333 21.7975 8.1C22.3228 9.31667 22.5851 10.6167 22.5845 12V12.45C22.5845 12.6 22.5678 12.75 22.5345 12.9L20.5845 12.3V12C20.5845 9.76667 19.8095 7.875 18.2595 6.325C16.7095 4.775 14.8178 4 12.5845 4C10.3511 4 8.45947 4.775 6.90947 6.325C5.35947 7.875 4.58447 9.76667 4.58447 12C4.58447 14.2333 5.35947 16.125 6.90947 17.675C8.45947 19.225 10.3511 20 12.5845 20H12.8845L13.4845 21.95C13.3345 21.9833 13.1845 22 13.0345 22H12.5845ZM20.7595 22.15L16.8345 18.225L16.0845 20.5C16.0011 20.7333 15.8428 20.846 15.6095 20.838C15.3761 20.83 15.2178 20.709 15.1345 20.475L12.8595 12.9C12.7928 12.7167 12.8345 12.55 12.9845 12.4C13.1345 12.25 13.3011 12.2083 13.4845 12.275L21.0595 14.55C21.2928 14.6333 21.4138 14.7917 21.4225 15.025C21.4311 15.2583 21.3185 15.4167 21.0845 15.5L18.8095 16.25L22.7345 20.175C22.8345 20.275 22.8845 20.3917 22.8845 20.525C22.8845 20.6583 22.8345 20.775 22.7345 20.875L21.4595 22.15C21.3595 22.25 21.2428 22.3 21.1095 22.3C20.9761 22.3 20.8595 22.25 20.7595 22.15Z"
        fill="#43A047"
      />
    </svg>
  );
};

export const LastVehicleIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
    >
      <path
        d="M13.9379 1.79805C13.8434 1.67202 13.7116 1.57895 13.5612 1.53205C13.4108 1.48515 13.2494 1.4868 13.1 1.53677C12.9506 1.58674 12.8207 1.68249 12.7288 1.81043C12.6369 1.93837 12.5876 2.09201 12.5879 2.24955V5.24955C12.5879 5.44846 12.6669 5.63923 12.8076 5.77988C12.9482 5.92053 13.139 5.99955 13.3379 5.99955C13.5368 5.99955 13.7276 5.92053 13.8682 5.77988C14.0089 5.63923 14.0879 5.44846 14.0879 5.24955V4.48755L15.0029 5.70255C15.1023 5.83402 15.2423 5.92907 15.4012 5.973C15.5601 6.01692 15.729 6.00728 15.8819 5.94555L18.1139 5.04855L17.1269 8.01255C17.0894 8.12524 17.0791 8.24523 17.097 8.36265C17.1149 8.48007 17.1605 8.59155 17.2299 8.68792C17.2993 8.7843 17.3907 8.86281 17.4964 8.91698C17.6021 8.97116 17.7191 8.99946 17.8379 8.99955H20.2034L18.1259 10.6645C18.0383 10.7348 17.9676 10.8239 17.919 10.9251C17.8704 11.0264 17.8452 11.1372 17.8452 11.2495C17.8452 11.3619 17.8704 11.4727 17.919 11.574C17.9676 11.6752 18.0383 11.7643 18.1259 11.8345L20.2034 13.4995H17.8379C17.639 13.4995 17.4482 13.5786 17.3076 13.7192C17.1669 13.8599 17.0879 14.0506 17.0879 14.2495C17.0879 14.4485 17.1669 14.6392 17.3076 14.7799C17.4482 14.9205 17.639 14.9995 17.8379 14.9995H22.3379C22.4932 14.9996 22.6447 14.9514 22.7715 14.8616C22.8983 14.7718 22.994 14.6449 23.0456 14.4984C23.0971 14.3518 23.1019 14.1929 23.0592 14.0435C23.0165 13.8942 22.9286 13.7618 22.8074 13.6645L19.7939 11.2495L22.8074 8.83455C22.9286 8.73734 23.0165 8.60491 23.0592 8.45555C23.1019 8.30619 23.0971 8.14726 23.0456 8.00072C22.994 7.85419 22.8983 7.72726 22.7715 7.63749C22.6447 7.54771 22.4932 7.49952 22.3379 7.49955H18.8789L20.0489 3.98655C20.094 3.8509 20.0994 3.70518 20.0644 3.56658C20.0294 3.42797 19.9556 3.30224 19.8516 3.2042C19.7475 3.10616 19.6176 3.03989 19.4772 3.0132C19.3368 2.98651 19.1916 3.00051 19.0589 3.05355L15.8549 4.34055L13.9379 1.79805ZM3.04339 11.9995L2.90839 12.9355C2.3809 13.4932 2.08725 14.2319 2.08789 14.9995V19.4995C2.08789 19.8974 2.24593 20.2789 2.52723 20.5602C2.80853 20.8415 3.19007 20.9995 3.58789 20.9995C3.98572 20.9995 4.36725 20.8415 4.64855 20.5602C4.92986 20.2789 5.08789 19.8974 5.08789 19.4995H12.5879C12.5879 19.8974 12.7459 20.2789 13.0272 20.5602C13.3085 20.8415 13.6901 20.9995 14.0879 20.9995C14.4857 20.9995 14.8672 20.8415 15.1486 20.5602C15.4299 20.2789 15.5879 19.8974 15.5879 19.4995V14.9995C15.5879 14.2001 15.2744 13.474 14.7644 12.9355L14.6309 11.9995H15.5879C15.7868 11.9995 15.9776 11.9205 16.1182 11.7799C16.2589 11.6392 16.3379 11.4485 16.3379 11.2495C16.3379 11.0506 16.2589 10.8599 16.1182 10.7192C15.9776 10.5786 15.7868 10.4995 15.5879 10.4995H14.4629L14.4179 10.501L14.2649 9.43155C14.1883 8.89533 13.9209 8.40472 13.5117 8.04982C13.1025 7.69491 12.579 7.49953 12.0374 7.49955H5.63839C5.09673 7.49953 4.57325 7.69491 4.16406 8.04982C3.75487 8.40472 3.48744 8.89533 3.41089 9.43155L3.25939 10.4995H2.08789C1.88898 10.4995 1.69821 10.5786 1.55756 10.7192C1.41691 10.8599 1.33789 11.0506 1.33789 11.2495C1.33789 11.4485 1.41691 11.6392 1.55756 11.7799C1.69821 11.9205 1.88898 11.9995 2.08789 11.9995H3.04489H3.04339ZM5.63839 8.99955H12.0359C12.2166 8.99958 12.3912 9.06485 12.5276 9.18335C12.664 9.30185 12.7531 9.46563 12.7784 9.64455L13.1219 12.0475C12.9457 12.0157 12.767 11.9997 12.5879 11.9995H5.08789C4.90489 11.9995 4.72789 12.0145 4.55389 12.0475L4.89589 9.64305C4.92152 9.4644 5.01071 9.30098 5.14709 9.18278C5.28348 9.06458 5.45791 8.99953 5.63839 8.99955ZM12.5879 15.7495C12.5879 15.9485 12.5089 16.1392 12.3682 16.2799C12.2276 16.4205 12.0368 16.4995 11.8379 16.4995C11.639 16.4995 11.4482 16.4205 11.3076 16.2799C11.1669 16.1392 11.0879 15.9485 11.0879 15.7495C11.0879 15.5506 11.1669 15.3599 11.3076 15.2192C11.4482 15.0786 11.639 14.9995 11.8379 14.9995C12.0368 14.9995 12.2276 15.0786 12.3682 15.2192C12.5089 15.3599 12.5879 15.5506 12.5879 15.7495ZM5.83789 16.4995C5.63898 16.4995 5.44821 16.4205 5.30756 16.2799C5.16691 16.1392 5.08789 15.9485 5.08789 15.7495C5.08789 15.5506 5.16691 15.3599 5.30756 15.2192C5.44821 15.0786 5.63898 14.9995 5.83789 14.9995C6.0368 14.9995 6.22757 15.0786 6.36822 15.2192C6.50887 15.3599 6.58789 15.5506 6.58789 15.7495C6.58789 15.9485 6.50887 16.1392 6.36822 16.2799C6.22757 16.4205 6.0368 16.4995 5.83789 16.4995Z"
        fill="#43A047"
      />
    </svg>
  );
};

export const StartMeetingIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M11.9998 6.02125C11.9998 5.62453 11.9217 5.23169 11.7698 4.86516C11.618 4.49864 11.3955 4.16561 11.115 3.88508C10.8344 3.60455 10.5014 3.38203 10.1349 3.23021C9.76836 3.07839 9.37552 3.00025 8.9788 3.00025H6.0208C5.62084 2.9951 5.22384 3.06944 4.85283 3.21894C4.48183 3.36843 4.1442 3.59012 3.85955 3.87113C3.5749 4.15215 3.34889 4.48689 3.19463 4.85594C3.04037 5.22499 2.96094 5.62101 2.96094 6.021C2.96094 6.42099 3.04037 6.81701 3.19463 7.18606C3.34889 7.55511 3.5749 7.88985 3.85955 8.17087C4.1442 8.45188 4.48183 8.67357 4.85283 8.82306C5.22384 8.97256 5.62084 9.0469 6.0208 9.04175H6.5998V10.5002C6.5998 10.5002 11.9998 9.77125 11.9998 6.02125ZM9.2498 14.0002C9.2498 15.1052 8.3548 16.0002 7.2498 16.0002C6.1448 16.0002 5.2498 15.1052 5.2498 14.0002C5.2498 12.8953 6.1448 12.0002 7.2498 12.0002C8.3548 12.0002 9.2498 12.8953 9.2498 14.0002ZM7.2498 17.0002C5.8313 17.0002 2.9998 17.7152 2.9998 19.1337V21.0002H11.4998V19.1337C11.4998 17.7147 8.6683 17.0002 7.2498 17.0002ZM16.7498 16.0002C17.8548 16.0002 18.7498 15.1052 18.7498 14.0002C18.7498 12.8953 17.8548 12.0002 16.7498 12.0002C15.6448 12.0002 14.7498 12.8953 14.7498 14.0002C14.7498 15.1052 15.6448 16.0002 16.7498 16.0002ZM16.7498 17.0002C15.3313 17.0002 12.4998 17.7152 12.4998 19.1337V21.0002H20.9998V19.1337C20.9998 17.7147 18.1683 17.0002 16.7498 17.0002ZM16.0208 3.50025C15.2196 3.50025 14.4512 3.81853 13.8846 4.38508C13.3181 4.95163 12.9998 5.72003 12.9998 6.52125C12.9998 10.2712 17.7998 11.0002 17.7998 11.0002V9.54175H17.9788C18.3788 9.5469 18.7758 9.47256 19.1468 9.32306C19.5178 9.17357 19.8554 8.95188 20.1401 8.67087C20.4247 8.38985 20.6507 8.05511 20.805 7.68606C20.9592 7.31701 21.0387 6.92099 21.0387 6.521C21.0387 6.12101 20.9592 5.72499 20.805 5.35594C20.6507 4.98689 20.4247 4.65215 20.1401 4.37113C19.8554 4.09012 19.5178 3.86843 19.1468 3.71894C18.7758 3.56944 18.3788 3.4951 17.9788 3.50025H16.0208Z"
        fill="#424242"
      />
    </svg>
  );
};

export const VehicleIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M9.266 1.99219C9.06709 1.99219 8.87632 2.07121 8.73567 2.21186C8.59502 2.35251 8.516 2.54328 8.516 2.74219V4.50019H7.852C7.15522 4.49997 6.47682 4.72369 5.91686 5.13834C5.3569 5.553 4.94503 6.13665 4.742 6.80319L4.683 7.00019H3.75C3.55109 7.00019 3.36032 7.07921 3.21967 7.21986C3.07902 7.36051 3 7.55128 3 7.75019C3 7.9491 3.07902 8.13986 3.21967 8.28052C3.36032 8.42117 3.55109 8.50019 3.75 8.50019H4.283L4.081 9.32719C3.7508 9.52786 3.47787 9.81022 3.28853 10.147C3.09918 10.4839 2.99981 10.8638 3 11.2502V19.7502C3 20.7162 3.784 21.5002 4.75 21.5002H6.25C6.71413 21.5002 7.15925 21.3158 7.48744 20.9876C7.81563 20.6594 8 20.2143 8 19.7502V18.5002H16V19.7502C16 20.7162 16.784 21.5002 17.75 21.5002H19.25C19.7141 21.5002 20.1592 21.3158 20.4874 20.9876C20.8156 20.6594 21 20.2143 21 19.7502V11.2502C21 10.4352 20.566 9.72019 19.917 9.32619L19.711 8.50019H20.25C20.4489 8.50019 20.6397 8.42117 20.7803 8.28052C20.921 8.13986 21 7.9491 21 7.75019C21 7.55128 20.921 7.36051 20.7803 7.21986C20.6397 7.07921 20.4489 7.00019 20.25 7.00019H19.308L19.253 6.81619C19.0521 6.14673 18.6408 5.55987 18.08 5.14267C17.5193 4.72547 16.8389 4.50017 16.14 4.50019H15.484V2.74219C15.484 2.54328 15.405 2.35251 15.2643 2.21186C15.1237 2.07121 14.9329 1.99219 14.734 1.99219H9.266ZM7.852 6.00019H16.14C16.5163 6.00022 16.8826 6.12155 17.1845 6.34618C17.4864 6.5708 17.7078 6.88676 17.816 7.24719L18.026 7.94919L18.29 9.00019H5.705L5.962 7.94819L6.178 7.24019C6.28731 6.8814 6.509 6.56722 6.81039 6.34396C7.11178 6.12071 7.47693 6.0002 7.852 6.00019ZM4.5 18.5002H6.5V19.7502C6.5 19.8165 6.47366 19.8801 6.42678 19.927C6.37989 19.9738 6.3163 20.0002 6.25 20.0002H4.75C4.6837 20.0002 4.62011 19.9738 4.57322 19.927C4.52634 19.8801 4.5 19.8165 4.5 19.7502V18.5002ZM17.5 18.5002H19.5V19.7502C19.5 19.8165 19.4737 19.8801 19.4268 19.927C19.3799 19.9738 19.3163 20.0002 19.25 20.0002H17.75C17.6837 20.0002 17.6201 19.9738 17.5732 19.927C17.5263 19.8801 17.5 19.8165 17.5 19.7502V18.5002ZM8.005 13.0002C8.005 13.2654 7.89964 13.5198 7.71211 13.7073C7.52457 13.8948 7.27022 14.0002 7.005 14.0002C6.73978 14.0002 6.48543 13.8948 6.29789 13.7073C6.11036 13.5198 6.005 13.2654 6.005 13.0002C6.005 12.735 6.11036 12.4806 6.29789 12.2931C6.48543 12.1055 6.73978 12.0002 7.005 12.0002C7.27022 12.0002 7.52457 12.1055 7.71211 12.2931C7.89964 12.4806 8.005 12.735 8.005 13.0002ZM17 14.0002C16.7348 14.0002 16.4804 13.8948 16.2929 13.7073C16.1054 13.5198 16 13.2654 16 13.0002C16 12.735 16.1054 12.4806 16.2929 12.2931C16.4804 12.1055 16.7348 12.0002 17 12.0002C17.2652 12.0002 17.5196 12.1055 17.7071 12.2931C17.8946 12.4806 18 12.735 18 13.0002C18 13.2654 17.8946 13.5198 17.7071 13.7073C17.5196 13.8948 17.2652 14.0002 17 14.0002Z"
        fill="#424242"
      />
    </svg>
  );
};

export const CoBuyerIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M16 17.0001V19.0001H2V17.0001C2 17.0001 2 13.0001 9 13.0001C16 13.0001 16 17.0001 16 17.0001ZM12.5 7.50005C12.5 6.80782 12.2947 6.13113 11.9101 5.55556C11.5256 4.97998 10.9789 4.53138 10.3394 4.26647C9.69985 4.00157 8.99612 3.93226 8.31718 4.0673C7.63825 4.20235 7.01461 4.5357 6.52513 5.02518C6.03564 5.51466 5.7023 6.1383 5.56725 6.81724C5.4322 7.49617 5.50152 8.1999 5.76642 8.83944C6.03133 9.47899 6.47993 10.0256 7.0555 10.4102C7.63108 10.7948 8.30777 11.0001 9 11.0001C9.92826 11.0001 10.8185 10.6313 11.4749 9.97493C12.1313 9.31855 12.5 8.42831 12.5 7.50005ZM15.94 13.0001C16.5547 13.4758 17.0578 14.0805 17.4137 14.7716C17.7696 15.4626 17.9697 16.2233 18 17.0001V19.0001H22V17.0001C22 17.0001 22 13.3701 15.94 13.0001ZM15 4.00005C14.3117 3.99622 13.6385 4.20201 13.07 4.59005C13.6774 5.43879 14.0041 6.45634 14.0041 7.50005C14.0041 8.54377 13.6774 9.56132 13.07 10.4101C13.6385 10.7981 14.3117 11.0039 15 11.0001C15.9283 11.0001 16.8185 10.6313 17.4749 9.97493C18.1313 9.31855 18.5 8.42831 18.5 7.50005C18.5 6.57179 18.1313 5.68156 17.4749 5.02518C16.8185 4.3688 15.9283 4.00005 15 4.00005Z"
        fill="#424242"
      />
    </svg>
  );
};

export const TradeInIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <ellipse
        className="vehicle-stroke"
        cx="7.81662"
        cy="20.0451"
        rx="1.83908"
        ry="1.83908"
        stroke="#424242"
        strokeWidth="1.65517"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        className="vehicle-stroke"
        cx="17.011"
        cy="20.0451"
        r="1.83908"
        stroke="#424242"
        strokeWidth="1.65517"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        className="vehicle-fill"
        d="M5.97678 20.8732C6.43385 20.8732 6.80437 20.5027 6.80437 20.0456C6.80437 19.5885 6.43385 19.218 5.97678 19.218V20.8732ZM4.1377 20.0456H3.31012C3.31012 20.5027 3.68064 20.8732 4.1377 20.8732V20.0456ZM4.1377 14.5284L3.36931 14.221C3.33021 14.3188 3.31012 14.4231 3.31012 14.5284H4.1377ZM5.97678 9.93066V9.10308C5.63838 9.10308 5.33407 9.30911 5.20839 9.62331L5.97678 9.93066ZM14.2526 9.93066L14.8989 9.41368C14.7418 9.21736 14.5041 9.10308 14.2526 9.10308V9.93066ZM17.9308 14.5284L17.2846 15.0454C17.4416 15.2417 17.6794 15.356 17.9308 15.356V14.5284ZM20.6894 20.0456V20.8732C21.1465 20.8732 21.517 20.5027 21.517 20.0456H20.6894ZM18.8503 19.218C18.3933 19.218 18.0228 19.5885 18.0228 20.0456C18.0228 20.5027 18.3933 20.8732 18.8503 20.8732V19.218ZM15.1725 20.8733C15.6295 20.8733 16.0001 20.5027 16.0001 20.0457C16.0001 19.5886 15.6295 19.2181 15.1725 19.2181V20.8733ZM9.65523 19.2181C9.19817 19.2181 8.82765 19.5886 8.82765 20.0457C8.82765 20.5027 9.19817 20.8733 9.65523 20.8733V19.2181ZM4.1377 13.7008C3.68063 13.7008 3.31011 14.0713 3.31011 14.5284C3.31011 14.9854 3.68063 15.356 4.1377 15.356V13.7008ZM17.9308 15.356C18.3879 15.356 18.7584 14.9854 18.7584 14.5284C18.7584 14.0713 18.3879 13.7008 17.9308 13.7008V15.356ZM11.5847 14.5284C11.5847 14.9854 11.9552 15.356 12.4123 15.356C12.8693 15.356 13.2399 14.9854 13.2399 14.5284H11.5847ZM13.2399 9.93067C13.2399 9.47361 12.8693 9.10308 12.4123 9.10308C11.9552 9.10308 11.5847 9.47361 11.5847 9.93067H13.2399ZM5.97678 19.218H4.1377V20.8732H5.97678V19.218ZM4.96529 20.0456V14.5284H3.31012V20.0456H4.96529ZM4.9061 14.8357L6.74518 10.238L5.20839 9.62331L3.36931 14.221L4.9061 14.8357ZM5.97678 10.7583H14.2526V9.10308H5.97678V10.7583ZM13.6064 10.4477L17.2846 15.0454L18.577 14.0114L14.8989 9.41368L13.6064 10.4477ZM17.9308 15.356H18.8503V13.7008H17.9308V15.356ZM18.8503 15.356C19.409 15.356 19.8618 15.8088 19.8618 16.3674H21.517C21.517 14.8947 20.3231 13.7008 18.8503 13.7008V15.356ZM19.8618 16.3674V20.0456H21.517V16.3674H19.8618ZM20.6894 19.218H18.8503V20.8732H20.6894V19.218ZM15.1725 19.2181H9.65523V20.8733H15.1725V19.2181ZM4.1377 15.356H17.9308V13.7008H4.1377V15.356ZM13.2399 14.5284V9.93067H11.5847V14.5284H13.2399Z"
        fill="#424242"
      />
      <path
        d="M1.65527 7.86244L11.5863 2.06934L21.5173 7.86244"
        className="vehicle-stroke"
        stroke="#424242"
        strokeWidth="1.65517"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ProcessSaleIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2ZM12 6C11.7551 6.00003 11.5187 6.08996 11.3356 6.25272C11.1526 6.41547 11.0357 6.63975 11.007 6.883L11 7V8H10C9.35011 7.99842 8.72515 8.24997 8.25758 8.70134C7.79002 9.15271 7.51659 9.76842 7.49526 10.418C7.47394 11.0675 7.70639 11.6998 8.14334 12.1809C8.5803 12.6619 9.18741 12.9539 9.836 12.995L10 13H11V14H9C8.74512 14.0003 8.49997 14.0979 8.31463 14.2728C8.1293 14.4478 8.01776 14.687 8.00283 14.9414C7.98789 15.1958 8.07067 15.4464 8.23426 15.6418C8.39785 15.8373 8.6299 15.9629 8.883 15.993L9 16H11V17C11.0003 17.2549 11.0979 17.5 11.2728 17.6854C11.4478 17.8707 11.687 17.9822 11.9414 17.9972C12.1958 18.0121 12.4464 17.9293 12.6418 17.7657C12.8373 17.6021 12.9629 17.3701 12.993 17.117L13 17V16H14C14.6499 16.0016 15.2748 15.75 15.7424 15.2987C16.21 14.8473 16.4834 14.2316 16.5047 13.582C16.5261 12.9325 16.2936 12.3002 15.8567 11.8191C15.4197 11.3381 14.8126 11.0461 14.164 11.005L14 11H13V10H15C15.2549 9.99972 15.5 9.90212 15.6854 9.72715C15.8707 9.55218 15.9822 9.31305 15.9972 9.05861C16.0121 8.80416 15.9293 8.55362 15.7657 8.35817C15.6021 8.16271 15.3701 8.0371 15.117 8.007L15 8H13V7C13 6.73478 12.8946 6.48043 12.7071 6.29289C12.5196 6.10536 12.2652 6 12 6ZM14 13C14.1326 13 14.2598 13.0527 14.3536 13.1464C14.4473 13.2402 14.5 13.3674 14.5 13.5C14.5 13.6326 14.4473 13.7598 14.3536 13.8536C14.2598 13.9473 14.1326 14 14 14H13V13H14ZM11 10V11H10C9.86739 11 9.74021 10.9473 9.64645 10.8536C9.55268 10.7598 9.5 10.6326 9.5 10.5C9.5 10.3674 9.55268 10.2402 9.64645 10.1464C9.74021 10.0527 9.86739 10 10 10H11Z"
        fill="#424242"
      />
    </svg>
  );
};

export const DuplicateCheckIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M2.39997 7.79981C2.39997 7.00416 2.71604 6.24109 3.27865 5.67848C3.84126 5.11588 4.60432 4.7998 5.39997 4.7998H18.6C19.3956 4.7998 20.1587 5.11588 20.7213 5.67848C21.2839 6.24109 21.6 7.00416 21.6 7.79981V16.1998C21.6 16.9955 21.2839 17.7585 20.7213 18.3211C20.1587 18.8837 19.3956 19.1998 18.6 19.1998H12.1452L10.2732 17.3278C10.534 16.7837 10.7011 16.1995 10.7676 15.5998H15C15.1591 15.5998 15.3117 15.5366 15.4242 15.4241C15.5368 15.3115 15.6 15.1589 15.6 14.9998C15.6 14.8407 15.5368 14.6881 15.4242 14.5755C15.3117 14.463 15.1591 14.3998 15 14.3998H10.7676C10.6987 13.7734 10.5199 13.1641 10.2396 12.5998H17.4C17.5591 12.5998 17.7117 12.5366 17.8242 12.4241C17.9368 12.3115 18 12.1589 18 11.9998C18 11.8407 17.9368 11.6881 17.8242 11.5755C17.7117 11.463 17.5591 11.3998 17.4 11.3998H9.42477C8.91881 10.8329 8.29862 10.3794 7.60496 10.0692C6.9113 9.75895 6.15985 9.59899 5.39997 9.59981C4.33181 9.59824 3.2874 9.9149 2.39997 10.5094V7.79981ZM6.59997 8.39981C6.44084 8.39981 6.28823 8.46302 6.17571 8.57554C6.06318 8.68806 5.99997 8.84068 5.99997 8.99981C5.99997 9.15894 6.06318 9.31155 6.17571 9.42407C6.28823 9.53659 6.44084 9.59981 6.59997 9.59981H13.8C13.9591 9.59981 14.1117 9.53659 14.2242 9.42407C14.3368 9.31155 14.4 9.15894 14.4 8.99981C14.4 8.84068 14.3368 8.68806 14.2242 8.57554C14.1117 8.46302 13.9591 8.39981 13.8 8.39981H6.59997ZM5.39997 19.1998C6.34317 19.1998 7.21437 18.8878 7.91517 18.3634L10.9752 21.4234C11.0309 21.4792 11.097 21.5235 11.1698 21.5537C11.2427 21.5839 11.3207 21.5995 11.3995 21.5995C11.4784 21.5996 11.5565 21.5841 11.6293 21.554C11.7022 21.5239 11.7684 21.4797 11.8242 21.424C11.88 21.3683 11.9242 21.3022 11.9544 21.2293C11.9847 21.1565 12.0002 21.0785 12.0003 20.9996C12.0004 20.9208 11.9849 20.8427 11.9548 20.7699C11.9247 20.697 11.8805 20.6308 11.8248 20.575L8.76477 17.515C9.33118 16.7575 9.62534 15.8311 9.59962 14.8856C9.5739 13.9401 9.2298 13.031 8.62304 12.3054C8.01628 11.5799 7.18239 11.0804 6.25638 10.8878C5.33037 10.6952 4.36646 10.8208 3.52074 11.2443C2.67501 11.6678 1.99697 12.3643 1.59641 13.2211C1.19586 14.0779 1.09623 15.0449 1.31367 15.9653C1.5311 16.8858 2.05287 17.706 2.79449 18.293C3.5361 18.88 4.45415 19.1995 5.39997 19.1998ZM5.39997 17.9998C4.60432 17.9998 3.84126 17.6837 3.27865 17.1211C2.71604 16.5585 2.39997 15.7955 2.39997 14.9998C2.39997 14.2042 2.71604 13.4411 3.27865 12.8785C3.84126 12.3159 4.60432 11.9998 5.39997 11.9998C6.19562 11.9998 6.95868 12.3159 7.52129 12.8785C8.0839 13.4411 8.39997 14.2042 8.39997 14.9998C8.39997 15.7955 8.0839 16.5585 7.52129 17.1211C6.95868 17.6837 6.19562 17.9998 5.39997 17.9998Z"
        fill="#424242"
      />
    </svg>
  );
};

export const AssignIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g clip-path="url(#clip0_5129_13190)">
        <path
          d="M11.9931 11.4462C14.5005 11.4462 16.5331 9.41358 16.5331 6.90621C16.5331 4.39884 14.5005 2.36621 11.9931 2.36621C9.48575 2.36621 7.45312 4.39884 7.45312 6.90621C7.45312 9.41358 9.48575 11.4462 11.9931 11.4462Z"
          fill="#424242"
        />
        <path
          d="M7.9999 17.7667C8.01376 17.3979 8.13666 17.0414 8.35308 16.7424C8.56949 16.4433 8.8697 16.2152 9.21576 16.0868C9.56182 15.9583 9.93818 15.9354 10.2973 16.0208C10.6564 16.1062 10.9821 16.2962 11.2332 16.5667L13.8066 19.3334L18.3666 14.2467C16.4829 12.9914 14.2633 12.336 11.9999 12.3667C10.4298 12.327 8.8701 12.6317 7.4304 13.2594C5.9907 13.8872 4.70598 14.8226 3.66657 16.0001C3.57864 16.1173 3.53178 16.2602 3.53324 16.4067V20.0001C3.53308 20.3468 3.66805 20.6801 3.90951 20.929C4.15098 21.1779 4.47993 21.323 4.82657 21.3334H10.5399L8.49324 19.1334C8.32414 18.9499 8.19339 18.7345 8.10867 18.4998C8.02396 18.2651 7.98698 18.0159 7.9999 17.7667Z"
          fill="#424242"
        />
        <path
          d="M19.1735 21.3332C19.5202 21.3228 19.8491 21.1777 20.0906 20.9288C20.3321 20.6798 20.467 20.3466 20.4669 19.9998V17.4932L17.0469 21.3332H19.1735Z"
          fill="#424242"
        />
        <path
          d="M22.5135 12.4132C22.4481 12.3541 22.3716 12.3086 22.2884 12.2792C22.2052 12.2499 22.1171 12.2373 22.029 12.2423C21.941 12.2472 21.8548 12.2696 21.7755 12.3081C21.6961 12.3466 21.6252 12.4005 21.5668 12.4666L13.8202 21.1332L10.3535 17.4066C10.2966 17.34 10.2272 17.2854 10.1491 17.2457C10.0711 17.206 9.98598 17.182 9.8987 17.1752C9.81141 17.1684 9.72363 17.1789 9.64038 17.206C9.55713 17.2331 9.48004 17.2763 9.41351 17.3332C9.35102 17.3952 9.30143 17.469 9.26758 17.5502C9.23373 17.6314 9.21631 17.7186 9.21631 17.8066C9.21631 17.8946 9.23373 17.9817 9.26758 18.063C9.30143 18.1442 9.35102 18.2179 9.41351 18.2799L13.8668 23.0799L22.5602 13.3332C22.6723 13.2034 22.73 13.0352 22.7213 12.8639C22.7126 12.6925 22.6382 12.5311 22.5135 12.4132Z"
          fill="#424242"
        />
      </g>
      <defs>
        <clipPath id="clip0_5129_13190">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const NotesIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M21 10V9L15 3H5C3.89 3 3 3.89 3 5V19C3 19.5304 3.21071 20.0391 3.58579 20.4142C3.96086 20.7893 4.46957 21 5 21H11V19.13L19.39 10.74C19.83 10.3 20.39 10.06 21 10ZM14 4.5L19.5 10H14V4.5ZM22.85 14.19L21.87 15.17L19.83 13.13L20.81 12.15C21 11.95 21.33 11.95 21.53 12.15L22.85 13.47C23.05 13.67 23.05 14 22.85 14.19ZM19.13 13.83L21.17 15.87L15.04 22H13V19.96L19.13 13.83Z"
        fill="#424242"
      />
    </svg>
  );
};

export const HistoryIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M19.65 20.35L20.35 19.65L18.5 17.8V15H17.5V18.2L19.65 20.35ZM10 6H14V4H10V6ZM18 23C16.6167 23 15.4373 22.5123 14.462 21.537C13.4867 20.5617 12.9993 19.3827 13 18C13 16.6167 13.4877 15.4373 14.463 14.462C15.4383 13.4867 16.6173 12.9993 18 13C19.3833 13 20.5627 13.4877 21.538 14.463C22.5133 15.4383 23.0007 16.6173 23 18C23 19.3833 22.5123 20.5627 21.537 21.538C20.5617 22.5133 19.3827 23.0007 18 23ZM4 21C3.45 21 2.979 20.804 2.587 20.412C2.195 20.02 1.99934 19.5493 2 19V8C2 7.45 2.196 6.979 2.588 6.587C2.98 6.195 3.45067 5.99934 4 6H8V4C8 3.45 8.196 2.979 8.588 2.587C8.98 2.195 9.45067 1.99934 10 2H14C14.55 2 15.021 2.196 15.413 2.588C15.805 2.98 16.0007 3.45067 16 4V6H20C20.55 6 21.021 6.196 21.413 6.588C21.805 6.98 22.0007 7.45067 22 8V12.275C21.4167 11.8583 20.7833 11.5417 20.1 11.325C19.4167 11.1083 18.7167 11 18 11C16.0667 11 14.4167 11.6833 13.05 13.05C11.6833 14.4167 11 16.0667 11 18C11 18.5167 11.0543 19.0293 11.163 19.538C11.2717 20.0467 11.4423 20.534 11.675 21H4Z"
        fill="white"
      />
    </svg>
  );
};

export const SimpleDateIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <rect
        x="3"
        y="3.75"
        width="12"
        height="12"
        rx="2"
        stroke="#212121"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 2.25V5.25"
        stroke="#212121"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 2.25V5.25"
        stroke="#212121"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 8.25H15"
        stroke="#212121"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.25 11.25H9"
        stroke="#212121"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 11.25V13.5"
        stroke="#212121"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ViewedEmailIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M21.8638 5.32654C21.8065 5.24436 21.7336 5.17427 21.6492 5.12027C21.5648 5.06627 21.4707 5.02943 21.372 5.01184C21.2734 4.99426 21.1723 4.99627 21.0745 5.01778C20.9767 5.03928 20.884 5.07985 20.8019 5.13716L2.13688 18.2097C2.27375 18.4053 2.50188 18.5353 2.75875 18.5353H21.2419C21.6619 18.5353 22 18.1934 22 17.7734V5.75154C21.9955 5.59957 21.9481 5.45199 21.8631 5.32591L21.8638 5.32654ZM3.19875 5.13779C3.08516 5.05853 2.95213 5.01171 2.81393 5.00235C2.67574 4.993 2.53761 5.02146 2.41437 5.08469C2.29114 5.14791 2.18745 5.24351 2.11444 5.36122C2.04144 5.47892 2.00188 5.61429 2 5.75279V17.7934L10.8869 10.5115L3.19875 5.13779Z"
        fill="#424242"
      />
    </svg>
  );
};

export const OutboundEmailIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M5.84723 9.25555L12.7806 13.7321L19.7139 9.25555L12.7806 4.77896L5.84723 9.25555ZM21.4472 9.25555V18.2087C21.4472 18.6836 21.2646 19.1391 20.9395 19.4749C20.6145 19.8107 20.1736 19.9993 19.7139 19.9993H5.84723C5.38752 19.9993 4.94664 19.8107 4.62157 19.4749C4.29651 19.1391 4.11389 18.6836 4.11389 18.2087V9.25555C4.11389 8.60197 4.45189 8.03792 4.95456 7.72456L12.7806 2.66602L20.6066 7.72456C21.1092 8.03792 21.4472 8.60197 21.4472 9.25555Z"
        fill="#424242"
      />
      <path
        d="M2.66992 13.3555H9.89214"
        stroke="white"
        strokeWidth="5.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.44861 16.8202L11.9153 13.3535"
        stroke="white"
        strokeWidth="5.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.44861 9.8877L11.9153 13.3544"
        stroke="white"
        strokeWidth="5.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.66992 13.4996H11.3366"
        stroke="#424242"
        strokeWidth="1.95"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.44861 16.8202L11.9153 13.3535"
        stroke="#424242"
        strokeWidth="1.95"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.44861 9.8877L11.9153 13.3544"
        stroke="#424242"
        strokeWidth="1.95"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const InboundEmailIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M18.1528 9.25555L11.2194 13.7321L4.28611 9.25555L11.2194 4.77896L18.1528 9.25555ZM2.55277 9.25555V18.2087C2.55277 18.6836 2.73539 19.1391 3.06046 19.4749C3.38552 19.8107 3.8264 19.9993 4.28611 19.9993H18.1528C18.6125 19.9993 19.0534 19.8107 19.3784 19.4749C19.7035 19.1391 19.8861 18.6836 19.8861 18.2087V9.25555C19.8861 8.60197 19.5481 8.03792 19.0454 7.72456L11.2194 2.66602L3.39344 7.72456C2.89077 8.03792 2.55277 8.60197 2.55277 9.25555Z"
        fill="#424242"
      />
      <path
        d="M21.3301 13.3555H14.1079"
        stroke="white"
        strokeWidth="5.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.5514 16.8202L12.0847 13.3535"
        stroke="white"
        strokeWidth="5.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.5514 9.8877L12.0847 13.3544"
        stroke="white"
        strokeWidth="5.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.3301 13.4996H12.6634"
        stroke="#424242"
        strokeWidth="1.95"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.5514 16.8202L12.0847 13.3535"
        stroke="#424242"
        strokeWidth="1.95"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.5514 9.8877L12.0847 13.3544"
        stroke="#424242"
        strokeWidth="1.95"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const SalesLeadIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.6 2.25C3.24196 2.25 2.89858 2.39223 2.64541 2.64541C2.39223 2.89858 2.25 3.24196 2.25 3.6V20.4C2.25 21.146 2.854 21.75 3.6 21.75H20.4C20.5773 21.75 20.7528 21.7151 20.9166 21.6472C21.0804 21.5794 21.2292 21.48 21.3546 21.3546C21.48 21.2292 21.5794 21.0804 21.6472 20.9166C21.7151 20.7528 21.75 20.5773 21.75 20.4V3.6C21.75 3.42272 21.7151 3.24717 21.6472 3.08338C21.5794 2.91959 21.48 2.77076 21.3546 2.64541C21.2292 2.52005 21.0804 2.42061 20.9166 2.35276C20.7528 2.28492 20.5773 2.25 20.4 2.25H3.6ZM8.75 8C8.75 7.80109 8.67098 7.61032 8.53033 7.46967C8.38968 7.32902 8.19891 7.25 8 7.25C7.80109 7.25 7.61032 7.32902 7.46967 7.46967C7.32902 7.61032 7.25 7.80109 7.25 8V16C7.25 16.1989 7.32902 16.3897 7.46967 16.5303C7.61032 16.671 7.80109 16.75 8 16.75C8.19891 16.75 8.38968 16.671 8.53033 16.5303C8.67098 16.3897 8.75 16.1989 8.75 16V8ZM12 10.25C12.1989 10.25 12.3897 10.329 12.5303 10.4697C12.671 10.6103 12.75 10.8011 12.75 11V16C12.75 16.1989 12.671 16.3897 12.5303 16.5303C12.3897 16.671 12.1989 16.75 12 16.75C11.8011 16.75 11.6103 16.671 11.4697 16.5303C11.329 16.3897 11.25 16.1989 11.25 16V11C11.25 10.8011 11.329 10.6103 11.4697 10.4697C11.6103 10.329 11.8011 10.25 12 10.25ZM16.75 13C16.75 12.8011 16.671 12.6103 16.5303 12.4697C16.3897 12.329 16.1989 12.25 16 12.25C15.8011 12.25 15.6103 12.329 15.4697 12.4697C15.329 12.6103 15.25 12.8011 15.25 13V16C15.25 16.1989 15.329 16.3897 15.4697 16.5303C15.6103 16.671 15.8011 16.75 16 16.75C16.1989 16.75 16.3897 16.671 16.5303 16.5303C16.671 16.3897 16.75 16.1989 16.75 16V13Z"
        fill="#424242"
      />
    </svg>
  );
};

export const SendIcon = ({ color }: PlayIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M17.3194 2.68104C17.235 2.59709 17.1284 2.53896 17.0122 2.5135C16.8959 2.48803 16.7748 2.49629 16.6631 2.53729L2.91311 7.53729C2.79453 7.58227 2.69244 7.66226 2.62039 7.76664C2.54835 7.87102 2.50977 7.99484 2.50977 8.12167C2.50977 8.2485 2.54835 8.37232 2.62039 8.4767C2.69244 8.58108 2.79453 8.66107 2.91311 8.70605L8.28186 10.8498L12.2444 6.87479L13.1256 7.75604L9.14436 11.7373L11.2944 17.106C11.3407 17.2223 11.4208 17.322 11.5245 17.3922C11.6281 17.4624 11.7504 17.4999 11.8756 17.4998C12.0019 17.4972 12.1245 17.4564 12.2271 17.3828C12.3298 17.3091 12.4077 17.2061 12.4506 17.0873L17.4506 3.3373C17.4932 3.22672 17.5035 3.10631 17.4802 2.99012C17.457 2.87393 17.4012 2.76674 17.3194 2.68104Z"
        fill={color ? color : "#616161"}
      />
    </svg>
  );
};

export const PhoneSmIcon = ({ color }: PlayIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
    >
      <rect
        x="6.59375"
        y="4.19141"
        width="8.65248"
        height="13.844"
        rx="1.0383"
        stroke={color ? color : "#757575"}
        strokeWidth="1.55745"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.0586 5.05665H11.7891"
        stroke={color ? color : "#757575"}
        strokeWidth="1.55745"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.9209 15.439V15.4477"
        stroke={color ? color : "#43A047"}
        strokeWidth="1.55745"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const EmailSentIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
    >
      <path
        d="M10 15.0719H4.16667C3.24619 15.0719 2.5 14.3257 2.5 13.4053V5.07194C2.5 4.15147 3.24619 3.40527 4.16667 3.40527H15.8333C16.7538 3.40527 17.5 4.15147 17.5 5.07194V11.3219"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.5 5.07227L10 10.0723L17.5 5.07227"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5 16.3229L14.1667 17.9896L17.5 14.6562"
        stroke="black"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const SolarIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M8.56297 13.7622C8.56714 13.6705 8.71881 13.6338 8.76297 13.7138C8.97464 14.0888 9.33464 14.6397 9.74381 14.8905C10.1521 15.1405 10.8063 15.2122 11.2363 15.2305C11.328 15.2347 11.3646 15.3855 11.2846 15.4305C10.9096 15.6422 10.3588 16.0022 10.108 16.4105C9.85797 16.8188 9.7863 17.4738 9.76797 17.9038C9.7638 17.9955 9.61214 18.0313 9.56797 17.9513C9.35631 17.5763 8.99631 17.0263 8.58797 16.7755C8.17964 16.5247 7.52464 16.4538 7.09464 16.4355C7.00297 16.4313 6.96714 16.2797 7.04714 16.2355C7.42214 16.0238 7.97214 15.6638 8.22297 15.2547C8.47381 14.8463 8.54464 14.1913 8.56297 13.7622ZM15.4088 12.9288C15.4021 12.8372 15.2421 12.7988 15.1946 12.8772C15.0513 13.113 14.8438 13.3963 14.6138 13.538C14.3838 13.6797 14.0363 13.7347 13.7613 13.7563C13.6696 13.763 13.6321 13.923 13.7096 13.9705C13.9455 14.1138 14.2296 14.3205 14.3705 14.5513C14.5121 14.7813 14.568 15.1288 14.5888 15.4038C14.5963 15.4955 14.7555 15.533 14.8038 15.4547C14.9471 15.2197 15.1538 14.9355 15.3846 14.7947C15.6146 14.653 15.9613 14.5972 16.2363 14.5763C16.328 14.5688 16.3663 14.4097 16.288 14.3613C16.0521 14.218 15.768 14.0113 15.6271 13.7805C15.4855 13.5505 15.4305 13.2038 15.4088 12.9288ZM12.2521 3.33467L12.0505 3.07967C11.2696 2.09384 10.8796 1.6005 10.4255 1.673C9.97131 1.74634 9.75381 2.33634 9.31964 3.51717L9.20797 3.82217C9.08381 4.158 9.02214 4.3255 8.90464 4.44884C8.78547 4.57217 8.62464 4.63634 8.30131 4.7655L8.00714 4.883L7.80047 4.96634C6.80047 5.36634 6.29714 5.59384 6.23297 6.0355C6.16464 6.50634 6.64131 6.90967 7.59464 7.7155L7.84131 7.92384C8.11214 8.153 8.24797 8.268 8.32464 8.42384C8.40297 8.57967 8.41381 8.75967 8.43631 9.11967L8.45631 9.44717C8.53381 10.7138 8.57297 11.3472 8.98464 11.5655C9.39631 11.7838 9.90797 11.443 10.9313 10.7605L11.1963 10.5838C11.488 10.3897 11.633 10.2922 11.7988 10.2663C11.9655 10.2397 12.1338 10.2863 12.4705 10.3797L12.7771 10.4647C13.9621 10.793 14.5546 10.9572 14.8771 10.6213C15.2005 10.2855 15.0405 9.67134 14.7188 8.44384L14.6363 8.12634C14.5446 7.77717 14.4996 7.603 14.5246 7.4305C14.5496 7.258 14.643 7.10634 14.8288 6.80384L14.998 6.52884C15.653 5.4655 15.9805 4.93384 15.768 4.50717C15.5563 4.08217 14.9455 4.043 13.723 3.96717L13.4071 3.94717C13.0596 3.9255 12.8863 3.91467 12.7355 3.83467C12.5855 3.75467 12.4738 3.61467 12.2521 3.33467ZM7.36131 11.1047C5.58047 11.9747 4.09797 13.353 3.53881 14.9997C2.91214 11.0772 3.78214 8.54384 5.17631 6.96884C5.29631 7.21467 5.45297 7.418 5.59297 7.57717C5.88464 7.90717 6.30297 8.2605 6.72797 8.61967L7.03381 8.878L7.17547 8.99883C7.17964 9.05217 7.18381 9.1155 7.18797 9.19634L7.21297 9.6005C7.24631 10.1463 7.27964 10.6788 7.36131 11.1047Z"
        fill="#616161"
      />
    </svg>
  );
};

export const ThumbsDownIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M17.3027 9.57617C17.373 9.3418 17.4082 9.09961 17.4082 8.85352C17.4082 8.30078 17.2266 7.76953 16.8984 7.33594C16.9688 7.10156 17.0039 6.85938 17.0039 6.61328C17.0039 6.06055 16.8223 5.5293 16.4941 5.0957C16.5645 4.86133 16.5996 4.61914 16.5996 4.37305C16.5996 3.36523 16 2.45703 15.0703 2.06055C14.9069 1.99009 14.7307 1.95419 14.5527 1.95508H5.33203V10.3145H5.33789L7.01367 16.3848C7.2832 17.3633 8.18164 18.0469 9.19727 18.0469C9.77734 18.0469 10.3184 17.8164 10.7188 17.3945C11.1191 16.9746 11.3242 16.4238 11.2949 15.8438L11.1777 13.4434H15.8633C16.0996 13.4434 16.3301 13.3809 16.5332 13.2617C17.3223 12.8027 17.8125 11.9707 17.8125 11.0938C17.8125 10.541 17.6309 10.0098 17.3027 9.57617ZM2.1875 2.57812V9.6875C2.1875 10.0332 2.4668 10.3125 2.8125 10.3125H4.08203V1.95312H2.8125C2.4668 1.95312 2.1875 2.23242 2.1875 2.57812Z"
        fill="#616161"
      />
    </svg>
  );
};

export const PersonKeyIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M10 2C8.93913 2 7.92172 2.42143 7.17157 3.17157C6.42143 3.92172 6 4.93913 6 6C6 7.06087 6.42143 8.07828 7.17157 8.82843C7.92172 9.57857 8.93913 10 10 10C11.0609 10 12.0783 9.57857 12.8284 8.82843C13.5786 8.07828 14 7.06087 14 6C14 4.93913 13.5786 3.92172 12.8284 3.17157C12.0783 2.42143 11.0609 2 10 2ZM5.009 11C4.74564 10.9989 4.48466 11.0499 4.24102 11.1499C3.99739 11.2499 3.7759 11.3971 3.58926 11.5829C3.40261 11.7687 3.25448 11.9895 3.15337 12.2327C3.05225 12.4759 3.00013 12.7366 3 13C3 14.691 3.833 15.966 5.135 16.797C6.183 17.465 7.53 17.845 9 17.96V17C9 16.59 9.162 16.22 9.441 15.941L12.021 13.361C12.0072 13.2201 12.0002 13.0786 12 12.937C11.9956 12.2549 12.179 11.5848 12.53 11H5.01H5.009ZM10.149 18.852C10.1943 18.8993 10.2488 18.9369 10.3092 18.9623C10.3696 18.9878 10.4345 19.0006 10.5 19H12.5C12.5954 18.9999 12.6893 18.9759 12.773 18.93C12.8396 18.8898 12.8918 18.8296 12.922 18.758C12.9536 18.683 12.9745 18.6039 12.984 18.523C12.9945 18.4377 12.9998 18.3519 13 18.266V18C13.24 17.995 13.427 17.987 13.563 17.977C13.6752 17.9754 13.7831 17.9335 13.867 17.859C13.9404 17.7773 13.982 17.6718 13.984 17.562C13.994 17.432 14 17.245 14 17H14.5C14.61 17 14.698 16.977 14.766 16.93C14.831 16.8859 14.8845 16.827 14.922 16.758C14.96 16.6848 14.9838 16.6051 14.992 16.523C15.002 16.435 15.008 16.343 15.008 16.25C15.0028 16.1744 15.0001 16.0987 15 16.023V15.828C15.172 15.891 15.346 15.935 15.523 15.961C15.701 15.987 15.88 16 16.063 16C16.4522 15.9993 16.8372 15.9192 17.1944 15.7649C17.5517 15.6105 17.8738 15.3849 18.141 15.102C18.411 14.82 18.622 14.5 18.773 14.141C18.924 13.781 19 13.401 19 13C19 12.583 18.922 12.193 18.766 11.828C18.6155 11.4721 18.3979 11.1486 18.125 10.875C17.8513 10.6025 17.5278 10.3852 17.172 10.235C16.8015 10.0773 16.4026 9.99731 16 10C15.6063 10.0074 15.2172 10.0867 14.852 10.234C14.4959 10.3774 14.1717 10.5898 13.898 10.859C13.6234 11.1286 13.401 11.4466 13.242 11.797C13.0798 12.155 12.9972 12.544 13 12.937C13 13.182 13.029 13.44 13.086 13.711L10.148 16.648C10.1006 16.6934 10.0629 16.7481 10.0375 16.8086C10.012 16.8692 9.99927 16.9343 10 17V18.5C10 18.635 10.05 18.753 10.148 18.852H10.149ZM17.281 11.719C17.3518 11.7879 17.4078 11.8705 17.4455 11.9618C17.4832 12.0531 17.5017 12.1512 17.5 12.25C17.5017 12.3488 17.4832 12.4469 17.4455 12.5382C17.4078 12.6295 17.3518 12.7121 17.281 12.781C17.2121 12.8518 17.1295 12.9078 17.0382 12.9455C16.9469 12.9832 16.8488 13.0017 16.75 13C16.6512 13.0017 16.5531 12.9832 16.4618 12.9455C16.3705 12.9078 16.2879 12.8518 16.219 12.781C16.1482 12.7121 16.0922 12.6295 16.0545 12.5382C16.0168 12.4469 15.9983 12.3488 16 12.25C16 12.042 16.073 11.865 16.219 11.719C16.2879 11.6482 16.3705 11.5922 16.4618 11.5545C16.5531 11.5168 16.6512 11.4983 16.75 11.5C16.958 11.5 17.135 11.573 17.281 11.719Z"
        fill="#616161"
      />
    </svg>
  );
};

export const RoadIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="23"
      height="20"
      viewBox="0 0 23 20"
      fill="none"
    >
      <g clip-path="url(#clip0_2820_119255)">
        <path
          d="M10 1.25H7.07812C6.01953 1.25 5.07422 1.91797 4.72266 2.91406L0.121094 15.9062C0.0429687 16.1328 0 16.375 0 16.6172C0 17.793 0.957031 18.75 2.13281 18.75H10V16.25C10 15.5586 10.5586 15 11.25 15C11.9414 15 12.5 15.5586 12.5 16.25V18.75H20.3672C21.5469 18.75 22.5 17.793 22.5 16.6172C22.5 16.375 22.457 16.1328 22.3789 15.9062L17.7773 2.91406C17.4219 1.91797 16.4805 1.25 15.4219 1.25H12.5V3.75C12.5 4.44141 11.9414 5 11.25 5C10.5586 5 10 4.44141 10 3.75V1.25ZM12.5 8.75V11.25C12.5 11.9414 11.9414 12.5 11.25 12.5C10.5586 12.5 10 11.9414 10 11.25V8.75C10 8.05859 10.5586 7.5 11.25 7.5C11.9414 7.5 12.5 8.05859 12.5 8.75Z"
          fill="#616161"
        />
      </g>
      <defs>
        <clipPath id="clip0_2820_119255">
          <rect width="22.5" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const PrinterIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M15.8346 6.66667H4.16797C2.78464 6.66667 1.66797 7.78333 1.66797 9.16667V12.5C1.66797 13.4167 2.41797 14.1667 3.33464 14.1667H5.0013V15.8333C5.0013 16.75 5.7513 17.5 6.66797 17.5H13.3346C14.2513 17.5 15.0013 16.75 15.0013 15.8333V14.1667H16.668C17.5846 14.1667 18.3346 13.4167 18.3346 12.5V9.16667C18.3346 7.78333 17.218 6.66667 15.8346 6.66667ZM12.5013 15.8333H7.5013C7.04297 15.8333 6.66797 15.4583 6.66797 15V11.6667H13.3346V15C13.3346 15.4583 12.9596 15.8333 12.5013 15.8333ZM15.8346 10C15.3763 10 15.0013 9.625 15.0013 9.16667C15.0013 8.70833 15.3763 8.33333 15.8346 8.33333C16.293 8.33333 16.668 8.70833 16.668 9.16667C16.668 9.625 16.293 10 15.8346 10ZM14.168 2.5H5.83464C5.3763 2.5 5.0013 2.875 5.0013 3.33333V5C5.0013 5.45833 5.3763 5.83333 5.83464 5.83333H14.168C14.6263 5.83333 15.0013 5.45833 15.0013 5V3.33333C15.0013 2.875 14.6263 2.5 14.168 2.5Z"
        fill="#616161"
      />
    </svg>
  );
};

export const DeSelectIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M16.0327 13.0334C15.8463 13.4033 15.9951 13.8543 16.365 14.0407C16.7349 14.227 17.1859 14.0782 17.3723 13.7083L16.0327 13.0334ZM6.29252 2.62857C5.9226 2.81495 5.77381 3.26591 5.96018 3.63582C6.14656 4.00574 6.59752 4.15453 6.96743 3.96816L6.29252 2.62857ZM5.2242 5.2306C5.51953 4.94016 5.52348 4.4653 5.23304 4.16998C4.9426 3.87465 4.46775 3.87069 4.17242 4.16113L5.2242 5.2306ZM15.837 15.8303C16.1276 15.5351 16.1238 15.0602 15.8286 14.7697C15.5334 14.4791 15.0585 14.4829 14.768 14.7781L15.837 15.8303ZM17.3723 13.7083C18.9742 10.5288 18.3557 6.6802 15.8382 4.16267L14.7775 5.22333C16.8373 7.28313 17.3434 10.4319 16.0327 13.0334L17.3723 13.7083ZM15.8382 4.16267C13.3206 1.64514 9.4721 1.02663 6.29252 2.62857L6.96743 3.96816C9.5689 2.65748 12.7177 3.16353 14.7775 5.22333L15.8382 4.16267ZM4.17242 4.16113C2.05955 6.23906 1.22348 9.29057 1.98214 12.1553L3.43215 11.7712C2.81143 9.42741 3.49549 6.93072 5.2242 5.2306L4.17242 4.16113ZM1.98214 12.1553C2.7408 15.0199 4.97763 17.2577 7.84202 18.0174L8.2266 16.5676C5.88301 15.9459 4.05288 14.1151 3.43215 11.7712L1.98214 12.1553ZM7.84202 18.0174C10.7064 18.7772 13.7582 17.9424 15.837 15.8303L14.768 14.7781C13.0671 16.5061 10.5702 17.1892 8.2266 16.5676L7.84202 18.0174Z"
        fill="#43A047"
      />
      <path
        d="M2.5 2.5L17.5 17.5"
        stroke="#212121"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const LiveConferenceIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="49"
      viewBox="0 0 48 49"
      fill="none"
    >
      <path
        d="M8.99971 11.75C8.99971 9.95979 9.71087 8.2429 10.9767 6.97703C12.2426 5.71116 13.9595 5 15.7497 5H38.2497C40.0399 5 41.7568 5.71116 43.0227 6.97703C44.2885 8.2429 44.9997 9.95979 44.9997 11.75V26.75C44.9997 28.5402 44.2885 30.2571 43.0227 31.523C41.7568 32.7888 40.0399 33.5 38.2497 33.5H28.7862C27.8862 31.526 25.9722 30.245 23.9982 29.867V27.5C23.9982 26.3065 24.4723 25.1619 25.3162 24.318C26.1601 23.4741 27.3047 23 28.4982 23H35.9982C37.1917 23 38.3363 23.4741 39.1802 24.318C40.0241 25.1619 40.4982 26.3065 40.4982 27.5V29.75C40.9646 29.4012 41.3431 28.9484 41.6038 28.4276C41.8644 27.9068 42 27.3324 41.9997 26.75V11.75C41.9997 10.7554 41.6046 9.80161 40.9014 9.09835C40.1981 8.39509 39.2443 8 38.2497 8H15.7497C14.7552 8 13.8013 8.39509 13.0981 9.09835C12.3948 9.80161 11.9997 10.7554 11.9997 11.75V12.221C10.914 12.5719 9.89851 13.1111 8.99971 13.814V11.75ZM22.7847 32C23.4149 32.0016 24.0378 32.136 24.6126 32.3945C25.1874 32.6529 25.7013 33.0296 26.1207 33.5H26.1192C26.4549 33.8822 26.711 34.3276 26.8725 34.81C27.034 35.2924 27.0977 35.8022 27.0597 36.3095C26.8572 39.4205 25.6827 41.8295 23.4552 43.4015C21.3057 44.918 18.3882 45.5 14.9967 45.5C11.6247 45.5 8.76271 44.924 6.64771 43.421C4.46071 41.8655 3.30571 39.4925 3.02221 36.446C2.77771 33.827 5.02321 32 7.30621 32H22.7832H22.7847ZM32.2482 21.5C33.6406 21.5 34.976 20.9469 35.9605 19.9623C36.9451 18.9777 37.4982 17.6424 37.4982 16.25C37.4982 14.8576 36.9451 13.5223 35.9605 12.5377C34.976 11.5531 33.6406 11 32.2482 11C30.8558 11 29.5205 11.5531 28.5359 12.5377C27.5513 13.5223 26.9982 14.8576 26.9982 16.25C26.9982 17.6424 27.5513 18.9777 28.5359 19.9623C29.5205 20.9469 30.8558 21.5 32.2482 21.5ZM22.4982 21.5C22.4982 23.4891 21.708 25.3968 20.3015 26.8033C18.895 28.2098 16.9873 29 14.9982 29C13.0091 29 11.1014 28.2098 9.69491 26.8033C8.28839 25.3968 7.49821 23.4891 7.49821 21.5C7.49821 19.5109 8.28839 17.6032 9.69491 16.1967C11.1014 14.7902 13.0091 14 14.9982 14C16.9873 14 18.895 14.7902 20.3015 16.1967C21.708 17.6032 22.4982 19.5109 22.4982 21.5Z"
        fill="#616161"
      />
    </svg>
  );
};

export const VideoUploadIcon = () => {
  return (
    <svg
      width="40"
      height="33"
      viewBox="0 0 40 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        id="Vector"
        d="M4 32.5C2.9 32.5 1.958 32.108 1.174 31.324C0.390003 30.54 -0.00132994 29.5987 3.39559e-06 28.5V4.5C3.39559e-06 3.4 0.392003 2.458 1.176 1.674C1.96 0.890003 2.90134 0.49867 4 0.500003H28C29.1 0.500003 30.042 0.892003 30.826 1.676C31.61 2.46 32.0013 3.40134 32 4.5V13.5L38.3 7.2C38.6 6.9 38.958 6.82467 39.374 6.974C39.79 7.12334 39.9987 7.432 40 7.9V25.1C40 25.5667 39.7913 25.8753 39.374 26.026C38.9567 26.1767 38.5987 26.1013 38.3 25.8L32 19.5V28.5C32 29.6 31.608 30.542 30.824 31.326C30.04 32.11 29.0987 32.5013 28 32.5H4Z"
        fill="#616161"
      />
    </svg>
  );
};

export const CameraIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="36"
      height="35"
      viewBox="0 0 36 35"
      fill="none"
    >
      <g clip-path="url(#clip0_2087_167277)">
        <path
          d="M22.3343 4.50098C23.0632 4.50075 23.7652 4.77603 24.2997 5.27166C24.8342 5.76728 25.1615 6.44661 25.2162 7.17346L25.2234 7.39014C25.2235 7.74397 25.3534 8.08547 25.5885 8.34988C25.8236 8.61429 26.1476 8.78322 26.499 8.82461L26.668 8.83473H28.1126C29.218 8.83466 30.2817 9.25701 31.0859 10.0154C31.8902 10.7737 32.3743 11.8107 32.4391 12.9142L32.4464 13.1685V26.1697C32.4464 27.2751 32.0241 28.3388 31.2657 29.1431C30.5074 29.9473 29.4704 30.4314 28.3669 30.4963L28.1126 30.5035H7.88844C6.78303 30.5035 5.71937 30.0812 4.91511 29.3228C4.11084 28.5645 3.62676 27.5275 3.56191 26.424L3.55469 26.1697V13.1685C3.55463 12.0631 3.97698 10.9994 4.73532 10.1951C5.49367 9.39088 6.53068 8.9068 7.63419 8.84195L7.88844 8.83473H9.33302C9.71615 8.83473 10.0836 8.68253 10.3545 8.41162C10.6254 8.14071 10.7776 7.77327 10.7776 7.39014C10.7774 6.66124 11.0527 5.95919 11.5483 5.42472C12.0439 4.89025 12.7232 4.56287 13.4501 4.5082L13.6668 4.50098H22.3343ZM18.0005 14.6131C16.9266 14.613 15.8909 15.0116 15.0942 15.7317C14.2975 16.4518 13.7965 17.4421 13.6884 18.5105L13.6725 18.7301L13.6668 18.9468L13.6725 19.1635C13.7149 20.0104 14.0048 20.8262 14.5063 21.5099C15.0078 22.1936 15.6988 22.7152 16.4938 23.0101C17.2888 23.3049 18.1529 23.3601 18.9789 23.1688C19.805 22.9774 20.5567 22.5479 21.1411 21.9335C21.7255 21.3191 22.1168 20.5468 22.2665 19.7122C22.4163 18.8776 22.3179 18.0174 21.9836 17.2382C21.6493 16.4589 21.0937 15.7949 20.3857 15.3283C19.6778 14.8617 18.8484 14.613 18.0005 14.6131Z"
          fill="#43A047"
        />
      </g>
      <defs>
        <clipPath id="clip0_2087_167277">
          <rect
            width="34.67"
            height="34.67"
            fill="white"
            transform="translate(0.664062 0.166992)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const AccordionIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M5.81812 9.08984L11.6363 14.908L17.4545 9.08985"
        stroke="#424242"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CallingIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="19"
      viewBox="0 0 20 19"
      fill="none"
    >
      <path
        d="M15.7916 16.1685C14.4082 16.1685 12.9765 15.8157 11.4965 15.11C10.0164 14.4044 8.64049 13.4091 7.36876 12.1242C6.08636 10.8524 5.09298 9.47947 4.38861 8.00526C3.68422 6.53103 3.33203 5.09893 3.33203 3.70896C3.33203 3.46994 3.41716 3.26403 3.58742 3.09122C3.75768 2.91843 3.96232 2.83203 4.20134 2.83203H6.41949C6.62452 2.83203 6.7977 2.89826 6.93904 3.03072C7.08037 3.16317 7.17869 3.33596 7.23402 3.5491L7.70747 5.6531C7.72727 5.83984 7.71686 6.01352 7.67626 6.17415C7.63566 6.33477 7.56335 6.46456 7.45933 6.56351L5.60881 8.3752C5.95947 8.98113 6.33083 9.54202 6.72286 10.0579C7.11488 10.5737 7.53723 11.0539 7.9899 11.4985C8.47911 12.01 8.99953 12.4726 9.55117 12.8862C10.1028 13.2998 10.6971 13.6809 11.3339 14.0295L13.1365 12.1813C13.2619 12.0428 13.4008 11.9481 13.5533 11.8974C13.7058 11.8466 13.8688 11.8357 14.0424 11.8646L15.9454 12.2818C16.1585 12.3229 16.3323 12.4281 16.4668 12.5973C16.6013 12.7665 16.6685 12.9577 16.6685 13.1709V15.2992C16.6685 15.5382 16.5821 15.7429 16.4093 15.9131C16.2365 16.0834 16.0306 16.1685 15.7916 16.1685Z"
        fill="white"
      />
    </svg>
  );
};

export const CloseIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M9.99997 10.9933L5.68476 15.3085C5.54315 15.4501 5.37739 15.5209 5.18747 15.5209C4.99755 15.5209 4.83179 15.4501 4.69018 15.3085C4.54858 15.1669 4.47778 15.0012 4.47778 14.8113C4.47778 14.6213 4.54858 14.4556 4.69018 14.314L9.00541 9.99875L4.69018 5.68354C4.54858 5.54193 4.47778 5.37617 4.47778 5.18625C4.47778 4.99633 4.54858 4.83057 4.69018 4.68896C4.83179 4.54736 4.99755 4.47656 5.18747 4.47656C5.37739 4.47656 5.54315 4.54736 5.68476 4.68896L9.99997 9.00419L14.3152 4.68896C14.4568 4.54736 14.6226 4.47656 14.8125 4.47656C15.0024 4.47656 15.1682 4.54736 15.3098 4.68896C15.4514 4.83057 15.5222 4.99633 15.5222 5.18625C15.5222 5.37617 15.4514 5.54193 15.3098 5.68354L10.9945 9.99875L15.3098 14.314C15.4514 14.4556 15.5222 14.6213 15.5222 14.8113C15.5222 15.0012 15.4514 15.1669 15.3098 15.3085C15.1682 15.4501 15.0024 15.5209 14.8125 15.5209C14.6226 15.5209 14.4568 15.4501 14.3152 15.3085L9.99997 10.9933Z"
        fill="black"
      />
    </svg>
  );
};

export const NoTaskIcon = () => {
  return (
    <svg
      width="308"
      height="297"
      viewBox="0 0 308 297"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M159.514 0C241.521 0 308 66.4857 308 148.5C308 230.514 241.521 297 159.514 297C77.5076 297 -35.9863 215.686 11.0282 148.5C58.0426 81.3144 77.5076 0 159.514 0Z"
        fill="#EEEEEE"
      />
      <path
        d="M174.212 111.322L190.027 111.88V127.214L186.42 123.589L168.941 140.875L153.681 179.629L118.999 144.779L162.004 133.069L178.929 116.062L174.212 111.322Z"
        fill="#66BB6A"
      />
      <path
        d="M162.837 87.9023H182.813L181.981 107.14L174.897 100.022L152.571 120.523L110.12 129.166L87.3691 106.303L152.848 111.322L170.883 95.9877L162.837 87.9023Z"
        fill="#66BB6A"
      />
      <path
        d="M195.848 108.81L220.443 105.961L223.295 129.867L211.651 121.555L193.908 146.214L203.888 229.056L176.719 201.903L183.373 145.66L205.274 116.845L195.848 108.81Z"
        fill="#66BB6A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M141.996 215.684L99.3017 172.997C97.5528 171.248 100.13 169.45 101.765 167.815L71.7515 137.809L59.1485 150.408C52.7994 156.758 57.7402 165.695 59.4063 168.284C81.3982 202.456 110.78 231.827 146.731 255.586C152.429 259.348 159.647 260.774 164.59 255.83L177.194 243.229L147.18 213.223C145.64 214.762 143.747 217.429 141.996 215.684Z"
        fill="#64B5F6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M109.668 153.658L86.1014 130.091C84.3492 128.34 81.4818 128.339 79.7286 130.091L74.5352 135.285L104.475 165.223L109.668 160.03C111.423 158.274 111.424 155.415 109.668 153.657V153.658ZM184.911 228.902L161.343 205.335C159.65 203.641 156.662 203.643 154.972 205.335L149.78 210.527L179.719 240.466L184.911 235.274C186.661 233.524 186.661 230.653 184.911 228.901V228.902Z"
        fill="#1E88E5"
      />
      <path
        d="M214.5 75.4585C210.896 75.4585 207.949 74.3138 205.66 72.0245C203.37 69.7351 202.226 66.7884 202.226 63.1842C202.226 59.5801 203.37 56.6321 205.66 54.3402C207.949 52.0483 210.896 50.9023 214.5 50.9023C218.104 50.9023 221.055 52.0483 223.353 54.3402C225.651 56.6321 226.8 59.5801 226.8 63.1842C226.8 66.7884 225.651 69.7351 223.353 72.0245C221.055 74.3138 218.104 75.4585 214.5 75.4585ZM191.844 101.686C190.187 101.686 188.844 100.343 188.844 98.6865V93.7828C188.844 91.7069 189.366 89.9216 190.411 88.4268C191.456 86.9319 192.806 85.7966 194.46 85.0209C198.001 83.4339 201.404 82.2438 204.668 81.4504C207.933 80.6569 211.21 80.2602 214.499 80.2602C217.811 80.2602 221.086 80.67 224.322 81.4897C227.558 82.3094 230.94 83.4864 234.468 85.0209C236.178 85.7801 237.558 86.9091 238.608 88.4078C239.657 89.9066 240.182 91.6966 240.182 93.7778V98.6865C240.182 100.343 238.839 101.686 237.182 101.686H191.844Z"
        fill="#42A5F5"
      />
    </svg>
  );
};

export const GreenCallIcon = () => {
  return (
    <svg
      width="140"
      height="139"
      viewBox="0 0 140 139"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="70"
        cy="69.5"
        r="68.5"
        fill="white"
        stroke="#E0E0E0"
        strokeWidth="2"
      />
      <circle cx="70" cy="69.5" r="54.5" fill="#43A047" />
      <path
        d="M88.8345 81.5843C85.5564 81.5843 82.3849 81.0512 79.4266 80.0918C78.4938 79.772 77.4544 80.0118 76.7348 80.7314L72.5505 85.9817C65.0082 82.3838 57.9455 75.5877 54.1877 67.7788L59.3847 63.3547C60.1043 62.6085 60.3175 61.5691 60.0243 60.6363C59.0382 57.678 58.5319 54.5065 58.5319 51.2283C58.5319 49.7892 57.3326 48.5898 55.8934 48.5898H46.672C45.2328 48.5898 43.5005 49.2295 43.5005 51.2283C43.5005 75.9875 64.102 96.5623 88.8345 96.5623C90.7267 96.5623 91.473 94.8833 91.473 93.4175V84.2228C91.473 82.7836 90.2737 81.5843 88.8345 81.5843Z"
        fill="white"
      />
      <path
        d="M79.4397 71.1458C79.1041 70.8606 78.8604 70.471 78.7308 70.0148C77.4653 65.2234 73.4646 61.7469 68.5226 61.1621C67.2843 61.0146 66.387 59.8938 66.5398 58.6392C66.6873 57.3956 67.8236 56.5037 69.07 56.6484C75.8679 57.4503 81.3875 62.2344 83.1221 68.8403C83.4386 70.0518 82.715 71.2934 81.5027 71.6195C80.7481 71.8155 79.9763 71.6167 79.4287 71.1404L79.4397 71.1458Z"
        fill="white"
      />
      <path
        d="M81.9568 72.3841C81.8833 72.4094 81.8098 72.4347 81.7363 72.46C80.7229 72.7268 79.6585 72.474 78.877 71.7959C78.3983 71.387 78.0659 70.8457 77.9022 70.2373C76.7272 65.7882 73.0044 62.562 68.426 62.0252C67.5977 61.9278 66.8514 61.5108 66.3322 60.8517C65.8131 60.1927 65.5875 59.3779 65.6839 58.5434C65.8237 57.357 66.653 56.3431 67.7801 55.9552C68.2293 55.8006 68.6957 55.7493 69.1713 55.8042C76.3219 56.6487 82.1304 61.6885 83.9608 68.6257C84.376 70.2038 83.4922 71.8557 81.9487 72.3869L81.9568 72.3841ZM68.3459 57.5726C67.8313 57.7497 67.4639 58.1948 67.4031 58.7348C67.3572 59.1057 67.4588 59.4805 67.6962 59.7722C67.9254 60.0666 68.2629 60.251 68.6347 60.2961C73.9211 60.9261 78.2162 64.6474 79.572 69.781C79.6481 70.0553 79.795 70.2962 80.0041 70.4792C80.3563 70.7859 80.8324 70.8953 81.2928 70.7732L81.3908 70.7395C82.085 70.5006 82.4799 69.7637 82.2907 69.0547C80.6383 62.7939 75.4159 58.2626 68.9677 57.4951C68.7572 57.4674 68.5472 57.4942 68.3431 57.5644L68.3459 57.5726Z"
        fill="#43A047"
      />
      <path
        d="M87.3989 68.9279C87.0633 68.6427 86.8196 68.2531 86.6981 67.7941C84.5798 59.7813 77.8853 53.9719 69.6304 52.9976C68.384 52.8529 67.4921 51.7211 67.6477 50.4747C67.8033 49.2282 68.9314 48.3391 70.1778 48.4838C80.2914 49.6835 88.5047 56.8005 91.1004 66.6249C91.4169 67.8364 90.6933 69.078 89.4811 69.4042C88.7264 69.6001 87.9547 69.4014 87.4071 68.9251L87.3989 68.9279Z"
        fill="white"
      />
      <path
        d="M89.911 70.1764C89.8375 70.2017 89.764 70.227 89.6905 70.2523C88.6852 70.5164 87.6126 70.2663 86.8312 69.5882C86.3525 69.1793 86.0201 68.6381 85.8645 68.0269C83.8365 60.3564 77.431 54.8027 69.5341 53.8599C68.7059 53.7625 67.9595 53.3455 67.4432 52.6946C66.9241 52.0355 66.6875 51.2154 66.7949 50.3863C66.9346 49.1999 67.764 48.186 68.8992 47.7953C69.3484 47.6407 69.8149 47.5894 70.2905 47.6442C80.7648 48.8837 89.2561 56.251 91.9422 66.4177C92.3575 67.9958 91.4737 69.6477 89.9301 70.179L89.911 70.1764ZM69.4405 49.4211C68.926 49.5982 68.5585 50.0433 68.4977 50.5833C68.4519 50.9542 68.5616 51.3262 68.7908 51.6207C69.0201 51.9151 69.3575 52.0995 69.7293 52.1445C78.3368 53.1614 85.3202 59.2265 87.529 67.5815C87.5969 67.8586 87.7519 68.0966 87.9611 68.2796C88.3133 68.5864 88.8003 68.7011 89.2526 68.5818L89.3506 68.5481C90.0448 68.3092 90.4397 67.5723 90.2587 66.8606C87.7533 57.3784 79.8343 50.5061 70.0761 49.3571C69.8656 49.3294 69.6556 49.3561 69.4515 49.4264L69.4405 49.4211Z"
        fill="#43A047"
      />
      <path
        d="M95.3488 66.7068C95.0214 66.4188 94.7695 66.032 94.648 65.5729C91.6849 54.336 82.2967 46.1938 70.7261 44.8217C69.4797 44.677 68.5878 43.5452 68.7353 42.3015C68.8827 41.0579 70.019 40.166 71.2682 40.3188C84.7028 41.9053 95.6044 51.3662 99.0422 64.4066C99.3586 65.6181 98.635 66.8597 97.42 67.1777C96.6654 67.3737 95.8936 67.1749 95.346 66.6986L95.3488 66.7068Z"
        fill="white"
      />
      <path
        d="M97.8691 67.9562C97.7956 67.9815 97.7221 68.0068 97.6486 68.0321C96.6434 68.2961 95.5736 68.0542 94.7894 67.368C94.3078 66.9509 93.9754 66.4097 93.8227 65.8067C90.9499 54.912 81.8478 47.0173 70.6328 45.6958C69.8045 45.5984 69.0582 45.1815 68.5418 44.5305C68.0227 43.8715 67.7861 43.0514 67.8935 42.2222C68.0333 41.0358 68.8626 40.0219 69.9897 39.634C70.4388 39.4794 70.9053 39.4281 71.3809 39.483C85.1682 41.112 96.3641 50.8176 99.895 64.2084C100.31 65.7866 99.4265 67.4384 97.8829 67.9697L97.8691 67.9562ZM70.5363 41.2489C70.0218 41.4259 69.6544 41.8711 69.5936 42.4111C69.5477 42.782 69.6574 43.154 69.8867 43.4485C70.1159 43.7429 70.4534 43.9273 70.8251 43.9723C82.7564 45.3842 92.4308 53.774 95.4843 65.3531C95.5523 65.6302 95.7073 65.8683 95.9192 66.0594C96.2714 66.3662 96.7557 66.4727 97.2079 66.3535L97.3059 66.3198C98.0001 66.0808 98.395 65.3439 98.2058 64.635C94.8585 51.9368 84.243 42.7235 71.161 41.1796C70.9505 41.1518 70.7405 41.1786 70.5363 41.2489Z"
        fill="#43A047"
      />
    </svg>
  );
};

export const PlayWhiteIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M6.8625 13.6518C6.675 13.7768 6.48437 13.7831 6.29062 13.6706C6.09687 13.5581 6 13.3893 6 13.1643V4.72681C6 4.50181 6.09687 4.33306 6.29062 4.22056C6.48437 4.10806 6.675 4.11431 6.8625 4.23931L13.5 8.47681C13.675 8.58931 13.7625 8.74556 13.7625 8.94556C13.7625 9.14556 13.675 9.30181 13.5 9.41431L6.8625 13.6518Z"
        fill="white"
      />
    </svg>
  );
};

export const SparklesIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g clip-path="url(#clip0_2031_80305)">
        <path
          d="M19 9L20.25 6.25L23 5L20.25 3.75L19 1L17.75 3.75L15 5L17.75 6.25L19 9ZM11.5 9.5L9 4L6.5 9.5L1 12L6.5 14.5L9 20L11.5 14.5L17 12L11.5 9.5ZM19 15L17.75 17.75L15 19L17.75 20.25L19 23L20.25 20.25L23 19L20.25 17.75L19 15Z"
          fill="#1E88E5"
        />
      </g>
      <defs>
        <clipPath id="clip0_2031_80305">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const PlayVideoIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
    >
      <path
        d="M24.8544 35.6853L35.2604 29.0233C35.6266 28.7849 35.8097 28.4423 35.8097 27.9956C35.8097 27.5488 35.6302 27.1977 35.2712 26.9421L24.8544 20.3124C24.4385 20.0282 24.0145 20.008 23.5822 20.2519C23.1499 20.4958 22.9338 20.8593 22.9338 21.3422V34.6286C22.9338 35.1294 23.1499 35.5018 23.5822 35.7457C24.0145 35.9896 24.4385 35.9695 24.8544 35.6853ZM28.0089 49.986C24.9911 49.986 22.1459 49.406 19.4735 48.2462C16.8009 47.0863 14.4684 45.5095 12.4758 43.5156C10.4832 41.5218 8.90788 39.1924 7.7498 36.5273C6.59173 33.8624 6.0127 31.0226 6.0127 28.0079C6.0127 24.9662 6.59263 22.1053 7.75249 19.4254C8.91231 16.7454 10.4892 14.4139 12.483 12.4311C14.4769 10.4482 16.8063 8.88259 19.4713 7.73424C22.1363 6.58589 24.9761 6.01172 27.9907 6.01172C31.0324 6.01172 33.8934 6.58908 36.5736 7.74381C39.2539 8.89854 41.5853 10.4657 43.5679 12.4452C45.5506 14.4247 47.1161 16.7507 48.2644 19.4232C49.4128 22.0957 49.9869 24.9512 49.9869 27.9897C49.9869 31.0076 49.4119 33.8527 48.2617 36.5252C47.1116 39.1977 45.5445 41.5303 43.5603 43.5229C41.5762 45.5154 39.2479 47.0908 36.5755 48.2488C33.903 49.4069 31.0475 49.986 28.0089 49.986Z"
        fill="white"
      />
    </svg>
  );
};

export const OutBoundEmailDasboardIcon = () => {
  return (
    <svg
      width="37"
      height="34"
      viewBox="0 0 37 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M31.6043 14.6147C31.4475 14.5242 31.2697 14.4766 31.0886 14.4766C30.9076 14.4766 30.7298 14.5242 30.573 14.6147L17.1668 22.1944L3.76051 14.6147C3.60344 14.524 3.42523 14.4764 3.24385 14.4766C3.06248 14.4767 2.88437 14.5248 2.72748 14.6157C2.57058 14.7067 2.44047 14.8375 2.35025 14.9949C2.26003 15.1522 2.21291 15.3305 2.21363 15.5119V24.4116C2.21363 25.2321 2.53958 26.019 3.11977 26.5992C3.69996 27.1794 4.48687 27.5054 5.30738 27.5054H29.0261C29.8466 27.5054 30.6336 27.1794 31.2137 26.5992C31.7939 26.019 32.1199 25.2321 32.1199 24.4116V15.5171C32.1215 15.3345 32.0746 15.1547 31.984 14.9962C31.8935 14.8377 31.7624 14.706 31.6043 14.6147Z"
        fill="#43A047"
      />
      <path
        d="M29.0261 5.85156H5.30738C4.48687 5.85156 3.69996 6.17751 3.11977 6.7577C2.53958 7.33789 2.21363 8.1248 2.21363 8.94531V10.8789C2.21291 11.0606 2.26022 11.2393 2.35076 11.3969C2.44131 11.5544 2.57188 11.6852 2.72926 11.7761L16.6511 19.6394C16.8079 19.7299 16.9857 19.7775 17.1668 19.7775C17.3478 19.7775 17.5256 19.7299 17.6824 19.6394L31.6043 11.7761C31.7616 11.6852 31.8922 11.5544 31.9827 11.3969C32.0733 11.2393 32.1206 11.0606 32.1199 10.8789V8.94531C32.1199 8.1248 31.7939 7.33789 31.2137 6.7577C30.6336 6.17751 29.8466 5.85156 29.0261 5.85156Z"
        fill="#43A047"
      />
      <rect
        x="36.4166"
        y="17.9297"
        width="20.5"
        height="13"
        rx="6.5"
        transform="rotate(180 36.4166 17.9297)"
        fill="white"
      />
      <rect
        x="36.4166"
        y="17.9297"
        width="20.5"
        height="13"
        rx="6.5"
        transform="rotate(180 36.4166 17.9297)"
        stroke="#43A047"
        strokeWidth="0.5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.4618 11.1329L28.868 11.1329C29.2588 11.1329 29.2586 11.7266 28.868 11.7266L23.4618 11.7266C23.0711 11.7266 23.0711 11.1329 23.4618 11.1329Z"
        fill="#43A047"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27.0211 9.28842C27.097 9.28842 27.1731 9.3175 27.2311 9.37538L29.0774 11.2217C29.1934 11.3376 29.1934 11.5255 29.0774 11.6414L27.2311 13.4877C26.9546 13.7641 26.5347 13.3442 26.8111 13.068L28.4477 11.4314L26.8111 9.79477C26.6234 9.60719 26.7592 9.28812 27.021 9.28812L27.0211 9.28842Z"
        fill="#43A047"
      />
    </svg>
  );
};

export const InboundEmailDashboardIcon = () => {
  return (
    <svg
      width="37"
      height="34"
      viewBox="0 0 37 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.72924 14.6147C5.88601 14.5242 6.06384 14.4766 6.24487 14.4766C6.42589 14.4766 6.60372 14.5242 6.76049 14.6147L20.1667 22.1944L33.573 14.6147C33.7301 14.524 33.9083 14.4764 34.0896 14.4766C34.271 14.4767 34.4491 14.5248 34.606 14.6157C34.7629 14.7067 34.893 14.8375 34.9832 14.9949C35.0735 15.1522 35.1206 15.3305 35.1199 15.5119V24.4116C35.1199 25.2321 34.7939 26.019 34.2137 26.5992C33.6335 27.1794 32.8466 27.5054 32.0261 27.5054H8.30737C7.48685 27.5054 6.69994 27.1794 6.11975 26.5992C5.53956 26.019 5.21362 25.2321 5.21362 24.4116V15.5171C5.21198 15.3345 5.25886 15.1547 5.34945 14.9962C5.44004 14.8377 5.5711 14.706 5.72924 14.6147Z"
        fill="#43A047"
      />
      <path
        d="M8.30736 5.85156H32.0261C32.8466 5.85156 33.6335 6.17751 34.2137 6.7577C34.7939 7.33789 35.1199 8.1248 35.1199 8.94531V10.8789C35.1206 11.0606 35.0733 11.2393 34.9827 11.3969C34.8922 11.5544 34.7616 11.6852 34.6042 11.7761L20.6824 19.6394C20.5256 19.7299 20.3478 19.7775 20.1667 19.7775C19.9857 19.7775 19.8079 19.7299 19.6511 19.6394L5.72924 11.7761C5.57186 11.6852 5.44129 11.5544 5.35075 11.3969C5.2602 11.2393 5.21289 11.0606 5.21361 10.8789V8.94531C5.21361 8.1248 5.53956 7.33789 6.11975 6.7577C6.69994 6.17751 7.48685 5.85156 8.30736 5.85156Z"
        fill="#43A047"
      />
      <rect
        x="0.25"
        y="-0.25"
        width="20.5"
        height="13"
        rx="6.5"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 0.66687 17.6797)"
        fill="white"
      />
      <rect
        x="0.25"
        y="-0.25"
        width="20.5"
        height="13"
        rx="6.5"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 0.66687 17.6797)"
        stroke="#43A047"
        strokeWidth="0.5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.8717 11.1329L8.46549 11.1329C8.07474 11.1329 8.07489 11.7266 8.46549 11.7266L13.8717 11.7266C14.2624 11.7266 14.2624 11.1329 13.8717 11.1329Z"
        fill="#43A047"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.3124 9.28842C10.2365 9.28842 10.1604 9.3175 10.1024 9.37538L8.25611 11.2217C8.14005 11.3376 8.14005 11.5255 8.25611 11.6414L10.1024 13.4877C10.3789 13.7641 10.7988 13.3442 10.5224 13.068L8.88578 11.4314L10.5224 9.79477C10.7101 9.60719 10.5743 9.28812 10.3125 9.28812L10.3124 9.28842Z"
        fill="#43A047"
      />
    </svg>
  );
};

export const BlueAppointmentIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
    >
      <g clip-path="url(#clip0_5126_147101)">
        <path
          d="M17.5833 11.1797C21.3112 11.1797 24.3333 14.2018 24.3333 17.9297C24.3333 21.6576 21.3112 24.6797 17.5833 24.6797C13.8553 24.6797 10.8333 21.6576 10.8333 17.9297C10.8333 14.2018 13.8553 11.1797 17.5833 11.1797ZM17.5833 14.1797C17.1691 14.1797 16.8333 14.5155 16.8333 14.9297V17.1797H14.5833C14.169 17.1797 13.8333 17.5155 13.8333 17.9297C13.8333 18.3438 14.169 18.6797 14.5833 18.6797H16.8333V20.9297C16.8333 21.3438 17.1691 21.6797 17.5833 21.6797C17.9974 21.6797 18.3333 21.3438 18.3333 20.9297V18.6797H20.5833C20.9974 18.6797 21.3333 18.3438 21.3333 17.9297C21.3333 17.5155 20.9974 17.1797 20.5833 17.1797H18.3333V14.9297C18.3333 14.5155 17.9974 14.1797 17.5833 14.1797ZM11.219 12.6797C10.041 14.1061 9.33325 15.9353 9.33325 17.9297C9.33325 18.7097 9.44148 19.4643 9.64374 20.1794L9.42354 20.1809C5.63227 20.1809 3.47975 18.9139 3.34046 16.3603L3.33325 16.0916V14.9297C3.33325 13.7601 4.22558 12.799 5.36656 12.69L5.58325 12.6797H11.219ZM9.33325 3.67969C11.4047 3.67969 13.0839 5.35889 13.0839 7.43029C13.0839 9.5017 11.4047 11.1809 9.33325 11.1809C7.26184 11.1809 5.58264 9.5017 5.58264 7.43029C5.58264 5.35889 7.26184 3.67969 9.33325 3.67969ZM16.8333 5.17969C18.4902 5.17969 19.8333 6.52283 19.8333 8.17969C19.8333 8.80327 19.6431 9.38242 19.3174 9.86225C18.7582 9.74264 18.1782 9.67969 17.5833 9.67969C16.5447 9.67969 15.5511 9.87158 14.6356 10.2219C14.1378 9.68633 13.8333 8.96857 13.8333 8.17969C13.8333 6.52283 15.1764 5.17969 16.8333 5.17969Z"
          fill="#1E88E5"
        />
      </g>
      <defs>
        <clipPath id="clip0_5126_147101">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0.333252 0.679688)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const BlueLeadIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
    >
      <path
        d="M6.33325 17.0156C6.33325 15.0156 10.3333 13.9156 12.3333 13.9156C14.3333 13.9156 18.3333 15.0156 18.3333 17.0156V18.0156H6.33325M15.3333 9.01562C15.3333 9.81127 15.0172 10.5743 14.4546 11.1369C13.892 11.6996 13.1289 12.0156 12.3333 12.0156C11.5376 12.0156 10.7745 11.6996 10.2119 11.1369C9.64932 10.5743 9.33325 9.81127 9.33325 9.01562C9.33325 8.21998 9.64932 7.45691 10.2119 6.8943C10.7745 6.3317 11.5376 6.01562 12.3333 6.01562C13.1289 6.01562 13.892 6.3317 14.4546 6.8943C15.0172 7.45691 15.3333 8.21998 15.3333 9.01562ZM3.33325 5.01562V19.0156C3.33325 19.5461 3.54397 20.0548 3.91904 20.4298C4.29411 20.8049 4.80282 21.0156 5.33325 21.0156H19.3333C19.8637 21.0156 20.3724 20.8049 20.7475 20.4298C21.1225 20.0548 21.3333 19.5461 21.3333 19.0156V5.01562C21.3333 4.48519 21.1225 3.97648 20.7475 3.60141C20.3724 3.22634 19.8637 3.01563 19.3333 3.01562H5.33325C4.80282 3.01563 4.29411 3.22634 3.91904 3.60141C3.54397 3.97648 3.33325 4.48519 3.33325 5.01562Z"
        fill="#1E88E5"
      />
    </svg>
  );
};

export const BlueBroadcastIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
    >
      <mask
        id="mask0_5126_147129"
        maskUnits="userSpaceOnUse"
        x="1"
        y="4"
        width="23"
        height="17"
      >
        <path
          d="M12.333 14.6565C12.6311 14.657 12.9263 14.5988 13.2019 14.4852C13.4774 14.3716 13.7279 14.2048 13.939 13.9944C14.1501 13.784 14.3176 13.534 14.4321 13.2588C14.5465 12.9836 14.6057 12.6886 14.606 12.3905C14.6056 12.0925 14.5464 11.7975 14.4319 11.5223C14.3175 11.2472 14.1499 10.9973 13.9388 10.7869C13.7277 10.5765 13.4773 10.4098 13.2018 10.2962C12.9263 10.1827 12.6311 10.1245 12.333 10.125C11.7314 10.1241 11.1539 10.3622 10.7278 10.7869C10.3016 11.2117 10.0616 11.7883 10.0605 12.39C10.0609 12.6881 10.1199 12.9831 10.2343 13.2584C10.3487 13.5336 10.5162 13.7836 10.7272 13.9941C10.9383 14.2045 11.1887 14.3714 11.4642 14.485C11.7398 14.5987 12.035 14.657 12.333 14.6565Z"
          fill="white"
          stroke="white"
          strokeWidth="1.66667"
          strokeLinejoin="round"
        />
        <path
          d="M8.33325 7.84375C5.66675 10.3287 5.66675 14.3588 8.33325 16.8438M16.3332 16.8438C18.9997 14.3588 18.9997 10.3287 16.3332 7.84375M5.26225 5.34375C1.35725 9.23675 1.35725 15.5487 5.26225 19.4417M19.4042 19.4417C23.3092 15.5487 23.3092 9.23675 19.4042 5.34375"
          stroke="white"
          strokeWidth="1.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </mask>
      <g mask="url(#mask0_5126_147129)">
        <path
          d="M0.333252 0.34375H24.3333V24.3438H0.333252V0.34375Z"
          fill="#1E88E5"
        />
      </g>
    </svg>
  );
};

export const ContactReminderIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="43"
      height="43"
      viewBox="0 0 43 43"
      fill="none"
    >
      <path
        d="M27.3613 33.3992C27.7079 33.3992 28.0111 33.2692 28.2711 33.0093C28.531 32.7494 28.661 32.4461 28.661 32.0995C28.661 31.7529 28.531 31.4497 28.2711 31.1897C28.0111 30.9298 27.7079 30.7998 27.3613 30.7998C27.0147 30.7998 26.7114 30.9298 26.4515 31.1897C26.1916 31.4497 26.0616 31.7529 26.0616 32.0995C26.0616 32.4461 26.1916 32.7494 26.4515 33.0093C26.7114 33.2692 27.0147 33.3992 27.3613 33.3992ZM32.1269 33.3992C32.4734 33.3992 32.7767 33.2692 33.0366 33.0093C33.2966 32.7494 33.4266 32.4461 33.4266 32.0995C33.4266 31.7529 33.2966 31.4497 33.0366 31.1897C32.7767 30.9298 32.4734 30.7998 32.1269 30.7998C31.7803 30.7998 31.477 30.9298 31.2171 31.1897C30.9571 31.4497 30.8272 31.7529 30.8272 32.0995C30.8272 32.4461 30.9571 32.7494 31.2171 33.0093C31.477 33.2692 31.7803 33.3992 32.1269 33.3992ZM36.8924 33.3992C37.239 33.3992 37.5423 33.2692 37.8022 33.0093C38.0622 32.7494 38.1921 32.4461 38.1921 32.0995C38.1921 31.7529 38.0622 31.4497 37.8022 31.1897C37.5423 30.9298 37.239 30.7998 36.8924 30.7998C36.5458 30.7998 36.2426 30.9298 35.9826 31.1897C35.7227 31.4497 35.5927 31.7529 35.5927 32.0995C35.5927 32.4461 35.7227 32.7494 35.9826 33.0093C36.2426 33.2692 36.5458 33.3992 36.8924 33.3992ZM32.1269 40.7642C29.7296 40.7642 27.6859 39.9191 25.9957 38.2289C24.3055 36.5387 23.461 34.4956 23.4622 32.0995C23.4622 29.7023 24.3073 27.6586 25.9975 25.9684C27.6877 24.2782 29.7308 23.4337 32.1269 23.4348C34.5241 23.4348 36.5678 24.2799 38.258 25.9701C39.9482 27.6603 40.7927 29.7034 40.7915 32.0995C40.7915 34.4967 39.9464 36.5405 38.2563 38.2306C36.5661 39.9208 34.5229 40.7654 32.1269 40.7642ZM14.7975 16.5031H28.661C29.152 16.5031 29.5638 16.3367 29.8966 16.004C30.2293 15.6713 30.3951 15.26 30.3939 14.7702C30.3939 14.2792 30.2276 13.8673 29.8948 13.5346C29.5621 13.2018 29.1508 13.0361 28.661 13.0372H14.7975C14.3065 13.0372 13.8946 13.2036 13.5619 13.5363C13.2292 13.869 13.0634 14.2803 13.0646 14.7702C13.0646 15.2612 13.2309 15.673 13.5636 16.0057C13.8964 16.3385 14.3077 16.5042 14.7975 16.5031ZM21.166 37.2983H9.59869C8.64557 37.2983 7.82936 36.9587 7.15005 36.2794C6.47074 35.6 6.13166 34.7844 6.13282 33.8325V9.57134C6.13282 8.61823 6.47247 7.80202 7.15178 7.1227C7.83109 6.44339 8.64673 6.10432 9.59869 6.10547H33.8598C34.8129 6.10547 35.6291 6.44513 36.3084 7.12444C36.9877 7.80375 37.3268 8.61938 37.3257 9.57134V21.182C36.4881 20.7777 35.643 20.4744 34.7904 20.2722C33.9378 20.07 33.0499 19.969 32.1269 19.969C31.8092 19.969 31.5128 19.9759 31.2379 19.9898C30.9629 20.0036 30.6816 20.04 30.3939 20.0989C30.134 20.0412 29.8452 20.0054 29.5275 19.9915C29.2097 19.9776 28.9209 19.9701 28.661 19.969H14.7975C14.3065 19.969 13.8946 20.1353 13.5619 20.468C13.2292 20.8008 13.0634 21.2121 13.0646 21.7019C13.0646 22.1929 13.2309 22.6048 13.5636 22.9375C13.8964 23.2702 14.3077 23.436 14.7975 23.4348H23.6788C23.1589 23.9258 22.6893 24.4602 22.2699 25.0378C21.8505 25.6154 21.4826 26.2364 21.166 26.9007H14.7975C14.3065 26.9007 13.8946 27.0671 13.5619 27.3998C13.2292 27.7325 13.0634 28.1438 13.0646 28.6336C13.0646 29.1246 13.2309 29.5365 13.5636 29.8692C13.8964 30.2019 14.3077 30.3677 14.7975 30.3666H20.1263C20.0685 30.6554 20.0321 30.9373 20.0171 31.2123C20.0021 31.4872 19.9951 31.783 19.9963 32.0995C19.9963 33.0526 20.083 33.941 20.2562 34.7648C20.4295 35.5885 20.7328 36.433 21.166 37.2983Z"
        fill="#424242"
      />
    </svg>
  );
};

export const ServiceIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="42"
      height="43"
      viewBox="0 0 42 43"
      fill="none"
    >
      <g clip-path="url(#clip0_2737_103566)">
        <path
          d="M41.5102 16.1775C40.0232 12.1111 35.1657 10.7669 31.8163 12.9926L27.3293 9.26735C28.542 5.3295 25.7088 0.997835 21.3038 0.870058C16.7674 0.738463 13.6364 5.15477 14.9007 9.26207L10.4105 12.9899C6.95879 10.6961 1.9776 12.2186 0.632894 16.4344C-0.609297 20.3289 2.0096 24.1459 5.68159 24.8066L7.41888 31.0401C4.31666 33.711 4.39196 38.8486 8.02552 41.317C11.6252 43.7624 16.382 42.002 17.7811 38.2134H24.4391C25.8889 42.1836 30.9398 43.8452 34.4964 41.0996C37.9219 38.4552 37.7513 33.4287 34.6375 30.9052L36.431 24.827C40.281 24.2134 42.9629 20.1504 41.5102 16.1775V16.1775ZM24.1695 34.6401H18.0552C17.3722 31.2829 14.0815 29.007 10.706 29.5247L9.28525 24.4265C12.7354 23.0383 14.2541 18.9786 12.7394 15.7011L16.856 12.2836C19.2575 14.3725 22.9463 14.3983 25.3705 12.2863L29.4907 15.707C27.98 18.9754 29.4968 22.9656 32.8361 24.3823L31.3271 29.4962C27.986 29.079 24.8403 31.3802 24.1695 34.6401Z"
          fill="#424242"
        />
      </g>
      <defs>
        <clipPath id="clip0_2737_103566">
          <rect
            width="41.5905"
            height="41.5905"
            fill="white"
            transform="translate(0.320312 0.867188)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const WarningIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
    >
      <path
        d="M11 17.0723H13V11.0723H11V17.0723ZM12 9.07227C12.2833 9.07227 12.521 8.97627 12.713 8.78427C12.905 8.59227 13.0007 8.35493 13 8.07227C13 7.78893 12.904 7.55127 12.712 7.35927C12.52 7.16727 12.2827 7.0716 12 7.07227C11.7167 7.07227 11.479 7.16827 11.287 7.36027C11.095 7.55227 10.9993 7.7896 11 8.07227C11 8.3556 11.096 8.59327 11.288 8.78527C11.48 8.97727 11.7173 9.07293 12 9.07227ZM12 22.0723C10.6167 22.0723 9.31667 21.8096 8.1 21.2843C6.88333 20.7589 5.825 20.0466 4.925 19.1473C4.025 18.2473 3.31267 17.1889 2.788 15.9723C2.26333 14.7556 2.00067 13.4556 2 12.0723C2 10.6889 2.26267 9.38893 2.788 8.17227C3.31333 6.9556 4.02567 5.89727 4.925 4.99727C5.825 4.09727 6.88333 3.38493 8.1 2.86027C9.31667 2.3356 10.6167 2.07293 12 2.07227C13.3833 2.07227 14.6833 2.33493 15.9 2.86027C17.1167 3.3856 18.175 4.09793 19.075 4.99727C19.975 5.89727 20.6877 6.9556 21.213 8.17227C21.7383 9.38893 22.0007 10.6889 22 12.0723C22 13.4556 21.7373 14.7556 21.212 15.9723C20.6867 17.1889 19.9743 18.2473 19.075 19.1473C18.175 20.0473 17.1167 20.7599 15.9 21.2853C14.6833 21.8106 13.3833 22.0729 12 22.0723Z"
        fill="#424242"
      />
    </svg>
  );
};

export const PenIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M15.7944 2.64576C16.1596 2.28065 16.593 1.99103 17.07 1.79344C17.5471 1.59584 18.0584 1.49414 18.5747 1.49414C19.091 1.49414 19.6023 1.59584 20.0794 1.79344C20.5564 1.99103 20.9898 2.28065 21.3549 2.64576C21.7201 3.01087 22.0097 3.44431 22.2073 3.92135C22.4049 4.39838 22.5066 4.90967 22.5066 5.42601C22.5066 5.94235 22.4049 6.45363 22.2073 6.93067C22.0097 7.4077 21.7201 7.84115 21.3549 8.20626L20.1864 9.37476L14.6259 3.81426L15.7944 2.64576ZM13.5654 4.87476L3.98645 14.4538C3.42564 15.0149 3.02573 15.7163 2.82845 16.4848L1.52345 21.5638C1.49108 21.6901 1.49224 21.8228 1.52681 21.9485C1.56137 22.0743 1.62815 22.1889 1.72054 22.281C1.81293 22.3731 1.92775 22.4395 2.05365 22.4737C2.17955 22.5078 2.31218 22.5085 2.43845 22.4758L7.51595 21.1723C8.28452 20.9753 8.986 20.5754 9.54695 20.0143L19.1259 10.4353L13.5654 4.87476Z"
        fill="#424242"
      />
    </svg>
  );
};

export const SuccessIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="127"
      height="127"
      viewBox="0 0 127 127"
      fill="none"
    >
      <path
        d="M63.5 7.90625C78.1781 7.90625 92.255 13.7371 102.634 24.1161C113.013 34.495 118.844 48.5719 118.844 63.25C118.844 77.9281 113.013 92.005 102.634 102.384C92.255 112.763 78.1781 118.594 63.5 118.594C48.8219 118.594 34.745 112.763 24.3661 102.384C13.9871 92.005 8.15625 77.9281 8.15625 63.25C8.15625 48.5719 13.9871 34.495 24.3661 24.1161C34.745 13.7371 48.8219 7.90625 63.5 7.90625ZM56.6057 74.1685L44.3115 61.8664C43.8708 61.4257 43.3475 61.076 42.7717 60.8375C42.1958 60.599 41.5786 60.4762 40.9553 60.4762C40.332 60.4762 39.7148 60.599 39.139 60.8375C38.5631 61.076 38.0399 61.4257 37.5991 61.8664C36.709 62.7565 36.2089 63.9638 36.2089 65.2226C36.2089 66.4814 36.709 67.6887 37.5991 68.5788L53.2535 84.2332C53.693 84.6761 54.2158 85.0277 54.7919 85.2676C55.3679 85.5075 55.9857 85.6311 56.6097 85.6311C57.2337 85.6311 57.8515 85.5075 58.4275 85.2676C59.0036 85.0277 59.5264 84.6761 59.9659 84.2332L92.3815 51.8097C92.8282 51.3707 93.1835 50.8477 93.427 50.2708C93.6705 49.6939 93.7973 49.0745 93.8002 48.4483C93.8032 47.8221 93.6821 47.2015 93.4439 46.6224C93.2058 46.0432 92.8554 45.5169 92.4129 45.0739C91.9703 44.6308 91.4445 44.2798 90.8656 44.041C90.2867 43.8022 89.6663 43.6803 89.0401 43.6825C88.4139 43.6847 87.7943 43.8108 87.2171 44.0536C86.6399 44.2964 86.1165 44.6511 85.677 45.0972L56.6057 74.1685Z"
        fill="#43A047"
      />
    </svg>
  );
};

export const UserIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="31"
      height="30"
      viewBox="0 0 31 30"
      fill="none"
    >
      <path
        d="M9.91686 8.07066C9.91686 11.1401 12.4147 13.6379 15.4841 13.6379C18.5535 13.6379 21.0513 11.1401 21.0513 8.07066C21.0513 5.00126 18.5535 2.50342 15.4841 2.50342C12.4147 2.50342 9.91686 5.00126 9.91686 8.07066ZM25.3814 26.0096H26.6186V24.7724C26.6186 19.9982 22.7327 16.1122 17.9584 16.1122H13.0098C8.23431 16.1122 4.34961 19.9982 4.34961 24.7724V26.0096H25.3814Z"
        fill="#212121"
      />
    </svg>
  );
};

export const GIFIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="31"
      height="30"
      viewBox="0 0 31 30"
      fill="none"
    >
      <path
        d="M23.7069 4.35938C24.2349 4.35938 24.7578 4.46338 25.2456 4.66544C25.7334 4.8675 26.1767 5.16367 26.55 5.53704C26.9234 5.9104 27.2196 6.35365 27.4216 6.84148C27.6237 7.3293 27.7277 7.85215 27.7277 8.38016V21.3741C27.7277 21.9021 27.6237 22.425 27.4216 22.9128C27.2196 23.4006 26.9234 23.8439 26.55 24.2172C26.1767 24.5906 25.7334 24.8868 25.2456 25.0888C24.7578 25.2909 24.2349 25.3949 23.7069 25.3949H7.00516C5.93878 25.3949 4.91608 24.9713 4.16204 24.2172C3.40799 23.4632 2.98438 22.4405 2.98438 21.3741V8.38016C2.98437 7.31378 3.40799 6.29108 4.16204 5.53704C4.91608 4.78299 5.93878 4.35938 7.00516 4.35938H23.7069ZM10.4259 11.0042C8.41306 11.0042 7.01877 12.7486 7.01877 14.8679C7.01877 16.9871 8.4143 18.7352 10.4259 18.7352C11.5233 18.7352 12.5328 18.207 13.0376 17.2333L13.1328 17.0329L13.1613 16.9463L13.1836 16.8535L13.1935 16.7508V14.8703L13.1848 14.7553C13.1606 14.5936 13.0858 14.4438 12.9711 14.3273C12.8564 14.2108 12.7077 14.1337 12.5464 14.107L12.4202 14.0971H11.1806L11.0668 14.1045C10.9052 14.1289 10.7555 14.2038 10.639 14.3185C10.5226 14.4332 10.4454 14.5817 10.4185 14.7429L10.4074 14.8703L10.416 14.9842C10.4655 15.3157 10.7253 15.578 11.0544 15.6324L11.1806 15.6436H11.6458V16.5504L11.6384 16.569C11.4045 16.9649 10.9554 17.1876 10.4259 17.1876C9.35454 17.1876 8.56523 16.2003 8.56523 14.8679C8.56523 13.5367 9.35331 12.5507 10.4259 12.5507C10.9468 12.5507 11.2425 12.6088 11.6136 12.7857C11.7976 12.869 12.0068 12.877 12.1966 12.8081C12.3864 12.7391 12.5417 12.5986 12.6293 12.4167C12.7168 12.2347 12.7298 12.0257 12.6653 11.8344C12.6008 11.643 12.464 11.4845 12.2842 11.3927C11.6866 11.1056 11.1645 11.0042 10.4259 11.0042ZM16.1342 11.1551C15.9489 11.1552 15.7698 11.2218 15.6294 11.3428C15.4891 11.4638 15.3969 11.6312 15.3696 11.8145L15.361 11.9284V17.8197L15.3696 17.9348C15.3973 18.1178 15.4896 18.2848 15.6299 18.4055C15.7702 18.5262 15.9491 18.5926 16.1342 18.5926C16.3193 18.5926 16.4982 18.5262 16.6385 18.4055C16.7788 18.2848 16.8712 18.1178 16.8988 17.9348L16.9074 17.8197V11.9296L16.8988 11.8158C16.8715 11.6325 16.7793 11.4651 16.639 11.3441C16.4987 11.223 16.3195 11.1564 16.1342 11.1564V11.1551ZM22.3114 11.1638L19.8408 11.1551C19.6556 11.1545 19.4763 11.2203 19.3355 11.3406C19.1948 11.4609 19.1019 11.6278 19.0737 11.8108L19.0651 11.9259V17.7999L19.0725 17.915C19.122 18.2466 19.3818 18.5088 19.7109 18.5633L19.8383 18.5732L19.9521 18.5658C20.2837 18.5163 20.5459 18.2565 20.6004 17.9274L20.6115 17.7999L20.6103 16.4205H21.9996L22.1134 16.4131C22.445 16.3636 22.7073 16.1038 22.7629 15.7747L22.7728 15.6485L22.7642 15.5347C22.7402 15.3728 22.6655 15.2227 22.5508 15.106C22.436 14.9893 22.2873 14.912 22.1258 14.8852L21.9996 14.8753H20.6103V12.7028L22.3052 12.7102L22.4203 12.7028C22.6042 12.6768 22.7727 12.5855 22.8949 12.4455C23.017 12.3054 23.0846 12.1261 23.0854 11.9403C23.0861 11.7545 23.02 11.5746 22.899 11.4336C22.7779 11.2926 22.6102 11.1999 22.4264 11.1724L22.3114 11.1638Z"
        fill="#212121"
      />
    </svg>
  );
};

export const ContactCardIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="31"
      height="30"
      viewBox="0 0 31 30"
      fill="none"
    >
      <path
        d="M2.02344 8.32719C2.02344 6.38088 3.56742 4.80127 5.46983 4.80127H26.1482C28.0506 4.80127 29.5946 6.38088 29.5946 8.32719V21.4235C29.5946 22.3586 29.2315 23.2554 28.5851 23.9167C27.9388 24.5779 27.0622 24.9494 26.1482 24.9494H5.46983C4.55579 24.9494 3.67919 24.5779 3.03286 23.9167C2.38654 23.2554 2.02344 22.3586 2.02344 21.4235V8.32719ZM10.4149 14.2991C10.7659 14.2991 11.1134 14.2284 11.4376 14.091C11.7618 13.9536 12.0564 13.7522 12.3046 13.4983C12.5528 13.2444 12.7496 12.943 12.8839 12.6113C13.0182 12.2796 13.0873 11.924 13.0873 11.565C13.0873 11.2059 13.0182 10.8504 12.8839 10.5187C12.7496 10.187 12.5528 9.88558 12.3046 9.6317C12.0564 9.37781 11.7618 9.17642 11.4376 9.03902C11.1134 8.90162 10.7659 8.8309 10.4149 8.8309C9.70614 8.8309 9.02639 9.11895 8.52521 9.6317C8.02404 10.1444 7.74248 10.8399 7.74248 11.565C7.74248 12.2901 8.02404 12.9856 8.52521 13.4983C9.02639 14.011 9.70614 14.2991 10.4149 14.2991ZM7.65189 15.6651C7.20375 15.6651 6.77396 15.8473 6.45708 16.1715C6.14019 16.4957 5.96217 16.9354 5.96217 17.3939C5.96223 18.1442 6.20745 18.873 6.65884 19.4644C7.11023 20.0558 7.74189 20.4759 8.45342 20.6578L8.55779 20.6861C9.7788 20.9984 11.053 20.9984 12.272 20.6861L12.3784 20.6599C13.0899 20.4779 13.7216 20.0578 14.1729 19.4664C14.6243 18.875 14.8695 18.1462 14.8696 17.3959C14.8699 17.1687 14.8264 16.9437 14.7416 16.7337C14.6568 16.5237 14.5323 16.3329 14.3754 16.1722C14.2185 16.0114 14.0321 15.8839 13.827 15.7969C13.6218 15.7099 13.402 15.6651 13.1799 15.6651H7.65189ZM18.7631 10.8457C18.5019 10.8457 18.2514 10.9518 18.0668 11.1408C17.8821 11.3297 17.7784 11.5859 17.7784 11.8531C17.7784 12.1203 17.8821 12.3765 18.0668 12.5655C18.2514 12.7544 18.5019 12.8605 18.7631 12.8605H24.6712C24.9323 12.8605 25.1828 12.7544 25.3674 12.5655C25.5521 12.3765 25.6558 12.1203 25.6558 11.8531C25.6558 11.5859 25.5521 11.3297 25.3674 11.1408C25.1828 10.9518 24.9323 10.8457 24.6712 10.8457H18.7631ZM18.7631 16.8901C18.5019 16.8901 18.2514 16.9963 18.0668 17.1852C17.8821 17.3741 17.7784 17.6304 17.7784 17.8976C17.7784 18.1647 17.8821 18.421 18.0668 18.6099C18.2514 18.7988 18.5019 18.905 18.7631 18.905H24.6712C24.9323 18.905 25.1828 18.7988 25.3674 18.6099C25.5521 18.421 25.6558 18.1647 25.6558 17.8976C25.6558 17.6304 25.5521 17.3741 25.3674 17.1852C25.1828 16.9963 24.9323 16.8901 24.6712 16.8901H18.7631Z"
        fill="#212121"
      />
    </svg>
  );
};

export const SendMsgIcon = ({
  width = 32,
  height = 32,
}: {
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        d="M4.74884 26.6216L27.0338 17.0691C27.2642 16.971 27.4606 16.8073 27.5987 16.5984C27.7367 16.3895 27.8104 16.1446 27.8104 15.8942C27.8104 15.6438 27.7367 15.3989 27.5987 15.19C27.4606 14.9811 27.2642 14.8174 27.0338 14.7193L4.74884 5.16679C4.55588 5.08263 4.34499 5.04783 4.13522 5.06553C3.92544 5.08323 3.72337 5.15287 3.54724 5.26818C3.37111 5.38349 3.22645 5.54084 3.12632 5.72602C3.0262 5.91121 2.97375 6.11841 2.97371 6.32893L2.96094 12.2162C2.96094 12.8548 3.43345 13.4039 4.07199 13.4805L22.1171 15.8942L4.07199 18.2951C3.43345 18.3845 2.96094 18.9337 2.96094 19.5722L2.97371 25.4595C2.97371 26.3662 3.90597 26.992 4.74884 26.6216Z"
        fill="white"
      />
    </svg>
  );
};

export const LiveAccountsIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M0.791992 16.0417V14.7083C0.791992 14.2222 0.916992 13.7813 1.16699 13.3854C1.41699 12.9896 1.76421 12.6944 2.20866 12.5C3.22255 12.0556 4.13574 11.7361 4.94824 11.5417C5.76074 11.3472 6.59755 11.25 7.45866 11.25C8.31977 11.25 9.1531 11.3472 9.95866 11.5417C10.7642 11.7361 11.6739 12.0556 12.6878 12.5C13.1323 12.6944 13.483 12.9896 13.7399 13.3854C13.9969 13.7813 14.1253 14.2222 14.1253 14.7083V16.0417C14.1253 16.2222 14.0663 16.3715 13.9482 16.4896C13.8302 16.6076 13.6809 16.6667 13.5003 16.6667H1.41699C1.23644 16.6667 1.08713 16.6076 0.969076 16.4896C0.85102 16.3715 0.791992 16.2222 0.791992 16.0417ZM15.0837 16.6667C15.167 16.5833 15.2364 16.4826 15.292 16.3646C15.3475 16.2465 15.3753 16.125 15.3753 16V14.7083C15.3753 13.8333 15.1531 13.1146 14.7087 12.5521C14.2642 11.9896 13.6809 11.5347 12.9587 11.1875C13.917 11.2986 14.8198 11.4618 15.667 11.6771C16.5142 11.8924 17.2017 12.1389 17.7295 12.4167C18.1878 12.6806 18.5489 13.0069 18.8128 13.3958C19.0767 13.7847 19.2087 14.2222 19.2087 14.7083V16.0417C19.2087 16.2222 19.1496 16.3715 19.0316 16.4896C18.9135 16.6076 18.7642 16.6667 18.5837 16.6667H15.0837ZM7.45866 9.97917C6.54199 9.97917 5.79199 9.68751 5.20866 9.10417C4.62533 8.52084 4.33366 7.77084 4.33366 6.85417C4.33366 5.93751 4.62533 5.18751 5.20866 4.60417C5.79199 4.02084 6.54199 3.72917 7.45866 3.72917C8.37533 3.72917 9.12533 4.02084 9.70866 4.60417C10.292 5.18751 10.5837 5.93751 10.5837 6.85417C10.5837 7.77084 10.292 8.52084 9.70866 9.10417C9.12533 9.68751 8.37533 9.97917 7.45866 9.97917ZM14.9587 6.85417C14.9587 7.77084 14.667 8.52084 14.0837 9.10417C13.5003 9.68751 12.7503 9.97917 11.8337 9.97917C11.6809 9.97917 11.5107 9.96876 11.3232 9.94792C11.1357 9.92709 10.9656 9.88889 10.8128 9.83334C11.1462 9.48612 11.3996 9.05903 11.5732 8.55209C11.7469 8.04514 11.8337 7.47917 11.8337 6.85417C11.8337 6.22917 11.7469 5.67709 11.5732 5.19792C11.3996 4.71876 11.1462 4.27778 10.8128 3.87501C10.9656 3.83334 11.1357 3.79862 11.3232 3.77084C11.5107 3.74306 11.6809 3.72917 11.8337 3.72917C12.7503 3.72917 13.5003 4.02084 14.0837 4.60417C14.667 5.18751 14.9587 5.93751 14.9587 6.85417Z"
        fill="#1E88E5"
      />
    </svg>
  );
};

export const OnlineAccountsIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M2.29199 18.3333C2.11491 18.3333 1.96647 18.2734 1.84668 18.1536C1.72689 18.0338 1.66699 17.8854 1.66699 17.7083V16.5208C1.66699 16.1181 1.77463 15.7569 1.98991 15.4375C2.20519 15.1181 2.49338 14.8681 2.85449 14.6875C3.60265 14.3264 4.37597 14.0486 5.17447 13.8542C5.97297 13.6597 6.78946 13.5625 7.62393 13.5625C8.4584 13.5625 9.2749 13.6597 10.0734 13.8542C10.8719 14.0486 11.6462 14.3264 12.3962 14.6875C12.7457 14.8657 13.0241 15.1172 13.2313 15.4418C13.4384 15.7665 13.542 16.1261 13.542 16.5208V17.7083C13.542 17.8854 13.4821 18.0338 13.3623 18.1536C13.2425 18.2734 13.0941 18.3333 12.917 18.3333H2.29199ZM16.8753 18.3333H14.5003C14.5837 18.25 14.6531 18.1493 14.7087 18.0312C14.7642 17.9132 14.792 17.7917 14.792 17.6667V16.4149C14.792 15.8774 14.6496 15.3753 14.3649 14.9085C14.0802 14.4417 13.7156 14.0486 13.2712 13.7292C13.7989 13.7986 14.3094 13.9167 14.8024 14.0833C15.2955 14.25 15.7712 14.4514 16.2295 14.6875C16.5737 14.873 16.8715 15.1115 17.1231 15.403C17.3746 15.6945 17.5003 16.0324 17.5003 16.4167V17.7083C17.5003 17.8854 17.4404 18.0338 17.3206 18.1536C17.2008 18.2734 17.0524 18.3333 16.8753 18.3333ZM7.62681 12.4792C6.86193 12.4792 6.21213 12.2088 5.67741 11.6681C5.14269 11.1274 4.87533 10.4747 4.87533 9.70981C4.87533 8.94493 5.14423 8.29166 5.68203 7.75C6.21984 7.20833 6.86914 6.9375 7.62995 6.9375C8.39076 6.9375 9.04199 7.20784 9.58366 7.74852C10.1253 8.28921 10.3962 8.94199 10.3962 9.70685C10.3962 10.4717 10.1258 11.125 9.58514 11.6667C9.04444 12.2083 8.39167 12.4792 7.62681 12.4792ZM14.2087 9.70685C14.2087 10.4717 13.9402 11.125 13.4033 11.6667C12.8664 12.2083 12.2182 12.4792 11.4587 12.4792C11.3198 12.4792 11.1878 12.4687 11.0628 12.4479C10.9378 12.4271 10.8128 12.3958 10.6878 12.3542C11.0073 11.9931 11.2469 11.5833 11.4066 11.125C11.5663 10.6667 11.6462 10.1944 11.6462 9.70833C11.6462 9.22222 11.5628 8.75 11.3962 8.29166C11.2295 7.83333 10.9934 7.41666 10.6878 7.04166C10.8128 7 10.9378 6.97222 11.0628 6.95833C11.1878 6.94444 11.3198 6.9375 11.4587 6.9375C12.2182 6.9375 12.8664 7.20784 13.4033 7.74852C13.9402 8.28921 14.2087 8.94199 14.2087 9.70685ZM15.667 7.83333C15.667 6.86111 15.3267 6.03472 14.6462 5.35416C13.9656 4.67361 13.1392 4.33333 12.167 4.33333C13.1392 4.33333 13.9656 3.99305 14.6462 3.31249C15.3267 2.63194 15.667 1.80555 15.667 0.833328C15.667 1.80555 16.0073 2.63194 16.6878 3.31249C17.3684 3.99305 18.1948 4.33333 19.167 4.33333C18.1948 4.33333 17.3684 4.67361 16.6878 5.35416C16.0073 6.03472 15.667 6.86111 15.667 7.83333Z"
        fill="#43A047"
      />
    </svg>
  );
};

export const OnlineUsersIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M9.31217 12.5H10.6872C10.7809 12.5 10.8634 12.4609 10.9346 12.3828C11.0058 12.3047 11.0275 12.2188 10.9997 12.125L10.5413 9.47917C10.8256 9.35202 11.0494 9.16765 11.2129 8.92607C11.3763 8.68447 11.458 8.41745 11.458 8.12501C11.458 7.72396 11.315 7.38064 11.0291 7.09505C10.7431 6.80946 10.3994 6.66667 9.99782 6.66667C9.59628 6.66667 9.25315 6.80946 8.96842 7.09505C8.6837 7.38064 8.54134 7.72396 8.54134 8.12501C8.54134 8.41745 8.62306 8.68447 8.78649 8.92607C8.94993 9.16765 9.17377 9.35202 9.45801 9.47917L8.99967 12.125C8.9719 12.2188 8.9936 12.3047 9.06478 12.3828C9.13596 12.4609 9.21842 12.5 9.31217 12.5ZM9.99967 18.25C9.92579 18.25 9.85717 18.2431 9.79384 18.2292C9.73051 18.2153 9.66717 18.1945 9.60384 18.1667C7.67329 17.5139 6.14551 16.3438 5.02051 14.6563C3.89551 12.9688 3.33301 11.1173 3.33301 9.10196V5.02084C3.33301 4.75338 3.40853 4.51267 3.55957 4.29871C3.71061 4.08474 3.90592 3.92962 4.14551 3.83334L9.56217 1.81251C9.71495 1.75695 9.86079 1.72917 9.99967 1.72917C10.1386 1.72917 10.2844 1.75695 10.4372 1.81251L15.8538 3.83334C16.0934 3.92962 16.2887 4.08474 16.4398 4.29871C16.5908 4.51267 16.6663 4.75338 16.6663 5.02084V9.10196C16.6663 11.1173 16.1038 12.9688 14.9788 14.6563C13.8538 16.3438 12.3261 17.5139 10.3955 18.1667C10.3322 18.1945 10.2688 18.2153 10.2055 18.2292C10.1422 18.2431 10.0736 18.25 9.99967 18.25Z"
        fill="#1E88E5"
      />
    </svg>
  );
};

export const RedAlertIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M10 14.1458C10.1944 14.1458 10.3646 14.0729 10.5104 13.9271C10.6562 13.7812 10.7292 13.6111 10.7292 13.4167C10.7292 13.2222 10.6562 13.0521 10.5104 12.9062C10.3646 12.7604 10.1944 12.6875 10 12.6875C9.80556 12.6875 9.63542 12.7604 9.48958 12.9062C9.34375 13.0521 9.27083 13.2222 9.27083 13.4167C9.27083 13.6111 9.34375 13.7812 9.48958 13.9271C9.63542 14.0729 9.80556 14.1458 10 14.1458ZM10 11.1458C10.1806 11.1458 10.3299 11.0868 10.4479 10.9688C10.566 10.8507 10.625 10.7014 10.625 10.5208V6.29167C10.625 6.11111 10.566 5.96181 10.4479 5.84375C10.3299 5.72569 10.1806 5.66667 10 5.66667C9.81944 5.66667 9.67014 5.72569 9.55208 5.84375C9.43403 5.96181 9.375 6.11111 9.375 6.29167V10.5208C9.375 10.7014 9.43403 10.8507 9.55208 10.9688C9.67014 11.0868 9.81944 11.1458 10 11.1458ZM7.39583 17.5C7.22917 17.5 7.06597 17.4653 6.90625 17.3958C6.74653 17.3264 6.61111 17.2361 6.5 17.125L2.875 13.5C2.76389 13.3889 2.67361 13.2535 2.60417 13.0938C2.53472 12.934 2.5 12.7708 2.5 12.6042V7.39583C2.5 7.22917 2.53472 7.06597 2.60417 6.90625C2.67361 6.74653 2.76389 6.61111 2.875 6.5L6.5 2.875C6.61111 2.76389 6.74653 2.67361 6.90625 2.60417C7.06597 2.53472 7.22917 2.5 7.39583 2.5H12.6042C12.7708 2.5 12.934 2.53472 13.0938 2.60417C13.2535 2.67361 13.3889 2.76389 13.5 2.875L17.125 6.5C17.2361 6.61111 17.3264 6.74653 17.3958 6.90625C17.4653 7.06597 17.5 7.22917 17.5 7.39583V12.6042C17.5 12.7708 17.4653 12.934 17.3958 13.0938C17.3264 13.2535 17.2361 13.3889 17.125 13.5L13.5 17.125C13.3889 17.2361 13.2535 17.3264 13.0938 17.3958C12.934 17.4653 12.7708 17.5 12.6042 17.5H7.39583Z"
        fill="#E53935"
      />
    </svg>
  );
};

export const CRMInterruptionsIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M21 5V11.6L18 8.6L14 12.6L10 8.6L6 12.6L3 9.6V5C3 3.9 3.9 3 5 3H19C20.1 3 21 3.9 21 5ZM18 11.4L21 14.4V19C21 20.1 20.1 21 19 21H5C3.9 21 3 20.1 3 19V12.4L6 15.4L10 11.4L14 15.4L18 11.4Z"
        fill="#5E35B1"
      />
    </svg>
  );
};

export const MailInterruptionIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g clip-path="url(#clip0_796_53768)">
        <path
          d="M20 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM20 8L12 13L4 8V6L12 11L20 6V8Z"
          fill="#039BE5"
        />
        <path
          d="M19 11H18V12V19V20H19H21H22V19V12V11H21H19Z"
          fill="#039BE5"
          stroke="white"
          strokeWidth="2"
        />
        <path
          d="M20 22C20.5523 22 21 21.5523 21 21C21 20.4477 20.5523 20 20 20C19.4477 20 19 20.4477 19 21C19 21.5523 19.4477 22 20 22Z"
          fill="#039BE5"
        />
        <path
          d="M20 22C20.5523 22 21 21.5523 21 21C21 20.4477 20.5523 20 20 20C19.4477 20 19 20.4477 19 21C19 21.5523 19.4477 22 20 22Z"
          stroke="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_796_53768">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const InventoryInterruptionIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g clip-path="url(#clip0_796_53756)">
        <path
          d="M6.66035 14.54L8.09035 13.11C7.53035 12.38 7.04035 11.61 6.62035 10.79L8.82035 8.59C9.10035 8.31 9.18035 7.92 9.07035 7.57C8.70035 6.45 8.50035 5.25 8.50035 4C8.50035 3.45 8.05035 3 7.50035 3H4.00035C3.45035 3 3.00035 3.45 3.00035 4C3.00035 7.98 4.37035 11.64 6.66035 14.54ZM9.48035 17.35C12.3704 19.64 16.0304 21 20.0004 21C20.5504 21 21.0004 20.55 21.0004 20V16.51C21.0004 15.96 20.5504 15.51 20.0004 15.51C18.7604 15.51 17.5504 15.31 16.4304 14.94C16.0804 14.82 15.6804 14.91 15.4104 15.18L13.2104 17.38C12.4004 16.96 11.6304 16.48 10.9104 15.92L22.6104 4.22L21.1904 2.81L2.81035 21.2L4.22035 22.61L9.48035 17.35Z"
          fill="#8BC34A"
        />
      </g>
      <defs>
        <clipPath id="clip0_796_53756">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="matrix(-1 0 0 1 24 0)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const CarrierInterruptionIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g clip-path="url(#clip0_796_53744)">
        <path
          d="M12 4C7.31 4 3.07 5.9 0 8.98L12 21L17 15.99V8H22.92C19.97 5.51 16.16 4 12 4Z"
          fill="#EF5350"
        />
        <path d="M21 18H19V20H21V18Z" fill="#EF5350" />
        <path d="M21 10H19V16H21V10Z" fill="#EF5350" />
      </g>
      <defs>
        <clipPath id="clip0_796_53744">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const TrendingUpIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
    >
      <path
        d="M1.0625 7.37587C1 7.31337 0.96875 7.23871 0.96875 7.15191C0.96875 7.0651 1 6.99045 1.0625 6.92795L3.4375 4.56337C3.5551 4.44531 3.70082 4.38628 3.87466 4.38628C4.0485 4.38628 4.19444 4.44531 4.3125 4.56337L5.61458 5.86545L8.125 3.35503H7.11458C7.02604 3.35503 6.95182 3.32491 6.89193 3.26467C6.83203 3.20442 6.80208 3.12977 6.80208 3.04071C6.80208 2.95165 6.83203 2.8776 6.89193 2.81858C6.95182 2.75955 7.02604 2.73003 7.11458 2.73003H8.85417C8.94271 2.73003 9.01693 2.75998 9.07682 2.81988C9.13672 2.87977 9.16667 2.95399 9.16667 3.04253V4.78212C9.16667 4.86545 9.13795 4.93837 9.0805 5.00087C9.02306 5.06337 8.95188 5.09462 8.86696 5.09462C8.78204 5.09462 8.70833 5.06337 8.64583 5.00087C8.58333 4.93837 8.55208 4.86545 8.55208 4.78212V3.81337L6.04167 6.31337C5.92407 6.43142 5.77835 6.49045 5.60451 6.49045C5.43067 6.49045 5.28472 6.43142 5.16667 6.31337L3.86458 5.0217L1.51042 7.37587C1.44792 7.43837 1.37326 7.46962 1.28646 7.46962C1.19965 7.46962 1.125 7.43837 1.0625 7.37587Z"
        fill="#43A047"
      />
    </svg>
  );
};

export const TrendingDownIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
    >
      <path
        d="M1.0625 2.62413C1 2.68663 0.96875 2.76129 0.96875 2.84809C0.96875 2.9349 1 3.00955 1.0625 3.07205L3.4375 5.43663C3.5551 5.55469 3.70082 5.61372 3.87466 5.61372C4.0485 5.61372 4.19444 5.55469 4.3125 5.43663L5.61458 4.13455L8.125 6.64497H7.11458C7.02604 6.64497 6.95182 6.67509 6.89193 6.73533C6.83203 6.79558 6.80208 6.87023 6.80208 6.95929C6.80208 7.04835 6.83203 7.1224 6.89193 7.18142C6.95182 7.24045 7.02604 7.26997 7.11458 7.26997H8.85417C8.94271 7.26997 9.01693 7.24002 9.07682 7.18012C9.13672 7.12023 9.16667 7.04601 9.16667 6.95747V5.21788C9.16667 5.13455 9.13795 5.06163 9.0805 4.99913C9.02306 4.93663 8.95188 4.90538 8.86696 4.90538C8.78204 4.90538 8.70833 4.93663 8.64583 4.99913C8.58333 5.06163 8.55208 5.13455 8.55208 5.21788V6.18663L6.04167 3.68663C5.92407 3.56858 5.77835 3.50955 5.60451 3.50955C5.43067 3.50955 5.28472 3.56858 5.16667 3.68663L3.86458 4.9783L1.51042 2.62413C1.44792 2.56163 1.37326 2.53038 1.28646 2.53038C1.19965 2.53038 1.125 2.56163 1.0625 2.62413Z"
        fill="#E53935"
      />
    </svg>
  );
};

export const UploadVideoIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="17"
      viewBox="0 0 22 17"
      fill="none"
    >
      <path
        d="M15 0.5C15.2652 0.5 15.5196 0.605357 15.7071 0.792893C15.8946 0.98043 16 1.23478 16 1.5V5.7L21.213 2.05C21.288 1.99746 21.3759 1.9665 21.4672 1.9605C21.5586 1.9545 21.6498 1.9737 21.731 2.01599C21.8122 2.05829 21.8802 2.12206 21.9276 2.20035C21.9751 2.27865 22.0001 2.36846 22 2.46V14.54C22.0001 14.6315 21.9751 14.7214 21.9276 14.7996C21.8802 14.8779 21.8122 14.9417 21.731 14.984C21.6498 15.0263 21.5586 15.0455 21.4672 15.0395C21.3759 15.0335 21.288 15.0025 21.213 14.95L16 11.3V15.5C16 15.7652 15.8946 16.0196 15.7071 16.2071C15.5196 16.3946 15.2652 16.5 15 16.5H1C0.734784 16.5 0.48043 16.3946 0.292893 16.2071C0.105357 16.0196 0 15.7652 0 15.5V1.5C0 1.23478 0.105357 0.98043 0.292893 0.792893C0.48043 0.605357 0.734784 0.5 1 0.5H15ZM8 4.5L4 8.5H7V12.5H9V8.5H12L8 4.5Z"
        fill="#4B4949"
      />
    </svg>
  );
};

export const HashIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="21"
      viewBox="0 0 19 21"
      fill="none"
    >
      <path
        d="M1.5 7.5H17.5M1.5 13.5H17.5M7.5 1.5L5.5 19.5M13.5 1.5L11.5 19.5"
        stroke="#1565C0"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const AsterikIconn = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
    >
      <path
        d="M12 12.5L20 8"
        stroke="#1565C0"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 12.5V21.5"
        stroke="#1565C0"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 12.5L4 8"
        stroke="#1565C0"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 12.5L20 17"
        stroke="#1565C0"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 3.5V12.5"
        stroke="#1565C0"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 12.5L4 17"
        stroke="#1565C0"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CallIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
    >
      <path
        d="M12.3961 2.96312C12.4173 2.8838 12.454 2.80944 12.5039 2.74429C12.5539 2.67913 12.6162 2.62446 12.6873 2.5834C12.7584 2.54233 12.8369 2.51568 12.9183 2.50496C12.9997 2.49425 13.0824 2.49967 13.1617 2.52094C14.3204 2.82324 15.3775 3.42894 16.2242 4.27565C17.0709 5.12236 17.6766 6.17948 17.9789 7.33812C18.0002 7.41743 18.0056 7.50015 17.9949 7.58155C17.9842 7.66296 17.9575 7.74145 17.9165 7.81255C17.8754 7.88366 17.8207 7.94597 17.7556 7.99593C17.6904 8.0459 17.616 8.08253 17.5367 8.10375C17.4839 8.11762 17.4296 8.1247 17.375 8.12484C17.2374 8.12488 17.1036 8.0795 16.9944 7.99573C16.8852 7.91196 16.8067 7.7945 16.7711 7.66156C16.5247 6.71557 16.0304 5.85243 15.3392 5.16113C14.6481 4.46982 13.785 3.97537 12.8391 3.72875C12.7597 3.70762 12.6852 3.67104 12.62 3.62111C12.5548 3.57118 12.5 3.50888 12.4589 3.43777C12.4177 3.36666 12.391 3.28814 12.3802 3.2067C12.3695 3.12525 12.3749 3.04248 12.3961 2.96312ZM12.2141 6.22875C13.2914 6.51625 13.9836 7.20922 14.2711 8.28656C14.3067 8.4195 14.3852 8.53696 14.4944 8.62073C14.6036 8.7045 14.7374 8.74988 14.875 8.74984C14.9296 8.7497 14.9839 8.74262 15.0367 8.72875C15.116 8.70753 15.1904 8.6709 15.2556 8.62093C15.3207 8.57097 15.3754 8.50866 15.4165 8.43755C15.4575 8.36645 15.4842 8.28796 15.4949 8.20655C15.5056 8.12515 15.5002 8.04243 15.4789 7.96312C15.0789 6.46625 14.0336 5.42094 12.5367 5.02094C12.4574 4.99975 12.3747 4.99439 12.2933 5.00517C12.212 5.01594 12.1335 5.04264 12.0624 5.08374C11.9914 5.12484 11.9291 5.17953 11.8792 5.24469C11.8293 5.30985 11.7927 5.38421 11.7715 5.46351C11.7503 5.54282 11.7449 5.62552 11.7557 5.7069C11.7665 5.78828 11.7932 5.86673 11.8343 5.93779C11.8754 6.00885 11.9301 6.07112 11.9952 6.12104C12.0604 6.17096 12.1348 6.20756 12.2141 6.22875ZM17.8727 12.3795L14.1922 10.7303L14.182 10.7256C13.991 10.6439 13.7825 10.6111 13.5756 10.6302C13.3687 10.6493 13.1698 10.7197 12.9969 10.835C12.9765 10.8484 12.957 10.8631 12.9383 10.8787L11.0367 12.4998C9.83204 11.9147 8.58829 10.6803 8.00313 9.49125L9.62657 7.56078C9.64219 7.54125 9.65704 7.52172 9.6711 7.50062C9.78394 7.3282 9.85239 7.13056 9.87039 6.92529C9.88838 6.72002 9.85534 6.51348 9.77423 6.32406V6.31469L8.12032 2.62797C8.01309 2.38052 7.8287 2.17438 7.59468 2.04034C7.36067 1.9063 7.08958 1.85153 6.82188 1.88422C5.76326 2.02352 4.79155 2.54341 4.08824 3.34679C3.38492 4.15017 2.99809 5.1821 3.00001 6.24984C3.00001 12.453 8.04688 17.4998 14.25 17.4998C15.3177 17.5018 16.3497 17.1149 17.1531 16.4116C17.9564 15.7083 18.4763 14.7366 18.6156 13.678C18.6484 13.4104 18.5937 13.1393 18.4598 12.9053C18.3259 12.6713 18.12 12.4869 17.8727 12.3795Z"
        fill="white"
      />
    </svg>
  );
};

export const MinimizeIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M4.16699 9.99967H15.8337"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const GreenDownloadIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M3.33398 14.166V15.8327C3.33398 16.7532 4.08018 17.4993 5.00065 17.4993H15.0007C15.9211 17.4993 16.6673 16.7532 16.6673 15.8327V14.166"
        stroke="#43A047"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.83398 9.16602L10.0007 13.3327L14.1673 9.16602"
        stroke="#43A047"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.0007 3.33398V13.334"
        stroke="#43A047"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const UploadFillIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
    >
      <path
        d="M13.9387 14.5605C13.7993 14.4212 13.6886 14.2557 13.6132 14.0736C13.5377 13.8915 13.4988 13.6964 13.4988 13.4992C13.4988 13.3021 13.5377 13.1069 13.6132 12.9248C13.6886 12.7427 13.7993 12.5773 13.9387 12.438L22.9387 3.43798C23.0781 3.29851 23.2435 3.18787 23.4256 3.11239C23.6077 3.0369 23.8029 2.99805 24 2.99805C24.1971 2.99805 24.3923 3.0369 24.5744 3.11239C24.7565 3.18787 24.9219 3.29851 25.0613 3.43798L34.0613 12.438C34.3427 12.7194 34.5008 13.1012 34.5008 13.4992C34.5008 13.8973 34.3427 14.279 34.0613 14.5605C33.7798 14.8419 33.398 15.0001 33 15.0001C32.602 15.0001 32.2202 14.8419 31.9387 14.5605L25.5 8.11985V23.9992C25.5 24.3971 25.342 24.7786 25.0607 25.0599C24.7794 25.3412 24.3978 25.4992 24 25.4992C23.6022 25.4992 23.2206 25.3412 22.9393 25.0599C22.658 24.7786 22.5 24.3971 22.5 23.9992V8.11985L16.0613 14.5605C15.9219 14.6999 15.7565 14.8106 15.5744 14.8861C15.3923 14.9616 15.1971 15.0004 15 15.0004C14.8029 15.0004 14.6077 14.9616 14.4256 14.8861C14.2435 14.8106 14.0781 14.6999 13.9387 14.5605ZM45 25.4992V37.4992C45 38.2949 44.6839 39.0579 44.1213 39.6205C43.5587 40.1832 42.7957 40.4992 42 40.4992H6C5.20435 40.4992 4.44129 40.1832 3.87868 39.6205C3.31607 39.0579 3 38.2949 3 37.4992V25.4992C3 24.7036 3.31607 23.9405 3.87868 23.3779C4.44129 22.8153 5.20435 22.4992 6 22.4992H18.75C18.9489 22.4992 19.1397 22.5782 19.2803 22.7189C19.421 22.8595 19.5 23.0503 19.5 23.2492V23.898C19.5 26.4199 21.5625 28.5461 24.0863 28.4992C25.2647 28.4766 26.3873 27.9926 27.2126 27.1511C28.038 26.3096 28.5002 25.1779 28.5 23.9992V23.2492C28.5 23.0503 28.579 22.8595 28.7197 22.7189C28.8603 22.5782 29.0511 22.4992 29.25 22.4992H42C42.7957 22.4992 43.5587 22.8153 44.1213 23.3779C44.6839 23.9405 45 24.7036 45 25.4992ZM37.5 31.4992C37.5 31.0542 37.368 30.6192 37.1208 30.2492C36.8736 29.8792 36.5222 29.5908 36.111 29.4205C35.6999 29.2502 35.2475 29.2056 34.811 29.2925C34.3746 29.3793 33.9737 29.5936 33.659 29.9082C33.3443 30.2229 33.13 30.6238 33.0432 31.0603C32.9564 31.4967 33.001 31.9491 33.1713 32.3603C33.3416 32.7714 33.63 33.1228 34 33.37C34.37 33.6173 34.805 33.7492 35.25 33.7492C35.8467 33.7492 36.419 33.5122 36.841 33.0902C37.2629 32.6683 37.5 32.096 37.5 31.4992Z"
        fill="#43A047"
      />
    </svg>
  );
};

export const DarkWarningIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M9.99935 1.66406C14.6027 1.66406 18.3343 5.39573 18.3343 9.99906C18.3343 14.6016 14.6027 18.3324 9.99935 18.3324C5.39602 18.3332 1.66602 14.6016 1.66602 9.99906C1.66518 5.39573 5.39602 1.66406 9.99935 1.66406ZM9.99602 8.53906C9.79179 8.53934 9.59478 8.6146 9.44239 8.75056C9.29 8.88651 9.19283 9.07369 9.16935 9.27656L9.16352 9.37323L9.16685 13.9582L9.17185 14.0549C9.19514 14.2582 9.29238 14.4457 9.44506 14.5819C9.59774 14.7181 9.79518 14.7934 9.99977 14.7934C10.2044 14.7934 10.4018 14.7181 10.5545 14.5819C10.7071 14.4457 10.8044 14.2582 10.8277 14.0549L10.8327 13.9574L10.8293 9.3724L10.8235 9.2749C10.7994 9.07219 10.7018 8.88538 10.5491 8.7499C10.3964 8.61442 10.1993 8.53969 9.99518 8.5399L9.99602 8.53906ZM10.0002 5.4149C9.72358 5.4149 9.45831 5.52477 9.26273 5.72036C9.06714 5.91594 8.95727 6.18121 8.95727 6.45781C8.95727 6.73441 9.06714 6.99968 9.26273 7.19527C9.45831 7.39085 9.72358 7.50073 10.0002 7.50073C10.1371 7.50067 10.2726 7.47365 10.3991 7.42121C10.5256 7.36877 10.6405 7.29194 10.7372 7.19509C10.834 7.09825 10.9107 6.98329 10.9631 6.85679C11.0154 6.73029 11.0423 6.59472 11.0423 6.45781C11.0422 6.32091 11.0152 6.18536 10.9628 6.0589C10.9103 5.93244 10.8335 5.81754 10.7366 5.72078C10.6398 5.62401 10.5248 5.54727 10.3983 5.49493C10.2718 5.44259 10.1363 5.41567 9.99935 5.41573L10.0002 5.4149Z"
        fill="#424242"
      />
    </svg>
  );
};

export const SimpleDownloadIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
    >
      <path
        d="M3.33301 14.666V16.3327C3.33301 17.2532 4.0792 17.9993 4.99967 17.9993H14.9997C15.9201 17.9993 16.6663 17.2532 16.6663 16.3327V14.666"
        stroke="#3E3E3E"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.83301 9.66602L9.99967 13.8327L14.1663 9.66602"
        stroke="#3E3E3E"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.99967 3.83398V13.834"
        stroke="#3E3E3E"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const BigCheckIcon = ({ color = "#43A047" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="127"
      height="127"
      viewBox="0 0 127 127"
      fill="none"
    >
      <path
        d="M63.5 7.90625C78.1781 7.90625 92.255 13.7371 102.634 24.1161C113.013 34.495 118.844 48.5719 118.844 63.25C118.844 77.9281 113.013 92.005 102.634 102.384C92.255 112.763 78.1781 118.594 63.5 118.594C48.8219 118.594 34.745 112.763 24.3661 102.384C13.9871 92.005 8.15625 77.9281 8.15625 63.25C8.15625 48.5719 13.9871 34.495 24.3661 24.1161C34.745 13.7371 48.8219 7.90625 63.5 7.90625ZM56.6057 74.1685L44.3115 61.8664C43.8708 61.4257 43.3475 61.076 42.7717 60.8375C42.1958 60.599 41.5786 60.4762 40.9553 60.4762C40.332 60.4762 39.7148 60.599 39.139 60.8375C38.5631 61.076 38.0399 61.4257 37.5991 61.8664C36.709 62.7565 36.2089 63.9638 36.2089 65.2226C36.2089 66.4814 36.709 67.6887 37.5991 68.5788L53.2535 84.2332C53.693 84.6761 54.2158 85.0277 54.7919 85.2676C55.3679 85.5075 55.9857 85.6311 56.6097 85.6311C57.2337 85.6311 57.8515 85.5075 58.4275 85.2676C59.0036 85.0277 59.5264 84.6761 59.9659 84.2332L92.3815 51.8097C92.8282 51.3707 93.1835 50.8477 93.427 50.2708C93.6705 49.6939 93.7973 49.0745 93.8002 48.4483C93.8032 47.8221 93.6821 47.2015 93.4439 46.6224C93.2058 46.0432 92.8554 45.5169 92.4129 45.0739C91.9703 44.6308 91.4445 44.2798 90.8656 44.041C90.2867 43.8022 89.6663 43.6803 89.0401 43.6825C88.4139 43.6847 87.7943 43.8108 87.2171 44.0536C86.6399 44.2964 86.1165 44.6511 85.677 45.0972L56.6057 74.1685Z"
        fill={color}
      />
    </svg>
  );
};
export const BigCrossIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="127"
      height="127"
      viewBox="0 0 127 127"
      fill="none"
    >
      <path
        d="M63.5 7.90625C78.1781 7.90625 92.255 13.7371 102.634 24.1161C113.013 34.495 118.844 48.5719 118.844 63.25C118.844 77.9281 113.013 92.005 102.634 102.384C92.255 112.763 78.1781 118.594 63.5 118.594C48.8219 118.594 34.745 112.763 24.3661 102.384C13.9871 92.005 8.15625 77.9281 8.15625 63.25C8.15625 48.5719 13.9871 34.495 24.3661 24.1161C34.745 13.7371 48.8219 7.90625 63.5 7.90625ZM56.6057 74.1685L44.3115 61.8664C43.8708 61.4257 43.3475 61.076 42.7717 60.8375C42.1958 60.599 41.5786 60.4762 40.9553 60.4762C40.332 60.4762 39.7148 60.599 39.139 60.8375C38.5631 61.076 38.0399 61.4257 37.5991 61.8664C36.709 62.7565 36.2089 63.9638 36.2089 65.2226C36.2089 66.4814 36.709 67.6887 37.5991 68.5788L53.2535 84.2332C53.693 84.6761 54.2158 85.0277 54.7919 85.2676C55.3679 85.5075 55.9857 85.6311 56.6097 85.6311C57.2337 85.6311 57.8515 85.5075 58.4275 85.2676C59.0036 85.0277 59.5264 84.6761 59.9659 84.2332L92.3815 51.8097C92.8282 51.3707 93.1835 50.8477 93.427 50.2708C93.6705 49.6939 93.7973 49.0745 93.8002 48.4483C93.8032 47.8221 93.6821 47.2015 93.4439 46.6224C93.2058 46.0432 92.8554 45.5169 92.4129 45.0739C91.9703 44.6308 91.4445 44.2798 90.8656 44.041C90.2867 43.8022 89.6663 43.6803 89.0401 43.6825C88.4139 43.6847 87.7943 43.8108 87.2171 44.0536C86.6399 44.2964 86.1165 44.6511 85.677 45.0972L56.6057 74.1685Z"
        fill="red"
      />
    </svg>
  );
};

export const DeclineIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="51"
      height="51"
      viewBox="0 0 51 51"
      fill="none"
    >
      <circle cx="25.3198" cy="25.3198" r="25.3198" fill="#FF3D33" />
    </svg>
  );
};

export const LogoutIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.6099 11.0003C14.6099 10.8263 14.5407 10.6593 14.4177 10.5363C14.2946 10.4132 14.1277 10.3441 13.9536 10.3441H4.35224L6.06811 8.87407C6.13361 8.81799 6.18742 8.74957 6.22647 8.6727C6.26553 8.59583 6.28905 8.51202 6.29572 8.42605C6.30238 8.34009 6.29205 8.25365 6.2653 8.17168C6.23856 8.08971 6.19594 8.01381 6.13986 7.94832C6.08379 7.88282 6.01536 7.82901 5.93849 7.78996C5.86162 7.75091 5.77781 7.72738 5.69185 7.72071C5.60588 7.71405 5.51945 7.72439 5.43748 7.75113C5.35551 7.77787 5.27961 7.82049 5.21411 7.87657L2.15161 10.5016C2.07957 10.5632 2.02173 10.6397 1.98207 10.7258C1.94241 10.8119 1.92188 10.9055 1.92188 11.0003C1.92188 11.0951 1.94241 11.1888 1.98207 11.2749C2.02173 11.361 2.07957 11.4375 2.15161 11.4991L5.21411 14.1241C5.34639 14.2373 5.51824 14.2934 5.69185 14.2799C5.86546 14.2665 6.02662 14.1846 6.13986 14.0523C6.25311 13.92 6.30917 13.7482 6.29572 13.5746C6.28226 13.401 6.20039 13.2398 6.06811 13.1266L4.35311 11.6566H13.9536C14.1277 11.6566 14.2946 11.5874 14.4177 11.4644C14.5407 11.3413 14.6099 11.1744 14.6099 11.0003Z"
        fill="#545454"
      />
      <path
        d="M8.70313 7.5C8.70313 8.11425 8.70312 8.42137 8.851 8.64275C8.91469 8.73793 8.99644 8.81969 9.09163 8.88338C9.313 9.03125 9.62012 9.03125 10.2344 9.03125H13.9531C14.4753 9.03125 14.976 9.23867 15.3452 9.60788C15.7145 9.9771 15.9219 10.4779 15.9219 11C15.9219 11.5221 15.7145 12.0229 15.3452 12.3921C14.976 12.7613 14.4753 12.9688 13.9531 12.9688H10.2344C9.62012 12.9688 9.313 12.9688 9.09163 13.1158C8.99636 13.1797 8.9146 13.2618 8.851 13.3573C8.70312 13.5786 8.70313 13.8857 8.70313 14.5C8.70313 16.9745 8.70312 18.2126 9.47225 18.9809C10.2405 19.75 11.4777 19.75 13.9522 19.75H14.8273C17.3035 19.75 18.5399 19.75 19.309 18.9809C20.0781 18.2126 20.0781 16.9745 20.0781 14.5V7.5C20.0781 5.0255 20.0781 3.78737 19.309 3.01912C18.5399 2.25 17.3026 2.25 14.8281 2.25H13.9531C11.4778 2.25 10.2405 2.25 9.47225 3.01912C8.70312 3.78737 8.70313 5.0255 8.70313 7.5Z"
        fill="#545454"
      />
    </svg>
  );
};

export const TikIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M4.16699 10.0007L8.33366 14.1673L16.667 5.83398"
        stroke="#212121"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const TransparentPhoneIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
    >
      <path
        d="M3.32191 3.57422H5.97013L7.29425 6.8845L5.63911 7.87758C6.34814 9.31525 7.51171 10.4788 8.94938 11.1879L9.94247 9.53272L13.2527 10.8568V13.505C13.2527 14.2363 12.6599 14.8292 11.9286 14.8292C6.58429 14.5044 2.32258 10.2427 1.9978 4.89833C1.9978 4.16704 2.59063 3.57422 3.32191 3.57422"
        stroke="white"
        strokeWidth="1.1917"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const TransparentMsgIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
    >
      <path
        d="M3.52563 14.1134V5.50667C3.52563 4.40974 4.41487 3.52051 5.5118 3.52051H12.1324C13.2293 3.52051 14.1185 4.40974 14.1185 5.50667V9.47901C14.1185 10.5759 13.2293 11.4652 12.1324 11.4652H6.17386L3.52563 14.1134"
        stroke="#4199F7"
        strokeWidth="1.1917"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.17383 6.16794H11.4703"
        stroke="#4199F7"
        strokeWidth="1.1917"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.17383 8.81736H10.1462"
        stroke="#4199F7"
        strokeWidth="1.1917"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const GreenAddIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="29"
      height="28"
      viewBox="0 0 29 28"
      fill="none"
    >
      <mask
        id="mask0_2820_181458"
        maskUnits="userSpaceOnUse"
        x="2"
        y="2"
        width="24"
        height="24"
      >
        <path
          d="M23.0516 3.49414H5.32125C4.34203 3.49414 3.54822 4.27649 3.54822 5.24156V22.7158C3.54822 23.6809 4.34203 24.4632 5.32125 24.4632H23.0516C24.0308 24.4632 24.8247 23.6809 24.8247 22.7158V5.24156C24.8247 4.27649 24.0308 3.49414 23.0516 3.49414Z"
          fill="white"
          stroke="white"
          strokeWidth="2.3299"
          strokeLinejoin="round"
        />
        <path
          d="M14.1864 9.31934V18.6389M9.45831 13.9791H18.9145"
          stroke="black"
          strokeWidth="2.3299"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </mask>
      <g mask="url(#mask0_2820_181458)">
        <path
          d="M0.000732422 0H28.3693V27.9588H0.000732422V0Z"
          fill="#43A047"
        />
      </g>
    </svg>
  );
};

export const CircleGreenAddIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="20"
      viewBox="0 0 19 20"
      fill="none"
    >
      <mask
        id="mask0_5015_172464"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="19"
        height="20"
      >
        <path
          d="M9.83333 18.3337C14.4358 18.3337 18.1667 14.6028 18.1667 10.0003C18.1667 5.39783 14.4358 1.66699 9.83333 1.66699C5.23083 1.66699 1.5 5.39783 1.5 10.0003C1.5 14.6028 5.23083 18.3337 9.83333 18.3337Z"
          fill="white"
          stroke="white"
          strokeWidth="1.66667"
          strokeLinejoin="round"
        />
        <path
          d="M9.83333 6.66699V13.3337M6.5 10.0003H13.1667"
          stroke="black"
          strokeWidth="1.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </mask>
      <g mask="url(#mask0_5015_172464)">
        <path d="M-0.166992 0H19.833V20H-0.166992V0Z" fill="#43A047" />
      </g>
    </svg>
  );
};

export const RegularAttchIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M15.0167 4.30353C14.3907 3.68104 13.5446 3.33025 12.6618 3.32713C11.7789 3.32401 10.9304 3.66882 10.3 4.28686L4.75002 9.74019C4.59265 9.89513 4.38031 9.98141 4.15947 9.98017C3.93864 9.97892 3.72729 9.89023 3.57168 9.73353C3.49477 9.656 3.43395 9.56402 3.39272 9.4629C3.35149 9.36177 3.33067 9.2535 3.33144 9.14429C3.33222 9.03509 3.35458 8.92712 3.39724 8.82659C3.4399 8.72606 3.50201 8.63496 3.58002 8.55853L9.12835 3.10686C10.0723 2.18027 11.3434 1.66296 12.6661 1.66702C13.9889 1.67107 15.2567 2.19617 16.195 3.12853C16.6605 3.59119 17.0299 4.14133 17.282 4.74729C17.534 5.35325 17.6638 6.00306 17.6638 6.65936C17.6638 7.31566 17.534 7.96547 17.282 8.57143C17.0299 9.17739 16.6605 9.72753 16.195 10.1902L8.97502 17.3802C8.3611 17.9904 7.53064 18.333 6.66502 18.333C5.79939 18.333 4.96894 17.9904 4.35502 17.3802C4.05181 17.0786 3.81119 16.7201 3.647 16.3253C3.48281 15.9304 3.39829 15.507 3.39829 15.0794C3.39829 14.6517 3.48281 14.2283 3.647 13.8335C3.81119 13.4386 4.05181 13.0801 4.35502 12.7785L11.0883 6.07353C11.2448 5.91821 11.4563 5.83105 11.6767 5.83105C11.8971 5.83105 12.1086 5.91821 12.265 6.07353C12.3422 6.15048 12.4035 6.24191 12.4453 6.34259C12.4871 6.44326 12.5086 6.55119 12.5086 6.66019C12.5086 6.7692 12.4871 6.87713 12.4453 6.9778C12.4035 7.07847 12.3422 7.16991 12.265 7.24686L5.53335 13.9519C5.38474 14.0996 5.26681 14.2753 5.18634 14.4688C5.10587 14.6623 5.06444 14.8698 5.06444 15.0794C5.06444 15.2889 5.10587 15.4964 5.18634 15.6899C5.26681 15.8834 5.38474 16.0591 5.53335 16.2069C5.83422 16.5069 6.24178 16.6754 6.66668 16.6754C7.09158 16.6754 7.49915 16.5069 7.80002 16.2069L15.0167 9.01686C15.3273 8.70801 15.5738 8.34081 15.742 7.93637C15.9102 7.53193 15.9968 7.09822 15.9968 6.66019C15.9968 6.22217 15.9102 5.78846 15.742 5.38402C15.5738 4.97957 15.3273 4.61237 15.0167 4.30353Z"
        fill="#1E88E5"
      />
    </svg>
  );
};

export const ActivityLogIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <g clip-path="url(#clip0_36_30)">
        <path
          d="M11.3625 3.45234C11.243 3.45234 11.1445 3.41015 11.0531 3.32578C10.9617 3.2414 10.8914 3.14296 10.8352 3.02343C10.7789 2.9039 10.7297 2.78437 10.7016 2.65781C10.6734 2.53124 10.6594 2.43281 10.6594 2.34843V0.168744H10.6945C10.7859 0.168744 10.8844 0.182806 10.9898 0.210931C11.0883 0.239056 11.2078 0.295306 11.3414 0.379681C11.475 0.464056 11.6438 0.583588 11.8336 0.745306C12.0305 0.907025 12.2695 1.11093 12.5648 1.37109C12.8812 1.65234 13.1344 1.8914 13.3172 2.09531C13.5 2.29218 13.6406 2.46093 13.7391 2.60156C13.8375 2.73515 13.9008 2.85468 13.9219 2.94609C13.943 3.03749 13.957 3.12187 13.957 3.19218V3.45937H11.3625V3.45234ZM13.4156 10.0687C13.957 10.0687 14.4633 10.1672 14.9344 10.3711C15.4055 10.568 15.8203 10.8492 16.1719 11.2008C16.5234 11.5523 16.8047 11.9672 17.0016 12.4383C17.1984 12.9094 17.3039 13.4156 17.3039 13.957C17.3039 14.4984 17.2055 15.0047 17.0016 15.4758C16.8047 15.9469 16.5234 16.3617 16.1719 16.7133C15.8203 17.0648 15.4055 17.3461 14.9344 17.543C14.4633 17.7398 13.957 17.8453 13.4156 17.8453C12.8883 17.8453 12.3891 17.7469 11.918 17.543C11.4469 17.3461 11.032 17.0648 10.6805 16.7133C10.3289 16.3617 10.0477 15.9469 9.84375 15.4758C9.63984 15.0047 9.53438 14.4984 9.53438 13.957C9.53438 13.4156 9.63984 12.9094 9.84375 12.4383C10.0477 11.9672 10.3289 11.5523 10.6805 11.2008C11.032 10.8492 11.4469 10.568 11.918 10.3711C12.382 10.1672 12.8813 10.0687 13.4156 10.0687ZM15.6164 14.5687C15.7219 14.5687 15.8133 14.5125 15.8977 14.393C15.982 14.2734 16.0242 14.1328 16.0242 13.9711C16.0242 13.8094 15.982 13.6617 15.8977 13.5492C15.8133 13.4297 15.7219 13.3734 15.6164 13.3734H13.9359V11.8195C13.9359 11.7281 13.8867 11.6437 13.7883 11.5734C13.6898 11.5031 13.5492 11.468 13.3734 11.468C13.1977 11.468 13.0641 11.5031 12.9797 11.5734C12.8883 11.6437 12.8461 11.7281 12.8461 11.8195V13.7601C12.825 13.8516 12.8109 13.9219 12.8109 13.9711C12.8109 14.1328 12.8531 14.2805 12.9375 14.393C13.0219 14.5125 13.1133 14.5687 13.2188 14.5687H15.6164ZM8.38125 13.4226C8.36719 13.507 8.36016 13.5844 8.36016 13.6687V13.9359C8.36016 14.4633 8.4375 14.9625 8.59219 15.4336C8.74687 15.9047 8.95781 16.3477 9.225 16.7555H2.98125C2.75625 16.7555 2.51719 16.6922 2.25 16.5586C1.98281 16.432 1.73672 16.2562 1.51172 16.0453C1.27969 15.8344 1.08984 15.5953 0.935156 15.3211C0.780469 15.0539 0.703125 14.7656 0.703125 14.4703V2.43984C0.703125 2.19374 0.759375 1.93359 0.878906 1.67343C0.998437 1.40624 1.14609 1.16718 1.33594 0.942181C1.52578 0.717181 1.74375 0.534369 1.98984 0.386713C2.23594 0.239056 2.49609 0.161713 2.76328 0.161713H9.52734V2.36953C9.52734 2.60859 9.5625 2.84765 9.63281 3.10078C9.70312 3.3539 9.81563 3.59296 9.97031 3.81796C10.125 4.04296 10.3148 4.22578 10.5539 4.3664C10.793 4.50703 11.0672 4.57734 11.3836 4.57734H13.957V8.97187C13.8656 8.95078 13.7602 8.93671 13.6547 8.93671H13.3383C12.4523 8.93671 11.6508 9.14062 10.9195 9.55546C10.1883 9.96327 9.60469 10.5187 9.15469 11.2148H4.02188C3.7125 11.2148 3.45234 11.3203 3.23438 11.5312C3.01641 11.7422 2.91094 12.0023 2.91094 12.3117C2.91094 12.6211 3.01641 12.8812 3.23438 13.0992C3.45234 13.3172 3.7125 13.4226 4.02188 13.4226H8.38125ZM4.02188 6.78515C3.7125 6.78515 3.45234 6.89062 3.23438 7.10859C3.01641 7.32656 2.91094 7.58671 2.91094 7.89609C2.91094 8.20546 3.01641 8.45859 3.23438 8.67656C3.45234 8.88749 3.7125 8.99296 4.02188 8.99296H10.6383C10.9477 8.99296 11.2008 8.88749 11.4187 8.67656C11.6297 8.46562 11.7352 8.20546 11.7352 7.89609C11.7352 7.58671 11.6297 7.32656 11.4187 7.10859C11.2078 6.89062 10.9477 6.78515 10.6383 6.78515H4.02188Z"
          fill="#424242"
        />
      </g>
      <defs>
        <clipPath id="clip0_36_30">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const DealershipIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <g clip-path="url(#clip0_26_730)">
        <path
          d="M14.0648 10.4807C13.9869 10.4807 13.9067 10.4919 13.8264 10.5141L13.5245 10.5972L13.0798 9.51386C12.8305 8.90652 12.0934 8.41241 11.4368 8.41241H6.55536C5.89882 8.41241 5.16174 8.90659 4.91248 9.51393L4.4685 10.5953L4.17382 10.5141C4.09357 10.492 4.01338 10.4808 3.93548 10.4808C3.54384 10.4808 3.25952 10.7618 3.25952 11.1488C3.25952 11.531 3.53842 11.8527 3.91642 11.9493C3.70914 12.5217 3.54806 13.3798 3.54806 13.9435V16.2488C3.54806 16.741 3.94841 17.1414 4.44058 17.1414H4.76782C5.25999 17.1414 5.66034 16.741 5.66034 16.2488V15.8176H12.3318V16.2488C12.3318 16.741 12.7321 17.1414 13.2243 17.1414H13.5517C14.0439 17.1414 14.4442 16.741 14.4442 16.2488V13.9435C14.4442 13.3803 14.2834 12.5235 14.0765 11.951C14.4582 11.8568 14.7407 11.5333 14.7407 11.1488C14.7407 10.7617 14.4564 10.4807 14.0648 10.4807ZM5.02336 11.3803L5.74888 9.61282C5.89804 9.24953 6.34137 8.95228 6.73408 8.95228H11.2583C11.651 8.95228 12.0944 9.24953 12.2435 9.61282L12.969 11.3803C13.1182 11.7436 12.9189 12.0408 12.5262 12.0408H5.4662C5.07349 12.0408 4.8742 11.7436 5.02336 11.3803ZM6.94693 14.2543C6.94693 14.4507 6.78628 14.6113 6.58992 14.6113H5.10919C4.91283 14.6113 4.75218 14.4507 4.75218 14.2543V13.6637C4.75218 13.4674 4.91283 13.3067 5.10919 13.3067H6.58992C6.78628 13.3067 6.94693 13.4674 6.94693 13.6637V14.2543ZM13.2239 14.2543C13.2239 14.4507 13.0633 14.6113 12.8669 14.6113H11.3863C11.19 14.6113 11.0293 14.4507 11.0293 14.2543V13.6637C11.0293 13.4674 11.19 13.3067 11.3863 13.3067H12.8669C13.0633 13.3067 13.2239 13.4674 13.2239 13.6637V14.2543Z"
          fill="#424242"
        />
        <path
          d="M17.6038 5.10794L9.39828 0.29809C9.28939 0.234257 9.14794 0.199127 9 0.199127C8.85206 0.199127 8.71061 0.234257 8.60172 0.29809L0.396209 5.10794C0.170365 5.24032 0 5.53764 0 5.79947V17.2653C0 17.5606 0.240196 17.8008 0.535515 17.8008H1.45746C1.75277 17.8008 1.99297 17.5606 1.99297 17.2653V7.56267C1.99297 7.46427 2.07301 7.38416 2.17148 7.38416H15.8284C15.9268 7.38416 16.0069 7.46427 16.0069 7.56267V17.2653C16.0069 17.5606 16.2471 17.8008 16.5424 17.8008H17.4644C17.7597 17.8008 17.9999 17.5606 17.9999 17.2653V5.79947C18 5.53764 17.8296 5.24032 17.6038 5.10794Z"
          fill="#424242"
        />
      </g>
      <defs>
        <clipPath id="clip0_26_730">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const RegisterationIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <g clip-path="url(#clip0_26_939)">
        <path d="M0 0H18V18H0V0Z" fill="#424242" />
        <path
          d="M8.50001 2.26001H9.52001L10.16 2.34001L10.64 2.44001L11.12 2.58001L11.5 2.72001L12 2.94001L12.38 3.14001L12.78 3.40001L13.12 3.64001L13.38 3.86001L13.6 4.04001L14 4.44001L14.18 4.66001L14.44 4.98001L14.6 5.22001L14.78 5.50001L14.96 5.80001L15.18 6.26001L15.36 6.72001L15.52 7.22001L15.64 7.76001L15.72 8.30001L15.74 8.52001V9.48001L15.7 9.86001L15.6 10.46L15.46 10.98L15.28 11.5L15.06 11.98L14.82 12.44L14.46 12.98L14.24 13.26L14 13.54L13.86 13.68L13.76 13.8L13.6 13.94L13.34 14.18L13.06 14.4L12.66 14.68L12.22 14.94L11.74 15.18L11.22 15.38L10.7 15.54L10.12 15.66L9.64001 15.72L9.42001 15.74H8.58001L8.16001 15.7L7.66001 15.62L7.16001 15.5L6.50001 15.28L6.10001 15.1L5.60001 14.84L5.34001 14.68L5.10001 14.52L4.84001 14.32L4.62001 14.14L4.38001 13.92L3.90001 13.44L3.74001 13.24L3.48001 12.9L3.28001 12.6L3.08001 12.26L2.86001 11.84L2.64001 11.3L2.48001 10.78L2.36001 10.26L2.28001 9.74001L2.26001 9.52001V8.46001L2.32001 7.96001L2.40001 7.54001L2.54001 7.00001L2.74001 6.44001L2.90001 6.08001L3.10001 5.70001L3.28001 5.40001L3.54001 5.02001L3.76001 4.74001L3.98001 4.48001L4.28001 4.16001L4.54001 3.92001L4.76001 3.74001L5.10001 3.48001L5.50001 3.22001L5.82001 3.04001L6.14001 2.88001L6.50001 2.72001L6.94001 2.56001L7.44001 2.42001L7.84001 2.34001L8.26001 2.28001L8.50001 2.26001Z"
          fill="#424242"
        />
        <path
          d="M8.50001 2.26001H9.52001L10.16 2.34001L10.64 2.44001L11.12 2.58001L11.5 2.72001L12 2.94001L12.38 3.14001L12.78 3.40001L13.12 3.64001L13.38 3.86001L13.6 4.04001L14 4.44001L14.18 4.66001L14.44 4.98001L14.6 5.22001L14.78 5.50001L14.96 5.80001L15.18 6.26001L15.36 6.72001L15.52 7.22001L15.64 7.76001L15.72 8.30001L15.74 8.52001V9.48001L15.7 9.86001L15.6 10.46L15.46 10.98L15.28 11.5L15.06 11.98L14.82 12.44L14.46 12.98L14.24 13.26L14 13.54L13.86 13.68L13.76 13.8L13.6 13.94L13.34 14.18L13.06 14.4L12.66 14.68L12.22 14.94L11.74 15.18L11.22 15.38L10.7 15.54L10.12 15.66L9.64001 15.72L9.42001 15.74H8.58001L8.16001 15.7L7.66001 15.62L7.16001 15.5L6.50001 15.28L6.10001 15.1L5.60001 14.84L5.34001 14.68L5.10001 14.52L4.84001 14.32L4.62001 14.14L4.38001 13.92L3.90001 13.44L3.74001 13.24L3.48001 12.9L3.28001 12.6L3.08001 12.26L2.86001 11.84L2.64001 11.3L2.48001 10.78L2.36001 10.26L2.28001 9.74001L2.26001 9.52001V8.46001L2.32001 7.96001L2.40001 7.54001L2.54001 7.00001L2.74001 6.44001L2.90001 6.08001L3.10001 5.70001L3.28001 5.40001L3.54001 5.02001L3.76001 4.74001L3.98001 4.48001L4.28001 4.16001L4.54001 3.92001L4.76001 3.74001L5.10001 3.48001L5.50001 3.22001L5.82001 3.04001L6.14001 2.88001L6.50001 2.72001L6.94001 2.56001L7.44001 2.42001L7.84001 2.34001L8.26001 2.28001L8.50001 2.26001ZM8.68001 4.04001L8.28001 4.08001L7.78001 4.18001L7.32001 4.32001L6.94001 4.48001L6.62001 4.64001L6.34001 4.80001L6.08001 4.98001L5.82001 5.18001L5.52001 5.46001L5.26001 5.72001L5.04001 6.00001L4.84001 6.28001L4.64001 6.62001L4.48001 6.94001L4.32001 7.34001L4.20001 7.74001L4.12001 8.10001L4.06001 8.46001L4.04001 8.72001V9.24001L4.08001 9.68001L4.18001 10.18L4.30001 10.6L4.44001 10.96L4.64001 11.38L4.86001 11.74L5.04001 11.98L5.18001 12.16L5.42001 12.44L5.62001 12.64L5.78001 12.78L6.08001 13.02L6.48001 13.28L6.98001 13.54L7.40001 13.7L7.82001 13.82L8.32001 13.92L8.92001 13.96L9.48001 13.94L9.88001 13.88L10.32 13.78L10.72 13.66L11.14 13.48L11.56 13.26L11.8 13.1L12.02 12.94L12.28 12.72L12.48 12.54L12.7 12.32L12.92 12.04L13.1 11.8L13.36 11.38L13.58 10.92L13.74 10.48L13.82 10.2L13.92 9.66001L13.96 9.28001V8.76001L13.92 8.32001L13.8 7.74001L13.68 7.34001L13.52 6.94001L13.32 6.54001L13.12 6.22001L12.94 5.98001L12.84 5.84001H12.8L12.76 5.76001L12.7 5.68001H12.66L12.62 5.60001L12.34 5.32001L12.12 5.14001L11.86 4.94001L11.56 4.74001L11.2 4.54001L10.68 4.32001L10.28 4.20001L9.94001 4.12001L9.56001 4.06001L9.34001 4.04001H8.68001Z"
          fill="#FEFFFE"
        />
        <path
          d="M7.25994 9.51999L7.57994 9.53999L7.81994 9.59999L8.09994 9.73999L8.35994 9.95999L8.51994 10.16L8.65994 10.44L8.71994 10.68L8.73994 11L8.69994 11.26L8.59994 11.54L8.47994 11.74L8.29994 11.94L8.13994 12.08L7.81994 12.24L7.47994 12.32H7.19994L6.89994 12.26L6.65994 12.16L6.41994 11.98L6.23994 11.8L6.09994 11.58L5.99994 11.34L5.93994 11.08V10.76L6.01994 10.44L6.17994 10.12L6.39994 9.87999L6.63994 9.69999L6.85994 9.59999L7.07994 9.53999L7.25994 9.51999Z"
          fill="#FEFFFE"
        />
        <path
          d="M7.17994 5.94H7.49994L7.77994 6L8.09994 6.16L8.27994 6.3L8.43994 6.46L8.57994 6.68L8.69994 6.98L8.73994 7.28L8.71994 7.58L8.63994 7.86L8.47994 8.16L8.23994 8.42L8.01994 8.56L7.79994 8.66L7.55994 8.72L7.29994 8.74L6.99994 8.7L6.67994 8.58L6.43994 8.42L6.23994 8.22L6.05994 7.92L5.95994 7.6L5.93994 7.48V7.18L5.99994 6.9L6.09994 6.68L6.21994 6.48L6.47994 6.22L6.69994 6.08L6.95994 5.98L7.17994 5.94Z"
          fill="#FEFFFE"
        />
        <path
          d="M10.84 9.51999L11.18 9.53999L11.46 9.61999L11.74 9.77999L11.94 9.95999L12.08 10.12L12.24 10.42L12.3 10.62L12.32 10.76V11.1L12.24 11.42L12.08 11.72L11.9 11.94L11.66 12.12L11.46 12.22L11.2 12.3L11.06 12.32H10.78L10.5 12.26L10.26 12.16L10.08 12.04L9.88002 11.86L9.72002 11.64L9.62002 11.44L9.54002 11.16L9.52002 10.94L9.56002 10.58L9.66002 10.32L9.80002 10.08L10 9.85999L10.3 9.65999L10.56 9.55999L10.84 9.51999Z"
          fill="#FEFFFE"
        />
        <path
          d="M10.74 5.94H11.08L11.36 6L11.58 6.1L11.8 6.24L11.92 6.34L12.1 6.56L12.24 6.84L12.32 7.16V7.5L12.24 7.82L12.08 8.14L11.86 8.38L11.66 8.54L11.44 8.64L11.26 8.7L11 8.74L10.7 8.72L10.46 8.66L10.28 8.58L10.08 8.46L9.90002 8.3L9.72002 8.06L9.60002 7.8L9.54002 7.56L9.52002 7.32L9.56002 7L9.66002 6.72L9.80002 6.5L9.98002 6.3L10.2 6.14L10.48 6L10.74 5.94Z"
          fill="#FEFFFE"
        />
        <path
          d="M0 15.68L0.04 15.76L0.14 16.14L0.26 16.44L0.42 16.74L0.6 16.98L0.78 17.18L0.96 17.36L1.26 17.58L1.6 17.76L2.02 17.9L2.32 17.98V18H0V15.68Z"
          fill="#FEFFFE"
        />
        <path
          d="M17.98 15.68H18V18H15.7L15.76 17.96L16.18 17.84L16.56 17.68L16.86 17.5L17.06 17.34L17.26 17.16L17.44 16.94L17.64 16.64L17.8 16.3L17.94 15.84L17.98 15.68Z"
          fill="#FEFFFE"
        />
        <path
          d="M15.7 0H18V2.32L17.96 2.3L17.88 1.94L17.74 1.56L17.54 1.2L17.32 0.92L17.24 0.84V0.8L17.16 0.76L17 0.6L16.64 0.36L16.36 0.22L15.94 0.08L15.7 0.02V0Z"
          fill="#FEFFFE"
        />
        <path
          d="M0 0H2.32L2.26 0.04L1.92 0.12L1.54 0.26L1.22 0.44L0.96 0.64L0.76 0.82L0.6 1L0.42 1.26L0.22 1.64L0.08 2.06L0.02 2.28H0V0Z"
          fill="#FEFFFE"
        />
      </g>
      <defs>
        <clipPath id="clip0_26_939">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const InventoryMappingIcon = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="icon-park-outline:mind-mapping" clipPath="url(#clip0_7393_102132)">
        <g id="Group">
          <path
            id="Vector"
            d="M3 10.5C3.39782 10.5 3.77936 10.342 4.06066 10.0607C4.34196 9.77936 4.5 9.39782 4.5 9C4.5 8.60218 4.34196 8.22064 4.06066 7.93934C3.77936 7.65804 3.39782 7.5 3 7.5C2.60218 7.5 2.22064 7.65804 1.93934 7.93934C1.65804 8.22064 1.5 8.60218 1.5 9C1.5 9.39782 1.65804 9.77936 1.93934 10.0607C2.22064 10.342 2.60218 10.5 3 10.5ZM15.75 3C15.9489 3 16.1397 2.92098 16.2803 2.78033C16.421 2.63968 16.5 2.44891 16.5 2.25C16.5 2.05109 16.421 1.86032 16.2803 1.71967C16.1397 1.57902 15.9489 1.5 15.75 1.5C15.5511 1.5 15.3603 1.57902 15.2197 1.71967C15.079 1.86032 15 2.05109 15 2.25C15 2.44891 15.079 2.63968 15.2197 2.78033C15.3603 2.92098 15.5511 3 15.75 3ZM15.75 9.75C15.9489 9.75 16.1397 9.67098 16.2803 9.53033C16.421 9.38968 16.5 9.19891 16.5 9C16.5 8.80109 16.421 8.61032 16.2803 8.46967C16.1397 8.32902 15.9489 8.25 15.75 8.25C15.5511 8.25 15.3603 8.32902 15.2197 8.46967C15.079 8.61032 15 8.80109 15 9C15 9.19891 15.079 9.38968 15.2197 9.53033C15.3603 9.67098 15.5511 9.75 15.75 9.75ZM15.75 16.5C15.9489 16.5 16.1397 16.421 16.2803 16.2803C16.421 16.1397 16.5 15.9489 16.5 15.75C16.5 15.5511 16.421 15.3603 16.2803 15.2197C16.1397 15.079 15.9489 15 15.75 15C15.5511 15 15.3603 15.079 15.2197 15.2197C15.079 15.3603 15 15.5511 15 15.75C15 15.9489 15.079 16.1397 15.2197 16.2803C15.3603 16.421 15.5511 16.5 15.75 16.5Z"
            stroke="#434343"
            strokeWidth="1.5"
            strokeLinejoin="round"
          />
          <path
            id="Vector_2"
            d="M12 2.25H7.5V15.75H12M4.5 9H12"
            stroke="#434343"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_7393_102132">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const TotalDealershipIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g clip-path="url(#clip0_7017_221076)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.9999 3C13.5044 2.99984 13.9904 3.19041 14.3604 3.5335C14.7304 3.87659 14.957 4.34684 14.9949 4.85L14.9999 5V19H15.9999V9.5C15.9998 9.38297 16.0408 9.26964 16.1158 9.17974C16.1907 9.08984 16.2948 9.02907 16.4099 9.008L16.4999 9H17.9999C18.5044 8.99984 18.9904 9.19041 19.3604 9.5335C19.7304 9.87659 19.957 10.3468 19.9949 10.85L19.9999 11V19H20.9999C21.2547 19.0003 21.4999 19.0979 21.6852 19.2728C21.8706 19.4478 21.9821 19.687 21.997 19.9414C22.012 20.1958 21.9292 20.4464 21.7656 20.6418C21.602 20.8373 21.37 20.9629 21.1169 20.993L20.9999 21H2.99987C2.74499 20.9997 2.49984 20.9021 2.3145 20.7272C2.12916 20.5522 2.01763 20.313 2.0027 20.0586C1.98776 19.8042 2.07054 19.5536 2.23413 19.3582C2.39772 19.1627 2.62977 19.0371 2.88287 19.007L2.99987 19H3.99987V5C3.99971 4.49542 4.19027 4.00943 4.53337 3.63945C4.87646 3.26947 5.34671 3.04284 5.84987 3.005L5.99987 3H12.9999ZM10.9999 15H7.99987V17H10.9999V15ZM10.9999 11H7.99987V13H10.9999V11ZM10.9999 7H7.99987V9H10.9999V7Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_7017_221076">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ExpandIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M20 5C20 4.73478 19.8946 4.48043 19.7071 4.29289C19.5196 4.10536 19.2652 4 19 4H14C13.7348 4 13.4804 4.10536 13.2929 4.29289C13.1054 4.48043 13 4.73478 13 5C13 5.26522 13.1054 5.51957 13.2929 5.70711C13.4804 5.89464 13.7348 6 14 6H16.57L13.29 9.29C13.1963 9.38296 13.1219 9.49356 13.0711 9.61542C13.0203 9.73728 12.9942 9.86799 12.9942 10C12.9942 10.132 13.0203 10.2627 13.0711 10.3846C13.1219 10.5064 13.1963 10.617 13.29 10.71C13.383 10.8037 13.4936 10.8781 13.6154 10.9289C13.7373 10.9797 13.868 11.0058 14 11.0058C14.132 11.0058 14.2627 10.9797 14.3846 10.9289C14.5064 10.8781 14.617 10.8037 14.71 10.71L18 7.42V10C18 10.2652 18.1054 10.5196 18.2929 10.7071C18.4804 10.8946 18.7348 11 19 11C19.2652 11 19.5196 10.8946 19.7071 10.7071C19.8946 10.5196 20 10.2652 20 10V5ZM10.71 13.29C10.617 13.1963 10.5064 13.1219 10.3846 13.0711C10.2627 13.0203 10.132 12.9942 10 12.9942C9.86799 12.9942 9.73728 13.0203 9.61542 13.0711C9.49356 13.1219 9.38296 13.1963 9.29 13.29L6 16.57V14C6 13.7348 5.89464 13.4804 5.70711 13.2929C5.51957 13.1054 5.26522 13 5 13C4.73478 13 4.48043 13.1054 4.29289 13.2929C4.10536 13.4804 4 13.7348 4 14V19C4 19.2652 4.10536 19.5196 4.29289 19.7071C4.48043 19.8946 4.73478 20 5 20H10C10.2652 20 10.5196 19.8946 10.7071 19.7071C10.8946 19.5196 11 19.2652 11 19C11 18.7348 10.8946 18.4804 10.7071 18.2929C10.5196 18.1054 10.2652 18 10 18H7.42L10.71 14.71C10.8037 14.617 10.8781 14.5064 10.9289 14.3846C10.9797 14.2627 11.0058 14.132 11.0058 14C11.0058 13.868 10.9797 13.7373 10.9289 13.6154C10.8781 13.4936 10.8037 13.383 10.71 13.29Z"
        fill="#424242"
      />
    </svg>
  );
};

export const AppsIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g clip-path="url(#clip0_7552_14247)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9 13.0001C9.53043 13.0001 10.0391 13.2108 10.4142 13.5859C10.7893 13.961 11 14.4697 11 15.0001V19.0001C11 19.5306 10.7893 20.0393 10.4142 20.4143C10.0391 20.7894 9.53043 21.0001 9 21.0001H5C4.46957 21.0001 3.96086 20.7894 3.58579 20.4143C3.21071 20.0393 3 19.5306 3 19.0001V15.0001C3 14.4697 3.21071 13.961 3.58579 13.5859C3.96086 13.2108 4.46957 13.0001 5 13.0001H9ZM19 13.0001C19.5304 13.0001 20.0391 13.2108 20.4142 13.5859C20.7893 13.961 21 14.4697 21 15.0001V19.0001C21 19.5306 20.7893 20.0393 20.4142 20.4143C20.0391 20.7894 19.5304 21.0001 19 21.0001H15C14.4696 21.0001 13.9609 20.7894 13.5858 20.4143C13.2107 20.0393 13 19.5306 13 19.0001V15.0001C13 14.4697 13.2107 13.961 13.5858 13.5859C13.9609 13.2108 14.4696 13.0001 15 13.0001H19ZM9 3.00012C9.53043 3.00012 10.0391 3.21084 10.4142 3.58591C10.7893 3.96098 11 4.46969 11 5.00012V9.00012C11 9.53056 10.7893 10.0393 10.4142 10.4143C10.0391 10.7894 9.53043 11.0001 9 11.0001H5C4.46957 11.0001 3.96086 10.7894 3.58579 10.4143C3.21071 10.0393 3 9.53056 3 9.00012V5.00012C3 4.46969 3.21071 3.96098 3.58579 3.58591C3.96086 3.21084 4.46957 3.00012 5 3.00012H9ZM19 3.00012C19.5304 3.00012 20.0391 3.21084 20.4142 3.58591C20.7893 3.96098 21 4.46969 21 5.00012V9.00012C21 9.53056 20.7893 10.0393 20.4142 10.4143C20.0391 10.7894 19.5304 11.0001 19 11.0001H15C14.4696 11.0001 13.9609 10.7894 13.5858 10.4143C13.2107 10.0393 13 9.53056 13 9.00012V5.00012C13 4.46969 13.2107 3.96098 13.5858 3.58591C13.9609 3.21084 14.4696 3.00012 15 3.00012H19Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_7552_14247">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const TelephoneyIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M22 12.0001C21.9995 9.34812 20.9457 6.80489 19.0705 4.92964C17.1952 3.05439 14.652 2.00065 12 2.00012V4.00012C13.5821 4.00048 15.1286 4.46976 16.4441 5.34866C17.7596 6.22756 18.7851 7.47665 19.391 8.93812C19.7931 9.90889 20.0001 10.9494 20 12.0001H22ZM2 10.0001V5.00012C2 4.73491 2.10536 4.48055 2.29289 4.29302C2.48043 4.10548 2.73478 4.00012 3 4.00012H8C8.26522 4.00012 8.51957 4.10548 8.70711 4.29302C8.89464 4.48055 9 4.73491 9 5.00012V9.00012C9 9.26534 8.89464 9.51969 8.70711 9.70723C8.51957 9.89476 8.26522 10.0001 8 10.0001H6C6 12.1219 6.84285 14.1567 8.34315 15.657C9.84344 17.1573 11.8783 18.0001 14 18.0001V16.0001C14 15.7349 14.1054 15.4806 14.2929 15.293C14.4804 15.1055 14.7348 15.0001 15 15.0001H19C19.2652 15.0001 19.5196 15.1055 19.7071 15.293C19.8946 15.4806 20 15.7349 20 16.0001V21.0001C20 21.2653 19.8946 21.5197 19.7071 21.7072C19.5196 21.8948 19.2652 22.0001 19 22.0001H14C7.373 22.0001 2 16.6271 2 10.0001Z"
        fill="white"
      />
      <path
        d="M17.543 9.70412C17.8449 10.4319 18.0002 11.2122 18 12.0001H16.2C16.2001 11.4485 16.0916 10.9023 15.8806 10.3927C15.6695 9.88307 15.3602 9.42001 14.9701 9.02998C14.5801 8.63995 14.1171 8.33058 13.6074 8.11956C13.0978 7.90854 12.5516 7.79999 12 7.80012V6.00012C13.1867 6.00019 14.3466 6.35212 15.3333 7.01142C16.3199 7.67073 17.0889 8.60779 17.543 9.70412Z"
        fill="white"
      />
    </svg>
  );
};

export const MsgIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M6.455 19L2 22.5V4C2 3.73478 2.10536 3.48043 2.29289 3.29289C2.48043 3.10536 2.73478 3 3 3H21C21.2652 3 21.5196 3.10536 21.7071 3.29289C21.8946 3.48043 22 3.73478 22 4V18C22 18.2652 21.8946 18.5196 21.7071 18.7071C21.5196 18.8946 21.2652 19 21 19H6.455ZM8 10V12H16V10H8Z"
        fill="white"
      />
    </svg>
  );
};

export const IntegrationsIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
    >
      <path
        d="M3.50068 2.18665H13.5624V6.12592H11.9843C11.7147 5.9041 11.4209 5.71345 11.1084 5.55761C10.7488 5.37954 10.4172 5.25092 10.065 5.25092C9.22847 5.25092 8.66453 5.65692 8.32809 6.18149C7.99078 6.70561 7.87484 7.32599 7.87484 7.87506C7.87484 8.42413 7.99121 9.04451 8.32765 9.56864C8.66453 10.0936 9.22847 10.4992 10.0645 10.4992C10.4172 10.4992 10.7488 10.3706 11.1084 10.1925C11.4209 10.0367 11.7147 9.84602 11.9843 9.6242H13.5624L13.5633 13.5617L9.18822 13.5626C9.13071 13.5623 9.07371 13.5734 9.02046 13.5951C8.96722 13.6168 8.91878 13.6489 8.87791 13.6893C8.83704 13.7298 8.80454 13.7779 8.78227 13.8309C8.75999 13.8839 8.74838 13.9408 8.74809 13.9984V16.1841C8.74809 16.2979 8.79272 16.4072 8.87103 16.4886C9.06003 16.6868 9.26435 16.99 9.40785 17.2796C9.55135 17.5697 9.62397 17.8703 9.62397 17.935C9.62397 18.4136 9.42185 18.7264 9.0946 18.9369C8.76734 19.1465 8.29178 19.2488 7.87484 19.2493C7.4579 19.2493 6.98233 19.1465 6.65552 18.9365C6.32783 18.7264 6.1257 18.4136 6.1257 17.935C6.1257 17.8698 6.19833 17.5697 6.34183 17.2796C6.48533 16.99 6.68964 16.6868 6.87864 16.4886C6.95739 16.4068 7.00114 16.2974 7.00158 16.1841V13.9984C7.00129 13.9408 6.98968 13.8839 6.96741 13.8309C6.94514 13.7779 6.91264 13.7298 6.87177 13.6893C6.8309 13.6489 6.78246 13.6168 6.72921 13.5951C6.67597 13.5734 6.61896 13.5623 6.56145 13.5626H2.18555V3.5009C2.18555 3.5009 2.19342 3.15309 2.36011 2.81971C2.52374 2.49202 2.84005 2.18665 3.50068 2.18665Z"
        fill="white"
      />
      <path
        d="M14.4367 2.18652H24.4984C25.159 2.18652 25.4753 2.4919 25.6389 2.81959C25.8056 3.15297 25.8135 3.50078 25.8135 3.50078V13.5607H21.8733V11.9831C22.0886 11.7258 22.2947 11.4043 22.4417 11.1072C22.6197 10.748 22.7483 10.416 22.7483 10.0638C22.7483 9.22726 22.3423 8.66332 21.8178 8.32688C21.2937 7.99 20.6733 7.87406 20.1242 7.87363C19.5751 7.87363 18.9548 7.99 18.4306 8.32644C17.9056 8.66332 17.5001 9.22726 17.5001 10.0638C17.5001 10.416 17.6287 10.748 17.8068 11.1072C17.9538 11.4043 18.1598 11.7258 18.3751 11.9831V13.5612L14.4375 13.562L14.4367 9.18832C14.437 9.13081 14.4259 9.07381 14.4042 9.02056C14.3824 8.96732 14.3504 8.91888 14.3099 8.87801C14.2695 8.83714 14.2214 8.80464 14.1683 8.78237C14.1153 8.76009 14.0584 8.74848 14.0009 8.7482H11.8151C11.7014 8.7482 11.592 8.79282 11.5111 8.87113C11.3129 9.06013 11.0093 9.26445 10.7192 9.40795C10.43 9.55145 10.1294 9.62408 10.0643 9.62408C9.58563 9.62408 9.27282 9.42195 9.06238 9.0947C8.85281 8.76745 8.75044 8.29188 8.75 7.87494C8.75 7.458 8.85281 6.98243 9.06281 6.65562C9.27282 6.32793 9.58563 6.1258 10.0643 6.1258C10.1294 6.1258 10.43 6.19843 10.7196 6.34193C11.0093 6.48543 11.3129 6.68974 11.5106 6.87874C11.5925 6.95749 11.7018 7.00125 11.8151 7.00125H14.0009C14.2424 7.00081 14.4375 6.80306 14.4367 6.56155V2.18652Z"
        fill="white"
      />
      <path
        d="M20.1242 8.74902C20.5411 8.74902 21.0167 8.85184 21.3435 9.06184C21.6712 9.27184 21.8733 9.58466 21.8733 10.0633C21.8733 10.1285 21.8007 10.429 21.6572 10.7187C21.5137 11.0083 21.3094 11.3119 21.1204 11.5101C21.0416 11.5915 20.9979 11.7009 20.9979 11.8142V13.9999C20.9983 14.2414 21.1956 14.4366 21.4376 14.4357H25.8135V24.4991C25.8135 24.4991 25.8056 24.8448 25.6389 25.1773C25.4726 25.5106 25.1625 25.8143 24.4983 25.8143H14.4384V21.8741H16.0164C16.2737 22.0894 16.5953 22.2954 16.8923 22.4424C17.2515 22.6205 17.5836 22.7491 17.9358 22.7491C18.7723 22.7491 19.3362 22.3431 19.6727 21.8186C20.0095 21.2944 20.1255 20.674 20.1259 20.125C20.1259 19.5759 20.0095 18.9555 19.6731 18.4314C19.3362 17.9064 18.7723 17.5008 17.9358 17.5008C17.5836 17.5008 17.2515 17.6295 16.8923 17.8075C16.5953 17.9545 16.2737 18.1606 16.0164 18.3758H14.4384L14.4375 14.4366L18.8108 14.4357C18.8683 14.436 18.9253 14.4249 18.9785 14.4032C19.0318 14.3814 19.0802 14.3494 19.1211 14.309C19.162 14.2685 19.1945 14.2204 19.2167 14.1674C19.239 14.1143 19.2506 14.0574 19.2509 13.9999V11.8142C19.2509 11.7009 19.2063 11.591 19.128 11.5101C18.939 11.3119 18.7347 11.0083 18.5912 10.7187C18.4477 10.429 18.375 10.128 18.375 10.0633C18.375 9.58466 18.5772 9.27184 18.9044 9.0614C19.2317 8.85184 19.7072 8.74946 20.1242 8.74902Z"
        fill="white"
      />
      <path
        d="M13.5633 14.4368L13.5641 18.8118C13.5638 18.8693 13.5749 18.9263 13.5966 18.9796C13.6184 19.0328 13.6504 19.0812 13.6908 19.1221C13.7313 19.163 13.7794 19.1955 13.8325 19.2178C13.8855 19.24 13.9424 19.2516 13.9999 19.2519H16.1856C16.299 19.2519 16.4088 19.2073 16.4897 19.129C16.6879 18.94 16.9915 18.7357 17.2812 18.5922C17.5708 18.4487 17.8718 18.376 17.9365 18.376C18.4152 18.376 18.728 18.5782 18.9384 18.9054C19.148 19.2327 19.2504 19.7082 19.2508 20.1252C19.2508 20.5421 19.148 21.0177 18.938 21.3445C18.728 21.6722 18.4152 21.8743 17.9365 21.8743C17.8713 21.8743 17.5708 21.8017 17.2812 21.6582C16.9915 21.5147 16.6879 21.3104 16.4897 21.1214C16.408 21.0428 16.299 20.9989 16.1856 20.9989H13.9999C13.8838 20.9995 13.7727 21.0461 13.691 21.1285C13.6093 21.211 13.5637 21.3225 13.5641 21.4386V25.8145H3.50068C2.83655 25.8145 2.52636 25.5108 2.36011 25.1779C2.25772 24.9655 2.19839 24.7348 2.18555 24.4993V14.4376H6.1257V16.0157C5.90388 16.2853 5.71323 16.5792 5.55738 16.8916C5.37932 17.2512 5.25069 17.5829 5.25069 17.935C5.25069 18.7715 5.6567 19.3355 6.18126 19.6719C6.70539 20.0092 7.32577 20.1252 7.87484 20.1252C8.4239 20.1252 9.04428 20.0088 9.56841 19.6724C10.0934 19.3355 10.499 18.7715 10.499 17.9355C10.499 17.5829 10.3704 17.2512 10.1923 16.8916C10.0364 16.5792 9.8458 16.2853 9.62397 16.0157V14.4376L13.5633 14.4368Z"
        fill="white"
      />
    </svg>
  );
};

export const PublicAPIIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
    >
      <path
        d="M9.625 12.1745L14.875 17.4245V24.0625C14.875 24.1785 14.8289 24.2898 14.7469 24.3719C14.6648 24.4539 14.5535 24.5 14.4375 24.5H5.25C4.78587 24.5 4.34075 24.3156 4.01256 23.9874C3.68437 23.6592 3.5 23.2141 3.5 22.75V5.25C3.5 4.78587 3.68437 4.34075 4.01256 4.01256C4.34075 3.68437 4.78587 3.5 5.25 3.5H7.4375C7.55353 3.5 7.66481 3.54609 7.74686 3.62814C7.82891 3.71019 7.875 3.82147 7.875 3.9375V16.7759C7.29119 16.9823 6.79914 17.3885 6.48582 17.9226C6.1725 18.4567 6.05809 19.0844 6.1628 19.6947C6.26752 20.305 6.58461 20.8587 7.05805 21.2578C7.53148 21.6569 8.13077 21.8758 8.75 21.8758C9.36923 21.8758 9.96852 21.6569 10.442 21.2578C10.9154 20.8587 11.2325 20.305 11.3372 19.6947C11.4419 19.0844 11.3275 18.4567 11.0142 17.9226C10.7009 17.3885 10.2088 16.9823 9.625 16.7759V12.1745ZM8.75 20.125C8.92306 20.125 9.09223 20.0737 9.23612 19.9775C9.38002 19.8814 9.49217 19.7447 9.55839 19.5848C9.62462 19.425 9.64195 19.249 9.60819 19.0793C9.57443 18.9096 9.49109 18.7537 9.36872 18.6313C9.24635 18.5089 9.09044 18.4256 8.9207 18.3918C8.75097 18.3581 8.57504 18.3754 8.41515 18.4416C8.25527 18.5078 8.11861 18.62 8.02246 18.7639C7.92632 18.9078 7.875 19.0769 7.875 19.25C7.875 19.4821 7.96719 19.7046 8.13128 19.8687C8.29538 20.0328 8.51794 20.125 8.75 20.125ZM20.125 11.375C20.125 11.2019 20.0737 11.0328 19.9775 10.8889C19.8814 10.745 19.7447 10.6328 19.5848 10.5666C19.425 10.5004 19.249 10.4831 19.0793 10.5168C18.9096 10.5506 18.7537 10.6339 18.6313 10.7563C18.5089 10.8787 18.4256 11.0346 18.3918 11.2043C18.3581 11.374 18.3754 11.55 18.4416 11.7098C18.5078 11.8697 18.62 12.0064 18.7639 12.1025C18.9078 12.1987 19.0769 12.25 19.25 12.25C19.4821 12.25 19.7046 12.1578 19.8687 11.9937C20.0328 11.8296 20.125 11.6071 20.125 11.375ZM22.75 3.5H17.0625C16.9465 3.5 16.8352 3.54609 16.7531 3.62814C16.6711 3.71019 16.625 3.82147 16.625 3.9375V7.51297L18.1191 9.00703C18.6778 8.74009 19.313 8.67929 19.9122 8.83536C20.5115 8.99144 21.0363 9.35435 21.3938 9.85995C21.7514 10.3655 21.9187 10.9813 21.8662 11.5983C21.8136 12.2153 21.5447 12.7939 21.1068 13.2318C20.6689 13.6697 20.0903 13.9386 19.4733 13.9912C18.8563 14.0437 18.2405 13.8764 17.735 13.5188C17.2294 13.1613 16.8664 12.6365 16.7104 12.0372C16.5543 11.438 16.6151 10.8028 16.882 10.2441L15.132 8.49406C15.0506 8.41283 14.986 8.31634 14.9419 8.21012C14.8978 8.10389 14.8751 7.99002 14.875 7.875V3.9375C14.875 3.82147 14.8289 3.71019 14.7469 3.62814C14.6648 3.54609 14.5535 3.5 14.4375 3.5H10.0625C9.94647 3.5 9.83519 3.54609 9.75314 3.62814C9.67109 3.71019 9.625 3.82147 9.625 3.9375V9.70047L16.3691 16.4434C16.4503 16.5248 16.5147 16.6213 16.5586 16.7275C16.6025 16.8337 16.6251 16.9476 16.625 17.0625V24.0625C16.625 24.1785 16.6711 24.2898 16.7531 24.3719C16.8352 24.4539 16.9465 24.5 17.0625 24.5H22.75C23.2141 24.5 23.6592 24.3156 23.9874 23.9874C24.3156 23.6592 24.5 23.2141 24.5 22.75V5.25C24.5 4.78587 24.3156 4.34075 23.9874 4.01256C23.6592 3.68437 23.2141 3.5 22.75 3.5Z"
        fill="white"
      />
    </svg>
  );
};

export const WebIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.5556 3.43449C8.42921 4.05302 6.53877 5.29848 5.13125 7.00819C3.72374 8.7179 2.86458 10.8124 2.66602 13.018H7.69425C7.98574 9.66173 8.95885 6.40021 10.5541 3.43292L10.5556 3.43449ZM7.69425 14.9821H2.66602C2.86417 17.1878 3.72295 19.2825 5.1302 20.9925C6.53744 22.7025 8.4277 23.9483 10.5541 24.5672C8.95885 21.5999 7.98574 18.3384 7.69425 14.9821ZM13.0745 24.9867C11.1681 21.9658 10 18.5385 9.66468 14.9821H17.5763C17.241 18.5385 16.0729 21.9658 14.1665 24.9867C13.8027 25.0044 13.4383 25.0044 13.0745 24.9867ZM16.6885 24.5656C18.8146 23.9468 20.7047 22.7013 22.1119 20.9916C23.5192 19.2819 24.3781 17.1876 24.5765 14.9821H19.5483C19.2568 18.3384 18.2837 21.5999 16.6885 24.5672V24.5656ZM19.5483 13.018H24.5765C24.3784 10.8123 23.5196 8.71761 22.1124 7.00762C20.7051 5.29763 18.8148 4.05181 16.6885 3.43292C18.2837 6.40019 19.2568 9.66172 19.5483 13.018ZM13.0745 3.01338C13.4388 2.99554 13.8038 2.99554 14.1681 3.01338C16.0739 6.03442 17.2415 9.46179 17.5763 13.018H9.66626C10.0072 9.44009 11.1779 6.00989 13.0745 3.01338Z"
        fill="white"
      />
    </svg>
  );
};

export const GreyAlertIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M10.0016 -0.00317383C15.5256 -0.00317383 20.0036 4.47482 20.0036 9.99882C20.0036 15.5218 15.5256 19.9988 10.0016 19.9988C4.47759 19.9998 0.00158708 15.5218 0.00158708 9.99882C0.000587082 4.47482 4.47759 -0.00317383 10.0016 -0.00317383ZM9.99759 8.24682C9.75252 8.24716 9.5161 8.33747 9.33323 8.50062C9.15036 8.66376 9.03377 8.88838 9.00558 9.13182L8.99858 9.24782L9.00259 14.7498L9.00858 14.8658C9.03653 15.1097 9.15323 15.3348 9.33644 15.4983C9.51965 15.6617 9.75658 15.752 10.0021 15.752C10.2476 15.752 10.4845 15.6617 10.6677 15.4983C10.8509 15.3348 10.9676 15.1097 10.9956 14.8658L11.0016 14.7488L10.9976 9.24682L10.9906 9.12982C10.9617 8.88658 10.8445 8.66241 10.6613 8.49983C10.4781 8.33726 10.2415 8.24758 9.99658 8.24782L9.99759 8.24682ZM10.0026 4.49783C9.67067 4.49783 9.35234 4.62968 9.11764 4.86438C8.88294 5.09908 8.75109 5.41741 8.75109 5.74933C8.75109 6.08124 8.88294 6.39957 9.11764 6.63427C9.35234 6.86897 9.67067 7.00082 10.0026 7.00082C10.1669 7.00076 10.3295 6.96834 10.4813 6.90541C10.633 6.84248 10.7709 6.75027 10.887 6.63406C11.0031 6.51785 11.0952 6.3799 11.158 6.2281C11.2209 6.0763 11.2532 5.91361 11.2531 5.74933C11.253 5.58504 11.2206 5.42238 11.1577 5.27063C11.0947 5.11887 11.0025 4.981 10.8863 4.86488C10.7701 4.74876 10.6322 4.65667 10.4804 4.59386C10.3286 4.53105 10.1659 4.49876 10.0016 4.49883L10.0026 4.49783Z"
        fill="#616161"
      />
    </svg>
  );
};

export const WhiteInboundIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path d="M15.6 2.40002H3.59998V21H15.6V2.40002Z" fill="white" />
      <mask
        id="mask0_7552_19935"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect
          width="24"
          height="24"
          transform="matrix(-1 0 0 1 24 0)"
          fill="#D9D9D9"
        />
      </mask>
      <g mask="url(#mask0_7552_19935)">
        <path
          d="M15.6 7.20002V3.60002C15.6 2.93728 15.0627 2.40002 14.4 2.40002H4.79997C4.13723 2.40002 3.59998 2.93728 3.59998 3.60002V20.4C3.59998 21.0628 4.13723 21.6 4.79998 21.6H14.4C15.0627 21.6 15.6 21.0628 15.6 20.4V16.8"
          stroke="white"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.8 3.6H8.40005"
          stroke="#388E3C"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20.4 14.0002H9.20002"
          stroke="#388E3C"
          strokeWidth="4.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.4008 17.2001L9.20076 14.0001"
          stroke="#388E3C"
          strokeWidth="4.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.4008 10.8L9.20076 14"
          stroke="#388E3C"
          strokeWidth="4.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20.4 14.0002H9.20002"
          stroke="white"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.4008 17.2001L9.20076 14.0001"
          stroke="white"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.4008 10.8L9.20076 14"
          stroke="white"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

export const WhiteInboundSMSIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M3 7C2.4 7 2 7.4 2 8C2 8.6 2.4 9 3 9H5V7H3ZM2 11C1.4 11 1 11.4 1 12C1 12.6 1.4 13 2 13H5V11H2ZM1 15C0.4 15 0 15.4 0 16C0 16.6 0.4 17 1 17H5V15H1ZM20 5H9C7.9 5 7 5.9 7 7V21L11 17H20C21.1 17 22 16.1 22 15V7C22 5.9 21.1 5 20 5Z"
        fill="white"
      />
    </svg>
  );
};

export const WhiteOutboundSMSIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g clip-path="url(#clip0_6304_152025)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19 3C19.7956 3 20.5587 3.31607 21.1213 3.87868C21.6839 4.44129 22 5.20435 22 6V16C22 16.7956 21.6839 17.5587 21.1213 18.1213C20.5587 18.6839 19.7956 19 19 19H7.333L4 21.5C3.176 22.118 2 21.53 2 20.5V6C2 5.20435 2.31607 4.44129 2.87868 3.87868C3.44129 3.31607 4.20435 3 5 3H19ZM11 12H8C7.73478 12 7.48043 12.1054 7.29289 12.2929C7.10536 12.4804 7 12.7348 7 13C7 13.2652 7.10536 13.5196 7.29289 13.7071C7.48043 13.8946 7.73478 14 8 14H11C11.2652 14 11.5196 13.8946 11.7071 13.7071C11.8946 13.5196 12 13.2652 12 13C12 12.7348 11.8946 12.4804 11.7071 12.2929C11.5196 12.1054 11.2652 12 11 12ZM16 8H8C7.74512 8.00028 7.49997 8.09788 7.31463 8.27285C7.1293 8.44782 7.01777 8.68695 7.00283 8.94139C6.98789 9.19584 7.07067 9.44638 7.23426 9.64183C7.39786 9.83729 7.6299 9.9629 7.883 9.993L8 10H16C16.2549 9.99972 16.5 9.90212 16.6854 9.72715C16.8707 9.55218 16.9822 9.31305 16.9972 9.05861C17.0121 8.80416 16.9293 8.55362 16.7657 8.35817C16.6021 8.16271 16.3701 8.0371 16.117 8.007L16 8Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_6304_152025">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const VoicemailSentIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      height="24"
      viewBox="0 0 26 24"
      fill="none"
    >
      <path
        d="M8.1674 11.9999C8.1674 11.6817 8.29468 11.3764 8.52125 11.1514C8.74782 10.9264 9.05512 10.7999 9.37553 10.7999C9.69595 10.7999 10.0032 10.9264 10.2298 11.1514C10.4564 11.3764 10.5837 11.6817 10.5837 11.9999C10.5837 12.3182 10.4564 12.6234 10.2298 12.8485C10.0032 13.0735 9.69595 13.1999 9.37553 13.1999C9.05512 13.1999 8.74782 13.0735 8.52125 12.8485C8.29468 12.6234 8.1674 12.3182 8.1674 11.9999ZM16.6244 9.59993C17.0497 9.59991 17.4675 9.71142 17.8356 9.92318C18.2036 10.1349 18.5089 10.4394 18.7205 10.8059C20.1653 10.865 21.5509 11.3927 22.6651 12.3083V7.19993C22.6651 6.56341 22.4105 5.95296 21.9574 5.50287C21.5042 5.05278 20.8896 4.79993 20.2488 4.79993H5.75112C5.11028 4.79993 4.49569 5.05278 4.04255 5.50287C3.58941 5.95296 3.33484 6.56341 3.33484 7.19993V16.7999C3.33484 17.4364 3.58941 18.0469 4.04255 18.497C4.49569 18.9471 5.11028 19.1999 5.75112 19.1999H12.0419C11.8754 18.6142 11.7913 18.0085 11.7918 17.3999C11.791 16.4228 12.009 15.4577 12.43 14.5746C12.851 13.6915 13.4646 12.9124 14.2262 12.2939C14.1637 11.7762 14.2709 11.2523 14.5319 10.7999H11.468C11.734 11.2575 11.8405 11.7894 11.7711 12.3132C11.7016 12.837 11.4601 13.3234 11.084 13.697C10.7079 14.0706 10.2182 14.3104 9.69084 14.3794C9.16348 14.4484 8.62795 14.3425 8.16731 14.0784C7.70666 13.8142 7.34665 13.4064 7.14311 12.9183C6.93956 12.4302 6.90386 11.889 7.04154 11.3787C7.17922 10.8684 7.48258 10.4175 7.90458 10.0958C8.32658 9.77423 8.84363 9.59991 9.37553 9.59993H16.6244ZM18.4366 22.7999C19.8785 22.7999 21.2613 22.231 22.2809 21.2183C23.3004 20.2056 23.8732 18.8321 23.8732 17.3999C23.8732 15.9678 23.3004 14.5942 22.2809 13.5816C21.2613 12.5689 19.8785 11.9999 18.4366 11.9999C16.9947 11.9999 15.6119 12.5689 14.5923 13.5816C13.5727 14.5942 13 15.9678 13 17.3999C13 18.8321 13.5727 20.2056 14.5923 21.2183C15.6119 22.231 16.9947 22.7999 18.4366 22.7999ZM17.3541 15.1247L16.2704 16.1999H18.1345C19.0157 16.1999 19.8608 16.5476 20.4838 17.1665C21.1069 17.7853 21.4569 18.6247 21.4569 19.4999V19.7999C21.4569 19.9591 21.3933 20.1117 21.28 20.2242C21.1667 20.3367 21.0131 20.3999 20.8529 20.3999C20.6926 20.3999 20.539 20.3367 20.4257 20.2242C20.3124 20.1117 20.2488 19.9591 20.2488 19.7999V19.4999C20.2488 18.943 20.026 18.4088 19.6295 18.015C19.233 17.6212 18.6953 17.3999 18.1345 17.3999H16.2704L17.3541 18.4751C17.4675 18.5878 17.5312 18.7406 17.5312 18.8999C17.5312 19.0593 17.4675 19.2121 17.3541 19.3247C17.2407 19.4374 17.0868 19.5007 16.9264 19.5007C16.766 19.5007 16.6122 19.4374 16.4987 19.3247L14.3821 17.2211C14.2696 17.1085 14.2067 16.9562 14.2071 16.7976C14.2076 16.639 14.2714 16.4871 14.3845 16.3751L16.4987 14.2751C16.6122 14.1625 16.766 14.0992 16.9264 14.0992C17.0868 14.0992 17.2407 14.1625 17.3541 14.2751C17.4675 14.3878 17.5312 14.5406 17.5312 14.6999C17.5312 14.8593 17.4675 15.0121 17.3541 15.1247Z"
        fill="white"
      />
    </svg>
  );
};

export const WhiteEmailIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M19.9998 4.00012H3.99976C2.89976 4.00012 2.00976 4.90012 2.00976 6.00012L1.99976 18.0001C1.99976 19.1001 2.89976 20.0001 3.99976 20.0001H19.9998C21.0998 20.0001 21.9998 19.1001 21.9998 18.0001V6.00012C21.9998 4.90012 21.0998 4.00012 19.9998 4.00012ZM19.5998 8.25012L12.5298 12.6701C12.2098 12.8701 11.7898 12.8701 11.4698 12.6701L4.39976 8.25012C4.29948 8.19383 4.21167 8.11778 4.14164 8.02658C4.07161 7.93537 4.02082 7.8309 3.99233 7.71949C3.96384 7.60809 3.95826 7.49206 3.97591 7.37843C3.99357 7.2648 4.03409 7.15594 4.09504 7.05842C4.15598 6.96091 4.23608 6.87678 4.33048 6.81112C4.42488 6.74546 4.53163 6.69963 4.64425 6.67642C4.75688 6.65321 4.87304 6.65309 4.98571 6.67607C5.09838 6.69905 5.20522 6.74466 5.29976 6.81012L11.9998 11.0001L18.6998 6.81012C18.7943 6.74466 18.9011 6.69905 19.0138 6.67607C19.1265 6.65309 19.2426 6.65321 19.3553 6.67642C19.4679 6.69963 19.5746 6.74546 19.669 6.81112C19.7634 6.87678 19.8435 6.96091 19.9045 7.05842C19.9654 7.15594 20.0059 7.2648 20.0236 7.37843C20.0413 7.49206 20.0357 7.60809 20.0072 7.71949C19.9787 7.8309 19.9279 7.93537 19.8579 8.02658C19.7878 8.11778 19.7 8.19383 19.5998 8.25012Z"
        fill="white"
      />
    </svg>
  );
};

export const WhiteVideoIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M4.49958 4.71399C3.76076 4.71399 3.05221 5.00748 2.52978 5.52991C2.00736 6.05233 1.71387 6.76089 1.71387 7.4997V16.4997C1.71387 17.2385 2.00736 17.9471 2.52978 18.4695C3.05221 18.9919 3.76076 19.2854 4.49958 19.2854H12.6424C13.3813 19.2854 14.0898 18.9919 14.6122 18.4695C15.1347 17.9471 15.4282 17.2385 15.4282 16.4997V7.4997C15.4282 6.76089 15.1347 6.05233 14.6122 5.52991C14.0898 5.00748 13.3813 4.71399 12.6424 4.71399H4.49958ZM19.8193 17.6937L16.7139 14.6508V9.42828L19.8099 6.31856C20.4844 5.64142 21.6407 6.11885 21.6407 7.07456V16.9283C21.6407 17.878 20.4973 18.358 19.8193 17.6937Z"
        fill="white"
      />
    </svg>
  );
};

export const DeskLogIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M14.625 2.25H3.375C3.07663 2.25 2.79049 2.36853 2.57951 2.5795C2.36853 2.79048 2.25 3.07663 2.25 3.375V14.625C2.25 14.9234 2.36853 15.2095 2.57951 15.4205C2.79049 15.6315 3.07663 15.75 3.375 15.75H14.625C14.9234 15.75 15.2095 15.6315 15.4205 15.4205C15.6315 15.2095 15.75 14.9234 15.75 14.625V3.375C15.75 3.07663 15.6315 2.79048 15.4205 2.5795C15.2095 2.36853 14.9234 2.25 14.625 2.25ZM3.99656 5.31422C3.96346 5.24812 3.94371 5.17614 3.93845 5.10239C3.93318 5.02865 3.94251 4.9546 3.96588 4.88446C3.98926 4.81433 4.02624 4.74949 4.07469 4.69365C4.12315 4.63782 4.18214 4.59208 4.24828 4.55906L5.37328 3.99656C5.45907 3.95363 5.55442 3.93336 5.65025 3.93766C5.74609 3.94197 5.83923 3.97071 5.92082 4.02116C6.00241 4.07161 6.06975 4.14209 6.11643 4.2259C6.1631 4.30971 6.18757 4.40407 6.1875 4.5V7.875C6.1875 8.02418 6.12824 8.16726 6.02275 8.27275C5.91726 8.37824 5.77419 8.4375 5.625 8.4375C5.47582 8.4375 5.33274 8.37824 5.22725 8.27275C5.12177 8.16726 5.0625 8.02418 5.0625 7.875V5.40984L4.75172 5.56594C4.68562 5.59904 4.61364 5.61879 4.5399 5.62406C4.46615 5.62932 4.3921 5.62 4.32196 5.59662C4.25183 5.57324 4.18699 5.53626 4.13115 5.48781C4.07532 5.43935 4.02958 5.38036 3.99656 5.31422ZM6.46875 12.6562C6.61794 12.6562 6.76101 12.7155 6.8665 12.821C6.97199 12.9265 7.03125 13.0696 7.03125 13.2188C7.03125 13.3679 6.97199 13.511 6.8665 13.6165C6.76101 13.722 6.61794 13.7812 6.46875 13.7812H4.78125C4.67679 13.7812 4.57439 13.7522 4.48553 13.6972C4.39667 13.6423 4.32485 13.5637 4.27814 13.4703C4.23142 13.3769 4.21164 13.2723 4.22102 13.1682C4.23041 13.0642 4.26857 12.9648 4.33125 12.8812L5.85492 10.8499C5.88875 10.8026 5.90672 10.7457 5.90625 10.6875C5.90614 10.6212 5.88262 10.5571 5.83984 10.5065C5.79707 10.4558 5.73779 10.4219 5.67245 10.4108C5.60712 10.3996 5.53994 10.4118 5.48276 10.4454C5.42558 10.4789 5.38208 10.5315 5.35992 10.594C5.31013 10.7347 5.20649 10.8498 5.07179 10.9141C4.9371 10.9784 4.78238 10.9865 4.64168 10.9368C4.50098 10.887 4.38582 10.7833 4.32154 10.6486C4.25726 10.5139 4.24912 10.3592 4.29891 10.2185C4.36717 10.0291 4.47533 9.85647 4.61606 9.71243C4.7568 9.56839 4.92683 9.45626 5.11465 9.38362C5.30248 9.31098 5.50371 9.27952 5.70474 9.29139C5.90577 9.30325 6.10191 9.35815 6.27989 9.45238C6.45786 9.5466 6.61353 9.67795 6.73635 9.83755C6.85916 9.99714 6.94627 10.1812 6.99178 10.3774C7.03729 10.5736 7.04013 10.7772 7.00011 10.9746C6.9601 11.172 6.87816 11.3584 6.75985 11.5214L5.90625 12.6562H6.46875ZM13.5 12.9375H8.4375C8.28832 12.9375 8.14524 12.8782 8.03975 12.7727C7.93427 12.6673 7.875 12.5242 7.875 12.375C7.875 12.2258 7.93427 12.0827 8.03975 11.9773C8.14524 11.8718 8.28832 11.8125 8.4375 11.8125H13.5C13.6492 11.8125 13.7923 11.8718 13.8977 11.9773C14.0032 12.0827 14.0625 12.2258 14.0625 12.375C14.0625 12.5242 14.0032 12.6673 13.8977 12.7727C13.7923 12.8782 13.6492 12.9375 13.5 12.9375ZM13.5 9.5625H8.4375C8.28832 9.5625 8.14524 9.50324 8.03975 9.39775C7.93427 9.29226 7.875 9.14918 7.875 9C7.875 8.85082 7.93427 8.70774 8.03975 8.60225C8.14524 8.49676 8.28832 8.4375 8.4375 8.4375H13.5C13.6492 8.4375 13.7923 8.49676 13.8977 8.60225C14.0032 8.70774 14.0625 8.85082 14.0625 9C14.0625 9.14918 14.0032 9.29226 13.8977 9.39775C13.7923 9.50324 13.6492 9.5625 13.5 9.5625ZM13.5 6.1875H8.4375C8.28832 6.1875 8.14524 6.12824 8.03975 6.02275C7.93427 5.91726 7.875 5.77418 7.875 5.625C7.875 5.47582 7.93427 5.33274 8.03975 5.22725C8.14524 5.12176 8.28832 5.0625 8.4375 5.0625H13.5C13.6492 5.0625 13.7923 5.12176 13.8977 5.22725C14.0032 5.33274 14.0625 5.47582 14.0625 5.625C14.0625 5.77418 14.0032 5.91726 13.8977 6.02275C13.7923 6.12824 13.6492 6.1875 13.5 6.1875Z"
        fill="#424242"
      />
    </svg>
  );
};

export const NoOfMeetingIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
    >
      <path
        d="M10.7917 15.1654C10.7917 16.4545 9.7475 17.4987 8.45833 17.4987C7.16917 17.4987 6.125 16.4545 6.125 15.1654C6.125 13.8762 7.16917 12.832 8.45833 12.832C9.7475 12.832 10.7917 13.8762 10.7917 15.1654Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.45833 16.332C8.76775 16.332 9.0645 16.2091 9.28329 15.9903C9.50208 15.7715 9.625 15.4748 9.625 15.1654C9.625 14.8559 9.50208 14.5592 9.28329 14.3404C9.0645 14.1216 8.76775 13.9987 8.45833 13.9987C8.14891 13.9987 7.85217 14.1216 7.63338 14.3404C7.41458 14.5592 7.29167 14.8559 7.29167 15.1654C7.29167 15.4748 7.41458 15.7715 7.63338 15.9903C7.85217 16.2091 8.14891 16.332 8.45833 16.332ZM8.45833 17.4987C9.7475 17.4987 10.7917 16.4545 10.7917 15.1654C10.7917 13.8762 9.7475 12.832 8.45833 12.832C7.16917 12.832 6.125 13.8762 6.125 15.1654C6.125 16.4545 7.16917 17.4987 8.45833 17.4987Z"
        fill="white"
      />
      <path
        d="M3.5 21.3198C3.5 19.5558 6.80342 18.668 8.45833 18.668C10.1133 18.668 13.4167 19.5564 13.4167 21.3192V24.5013H3.5V21.3192V21.3198Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.8615 20.9914C4.67717 21.1734 4.66667 21.2778 4.66667 21.3198V23.3346H12.25V21.3192C12.25 21.2784 12.2395 21.1734 12.0552 20.9914C11.8603 20.7995 11.5389 20.5936 11.0985 20.4051C10.2118 20.0254 9.12917 19.8346 8.45833 19.8346C7.7875 19.8346 6.70425 20.0254 5.81817 20.4051C5.37775 20.5936 5.05633 20.7995 4.8615 20.9914ZM8.45833 18.668C6.80342 18.668 3.5 19.5564 3.5 21.3192V24.5013H13.4167V21.3192C13.4167 19.557 10.1133 18.668 8.45833 18.668Z"
        fill="white"
      />
      <path
        d="M21.8749 15.1654C21.8749 16.4545 20.8308 17.4987 19.5416 17.4987C18.2524 17.4987 17.2083 16.4545 17.2083 15.1654C17.2083 13.8762 18.2524 12.832 19.5416 12.832C20.8308 12.832 21.8749 13.8762 21.8749 15.1654Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.5416 16.332C19.851 16.332 20.1478 16.2091 20.3665 15.9903C20.5853 15.7715 20.7083 15.4748 20.7083 15.1654C20.7083 14.8559 20.5853 14.5592 20.3665 14.3404C20.1478 14.1216 19.851 13.9987 19.5416 13.9987C19.2322 13.9987 18.9354 14.1216 18.7166 14.3404C18.4978 14.5592 18.3749 14.8559 18.3749 15.1654C18.3749 15.4748 18.4978 15.7715 18.7166 15.9903C18.9354 16.2091 19.2322 16.332 19.5416 16.332ZM19.5416 17.4987C20.8308 17.4987 21.8749 16.4545 21.8749 15.1654C21.8749 13.8762 20.8308 12.832 19.5416 12.832C18.2524 12.832 17.2083 13.8762 17.2083 15.1654C17.2083 16.4545 18.2524 17.4987 19.5416 17.4987Z"
        fill="white"
      />
      <path
        d="M16.3334 14.0013C16.3334 15.2905 15.2892 16.3346 14.0001 16.3346C12.7109 16.3346 11.6667 15.2905 11.6667 14.0013C11.6667 12.7121 12.7109 11.668 14.0001 11.668C15.2892 11.668 16.3334 12.7121 16.3334 14.0013Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.0001 15.168C14.3095 15.168 14.6062 15.0451 14.825 14.8263C15.0438 14.6075 15.1667 14.3107 15.1667 14.0013C15.1667 13.6919 15.0438 13.3951 14.825 13.1763C14.6062 12.9576 14.3095 12.8346 14.0001 12.8346C13.6907 12.8346 13.3939 12.9576 13.1751 13.1763C12.9563 13.3951 12.8334 13.6919 12.8334 14.0013C12.8334 14.3107 12.9563 14.6075 13.1751 14.8263C13.3939 15.0451 13.6907 15.168 14.0001 15.168ZM14.0001 16.3346C15.2892 16.3346 16.3334 15.2905 16.3334 14.0013C16.3334 12.7121 15.2892 11.668 14.0001 11.668C12.7109 11.668 11.6667 12.7121 11.6667 14.0013C11.6667 15.2905 12.7109 16.3346 14.0001 16.3346Z"
        fill="white"
      />
      <path
        d="M13.4166 7.48592C13.4166 6.7382 13.1196 6.02112 12.5909 5.49241C12.0622 4.96369 11.3451 4.66667 10.5974 4.66667H8.74881C7.9839 4.66544 7.24915 4.96486 6.70297 5.50037C6.15679 6.03588 5.84294 6.76458 5.82909 7.52936C5.81524 8.29415 6.10249 9.03374 6.62892 9.58868C7.15535 10.1436 7.87877 10.4694 8.64322 10.4959L8.74997 10.5V11.6667C8.74997 11.6667 13.4166 10.9859 13.4166 7.48592ZM15.1666 6.55433C15.1666 5.74427 15.4884 4.96739 16.0612 4.39459C16.634 3.82179 17.4109 3.5 18.221 3.5H21.5833C22.3569 3.5 23.0987 3.80729 23.6457 4.35427C24.1927 4.90125 24.5 5.64312 24.5 6.41667C24.5 7.19021 24.1927 7.93208 23.6457 8.47906C23.0987 9.02604 22.3569 9.33333 21.5833 9.33333H20.4166V11.0833C20.4166 11.0833 15.1666 10.346 15.1666 6.55433ZM14.5833 21.3185C14.5833 19.5545 17.8867 18.6667 19.5416 18.6667C21.1966 18.6667 24.5 19.5551 24.5 21.3179V24.5H14.5833V21.3179V21.3185Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.9449 20.9901C15.7606 21.1721 15.7501 21.2765 15.7501 21.3185V23.3333H23.3334V21.3179C23.3334 21.2771 23.3229 21.1721 23.1386 20.9901C22.9437 20.7982 22.6223 20.5923 22.1819 20.4038C21.2952 20.0241 20.2126 19.8333 19.5417 19.8333C18.8709 19.8333 17.7877 20.0241 16.9016 20.4038C16.4612 20.5923 16.1397 20.7982 15.9449 20.9901ZM19.5417 18.6667C17.8868 18.6667 14.5834 19.5551 14.5834 21.3179V24.5H24.5001V21.3179C24.5001 19.5557 21.1967 18.6667 19.5417 18.6667ZM14.0001 20.1512C14.0001 19.173 12.9227 18.4637 11.6638 18.0262C12.3944 17.681 13.1921 17.5013 14.0001 17.5C14.8081 17.5013 15.6058 17.681 16.3363 18.0262C15.0775 18.4637 14.0001 19.173 14.0001 20.1512Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.0001 20.1513C14.0001 19.6304 14.3057 19.1853 14.7817 18.8172L14.864 18.756C15.2706 18.4608 15.7857 18.2175 16.3363 18.0268C15.7899 17.7692 15.2051 17.6027 14.605 17.5339C14.203 17.4887 13.7972 17.4887 13.3952 17.5339C12.7951 17.6025 12.2102 17.7688 11.6638 18.0262C12.2139 18.2175 12.7296 18.4608 13.1356 18.7554C13.1636 18.7758 13.191 18.7962 13.2178 18.8172C13.6944 19.1847 14.0001 19.6304 14.0001 20.1513Z"
        fill="white"
      />
    </svg>
  );
};

export const HandShakeIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="29"
      height="24"
      viewBox="0 0 29 24"
      fill="none"
    >
      <g clip-path="url(#clip0_6534_181671)">
        <path
          d="M14.6594 3.99375L10.1219 7.66875C9.36719 8.27812 9.22188 9.375 9.79375 10.1578C10.3984 10.9922 11.575 11.1562 12.3859 10.5234L17.0406 6.90469C17.3688 6.65156 17.8375 6.70781 18.0953 7.03594C18.3531 7.36406 18.2922 7.83281 17.9641 8.09062L16.9844 8.85L23.5 14.85V6H23.4672L23.2844 5.88281L19.8812 3.70312C19.1641 3.24375 18.325 3 17.4719 3C16.45 3 15.4562 3.35156 14.6594 3.99375ZM15.7281 9.825L13.3047 11.7094C11.8281 12.8625 9.68594 12.5625 8.57969 11.0437C7.53906 9.61406 7.80156 7.61719 9.175 6.50625L13.075 3.35156C12.5312 3.12187 11.9453 3.00469 11.35 3.00469C10.4688 3 9.61094 3.2625 8.875 3.75L5.5 6V16.5H6.82187L11.1063 20.4094C12.025 21.2484 13.4453 21.1828 14.2844 20.2641C14.5422 19.9781 14.7156 19.6453 14.8047 19.2984L15.6016 20.0297C16.5156 20.8687 17.9406 20.8078 18.7797 19.8937C18.9906 19.6641 19.1453 19.3969 19.2438 19.1203C20.1531 19.7297 21.3906 19.6031 22.1547 18.7687C22.9937 17.8547 22.9328 16.4297 22.0187 15.5906L15.7281 9.825ZM0.25 6C-0.1625 6 -0.5 6.3375 -0.5 6.75V16.5C-0.5 17.3297 0.170312 18 1 18H2.5C3.32969 18 4 17.3297 4 16.5V6H0.25ZM1.75 15C1.94891 15 2.13968 15.079 2.28033 15.2197C2.42098 15.3603 2.5 15.5511 2.5 15.75C2.5 15.9489 2.42098 16.1397 2.28033 16.2803C2.13968 16.421 1.94891 16.5 1.75 16.5C1.55109 16.5 1.36032 16.421 1.21967 16.2803C1.07902 16.1397 1 15.9489 1 15.75C1 15.5511 1.07902 15.3603 1.21967 15.2197C1.36032 15.079 1.55109 15 1.75 15ZM25 6V16.5C25 17.3297 25.6703 18 26.5 18H28C28.8297 18 29.5 17.3297 29.5 16.5V6.75C29.5 6.3375 29.1625 6 28.75 6H25ZM26.5 15.75C26.5 15.5511 26.579 15.3603 26.7197 15.2197C26.8603 15.079 27.0511 15 27.25 15C27.4489 15 27.6397 15.079 27.7803 15.2197C27.921 15.3603 28 15.5511 28 15.75C28 15.9489 27.921 16.1397 27.7803 16.2803C27.6397 16.421 27.4489 16.5 27.25 16.5C27.0511 16.5 26.8603 16.421 26.7197 16.2803C26.579 16.1397 26.5 15.9489 26.5 15.75Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_6534_181671">
          <rect
            width="30"
            height="24"
            fill="white"
            transform="translate(-0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const RefreshIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M5.05016 14.95C4.95465 14.8578 4.87847 14.7474 4.82606 14.6254C4.77365 14.5034 4.74606 14.3722 4.74491 14.2394C4.74376 14.1066 4.76906 13.9749 4.81934 13.852C4.86962 13.7291 4.94387 13.6175 5.03777 13.5236C5.13166 13.4297 5.24331 13.3555 5.36621 13.3052C5.4891 13.2549 5.62078 13.2296 5.75356 13.2307C5.88634 13.2319 6.01756 13.2595 6.13957 13.3119C6.26157 13.3643 6.37191 13.4405 6.46416 13.536C7.16343 14.2355 8.05443 14.7118 9.02445 14.9048C9.99448 15.0978 11 14.9988 11.9137 14.6203C12.8275 14.2418 13.6084 13.6008 14.1578 12.7783C14.7072 11.9559 15.0003 10.989 15.0002 10C15.0002 9.73478 15.1055 9.48043 15.2931 9.29289C15.4806 9.10536 15.7349 9 16.0002 9C16.2654 9 16.5197 9.10536 16.7073 9.29289C16.8948 9.48043 17.0002 9.73478 17.0002 10C17.0003 11.3845 16.5898 12.738 15.8206 13.8893C15.0514 15.0405 13.9582 15.9378 12.679 16.4676C11.3999 16.9975 9.99232 17.1361 8.63439 16.866C7.27646 16.5958 6.02913 15.9291 5.05016 14.95Z"
        fill="black"
      />
      <path
        d="M13.559 12.8321C13.4498 12.905 13.3272 12.9557 13.1984 12.9812C13.0696 13.0067 12.937 13.0066 12.8082 12.9809C12.6794 12.9552 12.5569 12.9043 12.4478 12.8313C12.3386 12.7582 12.2449 12.6644 12.172 12.5551C12.0248 12.3345 11.9713 12.0644 12.0233 11.8043C12.0752 11.5441 12.2284 11.3153 12.449 11.1681L15.449 9.16812C15.5583 9.09524 15.6808 9.04459 15.8097 9.01907C15.9385 8.99354 16.0711 8.99365 16.1999 9.01937C16.3287 9.04509 16.4512 9.09593 16.5603 9.16898C16.6695 9.24203 16.7632 9.33586 16.836 9.44512C16.9089 9.55438 16.9596 9.67693 16.9851 9.80576C17.0106 9.9346 17.0105 10.0672 16.9848 10.196C16.9591 10.3248 16.9082 10.4473 16.8352 10.5564C16.7621 10.6656 16.6683 10.7592 16.559 10.8321L13.559 12.8321Z"
        fill="black"
      />
      <path
        d="M18.8322 12.4453C18.9794 12.6659 19.0329 12.936 18.981 13.1962C18.929 13.4563 18.7759 13.6851 18.5552 13.8323C18.3346 13.9795 18.0645 14.033 17.8044 13.981C17.5442 13.9291 17.3154 13.776 17.1682 13.5553L15.1682 10.5553C15.0953 10.446 15.0447 10.3235 15.0192 10.1947C14.9936 10.0658 14.9937 9.93322 15.0195 9.80442C15.0714 9.54431 15.2246 9.31549 15.4452 9.16829C15.6659 9.02109 15.936 8.96759 16.1961 9.01953C16.4562 9.07148 16.685 9.22463 16.8322 9.44529L18.8322 12.4453ZM14.8572 4.85129C14.9527 4.94354 15.0289 5.05388 15.0813 5.17589C15.1337 5.29789 15.1613 5.42911 15.1625 5.56189C15.1636 5.69467 15.1383 5.82635 15.088 5.94924C15.0378 6.07214 14.9635 6.18379 14.8696 6.27768C14.7757 6.37158 14.6641 6.44583 14.5412 6.49611C14.4183 6.54639 14.2866 6.57169 14.1538 6.57054C14.021 6.56939 13.8898 6.5418 13.7678 6.48939C13.6458 6.43698 13.5355 6.3608 13.4432 6.26529C12.744 5.56584 11.853 5.08948 10.8829 4.89648C9.91291 4.70348 8.90743 4.8025 7.99368 5.18101C7.07994 5.55953 6.29898 6.20053 5.74958 7.02295C5.20019 7.84537 4.90704 8.81225 4.90723 9.80129C4.90723 10.0665 4.80187 10.3209 4.61433 10.5084C4.4268 10.6959 4.17244 10.8013 3.90723 10.8013C3.64201 10.8013 3.38766 10.6959 3.20012 10.5084C3.01258 10.3209 2.90723 10.0665 2.90723 9.80129C2.90713 8.41675 3.31762 7.06327 4.08678 5.91203C4.85594 4.7608 5.94923 3.86351 7.22837 3.33366C8.50752 2.8038 9.91506 2.66518 11.273 2.93532C12.6309 3.20545 13.8783 3.87222 14.8572 4.85129Z"
        fill="black"
      />
      <path
        d="M6.3492 6.96891C6.56986 6.82171 6.83996 6.76821 7.10007 6.82015C7.36019 6.8721 7.58901 7.02525 7.7362 7.24591C7.8834 7.46657 7.93691 7.73667 7.88496 7.99678C7.83301 8.25689 7.67986 8.48572 7.4592 8.63291L4.4582 10.6329C4.34895 10.7058 4.2264 10.7564 4.09757 10.782C3.96873 10.8075 3.83613 10.8074 3.70734 10.7817C3.57854 10.7559 3.45607 10.7051 3.34693 10.6321C3.23778 10.559 3.14409 10.4652 3.0712 10.3559C2.92401 10.1352 2.8705 9.86515 2.92245 9.60504C2.9744 9.34493 3.12754 9.1161 3.3482 8.96891L6.3492 6.96891Z"
        fill="black"
      />
      <path
        d="M1.07511 7.35591C1.00222 7.24665 0.951574 7.1241 0.92605 6.99527C0.900526 6.86643 0.900628 6.73383 0.92635 6.60504C0.952072 6.47624 1.00291 6.35377 1.07596 6.24463C1.14901 6.13548 1.24285 6.04179 1.35211 5.96891C1.46137 5.89602 1.58391 5.84537 1.71275 5.81985C1.84158 5.79432 1.97418 5.79443 2.10298 5.82015C2.23177 5.84587 2.35424 5.89671 2.46339 5.96976C2.57253 6.04281 2.66622 6.13665 2.73911 6.24591L4.73911 9.24591C4.81199 9.35517 4.86264 9.47771 4.88816 9.60655C4.91369 9.73538 4.91359 9.86798 4.88786 9.99677C4.86214 10.1256 4.8113 10.248 4.73825 10.3572C4.6652 10.4663 4.57137 10.56 4.46211 10.6329C4.35285 10.7058 4.2303 10.7564 4.10147 10.782C3.97263 10.8075 3.84003 10.8074 3.71124 10.7817C3.58244 10.7559 3.45998 10.7051 3.35083 10.6321C3.24168 10.559 3.14799 10.4652 3.07511 10.3559L1.07511 7.35591Z"
        fill="black"
      />
    </svg>
  );
};

export const StepsIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M4.44445 12.4444C4.6963 12.4444 4.90756 12.3591 5.07822 12.1884C5.24889 12.0178 5.33393 11.8068 5.33333 11.5556C5.33333 11.3037 5.248 11.0924 5.07733 10.9218C4.90667 10.7511 4.6957 10.6661 4.44445 10.6667C4.19259 10.6667 3.98133 10.752 3.81067 10.9227C3.64 11.0933 3.55496 11.3043 3.55556 11.5556C3.55556 11.8074 3.64089 12.0187 3.81156 12.1893C3.98222 12.36 4.19319 12.445 4.44445 12.4444ZM4.44445 8.88889C4.6963 8.88889 4.90756 8.80356 5.07822 8.63289C5.24889 8.46222 5.33393 8.25126 5.33333 8C5.33333 7.74815 5.248 7.53689 5.07733 7.36622C4.90667 7.19556 4.6957 7.11052 4.44445 7.11111C4.19259 7.11111 3.98133 7.19644 3.81067 7.36711C3.64 7.53778 3.55496 7.74874 3.55556 8C3.55556 8.25185 3.64089 8.46311 3.81156 8.63378C3.98222 8.80444 4.19319 8.88948 4.44445 8.88889ZM4.44445 5.33333C4.6963 5.33333 4.90756 5.248 5.07822 5.07733C5.24889 4.90667 5.33393 4.6957 5.33333 4.44445C5.33333 4.19259 5.248 3.98133 5.07733 3.81067C4.90667 3.64 4.6957 3.55496 4.44445 3.55556C4.19259 3.55556 3.98133 3.64089 3.81067 3.81156C3.64 3.98222 3.55496 4.19319 3.55556 4.44445C3.55556 4.6963 3.64089 4.90756 3.81156 5.07822C3.98222 5.24889 4.19319 5.33393 4.44445 5.33333ZM7.11111 12.4444H12.4444V10.6667H7.11111V12.4444ZM7.11111 8.88889H12.4444V7.11111H7.11111V8.88889ZM7.11111 5.33333H12.4444V3.55556H7.11111V5.33333ZM1.77778 16C1.28889 16 0.870223 15.8258 0.521779 15.4773C0.173335 15.1289 -0.000591083 14.7105 1.50915e-06 14.2222V1.77778C1.50915e-06 1.28889 0.174224 0.870223 0.522668 0.521779C0.871112 0.173335 1.28948 -0.000591083 1.77778 1.50915e-06H14.2222C14.7111 1.50915e-06 15.1298 0.174224 15.4782 0.522668C15.8267 0.871112 16.0006 1.28948 16 1.77778V14.2222C16 14.7111 15.8258 15.1298 15.4773 15.4782C15.1289 15.8267 14.7105 16.0006 14.2222 16H1.77778Z"
        fill="#424242"
      />
    </svg>
  );
};

export const LedgerIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="18"
      viewBox="0 0 15 18"
      fill="none"
    >
      <path
        d="M12.6 -2.20305e-06C13.0774 -2.28652e-06 13.5352 0.18964 13.8728 0.527205C14.2104 0.864771 14.4 1.32261 14.4 1.8L14.4 16.2C14.4 16.6774 14.2104 17.1352 13.8728 17.4728C13.5352 17.8104 13.0774 18 12.6 18L1.8 18C1.32261 18 0.864776 17.8104 0.527211 17.4728C0.189645 17.1352 2.91597e-06 16.6774 2.8325e-06 16.2L3.14722e-07 1.8C2.31253e-07 1.32261 0.189642 0.864773 0.527208 0.527208C0.864773 0.189642 1.32261 -2.31253e-07 1.8 -3.14722e-07L12.6 -2.20305e-06ZM7.2 9.9L4.5 9.9C4.26131 9.9 4.03239 9.99482 3.86361 10.1636C3.69482 10.3324 3.6 10.5613 3.6 10.8C3.6 11.0387 3.69482 11.2676 3.86361 11.4364C4.03239 11.6052 4.26131 11.7 4.5 11.7L7.2 11.7C7.4387 11.7 7.66762 11.6052 7.8364 11.4364C8.00518 11.2676 8.1 11.0387 8.1 10.8C8.1 10.5613 8.00518 10.3324 7.8364 10.1636C7.66762 9.99482 7.4387 9.9 7.2 9.9ZM9.9 5.4L4.5 5.4C4.27061 5.40025 4.04997 5.48809 3.88317 5.64556C3.71637 5.80303 3.61599 6.01826 3.60255 6.24725C3.5891 6.47625 3.66361 6.70174 3.81084 6.87765C3.95807 7.05356 4.16692 7.16661 4.3947 7.1937L4.5 7.2L9.9 7.2C10.1294 7.19974 10.35 7.11191 10.5168 6.95443C10.6836 6.79696 10.784 6.58174 10.7975 6.35274C10.8109 6.12374 10.7364 5.89826 10.5892 5.72235C10.4419 5.54644 10.2331 5.43339 10.0053 5.4063L9.9 5.4Z"
        fill="#424242"
      />
    </svg>
  );
};

export const SimplePersonVector = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="17"
      viewBox="0 0 18 17"
      fill="none"
    >
      <path
        d="M3.64578 13.1346C4.51745 12.5302 5.38218 12.0664 6.23997 11.7433C7.09776 11.4203 8.01877 11.2587 9.00301 11.2587C9.98725 11.2587 10.9125 11.4215 11.7789 11.7472C12.6452 12.0728 13.5112 12.5353 14.3767 13.1346C14.9812 12.3813 15.4094 11.6303 15.6614 10.8815C15.9134 10.1327 16.0393 9.33948 16.0393 8.50194C16.0393 6.50384 15.3659 4.83123 14.0189 3.4841C12.672 2.13699 10.9996 1.46344 9.00172 1.46344C7.00386 1.46344 5.33116 2.13699 3.98364 3.4841C2.63611 4.83123 1.96234 6.50384 1.96234 8.50194C1.96234 9.3392 2.09101 10.1318 2.34834 10.8798C2.60569 11.6278 3.03817 12.3794 3.64578 13.1346ZM8.99697 9.16181C8.18351 9.16181 7.50011 8.88372 6.94678 8.32754C6.39345 7.77138 6.11678 7.08765 6.11678 6.27637C6.11678 5.4651 6.39474 4.78183 6.95066 4.22658C7.50657 3.67132 8.19126 3.39369 9.00472 3.39369C9.81818 3.39369 10.5016 3.67261 11.0549 4.23046C11.6082 4.78829 11.8849 5.47285 11.8849 6.28413C11.8849 7.0954 11.6069 7.77783 11.051 8.33142C10.4951 8.88501 9.81043 9.16181 8.99697 9.16181ZM9.00768 16.9598C7.84762 16.9598 6.75337 16.7381 5.72491 16.2946C4.69645 15.8512 3.79742 15.2447 3.02782 14.4752C2.25824 13.7057 1.6517 12.8082 1.2082 11.7828C0.764712 10.7574 0.542969 9.66183 0.542969 8.49598C0.542969 7.33388 0.765038 6.24106 1.20918 5.21752C1.65332 4.19397 2.25967 3.2979 3.02824 2.52933C3.79681 1.76076 4.69387 1.15358 5.71943 0.707771C6.74497 0.261966 7.84076 0.0390625 9.0068 0.0390625C10.1689 0.0390625 11.2617 0.261966 12.2853 0.707771C13.3088 1.15358 14.2049 1.76076 14.9734 2.52933C15.742 3.2979 16.3492 4.19433 16.795 5.21861C17.2408 6.24287 17.4637 7.33504 17.4637 8.4951C17.4637 9.65516 17.2408 10.7496 16.795 11.7784C16.3492 12.8073 15.742 13.706 14.9734 14.4745C14.2049 15.2431 13.3085 15.8495 12.2842 16.2936C11.2599 16.7377 10.1677 16.9598 9.00768 16.9598ZM9.00084 15.5404C9.75477 15.5404 10.488 15.4326 11.2006 15.2171C11.9131 15.0015 12.6236 14.6209 13.3319 14.0753C12.6203 13.5786 11.9063 13.2025 11.1902 12.9469C10.474 12.6913 9.74421 12.5635 9.00084 12.5635C8.25748 12.5635 7.52854 12.6913 6.81403 12.9469C6.0995 13.2025 5.38641 13.5786 4.67476 14.0753C5.38309 14.6209 6.09271 15.0015 6.80361 15.2171C7.5145 15.4326 8.24691 15.5404 9.00084 15.5404ZM9.00084 7.85202C9.46266 7.85202 9.8405 7.70604 10.1343 7.41408C10.4282 7.12211 10.5751 6.74417 10.5751 6.28025C10.5751 5.81633 10.4282 5.43756 10.1343 5.14392C9.8405 4.85029 9.46266 4.70348 9.00084 4.70348C8.53902 4.70348 8.16119 4.85029 7.86734 5.14392C7.5735 5.43756 7.42657 5.81633 7.42657 6.28025C7.42657 6.74417 7.5735 7.12211 7.86734 7.41408C8.16119 7.70604 8.53902 7.85202 9.00084 7.85202Z"
        fill="#616161"
      />
    </svg>
  );
};

export const SimpleMsgVector = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
    >
      <path
        d="M6.37435 9.60156C6.61046 9.60156 6.80838 9.5217 6.9681 9.36198C7.12782 9.20226 7.20768 9.00434 7.20768 8.76823C7.20768 8.53212 7.12782 8.3342 6.9681 8.17448C6.80838 8.01476 6.61046 7.9349 6.37435 7.9349C6.13824 7.9349 5.94032 8.01476 5.7806 8.17448C5.62088 8.3342 5.54102 8.53212 5.54102 8.76823C5.54102 9.00434 5.62088 9.20226 5.7806 9.36198C5.94032 9.5217 6.13824 9.60156 6.37435 9.60156ZM10.0618 9.60156C10.298 9.60156 10.4959 9.5217 10.6556 9.36198C10.8153 9.20226 10.8952 9.00434 10.8952 8.76823C10.8952 8.53212 10.8153 8.3342 10.6556 8.17448C10.4959 8.01476 10.298 7.9349 10.0618 7.9349C9.82574 7.9349 9.62782 8.01476 9.4681 8.17448C9.30838 8.3342 9.22852 8.53212 9.22852 8.76823C9.22852 9.00434 9.30838 9.20226 9.4681 9.36198C9.62782 9.5217 9.82574 9.60156 10.0618 9.60156ZM13.6035 9.60156C13.8396 9.60156 14.0375 9.5217 14.1973 9.36198C14.357 9.20226 14.4368 9.00434 14.4368 8.76823C14.4368 8.53212 14.357 8.3342 14.1973 8.17448C14.0375 8.01476 13.8396 7.9349 13.6035 7.9349C13.3674 7.9349 13.1695 8.01476 13.0098 8.17448C12.85 8.3342 12.7702 8.53212 12.7702 8.76823C12.7702 9.00434 12.85 9.20226 13.0098 9.36198C13.1695 9.5217 13.3674 9.60156 13.6035 9.60156ZM4.99935 15.4974L2.72852 17.7682C2.53407 17.9627 2.30838 18.0067 2.05143 17.9004C1.79449 17.7941 1.66602 17.6042 1.66602 17.3307V3.41406C1.66602 3.08073 1.79102 2.78906 2.04102 2.53906C2.29102 2.28906 2.58268 2.16406 2.91602 2.16406H17.0827C17.416 2.16406 17.7077 2.28906 17.9577 2.53906C18.2077 2.78906 18.3327 3.08073 18.3327 3.41406V14.2474C18.3327 14.5807 18.2077 14.8724 17.9577 15.1224C17.7077 15.3724 17.416 15.4974 17.0827 15.4974H4.99935ZM2.91602 14.2474H17.0827V3.41406H2.91602V14.2474Z"
        fill="#616161"
      />
    </svg>
  );
};

export const SimpleCalendarVector = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
    >
      <path
        d="M1.75 16.8307C1.41667 16.8307 1.125 16.7057 0.875 16.4557C0.625 16.2057 0.5 15.9141 0.5 15.5807V2.66406C0.5 2.33073 0.625 2.03906 0.875 1.78906C1.125 1.53906 1.41667 1.41406 1.75 1.41406H3.10417V0.830729C3.10417 0.64184 3.16806 0.483507 3.29583 0.355729C3.42361 0.227952 3.58194 0.164062 3.77083 0.164062C3.96563 0.164062 4.12891 0.227952 4.26069 0.355729C4.39245 0.483507 4.45833 0.64184 4.45833 0.830729V1.41406H11.5417V0.830729C11.5417 0.64184 11.6056 0.483507 11.7333 0.355729C11.8611 0.227952 12.0194 0.164062 12.2083 0.164062C12.4031 0.164062 12.5664 0.227952 12.6982 0.355729C12.83 0.483507 12.8958 0.64184 12.8958 0.830729V1.41406H14.25C14.5833 1.41406 14.875 1.53906 15.125 1.78906C15.375 2.03906 15.5 2.33073 15.5 2.66406V15.5807C15.5 15.9141 15.375 16.2057 15.125 16.4557C14.875 16.7057 14.5833 16.8307 14.25 16.8307H1.75ZM1.75 15.5807H14.25V6.6224H1.75V15.5807ZM1.75 5.3724H14.25V2.66406H1.75V5.3724ZM8 10.1641C7.76389 10.1641 7.56597 10.0842 7.40625 9.92448C7.24653 9.76476 7.16667 9.56684 7.16667 9.33073C7.16667 9.09462 7.24653 8.8967 7.40625 8.73698C7.56597 8.57726 7.76389 8.4974 8 8.4974C8.23611 8.4974 8.43403 8.57726 8.59375 8.73698C8.75347 8.8967 8.83333 9.09462 8.83333 9.33073C8.83333 9.56684 8.75347 9.76476 8.59375 9.92448C8.43403 10.0842 8.23611 10.1641 8 10.1641ZM4.66667 10.1641C4.43056 10.1641 4.23264 10.0842 4.07292 9.92448C3.91319 9.76476 3.83333 9.56684 3.83333 9.33073C3.83333 9.09462 3.91319 8.8967 4.07292 8.73698C4.23264 8.57726 4.43056 8.4974 4.66667 8.4974C4.90278 8.4974 5.10069 8.57726 5.26042 8.73698C5.42014 8.8967 5.5 9.09462 5.5 9.33073C5.5 9.56684 5.42014 9.76476 5.26042 9.92448C5.10069 10.0842 4.90278 10.1641 4.66667 10.1641ZM11.3333 10.1641C11.0972 10.1641 10.8993 10.0842 10.7396 9.92448C10.5799 9.76476 10.5 9.56684 10.5 9.33073C10.5 9.09462 10.5799 8.8967 10.7396 8.73698C10.8993 8.57726 11.0972 8.4974 11.3333 8.4974C11.5694 8.4974 11.7674 8.57726 11.9271 8.73698C12.0868 8.8967 12.1667 9.09462 12.1667 9.33073C12.1667 9.56684 12.0868 9.76476 11.9271 9.92448C11.7674 10.0842 11.5694 10.1641 11.3333 10.1641ZM8 13.4974C7.76389 13.4974 7.56597 13.4175 7.40625 13.2578C7.24653 13.0981 7.16667 12.9002 7.16667 12.6641C7.16667 12.428 7.24653 12.23 7.40625 12.0703C7.56597 11.9106 7.76389 11.8307 8 11.8307C8.23611 11.8307 8.43403 11.9106 8.59375 12.0703C8.75347 12.23 8.83333 12.428 8.83333 12.6641C8.83333 12.9002 8.75347 13.0981 8.59375 13.2578C8.43403 13.4175 8.23611 13.4974 8 13.4974ZM4.66667 13.4974C4.43056 13.4974 4.23264 13.4175 4.07292 13.2578C3.91319 13.0981 3.83333 12.9002 3.83333 12.6641C3.83333 12.428 3.91319 12.23 4.07292 12.0703C4.23264 11.9106 4.43056 11.8307 4.66667 11.8307C4.90278 11.8307 5.10069 11.9106 5.26042 12.0703C5.42014 12.23 5.5 12.428 5.5 12.6641C5.5 12.9002 5.42014 13.0981 5.26042 13.2578C5.10069 13.4175 4.90278 13.4974 4.66667 13.4974ZM11.3333 13.4974C11.0972 13.4974 10.8993 13.4175 10.7396 13.2578C10.5799 13.0981 10.5 12.9002 10.5 12.6641C10.5 12.428 10.5799 12.23 10.7396 12.0703C10.8993 11.9106 11.0972 11.8307 11.3333 11.8307C11.5694 11.8307 11.7674 11.9106 11.9271 12.0703C12.0868 12.23 12.1667 12.428 12.1667 12.6641C12.1667 12.9002 12.0868 13.0981 11.9271 13.2578C11.7674 13.4175 11.5694 13.4974 11.3333 13.4974Z"
        fill="#616161"
      />
    </svg>
  );
};

export const SimpleClockVector = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
    >
      <path
        d="M10.6868 10.2474V6.6849C10.6868 6.50434 10.6278 6.35503 10.5098 6.23698C10.3917 6.11892 10.2424 6.0599 10.0618 6.0599C9.88129 6.0599 9.73199 6.11892 9.61393 6.23698C9.49588 6.35503 9.43685 6.50434 9.43685 6.6849V10.4974C9.43685 10.5807 9.45074 10.6571 9.47852 10.7266C9.50629 10.796 9.54796 10.8655 9.60352 10.9349L12.6035 14.0391C12.7285 14.178 12.8848 14.2439 13.0723 14.237C13.2598 14.23 13.416 14.1641 13.541 14.0391C13.666 13.9141 13.7285 13.7613 13.7285 13.5807C13.7285 13.4002 13.666 13.2474 13.541 13.1224L10.6868 10.2474ZM9.99935 18.8307C8.86046 18.8307 7.78407 18.612 6.77018 18.1745C5.75629 17.737 4.87088 17.1398 4.11393 16.3828C3.35699 15.6259 2.75977 14.7405 2.32227 13.7266C1.88477 12.7127 1.66602 11.6363 1.66602 10.4974C1.66602 9.35851 1.88477 8.28212 2.32227 7.26823C2.75977 6.25434 3.35699 5.36892 4.11393 4.61198C4.87088 3.85503 5.75629 3.25781 6.77018 2.82031C7.78407 2.38281 8.86046 2.16406 9.99935 2.16406C11.1382 2.16406 12.2146 2.38281 13.2285 2.82031C14.2424 3.25781 15.1278 3.85503 15.8848 4.61198C16.6417 5.36892 17.2389 6.25434 17.6764 7.26823C18.1139 8.28212 18.3327 9.35851 18.3327 10.4974C18.3327 11.6363 18.1139 12.7127 17.6764 13.7266C17.2389 14.7405 16.6417 15.6259 15.8848 16.3828C15.1278 17.1398 14.2424 17.737 13.2285 18.1745C12.2146 18.612 11.1382 18.8307 9.99935 18.8307ZM9.99935 17.5807C11.9438 17.5807 13.6105 16.8863 14.9993 15.4974C16.3882 14.1085 17.0827 12.4418 17.0827 10.4974C17.0827 8.55295 16.3882 6.88628 14.9993 5.4974C13.6105 4.10851 11.9438 3.41406 9.99935 3.41406C8.0549 3.41406 6.38824 4.10851 4.99935 5.4974C3.61046 6.88628 2.91602 8.55295 2.91602 10.4974C2.91602 12.4418 3.61046 14.1085 4.99935 15.4974C6.38824 16.8863 8.0549 17.5807 9.99935 17.5807Z"
        fill="#616161"
      />
    </svg>
  );
};

export const DashedClockIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M9.56328 8.77188L11.8695 11.0781C11.982 11.1906 12.0383 11.3219 12.0383 11.4719C12.0383 11.6219 11.982 11.7531 11.8695 11.8656C11.757 11.9781 11.6258 12.0344 11.4758 12.0344C11.3258 12.0344 11.1945 11.9781 11.082 11.8656L8.60703 9.39063C8.54453 9.32813 8.50078 9.26563 8.47578 9.20313C8.45078 9.14063 8.43828 9.07188 8.43828 8.99688V5.99688C8.43828 5.83438 8.49141 5.7 8.59766 5.59375C8.70391 5.4875 8.83828 5.43438 9.00078 5.43438C9.16328 5.43438 9.29766 5.4875 9.40391 5.59375C9.51016 5.7 9.56328 5.83438 9.56328 5.99688V8.77188ZM2.19453 12.2406C2.00703 11.8156 1.85703 11.3781 1.74453 10.9281C1.63203 10.4781 1.55703 10.0219 1.51953 9.55938H2.64453C2.66953 9.92188 2.73203 10.2812 2.83203 10.6375C2.93203 10.9938 3.05078 11.3406 3.18828 11.6781L2.19453 12.2406ZM1.51953 8.43438C1.55703 7.95938 1.63203 7.49688 1.74453 7.04688C1.85703 6.59688 2.01328 6.15938 2.21328 5.73438L3.18828 6.29688C3.03828 6.63438 2.91641 6.98438 2.82266 7.34688C2.72891 7.70938 2.66953 8.07188 2.64453 8.43438H1.51953ZM4.76328 15.2406C4.36328 14.9656 3.99141 14.6594 3.64766 14.3219C3.30391 13.9844 3.00078 13.6156 2.73828 13.2156L3.73203 12.6531C3.94453 12.9656 4.18516 13.2563 4.45391 13.525C4.72266 13.7938 5.01328 14.0344 5.32578 14.2469L4.76328 15.2406ZM3.73203 5.32188L2.75703 4.75938C3.01953 4.35938 3.31953 3.99063 3.65703 3.65313C3.99453 3.31563 4.36328 3.01562 4.76328 2.75313L5.32578 3.74688C5.01328 3.95938 4.72266 4.19688 4.45391 4.45938C4.18516 4.72188 3.94453 5.00938 3.73203 5.32188ZM8.43828 16.4781C7.96328 16.4406 7.50078 16.3656 7.05078 16.2531C6.60078 16.1406 6.16328 15.9844 5.73828 15.7844L6.30078 14.8094C6.63828 14.9594 6.98828 15.0813 7.35078 15.175C7.71328 15.2688 8.07578 15.3281 8.43828 15.3531V16.4781ZM6.30078 3.18438L5.73828 2.20938C6.16328 2.00938 6.60078 1.85313 7.05078 1.74063C7.50078 1.62813 7.96328 1.55313 8.43828 1.51562V2.64062C8.07578 2.66563 7.71328 2.725 7.35078 2.81875C6.98828 2.9125 6.63828 3.03438 6.30078 3.18438ZM9.56328 16.4781V15.3531C9.92578 15.3281 10.2883 15.2688 10.6508 15.175C11.0133 15.0813 11.3633 14.9594 11.7008 14.8094L12.2633 15.7844C11.8383 15.9844 11.4008 16.1406 10.9508 16.2531C10.5008 16.3656 10.0383 16.4406 9.56328 16.4781ZM11.7008 3.18438C11.3633 3.03438 11.0133 2.9125 10.6508 2.81875C10.2883 2.725 9.92578 2.66563 9.56328 2.64062V1.51562C10.0383 1.55313 10.5008 1.625 10.9508 1.73125C11.4008 1.8375 11.8383 1.99688 12.2633 2.20938L11.7008 3.18438ZM13.2383 15.2406L12.6758 14.2469C12.9883 14.0344 13.2758 13.7969 13.5383 13.5344C13.8008 13.2719 14.0383 12.9844 14.2508 12.6719L15.2445 13.2344C14.982 13.6344 14.682 14.0031 14.3445 14.3406C14.007 14.6781 13.6383 14.9781 13.2383 15.2406ZM14.2508 5.32188C14.0383 5.00938 13.8008 4.72188 13.5383 4.45938C13.2758 4.19688 12.9883 3.95938 12.6758 3.74688L13.2383 2.75313C13.6383 3.01562 14.0039 3.31563 14.3352 3.65313C14.6664 3.99063 14.9633 4.35938 15.2258 4.75938L14.2508 5.32188ZM15.357 8.43438C15.332 8.05938 15.2695 7.69375 15.1695 7.3375C15.0695 6.98125 14.9445 6.63438 14.7945 6.29688L15.7883 5.73438C16.0008 6.15938 16.1602 6.59688 16.2664 7.04688C16.3727 7.49688 16.4445 7.95938 16.482 8.43438H15.357ZM15.7883 12.2594L14.8133 11.6969C14.9633 11.3594 15.0852 11.0094 15.1789 10.6469C15.2727 10.2844 15.332 9.92188 15.357 9.55938H16.482C16.4445 10.0344 16.3695 10.4969 16.257 10.9469C16.1445 11.3969 15.9883 11.8344 15.7883 12.2594Z"
        fill="white"
      />
    </svg>
  );
};

export const GreenAvatar = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
    >
      <g clipPath="url(#clip0_2584_94090)">
        <path
          d="M12.5007 0.00166678C11.7233 -0.0169218 10.9501 0.12013 10.2265 0.40476C9.50293 0.689391 8.84356 1.11585 8.28721 1.65906C7.73086 2.20226 7.28876 2.85124 6.98692 3.56782C6.68507 4.2844 6.52957 5.05411 6.52957 5.83167C6.52957 6.60922 6.68507 7.37893 6.98692 8.09551C7.28876 8.81209 7.73086 9.46107 8.28721 10.0043C8.84356 10.5475 9.50293 10.9739 10.2265 11.2586C10.9501 11.5432 11.7233 11.6803 12.5007 11.6617C13.278 11.6803 14.0512 11.5432 14.7748 11.2586C15.4984 10.9739 16.1577 10.5475 16.7141 10.0043C17.2704 9.46107 17.7125 8.81209 18.0144 8.09551C18.3162 7.37893 18.4717 6.60922 18.4717 5.83167C18.4717 5.05411 18.3162 4.2844 18.0144 3.56782C17.7125 2.85124 17.2704 2.20226 16.7141 1.65906C16.1577 1.11585 15.4984 0.689391 14.7748 0.40476C14.0512 0.12013 13.278 -0.0169218 12.5007 0.00166678ZM9.16732 14.9917C7.62022 14.9917 6.13649 15.6062 5.04253 16.7002C3.94857 17.7942 3.33398 19.2779 3.33398 20.825V24.9867H21.6673V20.825C21.6673 19.2779 21.0527 17.7942 19.9588 16.7002C18.8648 15.6062 17.3811 14.9917 15.834 14.9917H9.16732Z"
          fill="#43A047"
        />
      </g>
      <defs>
        <clipPath id="clip0_2584_94090">
          <rect width="25" height="25" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const BlueReloadIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M9.05625 11.6062C8.69375 11.6187 8.34687 11.5594 8.01562 11.4281C7.68437 11.2969 7.39375 11.1062 7.14375 10.8562C6.89375 10.6062 6.70312 10.325 6.57187 10.0125C6.44062 9.7 6.375 9.36875 6.375 9.01875C6.375 8.89375 6.38437 8.77187 6.40312 8.65312C6.42187 8.53437 6.45 8.4125 6.4875 8.2875C6.5375 8.1375 6.53437 7.9875 6.47812 7.8375C6.42187 7.6875 6.325 7.575 6.1875 7.5C6.05 7.425 5.90625 7.4125 5.75625 7.4625C5.60625 7.5125 5.50625 7.6125 5.45625 7.7625C5.39375 7.9625 5.34375 8.16562 5.30625 8.37187C5.26875 8.57812 5.25 8.7875 5.25 9C5.25 9.5 5.34687 9.97812 5.54062 10.4344C5.73437 10.8906 6.00625 11.2937 6.35625 11.6437C6.69375 11.9937 7.09062 12.2625 7.54687 12.45C8.00312 12.6375 8.475 12.7375 8.9625 12.75L8.64375 13.0687C8.53125 13.1812 8.475 13.3125 8.475 13.4625C8.475 13.6125 8.53125 13.7437 8.64375 13.8562C8.75625 13.9687 8.8875 14.025 9.0375 14.025C9.1875 14.025 9.31875 13.9687 9.43125 13.8562L10.7812 12.525C10.8937 12.4125 10.95 12.2812 10.95 12.1312C10.95 11.9812 10.8937 11.85 10.7812 11.7375L9.43125 10.4062C9.31875 10.2937 9.1875 10.2375 9.0375 10.2375C8.8875 10.2375 8.75625 10.2937 8.64375 10.4062C8.53125 10.5187 8.475 10.65 8.475 10.8C8.475 10.95 8.53125 11.0812 8.64375 11.1937L9.05625 11.6062ZM8.925 6.375C9.2875 6.375 9.6375 6.44062 9.975 6.57187C10.3125 6.70312 10.6062 6.89375 10.8562 7.14375C11.1062 7.39375 11.2969 7.675 11.4281 7.9875C11.5594 8.3 11.625 8.63125 11.625 8.98125C11.625 9.10625 11.6187 9.22812 11.6062 9.34687C11.5937 9.46562 11.5687 9.58125 11.5312 9.69375C11.4812 9.84375 11.4844 9.99375 11.5406 10.1437C11.5969 10.2937 11.6937 10.4 11.8312 10.4625C11.9812 10.525 12.1312 10.525 12.2812 10.4625C12.4312 10.4 12.5312 10.2937 12.5812 10.1437C12.6437 9.95625 12.6875 9.76875 12.7125 9.58125C12.7375 9.39375 12.75 9.2 12.75 9C12.75 8.5 12.6594 8.02187 12.4781 7.56562C12.2969 7.10937 12.025 6.7 11.6625 6.3375C11.3125 5.9875 10.9094 5.72187 10.4531 5.54062C9.99687 5.35937 9.525 5.26875 9.0375 5.26875L9.375 4.93125C9.475 4.81875 9.525 4.6875 9.525 4.5375C9.525 4.3875 9.46875 4.25625 9.35625 4.14375C9.24375 4.03125 9.1125 3.975 8.9625 3.975C8.8125 3.975 8.68125 4.03125 8.56875 4.14375L7.21875 5.475C7.10625 5.5875 7.05 5.71875 7.05 5.86875C7.05 6.01875 7.10625 6.15 7.21875 6.2625L8.56875 7.59375C8.68125 7.70625 8.8125 7.7625 8.9625 7.7625C9.1125 7.7625 9.24375 7.70625 9.35625 7.59375C9.46875 7.48125 9.525 7.35 9.525 7.2C9.525 7.05 9.46875 6.91875 9.35625 6.80625L8.925 6.375ZM9 16.5C7.975 16.5 7.00625 16.3031 6.09375 15.9094C5.18125 15.5156 4.38437 14.9781 3.70312 14.2969C3.02187 13.6156 2.48437 12.8187 2.09062 11.9062C1.69687 10.9937 1.5 10.025 1.5 9C1.5 7.9625 1.69687 6.9875 2.09062 6.075C2.48437 5.1625 3.02187 4.36875 3.70312 3.69375C4.38437 3.01875 5.18125 2.48437 6.09375 2.09062C7.00625 1.69687 7.975 1.5 9 1.5C10.0375 1.5 11.0125 1.69687 11.925 2.09062C12.8375 2.48437 13.6312 3.01875 14.3062 3.69375C14.9812 4.36875 15.5156 5.1625 15.9094 6.075C16.3031 6.9875 16.5 7.9625 16.5 9C16.5 10.025 16.3031 10.9937 15.9094 11.9062C15.5156 12.8187 14.9812 13.6156 14.3062 14.2969C13.6312 14.9781 12.8375 15.5156 11.925 15.9094C11.0125 16.3031 10.0375 16.5 9 16.5Z"
        fill="#1E88E5"
      />
    </svg>
  );
};

export const BlueImgIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M3.375 15.75C3.075 15.75 2.8125 15.6375 2.5875 15.4125C2.3625 15.1875 2.25 14.925 2.25 14.625V3.375C2.25 3.075 2.3625 2.8125 2.5875 2.5875C2.8125 2.3625 3.075 2.25 3.375 2.25H14.625C14.925 2.25 15.1875 2.3625 15.4125 2.5875C15.6375 2.8125 15.75 3.075 15.75 3.375V14.625C15.75 14.925 15.6375 15.1875 15.4125 15.4125C15.1875 15.6375 14.925 15.75 14.625 15.75H3.375ZM4.9875 12.8063H13.0312C13.1438 12.8063 13.225 12.7563 13.275 12.6562C13.325 12.5563 13.3188 12.4563 13.2563 12.3563L11.0625 9.43125C11 9.35625 10.925 9.31875 10.8375 9.31875C10.75 9.31875 10.675 9.35625 10.6125 9.43125L8.3625 12.3375L6.84375 10.2563C6.78125 10.1813 6.70625 10.1438 6.61875 10.1438C6.53125 10.1438 6.45625 10.1813 6.39375 10.2563L4.78125 12.3563C4.70625 12.4563 4.69375 12.5563 4.74375 12.6562C4.79375 12.7563 4.875 12.8063 4.9875 12.8063ZM6.375 7.3125C6.6375 7.3125 6.85938 7.22188 7.04063 7.04063C7.22188 6.85938 7.3125 6.6375 7.3125 6.375C7.3125 6.1125 7.22188 5.89063 7.04063 5.70938C6.85938 5.52813 6.6375 5.4375 6.375 5.4375C6.1125 5.4375 5.89063 5.52813 5.70938 5.70938C5.52813 5.89063 5.4375 6.1125 5.4375 6.375C5.4375 6.6375 5.52813 6.85938 5.70938 7.04063C5.89063 7.22188 6.1125 7.3125 6.375 7.3125Z"
        fill="#1E88E5"
      />
    </svg>
  );
};

export const GoogleIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g clip-path="url(#clip0_8219_77062)">
        <path
          d="M23.7663 12.2743C23.7663 11.4586 23.7001 10.6384 23.559 9.83594H12.2402V14.4569H18.722C18.453 15.9473 17.5888 17.2657 16.3233 18.1034V21.1018H20.1903C22.4611 19.0118 23.7663 15.9252 23.7663 12.2743Z"
          fill="#4285F4"
        />
        <path
          d="M12.2401 23.9974C15.4766 23.9974 18.2059 22.9348 20.1945 21.1005L16.3276 18.1021C15.2517 18.8341 13.8627 19.2486 12.2445 19.2486C9.11388 19.2486 6.45946 17.1365 5.50705 14.2969H1.5166V17.3878C3.55371 21.44 7.7029 23.9974 12.2401 23.9974Z"
          fill="#34A853"
        />
        <path
          d="M5.50277 14.3027C5.00011 12.8123 5.00011 11.1985 5.50277 9.70813V6.61719H1.51674C-0.185266 10.008 -0.185266 14.0028 1.51674 17.3936L5.50277 14.3027Z"
          fill="#FBBC04"
        />
        <path
          d="M12.2401 4.74966C13.9509 4.7232 15.6044 5.36697 16.8434 6.54867L20.2695 3.12262C18.1001 1.0855 15.2208 -0.034466 12.2401 0.000808666C7.7029 0.000808666 3.55371 2.55822 1.5166 6.61481L5.50264 9.70575C6.45064 6.86173 9.10947 4.74966 12.2401 4.74966Z"
          fill="#EA4335"
        />
      </g>
      <defs>
        <clipPath id="clip0_8219_77062">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const FacebookIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g clip-path="url(#clip0_8219_86626)">
        <path
          d="M24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 17.9895 4.3882 22.954 10.125 23.8542V15.4688H7.07812V12H10.125V9.35625C10.125 6.34875 11.9166 4.6875 14.6576 4.6875C15.9701 4.6875 17.3438 4.92188 17.3438 4.92188V7.875H15.8306C14.34 7.875 13.875 8.80008 13.875 9.75V12H17.2031L16.6711 15.4688H13.875V23.8542C19.6118 22.954 24 17.9895 24 12Z"
          fill="#1877F2"
        />
        <path
          d="M16.6711 15.4688L17.2031 12H13.875V9.75C13.875 8.80102 14.34 7.875 15.8306 7.875H17.3438V4.92188C17.3438 4.92188 15.9705 4.6875 14.6576 4.6875C11.9166 4.6875 10.125 6.34875 10.125 9.35625V12H7.07812V15.4688H10.125V23.8542C11.3674 24.0486 12.6326 24.0486 13.875 23.8542V15.4688H16.6711Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_8219_86626">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const EmptyIcon = () => {
  return (
    <svg
      width="64"
      height="41"
      viewBox="0 0 64 41"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(0 1)" fill="none" fill-rule="evenodd">
        <ellipse fill="#f5f5f5" cx="32" cy="33" rx="32" ry="7"></ellipse>
        <g fillRule="nonzero" stroke="#d9d9d9">
          <path d="M55 12.76L44.854 1.258C44.367.474 43.656 0 42.907 0H21.093c-.749 0-1.46.474-1.947 1.257L9 12.761V22h46v-9.24z"></path>
          <path
            d="M41.613 15.931c0-1.605.994-2.93 2.227-2.931H55v18.137C55 33.26 53.68 35 52.05 35h-40.1C10.32 35 9 33.259 9 31.137V13h11.16c1.233 0 2.227 1.323 2.227 2.928v.022c0 1.605 1.005 2.901 2.237 2.901h14.752c1.232 0 2.237-1.308 2.237-2.913v-.007z"
            fill="#fafafa"
          ></path>
        </g>
      </g>
    </svg>
  );
};

export const NotificationBell = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="33"
      height="32"
      viewBox="0 0 33 32"
      fill="none"
    >
      <g clip-path="url(#clip0_10321_17583)">
        <path
          d="M20.4998 25.3334C20.5 26.0062 20.2459 26.6542 19.7885 27.1475C19.331 27.6408 18.704 27.943 18.0331 27.9934L17.8331 28.0001H15.1665C14.4937 28.0003 13.8457 27.7462 13.3524 27.2888C12.8591 26.8313 12.5569 26.2043 12.5065 25.5334L12.4998 25.3334H20.4998ZM16.4998 2.66675C18.9198 2.66671 21.2452 3.60661 22.9854 5.28818C24.7257 6.96976 25.7448 9.26153 25.8278 11.6801L25.8331 12.0001V17.0187L28.2625 21.8774C28.3685 22.0894 28.4215 22.324 28.4171 22.5609C28.4127 22.7979 28.3508 23.0303 28.2369 23.2382C28.123 23.4461 27.9605 23.6232 27.7631 23.7545C27.5658 23.8858 27.3395 23.9673 27.1038 23.9921L26.9505 24.0001H6.04913C5.81202 24.0002 5.57842 23.9427 5.36836 23.8327C5.1583 23.7228 4.97804 23.5635 4.84302 23.3686C4.708 23.1736 4.62226 22.9489 4.59314 22.7136C4.56401 22.4782 4.59238 22.2394 4.6758 22.0174L4.73713 21.8774L7.16646 17.0187V12.0001C7.16646 9.52473 8.1498 7.15076 9.90014 5.40042C11.6505 3.65008 14.0244 2.66675 16.4998 2.66675Z"
          fill="#424242"
        />
      </g>
      <defs>
        <clipPath id="clip0_10321_17583">
          <rect
            width="32"
            height="32"
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const AddUserIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
    >
      <g clip-path="url(#clip0_10750_143857)">
        <path
          d="M17.584 10.5C21.3119 10.5 24.334 13.5221 24.334 17.25C24.334 20.978 21.3119 24 17.584 24C13.8561 24 10.834 20.978 10.834 17.25C10.834 13.5221 13.8561 10.5 17.584 10.5ZM17.584 13.5C17.1698 13.5 16.834 13.8358 16.834 14.25V16.5H14.584C14.1698 16.5 13.834 16.8358 13.834 17.25C13.834 17.6642 14.1698 18 14.584 18H16.834V20.25C16.834 20.6642 17.1698 21 17.584 21C17.9981 21 18.334 20.6642 18.334 20.25V18H20.584C20.9981 18 21.334 17.6642 21.334 17.25C21.334 16.8358 20.9981 16.5 20.584 16.5H18.334V14.25C18.334 13.8358 17.9981 13.5 17.584 13.5ZM11.2197 12C10.0417 13.4264 9.33398 15.2556 9.33398 17.25C9.33398 18.03 9.44221 18.7846 9.64447 19.4997L9.42427 19.5012C5.633 19.5012 3.48049 18.2342 3.3412 15.6807L3.33398 15.4119V14.25C3.33398 13.0805 4.22631 12.1193 5.36729 12.0103L5.58398 12H11.2197ZM9.33398 3C11.4054 3 13.0846 4.67921 13.0846 6.7506C13.0846 8.82201 11.4054 10.5012 9.33398 10.5012C7.26257 10.5012 5.58337 8.82201 5.58337 6.7506C5.58337 4.67921 7.26257 3 9.33398 3ZM16.834 4.5C18.4909 4.5 19.834 5.84314 19.834 7.5C19.834 8.12358 19.6438 8.70273 19.3181 9.18256C18.7589 9.06295 18.1789 9 17.584 9C16.5454 9 15.5518 9.1919 14.6363 9.54218C14.1385 9.00665 13.834 8.28888 13.834 7.5C13.834 5.84314 15.1771 4.5 16.834 4.5Z"
          fill="#1E88E5"
        />
      </g>
      <defs>
        <clipPath id="clip0_10750_143857">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0.333984)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const LeadUserIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
    >
      <path
        d="M6.33301 17.0117C6.33301 15.0117 10.333 13.9117 12.333 13.9117C14.333 13.9117 18.333 15.0117 18.333 17.0117V18.0117H6.33301M15.333 9.01172C15.333 9.80737 15.0169 10.5704 14.4543 11.133C13.8917 11.6956 13.1287 12.0117 12.333 12.0117C11.5374 12.0117 10.7743 11.6956 10.2117 11.133C9.64908 10.5704 9.33301 9.80737 9.33301 9.01172C9.33301 8.21607 9.64908 7.45301 10.2117 6.8904C10.7743 6.32779 11.5374 6.01172 12.333 6.01172C13.1287 6.01172 13.8917 6.32779 14.4543 6.8904C15.0169 7.45301 15.333 8.21607 15.333 9.01172ZM3.33301 5.01172V19.0117C3.33301 19.5422 3.54372 20.0509 3.91879 20.4259C4.29387 20.801 4.80257 21.0117 5.33301 21.0117H19.333C19.8634 21.0117 20.3721 20.801 20.7472 20.4259C21.1223 20.0509 21.333 19.5422 21.333 19.0117V5.01172C21.333 4.48129 21.1223 3.97258 20.7472 3.59751C20.3721 3.22243 19.8634 3.01172 19.333 3.01172H5.33301C4.80257 3.01172 4.29387 3.22243 3.91879 3.59751C3.54372 3.97258 3.33301 4.48129 3.33301 5.01172Z"
        fill="#1E88E5"
      />
    </svg>
  );
};

export const TooltipBackground = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="140"
      height="59"
      viewBox="0 0 140 59"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5 0C2.23828 0 0 2.23828 0 5V45C0 46.2188 0.43457 47.332 1.15723 48.1992C2.07422 49.2969 3.45508 50 5 50H63.8584L70 59L76.1416 50H135C137.762 50 140 47.7617 140 45V5C140 2.23828 137.762 0 135 0H5Z"
        fill="#263238"
      />
    </svg>
  );
};

export const CodeIcon = ({color}: any) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill={color} stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="16 18 22 12 16 6"></polyline>
      <polyline points="8 6 2 12 8 18"></polyline>
    </svg>
  );
};

export const EditorIcon = ({color}: any) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill={color} stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 20h9"></path>
      <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"></path>
    </svg>
  )
};
